//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.3.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import axios from 'axios';
import * as dayjs from 'dayjs';
var Client = /** @class */ (function () {
    function Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    Client.prototype.postStripeWebhook = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/stripe/webhook";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPostStripeWebhook(_response);
        });
    };
    Client.prototype.processPostStripeWebhook = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    Client.prototype.postTerraWebhook = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/terra/webhook";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPostTerraWebhook(_response);
        });
    };
    Client.prototype.processPostTerraWebhook = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Client;
}());
export { Client };
var ActivitiesClient = /** @class */ (function () {
    function ActivitiesClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    ActivitiesClient.prototype.getActivity = function (client, date, componentSlug, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/activities/get-by-path?";
        if (client === undefined)
            throw new Error("The parameter 'client' must be defined.");
        else if (client !== null)
            url_ += "Client=" + encodeURIComponent("" + client) + "&";
        if (date === undefined)
            throw new Error("The parameter 'date' must be defined.");
        else if (date !== null)
            url_ += "Date=" + encodeURIComponent("" + date) + "&";
        if (componentSlug === undefined)
            throw new Error("The parameter 'componentSlug' must be defined.");
        else if (componentSlug !== null)
            url_ += "ComponentSlug=" + encodeURIComponent("" + componentSlug) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetActivity(_response);
        });
    };
    ActivitiesClient.prototype.processGetActivity = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ActivityBriefDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ActivitiesClient.prototype.getSummary = function (client, componentSlug, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/activities/summary?";
        if (client === undefined)
            throw new Error("The parameter 'client' must be defined.");
        else if (client !== null)
            url_ += "Client=" + encodeURIComponent("" + client) + "&";
        if (componentSlug === undefined)
            throw new Error("The parameter 'componentSlug' must be defined.");
        else if (componentSlug !== null)
            url_ += "ComponentSlug=" + encodeURIComponent("" + componentSlug) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetSummary(_response);
        });
    };
    ActivitiesClient.prototype.processGetSummary = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ActivitySummary.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ActivitiesClient.prototype.getActivitiesWithPagination = function (pageSize, afterCursor, clientId, programId, date, week, period, withAnswersOnly, withMealLogging, withClientForms, activityTypes, coachArchived, orderBy, clientIds, groupIds, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/activities/paginated?";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (afterCursor !== undefined && afterCursor !== null)
            url_ += "AfterCursor=" + encodeURIComponent("" + afterCursor) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (programId !== undefined && programId !== null)
            url_ += "ProgramId=" + encodeURIComponent("" + programId) + "&";
        if (date !== undefined && date !== null)
            url_ += "Date=" + encodeURIComponent("" + date) + "&";
        if (week !== undefined && week !== null)
            url_ += "Week=" + encodeURIComponent("" + week) + "&";
        if (period !== undefined && period !== null)
            url_ += "Period=" + encodeURIComponent("" + period) + "&";
        if (withAnswersOnly !== undefined && withAnswersOnly !== null)
            url_ += "WithAnswersOnly=" + encodeURIComponent("" + withAnswersOnly) + "&";
        if (withMealLogging !== undefined && withMealLogging !== null)
            url_ += "WithMealLogging=" + encodeURIComponent("" + withMealLogging) + "&";
        if (withClientForms !== undefined && withClientForms !== null)
            url_ += "WithClientForms=" + encodeURIComponent("" + withClientForms) + "&";
        if (activityTypes !== undefined && activityTypes !== null)
            activityTypes && activityTypes.forEach(function (item) { url_ += "ActivityTypes=" + encodeURIComponent("" + item) + "&"; });
        if (coachArchived !== undefined && coachArchived !== null)
            url_ += "CoachArchived=" + encodeURIComponent("" + coachArchived) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (clientIds !== undefined && clientIds !== null)
            clientIds && clientIds.forEach(function (item) { url_ += "ClientIds=" + encodeURIComponent("" + item) + "&"; });
        if (groupIds !== undefined && groupIds !== null)
            groupIds && groupIds.forEach(function (item) { url_ += "GroupIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetActivitiesWithPagination(_response);
        });
    };
    ActivitiesClient.prototype.processGetActivitiesWithPagination = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ActivitiesCompositeCursorPaginatedList.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ActivitiesClient.prototype.getComponentActivities = function (pageNumber, pageSize, clientId, programId, date, week, period, withAnswersOnly, coachArchived, orderBy, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/activities/with-components?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (programId !== undefined && programId !== null)
            url_ += "ProgramId=" + encodeURIComponent("" + programId) + "&";
        if (date !== undefined && date !== null)
            url_ += "Date=" + encodeURIComponent("" + date) + "&";
        if (week !== undefined && week !== null)
            url_ += "Week=" + encodeURIComponent("" + week) + "&";
        if (period !== undefined && period !== null)
            url_ += "Period=" + encodeURIComponent("" + period) + "&";
        if (withAnswersOnly !== undefined && withAnswersOnly !== null)
            url_ += "WithAnswersOnly=" + encodeURIComponent("" + withAnswersOnly) + "&";
        if (coachArchived !== undefined && coachArchived !== null)
            url_ += "CoachArchived=" + encodeURIComponent("" + coachArchived) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetComponentActivities(_response);
        });
    };
    ActivitiesClient.prototype.processGetComponentActivities = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfComponentActivityDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ActivitiesClient.prototype.getActivitiesDateRange = function (startDate, endDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/activities/date-range?";
        if (startDate === undefined)
            throw new Error("The parameter 'startDate' must be defined.");
        else if (startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === undefined)
            throw new Error("The parameter 'endDate' must be defined.");
        else if (endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetActivitiesDateRange(_response);
        });
    };
    ActivitiesClient.prototype.processGetActivitiesDateRange = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_1 = resultData200; _i < resultData200_1.length; _i++) {
                    var item = resultData200_1[_i];
                    result200.push(dayjs(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ActivitiesClient.prototype.upsert = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/activities/upsert";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpsert(_response);
        });
    };
    ActivitiesClient.prototype.processUpsert = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ActivitiesClient.prototype.toggleArchived = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/activities/toggle-archived";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processToggleArchived(_response);
        });
    };
    ActivitiesClient.prototype.processToggleArchived = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ActivitiesClient.prototype.markAnswersRead = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/activities/mark-answers-read";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMarkAnswersRead(_response);
        });
    };
    ActivitiesClient.prototype.processMarkAnswersRead = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ActivitiesClient.prototype.getHabitsCheckIns = function (clientId, slug, period, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/activities/habits-checkins?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (slug === undefined)
            throw new Error("The parameter 'slug' must be defined.");
        else if (slug !== null)
            url_ += "Slug=" + encodeURIComponent("" + slug) + "&";
        if (period === undefined || period === null)
            throw new Error("The parameter 'period' must be defined and cannot be null.");
        else
            url_ += "Period=" + encodeURIComponent("" + period) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetHabitsCheckIns(_response);
        });
    };
    ActivitiesClient.prototype.processGetHabitsCheckIns = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_2 = resultData200; _i < resultData200_2.length; _i++) {
                    var item = resultData200_2[_i];
                    result200.push(HabitsCheckInsActivityDto.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return ActivitiesClient;
}());
export { ActivitiesClient };
var ActivityFeedbacksClient = /** @class */ (function () {
    function ActivityFeedbacksClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    ActivityFeedbacksClient.prototype.getActivityFeedbacks = function (activityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/activity-feedbacks?";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined and cannot be null.");
        else
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetActivityFeedbacks(_response);
        });
    };
    ActivityFeedbacksClient.prototype.processGetActivityFeedbacks = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_3 = resultData200; _i < resultData200_3.length; _i++) {
                    var item = resultData200_3[_i];
                    result200.push(ActivityFeedbackDto.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ActivityFeedbacksClient.prototype.createActivityFeedback = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/activity-feedbacks";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateActivityFeedback(_response);
        });
    };
    ActivityFeedbacksClient.prototype.processCreateActivityFeedback = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = CreateActivityFeedbackResponse.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ActivityFeedbacksClient.prototype.getMealLoggingActivity = function (date, clientId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/activity-feedbacks/meal-logging?";
        if (date === undefined)
            throw new Error("The parameter 'date' must be defined.");
        else if (date !== null)
            url_ += "Date=" + encodeURIComponent("" + date) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetMealLoggingActivity(_response);
        });
    };
    ActivityFeedbacksClient.prototype.processGetMealLoggingActivity = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = MealLoggingActivityDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ActivityFeedbacksClient.prototype.updateActivityFeedback = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/activity-feedbacks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateActivityFeedback(_response);
        });
    };
    ActivityFeedbacksClient.prototype.processUpdateActivityFeedback = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return ActivityFeedbacksClient;
}());
export { ActivityFeedbacksClient };
var AdminClient = /** @class */ (function () {
    function AdminClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    AdminClient.prototype.getPrograms = function (pageNumber, pageSize, activeSubscription, publishedPrograms, searchQuery, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/admin?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (activeSubscription === undefined || activeSubscription === null)
            throw new Error("The parameter 'activeSubscription' must be defined and cannot be null.");
        else
            url_ += "ActiveSubscription=" + encodeURIComponent("" + activeSubscription) + "&";
        if (publishedPrograms === undefined || publishedPrograms === null)
            throw new Error("The parameter 'publishedPrograms' must be defined and cannot be null.");
        else
            url_ += "PublishedPrograms=" + encodeURIComponent("" + publishedPrograms) + "&";
        if (searchQuery !== undefined && searchQuery !== null)
            url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetPrograms(_response);
        });
    };
    AdminClient.prototype.processGetPrograms = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfProgramAdminDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    AdminClient.prototype.createAdminExerciseCustomLibraryAsset = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/admin";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateAdminExerciseCustomLibraryAsset(_response);
        });
    };
    AdminClient.prototype.processCreateAdminExerciseCustomLibraryAsset = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    AdminClient.prototype.adminStats = function (extended, programId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/admin/stats?";
        if (extended === undefined || extended === null)
            throw new Error("The parameter 'extended' must be defined and cannot be null.");
        else
            url_ += "Extended=" + encodeURIComponent("" + extended) + "&";
        if (programId !== undefined && programId !== null)
            url_ += "ProgramId=" + encodeURIComponent("" + programId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdminStats(_response);
        });
    };
    AdminClient.prototype.processAdminStats = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = AdminStats.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    AdminClient.prototype.getComponentDuplicatesInfo = function (programId, days, title, type, includeContent, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/admin/component-week-titles?";
        if (programId === undefined || programId === null)
            throw new Error("The parameter 'programId' must be defined and cannot be null.");
        else
            url_ += "ProgramId=" + encodeURIComponent("" + programId) + "&";
        if (days === undefined)
            throw new Error("The parameter 'days' must be defined.");
        else if (days !== null)
            url_ += "Days=" + encodeURIComponent("" + days) + "&";
        if (title === undefined)
            throw new Error("The parameter 'title' must be defined.");
        else if (title !== null)
            url_ += "Title=" + encodeURIComponent("" + title) + "&";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (includeContent === undefined || includeContent === null)
            throw new Error("The parameter 'includeContent' must be defined and cannot be null.");
        else
            url_ += "IncludeContent=" + encodeURIComponent("" + includeContent) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetComponentDuplicatesInfo(_response);
        });
    };
    AdminClient.prototype.processGetComponentDuplicatesInfo = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_4 = resultData200; _i < resultData200_4.length; _i++) {
                    var item = resultData200_4[_i];
                    result200.push(ComponentDuplicateInfo.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    AdminClient.prototype.getDuplicateComponentGroups = function (programId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/admin/component-groups?";
        if (programId === undefined || programId === null)
            throw new Error("The parameter 'programId' must be defined and cannot be null.");
        else
            url_ += "ProgramId=" + encodeURIComponent("" + programId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetDuplicateComponentGroups(_response);
        });
    };
    AdminClient.prototype.processGetDuplicateComponentGroups = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ComponentDuplicatesProgramSummary.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    AdminClient.prototype.fixComponentDuplicates = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/admin/fix-component-duplicates";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFixComponentDuplicates(_response);
        });
    };
    AdminClient.prototype.processFixComponentDuplicates = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = FixDuplicatesResult.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    AdminClient.prototype.getProgramActivityDetails = function (slug, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/admin/activity-details?";
        if (slug === undefined)
            throw new Error("The parameter 'slug' must be defined.");
        else if (slug !== null)
            url_ += "Slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetProgramActivityDetails(_response);
        });
    };
    AdminClient.prototype.processGetProgramActivityDetails = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ProgramDetailsAdminDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    AdminClient.prototype.getProgramsByComponentDuplicates = function (notArchivedComponents, pageNumber, pageSize, activeSubscription, publishedPrograms, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/admin/component-duplicates?";
        if (notArchivedComponents === undefined || notArchivedComponents === null)
            throw new Error("The parameter 'notArchivedComponents' must be defined and cannot be null.");
        else
            url_ += "NotArchivedComponents=" + encodeURIComponent("" + notArchivedComponents) + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (activeSubscription === undefined || activeSubscription === null)
            throw new Error("The parameter 'activeSubscription' must be defined and cannot be null.");
        else
            url_ += "ActiveSubscription=" + encodeURIComponent("" + activeSubscription) + "&";
        if (publishedPrograms === undefined || publishedPrograms === null)
            throw new Error("The parameter 'publishedPrograms' must be defined and cannot be null.");
        else
            url_ += "PublishedPrograms=" + encodeURIComponent("" + publishedPrograms) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetProgramsByComponentDuplicates(_response);
        });
    };
    AdminClient.prototype.processGetProgramsByComponentDuplicates = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfProgramAdminDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    AdminClient.prototype.getProgramsByLengthIssues = function (pageNumber, pageSize, activeSubscription, publishedPrograms, searchQuery, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/admin/length-issues?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (activeSubscription === undefined || activeSubscription === null)
            throw new Error("The parameter 'activeSubscription' must be defined and cannot be null.");
        else
            url_ += "ActiveSubscription=" + encodeURIComponent("" + activeSubscription) + "&";
        if (publishedPrograms === undefined || publishedPrograms === null)
            throw new Error("The parameter 'publishedPrograms' must be defined and cannot be null.");
        else
            url_ += "PublishedPrograms=" + encodeURIComponent("" + publishedPrograms) + "&";
        if (searchQuery !== undefined && searchQuery !== null)
            url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetProgramsByLengthIssues(_response);
        });
    };
    AdminClient.prototype.processGetProgramsByLengthIssues = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfProgramAdminDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    AdminClient.prototype.getExerciseCustomAssetsByType = function (exerciseAssetsType, pageNumber, pageSize, activeSubscription, searchQueryByName, searchQueryByCoachId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/admin/exercise-custom-assets?";
        if (exerciseAssetsType === undefined || exerciseAssetsType === null)
            throw new Error("The parameter 'exerciseAssetsType' must be defined and cannot be null.");
        else
            url_ += "ExerciseAssetsType=" + encodeURIComponent("" + exerciseAssetsType) + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (activeSubscription !== undefined && activeSubscription !== null)
            url_ += "ActiveSubscription=" + encodeURIComponent("" + activeSubscription) + "&";
        if (searchQueryByName !== undefined && searchQueryByName !== null)
            url_ += "SearchQueryByName=" + encodeURIComponent("" + searchQueryByName) + "&";
        if (searchQueryByCoachId !== undefined && searchQueryByCoachId !== null)
            url_ += "SearchQueryByCoachId=" + encodeURIComponent("" + searchQueryByCoachId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetExerciseCustomAssetsByType(_response);
        });
    };
    AdminClient.prototype.processGetExerciseCustomAssetsByType = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfExerciseCustomAssetDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    AdminClient.prototype.getExerciseAssetHistory = function (assetId, legacyAssetId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/admin/exercise-asset-history?";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined and cannot be null.");
        else
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (legacyAssetId !== undefined && legacyAssetId !== null)
            url_ += "legacyAssetId=" + encodeURIComponent("" + legacyAssetId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetExerciseAssetHistory(_response);
        });
    };
    AdminClient.prototype.processGetExerciseAssetHistory = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    AdminClient.prototype.updateAdminExerciseCustomLibraryAsset = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/admin/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateAdminExerciseCustomLibraryAsset(_response);
        });
    };
    AdminClient.prototype.processUpdateAdminExerciseCustomLibraryAsset = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    AdminClient.prototype.adminDeleteExerciseCustomAsset = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/admin/admin-workout-exercises?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdminDeleteExerciseCustomAsset(_response);
        });
    };
    AdminClient.prototype.processAdminDeleteExerciseCustomAsset = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    AdminClient.prototype.regenerateActivities = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/admin/regenerate-activities";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRegenerateActivities(_response);
        });
    };
    AdminClient.prototype.processRegenerateActivities = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    AdminClient.prototype.fixProgramLength = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/admin/fix-program-length";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFixProgramLength(_response);
        });
    };
    AdminClient.prototype.processFixProgramLength = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return AdminClient;
}());
export { AdminClient };
var AnalyticsClient = /** @class */ (function () {
    function AnalyticsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    AnalyticsClient.prototype.sendAnalytics = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/analytics";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSendAnalytics(_response);
        });
    };
    AnalyticsClient.prototype.processSendAnalytics = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return AnalyticsClient;
}());
export { AnalyticsClient };
var BillingAddressesClient = /** @class */ (function () {
    function BillingAddressesClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    BillingAddressesClient.prototype.getMissingSubAccounts = function (emails, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/billing-addresses/get-missing-sub-accounts";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(emails);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetMissingSubAccounts(_response);
        });
    };
    BillingAddressesClient.prototype.processGetMissingSubAccounts = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = GetSubAccountsVm.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BillingAddressesClient.prototype.pauseAllSubAccountForLapsedCoaches = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/billing-addresses/pause-all-sub-accounts-for-lapsed-coaches";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPauseAllSubAccountForLapsedCoaches(_response);
        });
    };
    BillingAddressesClient.prototype.processPauseAllSubAccountForLapsedCoaches = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BillingAddressesClient.prototype.createSubAccountForExistingUser = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/billing-addresses/create-sub-account-for-existing-user";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateSubAccountForExistingUser(_response);
        });
    };
    BillingAddressesClient.prototype.processCreateSubAccountForExistingUser = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = CreateSubAccountResponse.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BillingAddressesClient.prototype.createBillingAddress = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/billing-addresses";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateBillingAddress(_response);
        });
    };
    BillingAddressesClient.prototype.processCreateBillingAddress = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BillingAddressesClient.prototype.updateBillingAddress = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/billing-addresses/update-billing-address";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateBillingAddress(_response);
        });
    };
    BillingAddressesClient.prototype.processUpdateBillingAddress = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BillingAddressesClient.prototype.resendGoHighLevelEmail = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/billing-addresses/resend-go-high-level-email";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processResendGoHighLevelEmail(_response);
        });
    };
    BillingAddressesClient.prototype.processResendGoHighLevelEmail = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BillingAddressesClient.prototype.updateUserGHLAccountState = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/billing-addresses/update-user-ghl-account-state";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateUserGHLAccountState(_response);
        });
    };
    BillingAddressesClient.prototype.processUpdateUserGHLAccountState = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PauseAllSubAccountForLapsedCoachesResponse.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BillingAddressesClient.prototype.toggleStopSubAccount = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/billing-addresses/toggle-stop-sub-account";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processToggleStopSubAccount(_response);
        });
    };
    BillingAddressesClient.prototype.processToggleStopSubAccount = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BillingAddressesClient.prototype.deleteSubAccount = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/billing-addresses/delete-sub-account/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDeleteSubAccount(_response);
        });
    };
    BillingAddressesClient.prototype.processDeleteSubAccount = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return BillingAddressesClient;
}());
export { BillingAddressesClient };
var BillingsClient = /** @class */ (function () {
    function BillingsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    BillingsClient.prototype.getHostedInvoiceUrl = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/billings/get-hosted-invoice-url";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetHostedInvoiceUrl(_response);
        });
    };
    BillingsClient.prototype.processGetHostedInvoiceUrl = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = HostedInvoiceUrlDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BillingsClient.prototype.getUserSubscription = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/billings/get-user-subscription";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetUserSubscription(_response);
        });
    };
    BillingsClient.prototype.processGetUserSubscription = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = SubscriptionStatusDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BillingsClient.prototype.changeCoachCreditCard = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/billings/change-coach-credit-card";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processChangeCoachCreditCard(_response);
        });
    };
    BillingsClient.prototype.processChangeCoachCreditCard = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ClientSecretDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BillingsClient.prototype.updateUserSubscription = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/billings/update-user-subscription";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateUserSubscription(_response);
        });
    };
    BillingsClient.prototype.processUpdateUserSubscription = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = SubscriptionStatusDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BillingsClient.prototype.continueOldPlan = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/billings/continue-old-plan";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContinueOldPlan(_response);
        });
    };
    BillingsClient.prototype.processContinueOldPlan = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = CreateCheckoutSessionDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BillingsClient.prototype.createCheckoutSession = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/billings/create-checkout-session";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateCheckoutSession(_response);
        });
    };
    BillingsClient.prototype.processCreateCheckoutSession = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = CreateCheckoutSessionDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BillingsClient.prototype.createSignupCheckoutSession = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/billings/create-signup-checkout-session";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateSignupCheckoutSession(_response);
        });
    };
    BillingsClient.prototype.processCreateSignupCheckoutSession = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = CreateCheckoutSessionDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BillingsClient.prototype.createCustomerPortalSession = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/billings/create-customer-portal-session";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateCustomerPortalSession(_response);
        });
    };
    BillingsClient.prototype.processCreateCustomerPortalSession = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = SessionUrlDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BillingsClient.prototype.createPromoSubscription = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/billings/create-promo-subscription";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreatePromoSubscription(_response);
        });
    };
    BillingsClient.prototype.processCreatePromoSubscription = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = CreateCheckoutSessionDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BillingsClient.prototype.updateCoachesPrices = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/billings/update-coaches-prices";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateCoachesPrices(_response);
        });
    };
    BillingsClient.prototype.processUpdateCoachesPrices = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = UpdateCoachesPricesResponsedDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return BillingsClient;
}());
export { BillingsClient };
var BodyMeasurementsClient = /** @class */ (function () {
    function BodyMeasurementsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    BodyMeasurementsClient.prototype.createMeasurement = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/body-measurements";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateMeasurement(_response);
        });
    };
    BodyMeasurementsClient.prototype.processCreateMeasurement = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BodyMeasurementsClient.prototype.getAllMeasurements = function (clientId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/body-measurements?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetAllMeasurements(_response);
        });
    };
    BodyMeasurementsClient.prototype.processGetAllMeasurements = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ClientBodyMeasurementsVm.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BodyMeasurementsClient.prototype.updateMeasurement = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/body-measurements/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateMeasurement(_response);
        });
    };
    BodyMeasurementsClient.prototype.processUpdateMeasurement = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BodyMeasurementsClient.prototype.deleteMeasurement = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/body-measurements/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDeleteMeasurement(_response);
        });
    };
    BodyMeasurementsClient.prototype.processDeleteMeasurement = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BodyMeasurementsClient.prototype.getMeasurementByType = function (clientId, measurementType, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/body-measurements/GetMeasurementByType?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (measurementType === undefined)
            throw new Error("The parameter 'measurementType' must be defined.");
        else if (measurementType !== null)
            url_ += "MeasurementType=" + encodeURIComponent("" + measurementType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetMeasurementByType(_response);
        });
    };
    BodyMeasurementsClient.prototype.processGetMeasurementByType = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_5 = resultData200; _i < resultData200_5.length; _i++) {
                    var item = resultData200_5[_i];
                    result200.push(BodyMeasurementDto.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return BodyMeasurementsClient;
}());
export { BodyMeasurementsClient };
var BodyWeightMeasurementsClient = /** @class */ (function () {
    function BodyWeightMeasurementsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    BodyWeightMeasurementsClient.prototype.createBodyWeightMeasurement = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/body-weight-measurements";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateBodyWeightMeasurement(_response);
        });
    };
    BodyWeightMeasurementsClient.prototype.processCreateBodyWeightMeasurement = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BodyWeightMeasurementsClient.prototype.getAllWeightMeasurements = function (clientId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/body-weight-measurements?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetAllWeightMeasurements(_response);
        });
    };
    BodyWeightMeasurementsClient.prototype.processGetAllWeightMeasurements = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_6 = resultData200; _i < resultData200_6.length; _i++) {
                    var item = resultData200_6[_i];
                    result200.push(BodyWeightDto.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BodyWeightMeasurementsClient.prototype.updateWeightMeasurement = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/body-weight-measurements/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateWeightMeasurement(_response);
        });
    };
    BodyWeightMeasurementsClient.prototype.processUpdateWeightMeasurement = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    BodyWeightMeasurementsClient.prototype.deleteWeightMeasurement = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/body-weight-measurements/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDeleteWeightMeasurement(_response);
        });
    };
    BodyWeightMeasurementsClient.prototype.processDeleteWeightMeasurement = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return BodyWeightMeasurementsClient;
}());
export { BodyWeightMeasurementsClient };
var CheckInAnswersClient = /** @class */ (function () {
    function CheckInAnswersClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    CheckInAnswersClient.prototype.createCheckInAnswer = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/check-in-answers";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateCheckInAnswer(_response);
        });
    };
    CheckInAnswersClient.prototype.processCreateCheckInAnswer = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CheckInAnswersClient.prototype.updateCheckInAnswer = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/check-in-answers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateCheckInAnswer(_response);
        });
    };
    CheckInAnswersClient.prototype.processUpdateCheckInAnswer = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CheckInAnswersClient.prototype.deleteCheckInAnswer = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/check-in-answers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDeleteCheckInAnswer(_response);
        });
    };
    CheckInAnswersClient.prototype.processDeleteCheckInAnswer = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CheckInAnswersClient.prototype.getCheckInAnswerByActivity = function (activityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/check-in-answers/GetCheckInAnswerByActivity?";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined and cannot be null.");
        else
            url_ += "ActivityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetCheckInAnswerByActivity(_response);
        });
    };
    CheckInAnswersClient.prototype.processGetCheckInAnswerByActivity = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_7 = resultData200; _i < resultData200_7.length; _i++) {
                    var item = resultData200_7[_i];
                    result200.push(CheckInAnswerDto.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CheckInAnswersClient.prototype.getCheckInAnswerByForm = function (clientFormRequestId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/check-in-answers/GetCheckInAnswerByForm?";
        if (clientFormRequestId === undefined || clientFormRequestId === null)
            throw new Error("The parameter 'clientFormRequestId' must be defined and cannot be null.");
        else
            url_ += "ClientFormRequestId=" + encodeURIComponent("" + clientFormRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetCheckInAnswerByForm(_response);
        });
    };
    CheckInAnswersClient.prototype.processGetCheckInAnswerByForm = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_8 = resultData200; _i < resultData200_8.length; _i++) {
                    var item = resultData200_8[_i];
                    result200.push(CheckInAnswerDto.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return CheckInAnswersClient;
}());
export { CheckInAnswersClient };
var ClientFormsClient = /** @class */ (function () {
    function ClientFormsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    ClientFormsClient.prototype.createClientForm = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/client-forms/create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateClientForm(_response);
        });
    };
    ClientFormsClient.prototype.processCreateClientForm = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ClientFormCreatedInfoDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientFormsClient.prototype.updateClientForm = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/client-forms/update/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateClientForm(_response);
        });
    };
    ClientFormsClient.prototype.processUpdateClientForm = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ClientFormDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientFormsClient.prototype.getClientFormCoach = function (slug, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/client-forms/coach-info?";
        if (slug === undefined)
            throw new Error("The parameter 'slug' must be defined.");
        else if (slug !== null)
            url_ += "Slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetClientFormCoach(_response);
        });
    };
    ClientFormsClient.prototype.processGetClientFormCoach = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ClientFormCoachInfoDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientFormsClient.prototype.getClientFormClient = function (slug, username, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/client-forms/client-info?";
        if (slug === undefined)
            throw new Error("The parameter 'slug' must be defined.");
        else if (slug !== null)
            url_ += "Slug=" + encodeURIComponent("" + slug) + "&";
        if (username !== undefined && username !== null)
            url_ += "Username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetClientFormClient(_response);
        });
    };
    ClientFormsClient.prototype.processGetClientFormClient = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ClientFormClientInfoDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientFormsClient.prototype.sendClientFormBatch = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/client-forms/send";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSendClientFormBatch(_response);
        });
    };
    ClientFormsClient.prototype.processSendClientFormBatch = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientFormsClient.prototype.submitClientForm = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/client-forms/submit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSubmitClientForm(_response);
        });
    };
    ClientFormsClient.prototype.processSubmitClientForm = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientFormsClient.prototype.getClientFormClientList = function (pageNumber, pageSize, clientId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/client-forms/client-list?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetClientFormClientList(_response);
        });
    };
    ClientFormsClient.prototype.processGetClientFormClientList = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfClientFormClientListDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientFormsClient.prototype.getClientFormCoachList = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/client-forms/coach-list?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetClientFormCoachList(_response);
        });
    };
    ClientFormsClient.prototype.processGetClientFormCoachList = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfClientFormCoachListDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientFormsClient.prototype.duplicateClientForm = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/client-forms/duplicate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDuplicateClientForm(_response);
        });
    };
    ClientFormsClient.prototype.processDuplicateClientForm = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ClientFormCreatedInfoDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientFormsClient.prototype.removeClientForm = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/client-forms/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemoveClientForm(_response);
        });
    };
    ClientFormsClient.prototype.processRemoveClientForm = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return ClientFormsClient;
}());
export { ClientFormsClient };
var ClientGoalsClient = /** @class */ (function () {
    function ClientGoalsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    ClientGoalsClient.prototype.getClientGoals = function (clientId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/client-goals?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetClientGoals(_response);
        });
    };
    ClientGoalsClient.prototype.processGetClientGoals = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfClientGoalDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientGoalsClient.prototype.createClientGoal = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/client-goals";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateClientGoal(_response);
        });
    };
    ClientGoalsClient.prototype.processCreateClientGoal = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientGoalsClient.prototype.update = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/client-goals/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdate(_response);
        });
    };
    ClientGoalsClient.prototype.processUpdate = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientGoalsClient.prototype.delete = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/client-goals/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDelete(_response);
        });
    };
    ClientGoalsClient.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientGoalsClient.prototype.toggleCompleted = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/client-goals/ToggleCompleted";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processToggleCompleted(_response);
        });
    };
    ClientGoalsClient.prototype.processToggleCompleted = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientGoalsClient.prototype.updateCurrentValue = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/client-goals/UpdateCurrentValue";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateCurrentValue(_response);
        });
    };
    ClientGoalsClient.prototype.processUpdateCurrentValue = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientGoalsClient.prototype.reorder = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/client-goals/Reorder";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReorder(_response);
        });
    };
    ClientGoalsClient.prototype.processReorder = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientGoalsClient.prototype.applySingleOrdinalGoal = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/client-goals/ApplySingleOrdinalGoal";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processApplySingleOrdinalGoal(_response);
        });
    };
    ClientGoalsClient.prototype.processApplySingleOrdinalGoal = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return ClientGoalsClient;
}());
export { ClientGoalsClient };
var ClientGroupsClient = /** @class */ (function () {
    function ClientGroupsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    ClientGroupsClient.prototype.updateGroupClients = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/client-groups/update-group-members";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateGroupClients(_response);
        });
    };
    ClientGroupsClient.prototype.processUpdateGroupClients = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientGroupsClient.prototype.removeGroupMember = function (groupId, memberId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/client-groups/{groupId}/{memberId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemoveGroupMember(_response);
        });
    };
    ClientGroupsClient.prototype.processRemoveGroupMember = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return ClientGroupsClient;
}());
export { ClientGroupsClient };
var ClientsClient = /** @class */ (function () {
    function ClientsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    ClientsClient.prototype.getTargetClients = function (pageNumber, pageSize, targetGroupId, targetProgramId, targetClientFormId, statuses, searchQuery, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/clients/get-target-clients?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (targetGroupId !== undefined && targetGroupId !== null)
            url_ += "TargetGroupId=" + encodeURIComponent("" + targetGroupId) + "&";
        if (targetProgramId !== undefined && targetProgramId !== null)
            url_ += "TargetProgramId=" + encodeURIComponent("" + targetProgramId) + "&";
        if (targetClientFormId !== undefined && targetClientFormId !== null)
            url_ += "TargetClientFormId=" + encodeURIComponent("" + targetClientFormId) + "&";
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(function (item) { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (searchQuery !== undefined && searchQuery !== null)
            url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetTargetClients(_response);
        });
    };
    ClientsClient.prototype.processGetTargetClients = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfClientBriefDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientsClient.prototype.getBriefClientInfo = function (username, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/clients/get-brief-client-info?";
        if (username === undefined)
            throw new Error("The parameter 'username' must be defined.");
        else if (username !== null)
            url_ += "Username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetBriefClientInfo(_response);
        });
    };
    ClientsClient.prototype.processGetBriefClientInfo = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = BriefClientInfo.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientsClient.prototype.getClients = function (pageNumber, pageSize, statuses, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/clients?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (statuses === undefined)
            throw new Error("The parameter 'statuses' must be defined.");
        else if (statuses !== null)
            statuses && statuses.forEach(function (item) { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetClients(_response);
        });
    };
    ClientsClient.prototype.processGetClients = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ClientsVm.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientsClient.prototype.getClientsList = function (statuses, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/clients/list?";
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(function (item) { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetClientsList(_response);
        });
    };
    ClientsClient.prototype.processGetClientsList = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_9 = resultData200; _i < resultData200_9.length; _i++) {
                    var item = resultData200_9[_i];
                    result200.push(ClientBriefDto.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientsClient.prototype.getClientsPaginated = function (pageNumber, pageSize, statuses, orderBy, noSample, programSlug, searchQuery, clientTagId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/clients/info-paginated?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (statuses === undefined)
            throw new Error("The parameter 'statuses' must be defined.");
        else if (statuses !== null)
            statuses && statuses.forEach(function (item) { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (orderBy === undefined || orderBy === null)
            throw new Error("The parameter 'orderBy' must be defined and cannot be null.");
        else
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (noSample !== undefined && noSample !== null)
            url_ += "NoSample=" + encodeURIComponent("" + noSample) + "&";
        if (programSlug !== undefined && programSlug !== null)
            url_ += "ProgramSlug=" + encodeURIComponent("" + programSlug) + "&";
        if (searchQuery !== undefined && searchQuery !== null)
            url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (clientTagId !== undefined && clientTagId !== null)
            url_ += "ClientTagId=" + encodeURIComponent("" + clientTagId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetClientsPaginated(_response);
        });
    };
    ClientsClient.prototype.processGetClientsPaginated = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfClientInfoDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientsClient.prototype.getClientsCount = function (statuses, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/clients/count?";
        if (statuses === undefined)
            throw new Error("The parameter 'statuses' must be defined.");
        else if (statuses !== null)
            statuses && statuses.forEach(function (item) { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetClientsCount(_response);
        });
    };
    ClientsClient.prototype.processGetClientsCount = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ClientsCountDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientsClient.prototype.getClientsStats = function (clientIds, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/clients/stats?";
        if (clientIds === undefined)
            throw new Error("The parameter 'clientIds' must be defined.");
        else if (clientIds !== null)
            clientIds && clientIds.forEach(function (item) { url_ += "ClientIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetClientsStats(_response);
        });
    };
    ClientsClient.prototype.processGetClientsStats = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_10 = resultData200; _i < resultData200_10.length; _i++) {
                    var item = resultData200_10[_i];
                    result200.push(ClientStatsDto.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientsClient.prototype.archiveClient = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/clients/archive-client";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processArchiveClient(_response);
        });
    };
    ClientsClient.prototype.processArchiveClient = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientsClient.prototype.batchArchiveClients = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/clients/batch-archive-clients";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBatchArchiveClients(_response);
        });
    };
    ClientsClient.prototype.processBatchArchiveClients = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientsClient.prototype.addClientsWithoutInvite = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/clients/add-client-without-invite";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAddClientsWithoutInvite(_response);
        });
    };
    ClientsClient.prototype.processAddClientsWithoutInvite = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = DialogInviteVm.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientsClient.prototype.revokeAddedClient = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/clients/revoke-added-client/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRevokeAddedClient(_response);
        });
    };
    ClientsClient.prototype.processRevokeAddedClient = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientsClient.prototype.deleteClient = function (clientId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/clients/delete-client?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDeleteClient(_response);
        });
    };
    ClientsClient.prototype.processDeleteClient = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientsClient.prototype.batchDeleteClients = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/clients/batch-delete-clients";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBatchDeleteClients(_response);
        });
    };
    ClientsClient.prototype.processBatchDeleteClients = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ClientsClient.prototype.generateDummyClients = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/clients/generate-dummy-clients";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGenerateDummyClients(_response);
        });
    };
    ClientsClient.prototype.processGenerateDummyClients = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = BulkClientsResponse.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return ClientsClient;
}());
export { ClientsClient };
var ClientTagsClient = /** @class */ (function () {
    function ClientTagsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    ClientTagsClient.prototype.assignTagsToClient = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/client-tags/assign";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAssignTagsToClient(_response);
        });
    };
    ClientTagsClient.prototype.processAssignTagsToClient = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return ClientTagsClient;
}());
export { ClientTagsClient };
var ComponentsClient = /** @class */ (function () {
    function ComponentsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    ComponentsClient.prototype.splitUnlinkRepeat = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/components/split-unlink-repeat";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSplitUnlinkRepeat(_response);
        });
    };
    ComponentsClient.prototype.processSplitUnlinkRepeat = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = CreatedComponentResult.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ComponentsClient.prototype.addComponentTemplate = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/components/add-template";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAddComponentTemplate(_response);
        });
    };
    ComponentsClient.prototype.processAddComponentTemplate = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ComponentsClient.prototype.archiveComponent = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/components/archive";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processArchiveComponent(_response);
        });
    };
    ComponentsClient.prototype.processArchiveComponent = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ComponentsClient.prototype.createComponent = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/components";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateComponent(_response);
        });
    };
    ComponentsClient.prototype.processCreateComponent = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = CreatedComponentResult.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ComponentsClient.prototype.getComponent = function (slug, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/components?";
        if (slug === undefined)
            throw new Error("The parameter 'slug' must be defined.");
        else if (slug !== null)
            url_ += "slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetComponent(_response);
        });
    };
    ComponentsClient.prototype.processGetComponent = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ComponentDto2.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ComponentsClient.prototype.duplicateComponent = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/components/duplicate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDuplicateComponent(_response);
        });
    };
    ComponentsClient.prototype.processDuplicateComponent = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = CreatedComponentResult.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ComponentsClient.prototype.pasteComponent = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/components/paste";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPasteComponent(_response);
        });
    };
    ComponentsClient.prototype.processPasteComponent = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = CreatedComponentResult.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ComponentsClient.prototype.removeComponent = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/components/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemoveComponent(_response);
        });
    };
    ComponentsClient.prototype.processRemoveComponent = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ComponentsClient.prototype.removeComponentTemplate = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/components/remove-template/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemoveComponentTemplate(_response);
        });
    };
    ComponentsClient.prototype.processRemoveComponentTemplate = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ComponentsClient.prototype.updateComponent = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/components/update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateComponent(_response);
        });
    };
    ComponentsClient.prototype.processUpdateComponent = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = UpdateComponentResponse.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ComponentsClient.prototype.updateComponentsLockedStatus = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/components/locked";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateComponentsLockedStatus(_response);
        });
    };
    ComponentsClient.prototype.processUpdateComponentsLockedStatus = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ComponentsClient.prototype.updateComponentsLockedStatusByProgramId = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/components/program-locked";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateComponentsLockedStatusByProgramId(_response);
        });
    };
    ComponentsClient.prototype.processUpdateComponentsLockedStatusByProgramId = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ComponentsClient.prototype.updateComponentTemplate = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/components/update-template";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateComponentTemplate(_response);
        });
    };
    ComponentsClient.prototype.processUpdateComponentTemplate = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ComponentsClient.prototype.updateDefaultIcon = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/components/default-icon";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateDefaultIcon(_response);
        });
    };
    ComponentsClient.prototype.processUpdateDefaultIcon = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ComponentsClient.prototype.getLastPublishedContent = function (componentId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/components/versions?";
        if (componentId === undefined || componentId === null)
            throw new Error("The parameter 'componentId' must be defined and cannot be null.");
        else
            url_ += "ComponentId=" + encodeURIComponent("" + componentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetLastPublishedContent(_response);
        });
    };
    ComponentsClient.prototype.processGetLastPublishedContent = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ComponentVersions.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ComponentsClient.prototype.getComponentTemplate = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/components/template?";
        if (id === undefined)
            throw new Error("The parameter 'id' must be defined.");
        else if (id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetComponentTemplate(_response);
        });
    };
    ComponentsClient.prototype.processGetComponentTemplate = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ComponentTemplateDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ComponentsClient.prototype.getComponentTemplatesWithPagination = function (pageNumber, pageSize, type, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/components/template-list?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetComponentTemplatesWithPagination(_response);
        });
    };
    ComponentsClient.prototype.processGetComponentTemplatesWithPagination = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfComponentTemplateBriefDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ComponentsClient.prototype.createComponentOverride = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/components/add-override";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateComponentOverride(_response);
        });
    };
    ComponentsClient.prototype.processCreateComponentOverride = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = CreatedOverrideResult.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ComponentsClient.prototype.removeComponentOverride = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/components/remove-override/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemoveComponentOverride(_response);
        });
    };
    ComponentsClient.prototype.processRemoveComponentOverride = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ComponentsClient.prototype.updateComponentOverride = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/components/update-override";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateComponentOverride(_response);
        });
    };
    ComponentsClient.prototype.processUpdateComponentOverride = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = UpdateComponentResponse.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return ComponentsClient;
}());
export { ComponentsClient };
var CustomAssetsClient = /** @class */ (function () {
    function CustomAssetsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    CustomAssetsClient.prototype.createCustomAsset = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/custom-assets";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateCustomAsset(_response);
        });
    };
    CustomAssetsClient.prototype.processCreateCustomAsset = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomAssetsClient.prototype.getCustomAssets = function (pageNumber, pageSize, type, searchQuery, includeShared, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/custom-assets?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (type !== undefined && type !== null)
            type && type.forEach(function (item) { url_ += "Type=" + encodeURIComponent("" + item) + "&"; });
        if (searchQuery !== undefined && searchQuery !== null)
            url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (includeShared !== undefined && includeShared !== null)
            url_ += "IncludeShared=" + encodeURIComponent("" + includeShared) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetCustomAssets(_response);
        });
    };
    CustomAssetsClient.prototype.processGetCustomAssets = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfCustomAssetDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomAssetsClient.prototype.updateAssetIds = function (chunkSize, startAssetId, entitiesToUpdateAssetId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/custom-assets/update-asset-ids?";
        if (chunkSize === undefined || chunkSize === null)
            throw new Error("The parameter 'chunkSize' must be defined and cannot be null.");
        else
            url_ += "ChunkSize=" + encodeURIComponent("" + chunkSize) + "&";
        if (startAssetId === undefined || startAssetId === null)
            throw new Error("The parameter 'startAssetId' must be defined and cannot be null.");
        else
            url_ += "StartAssetId=" + encodeURIComponent("" + startAssetId) + "&";
        if (entitiesToUpdateAssetId === undefined || entitiesToUpdateAssetId === null)
            throw new Error("The parameter 'entitiesToUpdateAssetId' must be defined and cannot be null.");
        else
            url_ += "EntitiesToUpdateAssetId=" + encodeURIComponent("" + entitiesToUpdateAssetId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateAssetIds(_response);
        });
    };
    CustomAssetsClient.prototype.processUpdateAssetIds = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomAssetsClient.prototype.getWorkoutExercises = function (pageNumber, pageSize, searchQuery, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/custom-assets/workout-exercises?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchQuery !== undefined && searchQuery !== null)
            url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetWorkoutExercises(_response);
        });
    };
    CustomAssetsClient.prototype.processGetWorkoutExercises = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfCustomAssetDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomAssetsClient.prototype.deleteExerciseCustomAsset = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/custom-assets/workout-exercises?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDeleteExerciseCustomAsset(_response);
        });
    };
    CustomAssetsClient.prototype.processDeleteExerciseCustomAsset = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomAssetsClient.prototype.updateCustomAsset = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/custom-assets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateCustomAsset(_response);
        });
    };
    CustomAssetsClient.prototype.processUpdateCustomAsset = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    CustomAssetsClient.prototype.deleteCustomAsset = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/custom-assets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDeleteCustomAsset(_response);
        });
    };
    CustomAssetsClient.prototype.processDeleteCustomAsset = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return CustomAssetsClient;
}());
export { CustomAssetsClient };
var EnrollmentsClient = /** @class */ (function () {
    function EnrollmentsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    EnrollmentsClient.prototype.getEnrollments = function (programSlug, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/enrollments/get-enrollments?";
        if (programSlug === undefined)
            throw new Error("The parameter 'programSlug' must be defined.");
        else if (programSlug !== null)
            url_ += "ProgramSlug=" + encodeURIComponent("" + programSlug) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetEnrollments(_response);
        });
    };
    EnrollmentsClient.prototype.processGetEnrollments = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = EnrollmentsVm.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    EnrollmentsClient.prototype.getProgramEnrollmentInfo = function (slug, avatarsToTake, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/enrollments/get-program-enrollment-info?";
        if (slug === undefined)
            throw new Error("The parameter 'slug' must be defined.");
        else if (slug !== null)
            url_ += "Slug=" + encodeURIComponent("" + slug) + "&";
        if (avatarsToTake === undefined || avatarsToTake === null)
            throw new Error("The parameter 'avatarsToTake' must be defined and cannot be null.");
        else
            url_ += "AvatarsToTake=" + encodeURIComponent("" + avatarsToTake) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetProgramEnrollmentInfo(_response);
        });
    };
    EnrollmentsClient.prototype.processGetProgramEnrollmentInfo = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ProgramEnrollmentsAvatarsVm.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    EnrollmentsClient.prototype.getEnrollmentsStats = function (enrollmentsIds, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/enrollments/get-enrollments-stats?";
        if (enrollmentsIds === undefined)
            throw new Error("The parameter 'enrollmentsIds' must be defined.");
        else if (enrollmentsIds !== null)
            enrollmentsIds && enrollmentsIds.forEach(function (item) { url_ += "EnrollmentsIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetEnrollmentsStats(_response);
        });
    };
    EnrollmentsClient.prototype.processGetEnrollmentsStats = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_11 = resultData200; _i < resultData200_11.length; _i++) {
                    var item = resultData200_11[_i];
                    result200.push(EnrollmentsStatsDto.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    EnrollmentsClient.prototype.getClientEnrollments = function (status, pageNumber, pageSize, clientId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/enrollments/get-client-enrollments?";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetClientEnrollments(_response);
        });
    };
    EnrollmentsClient.prototype.processGetClientEnrollments = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfClientEnrollmentDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    EnrollmentsClient.prototype.getClientEnrollmentsList = function (clientId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/enrollments/get-client-enrollments-list?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetClientEnrollmentsList(_response);
        });
    };
    EnrollmentsClient.prototype.processGetClientEnrollmentsList = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_12 = resultData200; _i < resultData200_12.length; _i++) {
                    var item = resultData200_12[_i];
                    result200.push(ClientEnrollmentDto.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    EnrollmentsClient.prototype.getClientEnrollmentsStatusCount = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/enrollments/get-client-enrollments-status-count";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetClientEnrollmentsStatusCount(_response);
        });
    };
    EnrollmentsClient.prototype.processGetClientEnrollmentsStatusCount = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = EnrollmentsStatusCountDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    EnrollmentsClient.prototype.getClientEnrollmentProgram = function (programSlug, clientId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/enrollments/get-client-enrollment-program?";
        if (programSlug === undefined || programSlug === null)
            throw new Error("The parameter 'programSlug' must be defined and cannot be null.");
        else
            url_ += "programSlug=" + encodeURIComponent("" + programSlug) + "&";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetClientEnrollmentProgram(_response);
        });
    };
    EnrollmentsClient.prototype.processGetClientEnrollmentProgram = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ProgramWeeksDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    EnrollmentsClient.prototype.getClientEnrollmentWeek = function (programSlug, weekNumber, clientId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/enrollments/get-client-enrollment-week?";
        if (programSlug === undefined || programSlug === null)
            throw new Error("The parameter 'programSlug' must be defined and cannot be null.");
        else
            url_ += "programSlug=" + encodeURIComponent("" + programSlug) + "&";
        if (weekNumber === undefined || weekNumber === null)
            throw new Error("The parameter 'weekNumber' must be defined and cannot be null.");
        else
            url_ += "weekNumber=" + encodeURIComponent("" + weekNumber) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetClientEnrollmentWeek(_response);
        });
    };
    EnrollmentsClient.prototype.processGetClientEnrollmentWeek = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ClientEnrollmentWeekDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    EnrollmentsClient.prototype.getClientEnrollmentsForCalendar = function (clientUsername, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/enrollments/get-client-enrollments-for-calendar?";
        if (clientUsername === undefined)
            throw new Error("The parameter 'clientUsername' must be defined.");
        else if (clientUsername !== null)
            url_ += "ClientUsername=" + encodeURIComponent("" + clientUsername) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetClientEnrollmentsForCalendar(_response);
        });
    };
    EnrollmentsClient.prototype.processGetClientEnrollmentsForCalendar = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_13 = resultData200; _i < resultData200_13.length; _i++) {
                    var item = resultData200_13[_i];
                    result200.push(EnrollmentsForCalendarDto.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    EnrollmentsClient.prototype.getGroupsForEnrollment = function (pageNumber, pageSize, searchQuery, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/enrollments/get-groups-for-enrollment?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchQuery !== undefined && searchQuery !== null)
            url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetGroupsForEnrollment(_response);
        });
    };
    EnrollmentsClient.prototype.processGetGroupsForEnrollment = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfEnrollGroupDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    EnrollmentsClient.prototype.batchEnrollClients = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/enrollments/batch-enroll-clients";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBatchEnrollClients(_response);
        });
    };
    EnrollmentsClient.prototype.processBatchEnrollClients = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_14 = resultData200; _i < resultData200_14.length; _i++) {
                    var item = resultData200_14[_i];
                    result200.push(item);
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    EnrollmentsClient.prototype.batchEnrollGroups = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/enrollments/batch-enroll-groups";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBatchEnrollGroups(_response);
        });
    };
    EnrollmentsClient.prototype.processBatchEnrollGroups = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_15 = resultData200; _i < resultData200_15.length; _i++) {
                    var item = resultData200_15[_i];
                    result200.push(item);
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    EnrollmentsClient.prototype.unenrollClient = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/enrollments/unenroll-client/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUnenrollClient(_response);
        });
    };
    EnrollmentsClient.prototype.processUnenrollClient = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    EnrollmentsClient.prototype.unenrollGroup = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/enrollments/unenroll-group/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUnenrollGroup(_response);
        });
    };
    EnrollmentsClient.prototype.processUnenrollGroup = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    EnrollmentsClient.prototype.unenrollEnrollClient = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/enrollments/unenroll-enroll-client";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUnenrollEnrollClient(_response);
        });
    };
    EnrollmentsClient.prototype.processUnenrollEnrollClient = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    EnrollmentsClient.prototype.createPreviewEnrollment = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/enrollments/create-preview-enrollment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreatePreviewEnrollment(_response);
        });
    };
    EnrollmentsClient.prototype.processCreatePreviewEnrollment = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    EnrollmentsClient.prototype.changeEnrollmentStartDate = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/enrollments/change-enrollment-start-date";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processChangeEnrollmentStartDate(_response);
        });
    };
    EnrollmentsClient.prototype.processChangeEnrollmentStartDate = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return EnrollmentsClient;
}());
export { EnrollmentsClient };
var GroupPostCommentsClient = /** @class */ (function () {
    function GroupPostCommentsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    GroupPostCommentsClient.prototype.createGroupPostComment = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/group-post-comments";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateGroupPostComment(_response);
        });
    };
    GroupPostCommentsClient.prototype.processCreateGroupPostComment = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    GroupPostCommentsClient.prototype.getGroupPostComments = function (groupPostId, pageNumber, pageSize, likesToTake, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/group-post-comments?";
        if (groupPostId === undefined || groupPostId === null)
            throw new Error("The parameter 'groupPostId' must be defined and cannot be null.");
        else
            url_ += "GroupPostId=" + encodeURIComponent("" + groupPostId) + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (likesToTake === undefined || likesToTake === null)
            throw new Error("The parameter 'likesToTake' must be defined and cannot be null.");
        else
            url_ += "LikesToTake=" + encodeURIComponent("" + likesToTake) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetGroupPostComments(_response);
        });
    };
    GroupPostCommentsClient.prototype.processGetGroupPostComments = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfCommentBriefDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    GroupPostCommentsClient.prototype.createReplyComment = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/group-post-comments/CreateReplyComment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateReplyComment(_response);
        });
    };
    GroupPostCommentsClient.prototype.processCreateReplyComment = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    GroupPostCommentsClient.prototype.addCommentLike = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/group-post-comments/like";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAddCommentLike(_response);
        });
    };
    GroupPostCommentsClient.prototype.processAddCommentLike = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    GroupPostCommentsClient.prototype.removeCommentLike = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/group-post-comments/removeLike";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemoveCommentLike(_response);
        });
    };
    GroupPostCommentsClient.prototype.processRemoveCommentLike = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    GroupPostCommentsClient.prototype.getCommentReplies = function (parentComentId, pageNumber, pageSize, likesToTake, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/group-post-comments/GetCommentReplies?";
        if (parentComentId === undefined || parentComentId === null)
            throw new Error("The parameter 'parentComentId' must be defined and cannot be null.");
        else
            url_ += "ParentComentId=" + encodeURIComponent("" + parentComentId) + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (likesToTake === undefined || likesToTake === null)
            throw new Error("The parameter 'likesToTake' must be defined and cannot be null.");
        else
            url_ += "LikesToTake=" + encodeURIComponent("" + likesToTake) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetCommentReplies(_response);
        });
    };
    GroupPostCommentsClient.prototype.processGetCommentReplies = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfCommentBriefDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    GroupPostCommentsClient.prototype.getCommentsWithReplies = function (groupPostId, likesToTake, pageSize, afterCursor, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/group-post-comments/get-comments-with-replies?";
        if (groupPostId === undefined || groupPostId === null)
            throw new Error("The parameter 'groupPostId' must be defined and cannot be null.");
        else
            url_ += "GroupPostId=" + encodeURIComponent("" + groupPostId) + "&";
        if (likesToTake === undefined || likesToTake === null)
            throw new Error("The parameter 'likesToTake' must be defined and cannot be null.");
        else
            url_ += "LikesToTake=" + encodeURIComponent("" + likesToTake) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (afterCursor !== undefined && afterCursor !== null)
            url_ += "AfterCursor=" + encodeURIComponent("" + afterCursor) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetCommentsWithReplies(_response);
        });
    };
    GroupPostCommentsClient.prototype.processGetCommentsWithReplies = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = CursorPaginatedListOfGroupPostCommentDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return GroupPostCommentsClient;
}());
export { GroupPostCommentsClient };
var GroupPostsClient = /** @class */ (function () {
    function GroupPostsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    GroupPostsClient.prototype.getGroupPosts = function (groupId, likesToTake, pageSize, afterCursor, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/group-posts/get-group-posts?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&";
        if (likesToTake === undefined || likesToTake === null)
            throw new Error("The parameter 'likesToTake' must be defined and cannot be null.");
        else
            url_ += "LikesToTake=" + encodeURIComponent("" + likesToTake) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (afterCursor !== undefined && afterCursor !== null)
            url_ += "AfterCursor=" + encodeURIComponent("" + afterCursor) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetGroupPosts(_response);
        });
    };
    GroupPostsClient.prototype.processGetGroupPosts = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = CursorPaginatedListOfGroupPostDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    GroupPostsClient.prototype.createGroupPost = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/group-posts";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateGroupPost(_response);
        });
    };
    GroupPostsClient.prototype.processCreateGroupPost = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = GroupPostDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    GroupPostsClient.prototype.addPostLike = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/group-posts/like";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAddPostLike(_response);
        });
    };
    GroupPostsClient.prototype.processAddPostLike = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    GroupPostsClient.prototype.removePostLike = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/group-posts/removeLike";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemovePostLike(_response);
        });
    };
    GroupPostsClient.prototype.processRemovePostLike = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    GroupPostsClient.prototype.updateGroupPost = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/group-posts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateGroupPost(_response);
        });
    };
    GroupPostsClient.prototype.processUpdateGroupPost = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    GroupPostsClient.prototype.deleteGroupPost = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/group-posts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDeleteGroupPost(_response);
        });
    };
    GroupPostsClient.prototype.processDeleteGroupPost = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return GroupPostsClient;
}());
export { GroupPostsClient };
var GroupsClient = /** @class */ (function () {
    function GroupsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    GroupsClient.prototype.getGroups = function (status, orderBy, pageNumber, pageSize, searchQueryName, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/groups?";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (orderBy === undefined || orderBy === null)
            throw new Error("The parameter 'orderBy' must be defined and cannot be null.");
        else
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchQueryName !== undefined && searchQueryName !== null)
            url_ += "SearchQueryName=" + encodeURIComponent("" + searchQueryName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetGroups(_response);
        });
    };
    GroupsClient.prototype.processGetGroups = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfGroupDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    GroupsClient.prototype.createGroup = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/groups";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateGroup(_response);
        });
    };
    GroupsClient.prototype.processCreateGroup = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = GroupCreatedInfoDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    GroupsClient.prototype.getGroupsCount = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/groups/count";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetGroupsCount(_response);
        });
    };
    GroupsClient.prototype.processGetGroupsCount = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = GroupsCountDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    GroupsClient.prototype.getGroupBySlug = function (groupSlug, membersToTake, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/groups/get-group-by-slug?";
        if (groupSlug === undefined)
            throw new Error("The parameter 'groupSlug' must be defined.");
        else if (groupSlug !== null)
            url_ += "GroupSlug=" + encodeURIComponent("" + groupSlug) + "&";
        if (membersToTake === undefined || membersToTake === null)
            throw new Error("The parameter 'membersToTake' must be defined and cannot be null.");
        else
            url_ += "MembersToTake=" + encodeURIComponent("" + membersToTake) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetGroupBySlug(_response);
        });
    };
    GroupsClient.prototype.processGetGroupBySlug = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = GroupDto2.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    GroupsClient.prototype.getGroupSettings = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/groups/settings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetGroupSettings(_response);
        });
    };
    GroupsClient.prototype.processGetGroupSettings = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = GroupSettingsDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    GroupsClient.prototype.getGroupMembers = function (groupId, pageNumber, pageSize, searchQuery, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/groups/get-group-members?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchQuery !== undefined && searchQuery !== null)
            url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetGroupMembers(_response);
        });
    };
    GroupsClient.prototype.processGetGroupMembers = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfGroupMemberDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    GroupsClient.prototype.archiveGroup = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/groups/archive-group/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processArchiveGroup(_response);
        });
    };
    GroupsClient.prototype.processArchiveGroup = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    GroupsClient.prototype.updateGroup = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateGroup(_response);
        });
    };
    GroupsClient.prototype.processUpdateGroup = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    GroupsClient.prototype.deleteGroup = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDeleteGroup(_response);
        });
    };
    GroupsClient.prototype.processDeleteGroup = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return GroupsClient;
}());
export { GroupsClient };
var InviteCodesClient = /** @class */ (function () {
    function InviteCodesClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    InviteCodesClient.prototype.getNotAssignedCode = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/invite-codes";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetNotAssignedCode(_response);
        });
    };
    InviteCodesClient.prototype.processGetNotAssignedCode = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = BaseInviteCode.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    InviteCodesClient.prototype.createInviteCode = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/invite-codes";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateInviteCode(_response);
        });
    };
    InviteCodesClient.prototype.processCreateInviteCode = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = BaseInviteCode.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    InviteCodesClient.prototype.updateInviteCodeStartDate = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/invite-codes/update-invite-code-start-date";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateInviteCodeStartDate(_response);
        });
    };
    InviteCodesClient.prototype.processUpdateInviteCodeStartDate = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    InviteCodesClient.prototype.deleteInviteCode = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/invite-codes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDeleteInviteCode(_response);
        });
    };
    InviteCodesClient.prototype.processDeleteInviteCode = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return InviteCodesClient;
}());
export { InviteCodesClient };
var InvitesClient = /** @class */ (function () {
    function InvitesClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    InvitesClient.prototype.resolveInvite = function (fbUserId, workspaceSlug, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/invites/resolve-invite?";
        if (fbUserId === undefined || fbUserId === null)
            throw new Error("The parameter 'fbUserId' must be defined and cannot be null.");
        else
            url_ += "fbUserId=" + encodeURIComponent("" + fbUserId) + "&";
        if (workspaceSlug === undefined || workspaceSlug === null)
            throw new Error("The parameter 'workspaceSlug' must be defined and cannot be null.");
        else
            url_ += "workspaceSlug=" + encodeURIComponent("" + workspaceSlug) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processResolveInvite(_response);
        });
    };
    InvitesClient.prototype.processResolveInvite = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = InviteInfoDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    InvitesClient.prototype.verifyInviteCode = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/invites/verify-invite-code";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processVerifyInviteCode(_response);
        });
    };
    InvitesClient.prototype.processVerifyInviteCode = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ValidatedInviteCodeDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    InvitesClient.prototype.clientLinkInvite = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/invites/client-link-invite";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processClientLinkInvite(_response);
        });
    };
    InvitesClient.prototype.processClientLinkInvite = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = EmailLinkResult.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    InvitesClient.prototype.batchInviteClients = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/invites/batch-invite-clients";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBatchInviteClients(_response);
        });
    };
    InvitesClient.prototype.processBatchInviteClients = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = DialogInviteVm.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    InvitesClient.prototype.inviteAddedClients = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/invites/invite-added-clients";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processInviteAddedClients(_response);
        });
    };
    InvitesClient.prototype.processInviteAddedClients = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_16 = resultData200; _i < resultData200_16.length; _i++) {
                    var item = resultData200_16[_i];
                    result200.push(InviteAddedClientDto.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    InvitesClient.prototype.resendInvite = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/invites/resend-invite";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processResendInvite(_response);
        });
    };
    InvitesClient.prototype.processResendInvite = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = EmailLinkResult.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    InvitesClient.prototype.revokeInvite = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/invites/revoke-invite/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRevokeInvite(_response);
        });
    };
    InvitesClient.prototype.processRevokeInvite = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    InvitesClient.prototype.resendClientVerificationLink = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/invites/resend-verification-link";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processResendClientVerificationLink(_response);
        });
    };
    InvitesClient.prototype.processResendClientVerificationLink = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return InvitesClient;
}());
export { InvitesClient };
var MealLoggingsClient = /** @class */ (function () {
    function MealLoggingsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    MealLoggingsClient.prototype.getMealLoggings = function (date, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/meal-loggings?";
        if (date === undefined)
            throw new Error("The parameter 'date' must be defined.");
        else if (date !== null)
            url_ += "Date=" + encodeURIComponent("" + date) + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetMealLoggings(_response);
        });
    };
    MealLoggingsClient.prototype.processGetMealLoggings = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfMealLoggingDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    MealLoggingsClient.prototype.createMealLogging = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/meal-loggings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateMealLogging(_response);
        });
    };
    MealLoggingsClient.prototype.processCreateMealLogging = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    MealLoggingsClient.prototype.getMealLoggingsById = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/meal-loggings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetMealLoggingsById(_response);
        });
    };
    MealLoggingsClient.prototype.processGetMealLoggingsById = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = MealLoggingDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    MealLoggingsClient.prototype.updateMealLogging = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/meal-loggings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateMealLogging(_response);
        });
    };
    MealLoggingsClient.prototype.processUpdateMealLogging = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    MealLoggingsClient.prototype.deleteMealLogging = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/meal-loggings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDeleteMealLogging(_response);
        });
    };
    MealLoggingsClient.prototype.processDeleteMealLogging = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return MealLoggingsClient;
}());
export { MealLoggingsClient };
var MessagesClient = /** @class */ (function () {
    function MessagesClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    MessagesClient.prototype.getMessageRecipients = function (pageNumber, pageSize, searchQuery, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/messages?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchQuery !== undefined && searchQuery !== null)
            url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetMessageRecipients(_response);
        });
    };
    MessagesClient.prototype.processGetMessageRecipients = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfRecipientsDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    MessagesClient.prototype.createMessage = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/messages/create-message";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateMessage(_response);
        });
    };
    MessagesClient.prototype.processCreateMessage = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = MessageDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    MessagesClient.prototype.createManyMessages = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/messages/create-many-messages";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateManyMessages(_response);
        });
    };
    MessagesClient.prototype.processCreateManyMessages = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return MessagesClient;
}());
export { MessagesClient };
var NotificationsClient = /** @class */ (function () {
    function NotificationsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    NotificationsClient.prototype.getNotifications = function (pageSize, afterCursor, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/notifications?";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (afterCursor !== undefined && afterCursor !== null)
            url_ += "AfterCursor=" + encodeURIComponent("" + afterCursor) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetNotifications(_response);
        });
    };
    NotificationsClient.prototype.processGetNotifications = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = CursorPaginatedListOfNotificationBriefDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    NotificationsClient.prototype.getNotification = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/notifications/get-notification/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetNotification(_response);
        });
    };
    NotificationsClient.prototype.processGetNotification = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = NotificationDto2.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    NotificationsClient.prototype.clickNotification = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/notifications/click-notification";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processClickNotification(_response);
        });
    };
    NotificationsClient.prototype.processClickNotification = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    NotificationsClient.prototype.deleteNotification = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/notifications/delete-notification/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDeleteNotification(_response);
        });
    };
    NotificationsClient.prototype.processDeleteNotification = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    NotificationsClient.prototype.readNotification = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/notifications/read-notification";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReadNotification(_response);
        });
    };
    NotificationsClient.prototype.processReadNotification = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    NotificationsClient.prototype.readAllNotifications = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/notifications/read-all-notifications";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReadAllNotifications(_response);
        });
    };
    NotificationsClient.prototype.processReadAllNotifications = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return NotificationsClient;
}());
export { NotificationsClient };
var NotificationsSettingsClient = /** @class */ (function () {
    function NotificationsSettingsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    NotificationsSettingsClient.prototype.updateSettings = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/notifications-settings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateSettings(_response);
        });
    };
    NotificationsSettingsClient.prototype.processUpdateSettings = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    NotificationsSettingsClient.prototype.getSettings = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/notifications-settings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetSettings(_response);
        });
    };
    NotificationsSettingsClient.prototype.processGetSettings = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = NotificationsSettingDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return NotificationsSettingsClient;
}());
export { NotificationsSettingsClient };
var NutritionEntriesClient = /** @class */ (function () {
    function NutritionEntriesClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    NutritionEntriesClient.prototype.getNutritions = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/nutrition-entries/get-nutritions?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetNutritions(_response);
        });
    };
    NutritionEntriesClient.prototype.processGetNutritions = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_17 = resultData200; _i < resultData200_17.length; _i++) {
                    var item = resultData200_17[_i];
                    result200.push(NutritionEntryDto.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    NutritionEntriesClient.prototype.createNutrition = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/nutrition-entries";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateNutrition(_response);
        });
    };
    NutritionEntriesClient.prototype.processCreateNutrition = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    NutritionEntriesClient.prototype.updateNutritionEntry = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/nutrition-entries/update-nutrtion-entry/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateNutritionEntry(_response);
        });
    };
    NutritionEntriesClient.prototype.processUpdateNutritionEntry = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    NutritionEntriesClient.prototype.deleteNutritionEntry = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/nutrition-entries/delete-nutrition-entry/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDeleteNutritionEntry(_response);
        });
    };
    NutritionEntriesClient.prototype.processDeleteNutritionEntry = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return NutritionEntriesClient;
}());
export { NutritionEntriesClient };
var NutritionTargetsClient = /** @class */ (function () {
    function NutritionTargetsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    NutritionTargetsClient.prototype.getNutritionTargets = function (username, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/nutrition-targets/get-nutrition-targets?";
        if (username !== undefined && username !== null)
            url_ += "Username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetNutritionTargets(_response);
        });
    };
    NutritionTargetsClient.prototype.processGetNutritionTargets = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_18 = resultData200; _i < resultData200_18.length; _i++) {
                    var item = resultData200_18[_i];
                    result200.push(NutritionTargetDto.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    NutritionTargetsClient.prototype.createNutritionsTarget = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/nutrition-targets/create-nutrition-target";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateNutritionsTarget(_response);
        });
    };
    NutritionTargetsClient.prototype.processCreateNutritionsTarget = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    NutritionTargetsClient.prototype.updateNutritionTarget = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/nutrition-targets/update-nutrition-target/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateNutritionTarget(_response);
        });
    };
    NutritionTargetsClient.prototype.processUpdateNutritionTarget = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    NutritionTargetsClient.prototype.reorderNutritionTargets = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/nutrition-targets/ReorderNutritionTargets";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReorderNutritionTargets(_response);
        });
    };
    NutritionTargetsClient.prototype.processReorderNutritionTargets = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    NutritionTargetsClient.prototype.deleteNutritionsTarget = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/nutrition-targets/delete-nutrition-target{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDeleteNutritionsTarget(_response);
        });
    };
    NutritionTargetsClient.prototype.processDeleteNutritionsTarget = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    NutritionTargetsClient.prototype.applySingleOrdinalTarget = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/nutrition-targets/ApplySingleOrdinalTarget";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processApplySingleOrdinalTarget(_response);
        });
    };
    NutritionTargetsClient.prototype.processApplySingleOrdinalTarget = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return NutritionTargetsClient;
}());
export { NutritionTargetsClient };
var ProgramFoldersClient = /** @class */ (function () {
    function ProgramFoldersClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    ProgramFoldersClient.prototype.getProgramFolders = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/program-folders";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetProgramFolders(_response);
        });
    };
    ProgramFoldersClient.prototype.processGetProgramFolders = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_19 = resultData200; _i < resultData200_19.length; _i++) {
                    var item = resultData200_19[_i];
                    result200.push(ProgramFolderDto.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ProgramFoldersClient.prototype.createProgramFolder = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/program-folders";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateProgramFolder(_response);
        });
    };
    ProgramFoldersClient.prototype.processCreateProgramFolder = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ProgramFoldersClient.prototype.updateProgramFolder = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/program-folders/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateProgramFolder(_response);
        });
    };
    ProgramFoldersClient.prototype.processUpdateProgramFolder = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ProgramFoldersClient.prototype.deleteProgramFolder = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/program-folders/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDeleteProgramFolder(_response);
        });
    };
    ProgramFoldersClient.prototype.processDeleteProgramFolder = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return ProgramFoldersClient;
}());
export { ProgramFoldersClient };
var ProgramsClient = /** @class */ (function () {
    function ProgramsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    ProgramsClient.prototype.getCoachPrograms = function (status, orderBy, clientsToTake, pageNumber, pageSize, folderId, ungrouped, searchQuery, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/programs/get-coach-programs?";
        if (status === undefined)
            throw new Error("The parameter 'status' must be defined.");
        else if (status !== null)
            status && status.forEach(function (item) { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (orderBy === undefined || orderBy === null)
            throw new Error("The parameter 'orderBy' must be defined and cannot be null.");
        else
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (clientsToTake === undefined || clientsToTake === null)
            throw new Error("The parameter 'clientsToTake' must be defined and cannot be null.");
        else
            url_ += "ClientsToTake=" + encodeURIComponent("" + clientsToTake) + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (folderId !== undefined && folderId !== null)
            url_ += "FolderId=" + encodeURIComponent("" + folderId) + "&";
        if (ungrouped !== undefined && ungrouped !== null)
            url_ += "Ungrouped=" + encodeURIComponent("" + ungrouped) + "&";
        if (searchQuery !== undefined && searchQuery !== null)
            url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetCoachPrograms(_response);
        });
    };
    ProgramsClient.prototype.processGetCoachPrograms = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfProgramDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ProgramsClient.prototype.getProgramWeeks = function (programId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/programs/get-programs-weeks?";
        if (programId === undefined || programId === null)
            throw new Error("The parameter 'programId' must be defined and cannot be null.");
        else
            url_ += "programId=" + encodeURIComponent("" + programId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetProgramWeeks(_response);
        });
    };
    ProgramsClient.prototype.processGetProgramWeeks = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ProgramWeeksInfoDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ProgramsClient.prototype.getProgramsCount = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/programs/get-programs-count";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetProgramsCount(_response);
        });
    };
    ProgramsClient.prototype.processGetProgramsCount = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ProgramsCountDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ProgramsClient.prototype.getProgramCurriculum = function (programSlug, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/programs/get-program-curriculum?";
        if (programSlug === undefined)
            throw new Error("The parameter 'programSlug' must be defined.");
        else if (programSlug !== null)
            url_ += "ProgramSlug=" + encodeURIComponent("" + programSlug) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetProgramCurriculum(_response);
        });
    };
    ProgramsClient.prototype.processGetProgramCurriculum = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = CurriculumVm.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ProgramsClient.prototype.getProgramSettings = function (slug, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/programs/get-program-settings/{slug}";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetProgramSettings(_response);
        });
    };
    ProgramsClient.prototype.processGetProgramSettings = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ProgramSettingsDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ProgramsClient.prototype.getPublishedPrograms = function (pageNumber, pageSize, searchQuery, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/programs/get-published-programs?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchQuery !== undefined && searchQuery !== null)
            url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetPublishedPrograms(_response);
        });
    };
    ProgramsClient.prototype.processGetPublishedPrograms = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfProgramEnrollDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ProgramsClient.prototype.createProgram = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/programs/create-program";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateProgram(_response);
        });
    };
    ProgramsClient.prototype.processCreateProgram = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ProgramsClient.prototype.duplicateProgram = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/programs/duplicate-program";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDuplicateProgram(_response);
        });
    };
    ProgramsClient.prototype.processDuplicateProgram = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = DuplicateProgramResponse.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ProgramsClient.prototype.archiveProgram = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/programs/archive-program";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processArchiveProgram(_response);
        });
    };
    ProgramsClient.prototype.processArchiveProgram = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ProgramsClient.prototype.restoreProgram = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/programs/restore-program";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRestoreProgram(_response);
        });
    };
    ProgramsClient.prototype.processRestoreProgram = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ProgramsClient.prototype.handleProgramFolder = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/programs/handle-program-folder";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processHandleProgramFolder(_response);
        });
    };
    ProgramsClient.prototype.processHandleProgramFolder = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ProgramsClient.prototype.updateProgram = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/programs/update-program";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateProgram(_response);
        });
    };
    ProgramsClient.prototype.processUpdateProgram = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ProgramsClient.prototype.lockProgram = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/programs/lock-program";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLockProgram(_response);
        });
    };
    ProgramsClient.prototype.processLockProgram = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ProgramsClient.prototype.unlockProgram = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/programs/unlock-program";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUnlockProgram(_response);
        });
    };
    ProgramsClient.prototype.processUnlockProgram = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return ProgramsClient;
}());
export { ProgramsClient };
var ProgramTemplatesClient = /** @class */ (function () {
    function ProgramTemplatesClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    ProgramTemplatesClient.prototype.getProgramTemplates = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/program-templates";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetProgramTemplates(_response);
        });
    };
    ProgramTemplatesClient.prototype.processGetProgramTemplates = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ProgramTemplatesVm.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ProgramTemplatesClient.prototype.useProgramTemplate = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/program-templates";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUseProgramTemplate(_response);
        });
    };
    ProgramTemplatesClient.prototype.processUseProgramTemplate = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return ProgramTemplatesClient;
}());
export { ProgramTemplatesClient };
var ProgressPhotoClient = /** @class */ (function () {
    function ProgressPhotoClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    ProgressPhotoClient.prototype.createPhotoSet = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/progress-photo";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreatePhotoSet(_response);
        });
    };
    ProgressPhotoClient.prototype.processCreatePhotoSet = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = CreatedSetIds.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ProgressPhotoClient.prototype.getPhotoSets = function (pageNumber, pageSize, clientId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/progress-photo?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetPhotoSets(_response);
        });
    };
    ProgressPhotoClient.prototype.processGetPhotoSets = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfProgressPhotoSetDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ProgressPhotoClient.prototype.updatePhotoSet = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/progress-photo/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdatePhotoSet(_response);
        });
    };
    ProgressPhotoClient.prototype.processUpdatePhotoSet = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ProgressPhotoClient.prototype.deletePhotoSet = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/progress-photo/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDeletePhotoSet(_response);
        });
    };
    ProgressPhotoClient.prototype.processDeletePhotoSet = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ProgressPhotoClient.prototype.deleteSinglePhoto = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/progress-photo/delete-single-photo/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDeleteSinglePhoto(_response);
        });
    };
    ProgressPhotoClient.prototype.processDeleteSinglePhoto = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ProgressPhotoClient.prototype.getPhotos = function (pageNumber, pageSize, clientId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/progress-photo/photo-list?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetPhotos(_response);
        });
    };
    ProgressPhotoClient.prototype.processGetPhotos = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfPaginatedProgressPhotoDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return ProgressPhotoClient;
}());
export { ProgressPhotoClient };
var StepsCountsClient = /** @class */ (function () {
    function StepsCountsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    StepsCountsClient.prototype.createStepsCount = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/steps-counts";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateStepsCount(_response);
        });
    };
    StepsCountsClient.prototype.processCreateStepsCount = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    StepsCountsClient.prototype.getAllStepsCounts = function (clientId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/steps-counts?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetAllStepsCounts(_response);
        });
    };
    StepsCountsClient.prototype.processGetAllStepsCounts = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_20 = resultData200; _i < resultData200_20.length; _i++) {
                    var item = resultData200_20[_i];
                    result200.push(StepsCountDto.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    StepsCountsClient.prototype.updateStepsCount = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/steps-counts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateStepsCount(_response);
        });
    };
    StepsCountsClient.prototype.processUpdateStepsCount = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    StepsCountsClient.prototype.deleteStepsCount = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/steps-counts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDeleteStepsCount(_response);
        });
    };
    StepsCountsClient.prototype.processDeleteStepsCount = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return StepsCountsClient;
}());
export { StepsCountsClient };
var StorageClient = /** @class */ (function () {
    function StorageClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    StorageClient.prototype.createSignedUrl = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/storage/signed-url";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateSignedUrl(_response);
        });
    };
    StorageClient.prototype.processCreateSignedUrl = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = SignedUrlVm.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    StorageClient.prototype.transcodeVideo = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/storage/transcode-video";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTranscodeVideo(_response);
        });
    };
    StorageClient.prototype.processTranscodeVideo = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = TranscodedVideoVm.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return StorageClient;
}());
export { StorageClient };
var TagsClient = /** @class */ (function () {
    function TagsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    TagsClient.prototype.getTags = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/tags";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetTags(_response);
        });
    };
    TagsClient.prototype.processGetTags = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_21 = resultData200; _i < resultData200_21.length; _i++) {
                    var item = resultData200_21[_i];
                    result200.push(TagDto.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    TagsClient.prototype.createTag = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/tags";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateTag(_response);
        });
    };
    TagsClient.prototype.processCreateTag = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    TagsClient.prototype.getTagsWithPargination = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/tags/paginated?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetTagsWithPargination(_response);
        });
    };
    TagsClient.prototype.processGetTagsWithPargination = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfTagDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    TagsClient.prototype.updateTag = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/tags/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateTag(_response);
        });
    };
    TagsClient.prototype.processUpdateTag = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    TagsClient.prototype.deleteTag = function (tagId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/tags/{tagId}";
        if (tagId === undefined || tagId === null)
            throw new Error("The parameter 'tagId' must be defined.");
        url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDeleteTag(_response);
        });
    };
    TagsClient.prototype.processDeleteTag = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return TagsClient;
}());
export { TagsClient };
var TerraUsersClient = /** @class */ (function () {
    function TerraUsersClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    TerraUsersClient.prototype.generateAuthToken = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/terra-users/generate-auth-token";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGenerateAuthToken(_response);
        });
    };
    TerraUsersClient.prototype.processGenerateAuthToken = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = TerraSdkOptionsDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    TerraUsersClient.prototype.generateWidgetSession = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/terra-users/generate-widget-session";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGenerateWidgetSession(_response);
        });
    };
    TerraUsersClient.prototype.processGenerateWidgetSession = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = TerraWidgetSessionDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return TerraUsersClient;
}());
export { TerraUsersClient };
var ThreadClient = /** @class */ (function () {
    function ThreadClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    ThreadClient.prototype.getThread = function (recipient, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/thread/get-thread?";
        if (recipient === undefined)
            throw new Error("The parameter 'recipient' must be defined.");
        else if (recipient !== null)
            url_ += "Recipient=" + encodeURIComponent("" + recipient) + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetThread(_response);
        });
    };
    ThreadClient.prototype.processGetThread = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ThreadDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ThreadClient.prototype.getThreads = function (pageNumber, pageSize, searchQuery, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/thread/get-threads?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchQuery !== undefined && searchQuery !== null)
            url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetThreads(_response);
        });
    };
    ThreadClient.prototype.processGetThreads = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfThreadsDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    ThreadClient.prototype.updateThread = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/thread/update-thread";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateThread(_response);
        });
    };
    ThreadClient.prototype.processUpdateThread = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = MessagesCountDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return ThreadClient;
}());
export { ThreadClient };
var UnsplashClient = /** @class */ (function () {
    function UnsplashClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    UnsplashClient.prototype.getUnsplashImages = function (pageNumber, pageSize, searchQuery, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/unsplash/get-unsplash-images?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchQuery !== undefined && searchQuery !== null)
            url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetUnsplashImages(_response);
        });
    };
    UnsplashClient.prototype.processGetUnsplashImages = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfUnsplashImageRecord.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UnsplashClient.prototype.trackUnsplashPhoto = function (unsplashImageId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/unsplash/track-unsplash-photo/{unsplashImageId}";
        if (unsplashImageId === undefined || unsplashImageId === null)
            throw new Error("The parameter 'unsplashImageId' must be defined.");
        url_ = url_.replace("{unsplashImageId}", encodeURIComponent("" + unsplashImageId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTrackUnsplashPhoto(_response);
        });
    };
    UnsplashClient.prototype.processTrackUnsplashPhoto = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return UnsplashClient;
}());
export { UnsplashClient };
var UrlClient = /** @class */ (function () {
    function UrlClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    UrlClient.prototype.getUrlMetadata = function (url, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/url/get-metadata?";
        if (url === undefined)
            throw new Error("The parameter 'url' must be defined.");
        else if (url !== null)
            url_ += "Url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetUrlMetadata(_response);
        });
    };
    UrlClient.prototype.processGetUrlMetadata = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = UrlMetadata.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return UrlClient;
}());
export { UrlClient };
var UserEmailsClient = /** @class */ (function () {
    function UserEmailsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    UserEmailsClient.prototype.sendEmailVerificationCode = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/user-emails/send-email-verification-code";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSendEmailVerificationCode(_response);
        });
    };
    UserEmailsClient.prototype.processSendEmailVerificationCode = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return UserEmailsClient;
}());
export { UserEmailsClient };
var UserNotesClient = /** @class */ (function () {
    function UserNotesClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    UserNotesClient.prototype.getNotesOnUser = function (userId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/user-notes?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetNotesOnUser(_response);
        });
    };
    UserNotesClient.prototype.processGetNotesOnUser = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfUserNoteContentDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UserNotesClient.prototype.createUserNote = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/user-notes";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateUserNote(_response);
        });
    };
    UserNotesClient.prototype.processCreateUserNote = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UserNotesClient.prototype.updateUserNote = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/user-notes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateUserNote(_response);
        });
    };
    UserNotesClient.prototype.processUpdateUserNote = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UserNotesClient.prototype.deleteUserNote = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/user-notes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDeleteUserNote(_response);
        });
    };
    UserNotesClient.prototype.processDeleteUserNote = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return UserNotesClient;
}());
export { UserNotesClient };
var UsersClient = /** @class */ (function () {
    function UsersClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    UsersClient.prototype.clientSignUp = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/client-sign-up";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processClientSignUp(_response);
        });
    };
    UsersClient.prototype.processClientSignUp = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = AuthBaseDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UsersClient.prototype.preCoachSignUp = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/pre-coach-sign-up";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPreCoachSignUp(_response);
        });
    };
    UsersClient.prototype.processPreCoachSignUp = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = SendEmailVerificationResponse.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UsersClient.prototype.completeCoachSignUp = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/complete-coach-sign-up";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCompleteCoachSignUp(_response);
        });
    };
    UsersClient.prototype.processCompleteCoachSignUp = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = AuthBaseDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UsersClient.prototype.signUpClientComplete = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/sign-up-client-complete";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSignUpClientComplete(_response);
        });
    };
    UsersClient.prototype.processSignUpClientComplete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UsersClient.prototype.signUpClientCompletePhoto = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/sign-up-client-complete-photo";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSignUpClientCompletePhoto(_response);
        });
    };
    UsersClient.prototype.processSignUpClientCompletePhoto = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UsersClient.prototype.signIn = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/signin";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSignIn(_response);
        });
    };
    UsersClient.prototype.processSignIn = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = AuthBaseDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UsersClient.prototype.signInWithAuthToken = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/signin-oauth";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSignInWithAuthToken(_response);
        });
    };
    UsersClient.prototype.processSignInWithAuthToken = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = CustomTokenDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UsersClient.prototype.clientSignUpWithAuthToken = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/client-sign-up-oauth";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processClientSignUpWithAuthToken(_response);
        });
    };
    UsersClient.prototype.processClientSignUpWithAuthToken = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = CustomTokenDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UsersClient.prototype.refresh = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/refresh";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRefresh(_response);
        });
    };
    UsersClient.prototype.processRefresh = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = AuthBaseDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UsersClient.prototype.signOut = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/signout";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSignOut(_response);
        });
    };
    UsersClient.prototype.processSignOut = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UsersClient.prototype.resetPassword = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/reset-password";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processResetPassword(_response);
        });
    };
    UsersClient.prototype.processResetPassword = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UsersClient.prototype.updatePasswordDate = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/update-password-date";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdatePasswordDate(_response);
        });
    };
    UsersClient.prototype.processUpdatePasswordDate = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UsersClient.prototype.verifyEmail = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/verify-email";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processVerifyEmail(_response);
        });
    };
    UsersClient.prototype.processVerifyEmail = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UsersClient.prototype.verifySignUpEmail = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/verify-sign-up-email";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processVerifySignUpEmail(_response);
        });
    };
    UsersClient.prototype.processVerifySignUpEmail = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = VerifySignUpEmailResponse.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UsersClient.prototype.updateUserProfile = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/update-user-profile/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateUserProfile(_response);
        });
    };
    UsersClient.prototype.processUpdateUserProfile = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UsersClient.prototype.updateEmail = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/update-email";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateEmail(_response);
        });
    };
    UsersClient.prototype.processUpdateEmail = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UsersClient.prototype.signInAs = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/signin-as";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSignInAs(_response);
        });
    };
    UsersClient.prototype.processSignInAs = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = AuthBaseDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UsersClient.prototype.getUserInfo = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/user-info";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetUserInfo(_response);
        });
    };
    UsersClient.prototype.processGetUserInfo = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = UserInfoDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UsersClient.prototype.adminGetUsersInfo = function (role, pageNumber, pageSize, searchQuery, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/admin-users-info?";
        if (role === undefined || role === null)
            throw new Error("The parameter 'role' must be defined and cannot be null.");
        else
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchQuery !== undefined && searchQuery !== null)
            url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdminGetUsersInfo(_response);
        });
    };
    UsersClient.prototype.processAdminGetUsersInfo = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfAdminUserInfoDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UsersClient.prototype.adminGetUserInfo = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/admin-user-info?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdminGetUserInfo(_response);
        });
    };
    UsersClient.prototype.processAdminGetUserInfo = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = UserInfoDto2.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    UsersClient.prototype.deleteUser = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDeleteUser(_response);
        });
    };
    UsersClient.prototype.processDeleteUser = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return UsersClient;
}());
export { UsersClient };
var WeeksClient = /** @class */ (function () {
    function WeeksClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    WeeksClient.prototype.addWeek = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/weeks/add-week";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAddWeek(_response);
        });
    };
    WeeksClient.prototype.processAddWeek = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    WeeksClient.prototype.moveWeek = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/weeks/move-week";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMoveWeek(_response);
        });
    };
    WeeksClient.prototype.processMoveWeek = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    WeeksClient.prototype.duplicateWeek = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/weeks/duplicate-week";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDuplicateWeek(_response);
        });
    };
    WeeksClient.prototype.processDuplicateWeek = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = DuplicateWeekResult.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    WeeksClient.prototype.updateWeekComponentsOrder = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/weeks/update-week-components-order";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateWeekComponentsOrder(_response);
        });
    };
    WeeksClient.prototype.processUpdateWeekComponentsOrder = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    WeeksClient.prototype.updateWeekDescription = function (command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/weeks/update-week-description";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateWeekDescription(_response);
        });
    };
    WeeksClient.prototype.processUpdateWeekDescription = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    WeeksClient.prototype.deleteWeek = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/weeks/delete-week/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDeleteWeek(_response);
        });
    };
    WeeksClient.prototype.processDeleteWeek = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return WeeksClient;
}());
export { WeeksClient };
var WorkoutsClient = /** @class */ (function () {
    function WorkoutsClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    WorkoutsClient.prototype.getUserExercises = function (pageNumber, pageSize, clientId, searchQuery, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/workouts/exercises?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (searchQuery !== undefined && searchQuery !== null)
            url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetUserExercises(_response);
        });
    };
    WorkoutsClient.prototype.processGetUserExercises = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfUserExerciseDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    WorkoutsClient.prototype.getUserExerciseResults = function (pageNumber, pageSize, clientId, exerciseId, exerciseTitle, clientUsername, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/workouts/exercise-results?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (exerciseId !== undefined && exerciseId !== null)
            url_ += "ExerciseId=" + encodeURIComponent("" + exerciseId) + "&";
        if (exerciseTitle !== undefined && exerciseTitle !== null)
            url_ += "ExerciseTitle=" + encodeURIComponent("" + exerciseTitle) + "&";
        if (clientUsername !== undefined && clientUsername !== null)
            url_ += "ClientUsername=" + encodeURIComponent("" + clientUsername) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetUserExerciseResults(_response);
        });
    };
    WorkoutsClient.prototype.processGetUserExerciseResults = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = PaginatedListOfExerciseResultsDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return WorkoutsClient;
}());
export { WorkoutsClient };
var WorkspacesClient = /** @class */ (function () {
    function WorkspacesClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    WorkspacesClient.prototype.getWorkspaceClientPortal = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/workspaces/workspace-client-portal";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetWorkspaceClientPortal(_response);
        });
    };
    WorkspacesClient.prototype.processGetWorkspaceClientPortal = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = GetWorkspaceClientPortalDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    WorkspacesClient.prototype.getCoachWorkspaceTheme = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/workspaces/workspace-theme";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetCoachWorkspaceTheme(_response);
        });
    };
    WorkspacesClient.prototype.processGetCoachWorkspaceTheme = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = GetCoachWorkspaceThemeDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    WorkspacesClient.prototype.updateWorkspace = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/workspaces/update-workspace/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateWorkspace(_response);
        });
    };
    WorkspacesClient.prototype.processUpdateWorkspace = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    WorkspacesClient.prototype.setWorkspaceColor = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/workspaces/set-workspace-color/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSetWorkspaceColor(_response);
        });
    };
    WorkspacesClient.prototype.processSetWorkspaceColor = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    WorkspacesClient.prototype.updateMealLoggingPromts = function (id, command, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/workspaces/update-meal-logging-promts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateMealLoggingPromts(_response);
        });
    };
    WorkspacesClient.prototype.processUpdateMealLoggingPromts = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    WorkspacesClient.prototype.getWorkspace = function (slug, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/workspaces/workspace/{slug}";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetWorkspace(_response);
        });
    };
    WorkspacesClient.prototype.processGetWorkspace = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = GetWorkspaceDto.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    WorkspacesClient.prototype.getWorkspaceTest = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/workspaces/workspace-test";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetWorkspaceTest(_response);
        });
    };
    WorkspacesClient.prototype.processGetWorkspaceTest = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return WorkspacesClient;
}());
export { WorkspacesClient };
var ActivityBriefDto = /** @class */ (function () {
    function ActivityBriefDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ActivityBriefDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.enrollmentId = _data["enrollmentId"];
            this.componentId = _data["componentId"];
            this.type = _data["type"];
            this.date = _data["date"] ? dayjs(_data["date"].toString()) : undefined;
            this.completedAt = _data["completedAt"] ? dayjs(_data["completedAt"].toString()) : undefined;
            this.submittedAt = _data["submittedAt"] ? dayjs(_data["submittedAt"].toString()) : undefined;
            this.answers = _data["answers"];
            this.feedbacksCount = _data["feedbacksCount"];
            this.editedAt = _data["editedAt"] ? dayjs(_data["editedAt"].toString()) : undefined;
            this.edited = _data["edited"];
            this.startWorkout = _data["startWorkout"];
            this.endWorkout = _data["endWorkout"];
            this.content = _data["content"];
            this.coachArchived = _data["coachArchived"];
            this.coachReadAnswers = _data["coachReadAnswers"];
            this.component = _data["component"] ? ActivityComponentDto.fromJS(_data["component"]) : undefined;
            this.displayName = _data["displayName"];
        }
    };
    ActivityBriefDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ActivityBriefDto();
        result.init(data);
        return result;
    };
    ActivityBriefDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enrollmentId"] = this.enrollmentId;
        data["componentId"] = this.componentId;
        data["type"] = this.type;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined;
        data["submittedAt"] = this.submittedAt ? this.submittedAt.toISOString() : undefined;
        data["answers"] = this.answers;
        data["feedbacksCount"] = this.feedbacksCount;
        data["editedAt"] = this.editedAt ? this.editedAt.toISOString() : undefined;
        data["edited"] = this.edited;
        data["startWorkout"] = this.startWorkout;
        data["endWorkout"] = this.endWorkout;
        data["content"] = this.content;
        data["coachArchived"] = this.coachArchived;
        data["coachReadAnswers"] = this.coachReadAnswers;
        data["component"] = this.component ? this.component.toJSON() : undefined;
        data["displayName"] = this.displayName;
        return data;
    };
    return ActivityBriefDto;
}());
export { ActivityBriefDto };
export var ActivityType;
(function (ActivityType) {
    ActivityType["PROGRAM_COMPONENT"] = "PROGRAM_COMPONENT";
    ActivityType["MEAL_LOGGING"] = "MEAL_LOGGING";
    ActivityType["CLIENT_FORM"] = "CLIENT_FORM";
    ActivityType["NUTRITION_TARGET"] = "NUTRITION_TARGET";
})(ActivityType || (ActivityType = {}));
var ActivityComponentDto = /** @class */ (function () {
    function ActivityComponentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ActivityComponentDto.prototype.init = function (_data) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.days = _data["days"];
            this.locked = _data["locked"];
            this.habitPrompt = _data["habitPrompt"];
            this.iconName = _data["iconName"];
            this.slugId = _data["slugId"];
            this.slug = _data["slug"];
        }
    };
    ActivityComponentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ActivityComponentDto();
        result.init(data);
        return result;
    };
    ActivityComponentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["days"] = this.days;
        data["locked"] = this.locked;
        data["habitPrompt"] = this.habitPrompt;
        data["iconName"] = this.iconName;
        data["slugId"] = this.slugId;
        data["slug"] = this.slug;
        return data;
    };
    return ActivityComponentDto;
}());
export { ActivityComponentDto };
export var ComponentType;
(function (ComponentType) {
    ComponentType["LESSON"] = "LESSON";
    ComponentType["HABIT"] = "HABIT";
    ComponentType["CHECKIN"] = "CHECKIN";
    ComponentType["WORKOUT"] = "WORKOUT";
    ComponentType["MESSAGE"] = "MESSAGE";
})(ComponentType || (ComponentType = {}));
var ActivitySummary = /** @class */ (function () {
    function ActivitySummary(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ActivitySummary.prototype.init = function (_data) {
        if (_data) {
            this.completion = _data["completion"] ? BaseCompletion.fromJS(_data["completion"]) : undefined;
            if (Array.isArray(_data["schedule"])) {
                this.schedule = [];
                for (var _i = 0, _a = _data["schedule"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.schedule.push(ScheduledDate.fromJS(item));
                }
            }
            this.longestStreak = _data["longestStreak"];
        }
    };
    ActivitySummary.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ActivitySummary();
        result.init(data);
        return result;
    };
    ActivitySummary.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["completion"] = this.completion ? this.completion.toJSON() : undefined;
        if (Array.isArray(this.schedule)) {
            data["schedule"] = [];
            for (var _i = 0, _a = this.schedule; _i < _a.length; _i++) {
                var item = _a[_i];
                data["schedule"].push(item.toJSON());
            }
        }
        data["longestStreak"] = this.longestStreak;
        return data;
    };
    return ActivitySummary;
}());
export { ActivitySummary };
var BaseCompletion = /** @class */ (function () {
    function BaseCompletion(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BaseCompletion.prototype.init = function (_data) {
        if (_data) {
            this.completed = _data["completed"];
            this.total = _data["total"];
            this.rate = _data["rate"];
        }
    };
    BaseCompletion.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BaseCompletion();
        result.init(data);
        return result;
    };
    BaseCompletion.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["completed"] = this.completed;
        data["total"] = this.total;
        data["rate"] = this.rate;
        return data;
    };
    return BaseCompletion;
}());
export { BaseCompletion };
var ScheduledDate = /** @class */ (function () {
    function ScheduledDate(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ScheduledDate.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? dayjs(_data["date"].toString()) : undefined;
            this.completedAt = _data["completedAt"] ? dayjs(_data["completedAt"].toString()) : undefined;
        }
    };
    ScheduledDate.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ScheduledDate();
        result.init(data);
        return result;
    };
    ScheduledDate.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined;
        return data;
    };
    return ScheduledDate;
}());
export { ScheduledDate };
var ActivitiesCompositeCursorPaginatedList = /** @class */ (function () {
    function ActivitiesCompositeCursorPaginatedList(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ActivitiesCompositeCursorPaginatedList.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ActivityDto.fromJS(item));
                }
            }
            this.nextCursor = _data["nextCursor"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    ActivitiesCompositeCursorPaginatedList.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ActivitiesCompositeCursorPaginatedList();
        result.init(data);
        return result;
    };
    ActivitiesCompositeCursorPaginatedList.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["nextCursor"] = this.nextCursor;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return ActivitiesCompositeCursorPaginatedList;
}());
export { ActivitiesCompositeCursorPaginatedList };
var HasId = /** @class */ (function () {
    function HasId(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HasId.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
        }
    };
    HasId.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'HasId' cannot be instantiated.");
    };
    HasId.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return HasId;
}());
export { HasId };
var ActivityDto = /** @class */ (function (_super) {
    __extends(ActivityDto, _super);
    function ActivityDto(data) {
        return _super.call(this, data) || this;
    }
    ActivityDto.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.enrollmentId = _data["enrollmentId"];
            this.type = _data["type"];
            this.date = _data["date"] ? dayjs(_data["date"].toString()) : undefined;
            this.completedAt = _data["completedAt"] ? dayjs(_data["completedAt"].toString()) : undefined;
            this.submittedAt = _data["submittedAt"] ? dayjs(_data["submittedAt"].toString()) : undefined;
            this.answers = _data["answers"];
            this.editedAt = _data["editedAt"] ? dayjs(_data["editedAt"].toString()) : undefined;
            this.edited = _data["edited"];
            this.startWorkout = _data["startWorkout"];
            this.endWorkout = _data["endWorkout"];
            this.content = _data["content"];
            this.coachArchived = _data["coachArchived"];
            this.coachReadAnswers = _data["coachReadAnswers"];
            this.enrollment = _data["enrollment"] ? EnrollmentProgramInfoDto.fromJS(_data["enrollment"]) : undefined;
            this.client = _data["client"] ? UserBriefInfoDto.fromJS(_data["client"]) : undefined;
            this.component = _data["component"] ? ComponentBriefDto.fromJS(_data["component"]) : undefined;
            if (Array.isArray(_data["activityFeedbacks"])) {
                this.activityFeedbacks = [];
                for (var _i = 0, _a = _data["activityFeedbacks"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.activityFeedbacks.push(ActivityFeedbackDto.fromJS(item));
                }
            }
            this.clientForm = _data["clientForm"] ? ClientFormIdDto.fromJS(_data["clientForm"]) : undefined;
            if (Array.isArray(_data["workoutExerciseResults"])) {
                this.workoutExerciseResults = [];
                for (var _b = 0, _c = _data["workoutExerciseResults"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.workoutExerciseResults.push(WorkoutExerciseResultDto.fromJS(item));
                }
            }
            if (Array.isArray(_data["metrics"])) {
                this.metrics = [];
                for (var _d = 0, _e = _data["metrics"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.metrics.push(MetricDto.fromJS(item));
                }
            }
        }
    };
    ActivityDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ActivityDto();
        result.init(data);
        return result;
    };
    ActivityDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["enrollmentId"] = this.enrollmentId;
        data["type"] = this.type;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined;
        data["submittedAt"] = this.submittedAt ? this.submittedAt.toISOString() : undefined;
        data["answers"] = this.answers;
        data["editedAt"] = this.editedAt ? this.editedAt.toISOString() : undefined;
        data["edited"] = this.edited;
        data["startWorkout"] = this.startWorkout;
        data["endWorkout"] = this.endWorkout;
        data["content"] = this.content;
        data["coachArchived"] = this.coachArchived;
        data["coachReadAnswers"] = this.coachReadAnswers;
        data["enrollment"] = this.enrollment ? this.enrollment.toJSON() : undefined;
        data["client"] = this.client ? this.client.toJSON() : undefined;
        data["component"] = this.component ? this.component.toJSON() : undefined;
        if (Array.isArray(this.activityFeedbacks)) {
            data["activityFeedbacks"] = [];
            for (var _i = 0, _a = this.activityFeedbacks; _i < _a.length; _i++) {
                var item = _a[_i];
                data["activityFeedbacks"].push(item.toJSON());
            }
        }
        data["clientForm"] = this.clientForm ? this.clientForm.toJSON() : undefined;
        if (Array.isArray(this.workoutExerciseResults)) {
            data["workoutExerciseResults"] = [];
            for (var _b = 0, _c = this.workoutExerciseResults; _b < _c.length; _b++) {
                var item = _c[_b];
                data["workoutExerciseResults"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.metrics)) {
            data["metrics"] = [];
            for (var _d = 0, _e = this.metrics; _d < _e.length; _d++) {
                var item = _e[_d];
                data["metrics"].push(item.toJSON());
            }
        }
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return ActivityDto;
}(HasId));
export { ActivityDto };
var EnrollmentProgramInfoDto = /** @class */ (function () {
    function EnrollmentProgramInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EnrollmentProgramInfoDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.program = _data["program"] ? ProgramInfoDto.fromJS(_data["program"]) : undefined;
        }
    };
    EnrollmentProgramInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EnrollmentProgramInfoDto();
        result.init(data);
        return result;
    };
    EnrollmentProgramInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["program"] = this.program ? this.program.toJSON() : undefined;
        return data;
    };
    return EnrollmentProgramInfoDto;
}());
export { EnrollmentProgramInfoDto };
var ProgramInfoDto = /** @class */ (function () {
    function ProgramInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProgramInfoDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.slug = _data["slug"];
            this.image = _data["image"];
        }
    };
    ProgramInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProgramInfoDto();
        result.init(data);
        return result;
    };
    ProgramInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["slug"] = this.slug;
        data["image"] = this.image;
        return data;
    };
    return ProgramInfoDto;
}());
export { ProgramInfoDto };
var UserBriefInfoDto = /** @class */ (function () {
    function UserBriefInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserBriefInfoDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.username = _data["username"];
            this.displayName = _data["displayName"];
            this.photoUrl = _data["photoUrl"];
            this.role = _data["role"];
        }
    };
    UserBriefInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserBriefInfoDto();
        result.init(data);
        return result;
    };
    UserBriefInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["username"] = this.username;
        data["displayName"] = this.displayName;
        data["photoUrl"] = this.photoUrl;
        data["role"] = this.role;
        return data;
    };
    return UserBriefInfoDto;
}());
export { UserBriefInfoDto };
var ComponentBriefDto = /** @class */ (function () {
    function ComponentBriefDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ComponentBriefDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.slug = _data["slug"];
            this.teaser = _data["teaser"];
            this.iconName = _data["iconName"];
            this.locked = _data["locked"];
            this.baseComponentId = _data["baseComponentId"];
        }
    };
    ComponentBriefDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ComponentBriefDto();
        result.init(data);
        return result;
    };
    ComponentBriefDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["title"] = this.title;
        data["slug"] = this.slug;
        data["teaser"] = this.teaser;
        data["iconName"] = this.iconName;
        data["locked"] = this.locked;
        data["baseComponentId"] = this.baseComponentId;
        return data;
    };
    return ComponentBriefDto;
}());
export { ComponentBriefDto };
var ActivityFeedbackDto = /** @class */ (function (_super) {
    __extends(ActivityFeedbackDto, _super);
    function ActivityFeedbackDto(data) {
        return _super.call(this, data) || this;
    }
    ActivityFeedbackDto.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.content = _data["content"];
            this.read = _data["read"];
            this.created = _data["created"] ? dayjs(_data["created"].toString()) : undefined;
            this.author = _data["author"] ? UserBriefInfoDto.fromJS(_data["author"]) : undefined;
            this.activityId = _data["activityId"];
            this.formattedFromNow = _data["formattedFromNow"];
        }
    };
    ActivityFeedbackDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ActivityFeedbackDto();
        result.init(data);
        return result;
    };
    ActivityFeedbackDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["read"] = this.read;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["author"] = this.author ? this.author.toJSON() : undefined;
        data["activityId"] = this.activityId;
        data["formattedFromNow"] = this.formattedFromNow;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return ActivityFeedbackDto;
}(HasId));
export { ActivityFeedbackDto };
var ClientFormIdDto = /** @class */ (function () {
    function ClientFormIdDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientFormIdDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.slug = _data["slug"];
        }
    };
    ClientFormIdDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientFormIdDto();
        result.init(data);
        return result;
    };
    ClientFormIdDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slug"] = this.slug;
        return data;
    };
    return ClientFormIdDto;
}());
export { ClientFormIdDto };
var WorkoutExerciseResultDto = /** @class */ (function () {
    function WorkoutExerciseResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WorkoutExerciseResultDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    };
    WorkoutExerciseResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WorkoutExerciseResultDto();
        result.init(data);
        return result;
    };
    WorkoutExerciseResultDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    };
    return WorkoutExerciseResultDto;
}());
export { WorkoutExerciseResultDto };
var MetricDto = /** @class */ (function () {
    function MetricDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MetricDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.formattedValue = _data["formattedValue"];
        }
    };
    MetricDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MetricDto();
        result.init(data);
        return result;
    };
    MetricDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["name"] = this.name;
        data["value"] = this.value;
        data["formattedValue"] = this.formattedValue;
        return data;
    };
    return MetricDto;
}());
export { MetricDto };
export var MetricSourceType;
(function (MetricSourceType) {
    MetricSourceType["BODY_WEIGHT"] = "BODY_WEIGHT";
    MetricSourceType["BODY_MEASUREMENT"] = "BODY_MEASUREMENT";
    MetricSourceType["WORKOUT_EXERCISE_RESULT"] = "WORKOUT_EXERCISE_RESULT";
    MetricSourceType["PROGRESS_PHOTO_SET"] = "PROGRESS_PHOTO_SET";
    MetricSourceType["NUTRITION_TARGET"] = "NUTRITION_TARGET";
    MetricSourceType["CHECKIN_ANSWER_BINARY"] = "CHECKIN_ANSWER_BINARY";
    MetricSourceType["CHECKIN_ANSWER_RATING_SCALE"] = "CHECKIN_ANSWER_RATING_SCALE";
    MetricSourceType["CHECKIN_ANSWER_LONG_TEXT"] = "CHECKIN_ANSWER_LONG_TEXT";
    MetricSourceType["CHECKIN_ANSWER_FILE"] = "CHECKIN_ANSWER_FILE";
    MetricSourceType["CHECKIN_ANSWER_MULTIPLE_CHOICE"] = "CHECKIN_ANSWER_MULTIPLE_CHOICE";
    MetricSourceType["CHECKIN_ANSWER_NUMBER"] = "CHECKIN_ANSWER_NUMBER";
    MetricSourceType["CHECKIN_ANSWER_SHORT_TEXT"] = "CHECKIN_ANSWER_SHORT_TEXT";
    MetricSourceType["CHECKIN_ANSWER_MULTIPLE_CHOICE_CHECKBOX"] = "CHECKIN_ANSWER_MULTIPLE_CHOICE_CHECKBOX";
    MetricSourceType["CHECKIN_ANSWER_DATE"] = "CHECKIN_ANSWER_DATE";
    MetricSourceType["CHECKIN_ANSWER_EMOJI"] = "CHECKIN_ANSWER_EMOJI";
    MetricSourceType["CHECKIN_ANSWER_STAR_RATING"] = "CHECKIN_ANSWER_STAR_RATING";
    MetricSourceType["CHECKIN_ANSWER_NUTRITION_TARGET"] = "CHECKIN_ANSWER_NUTRITION_TARGET";
})(MetricSourceType || (MetricSourceType = {}));
export var CompletionPeriod;
(function (CompletionPeriod) {
    CompletionPeriod["ALL_TIME"] = "ALL_TIME";
    CompletionPeriod["BEFORE_NOW"] = "BEFORE_NOW";
    CompletionPeriod["BEFORE_NEXT_WEEK"] = "BEFORE_NEXT_WEEK";
    CompletionPeriod["LAST_7_DAYS"] = "LAST_7_DAYS";
    CompletionPeriod["LAST_30_DAYS"] = "LAST_30_DAYS";
    CompletionPeriod["THIS_WEEK"] = "THIS_WEEK";
    CompletionPeriod["LAST_WEEK"] = "LAST_WEEK";
})(CompletionPeriod || (CompletionPeriod = {}));
export var ActivitySortType;
(function (ActivitySortType) {
    ActivitySortType["CREATED_AT_ASC"] = "CREATED_AT_ASC";
    ActivitySortType["CREATED_AT_DESC"] = "CREATED_AT_DESC";
    ActivitySortType["COMPLETED_AT_ASC"] = "COMPLETED_AT_ASC";
    ActivitySortType["COMPLETED_AT_DESC"] = "COMPLETED_AT_DESC";
    ActivitySortType["DATE_ASC"] = "DATE_ASC";
    ActivitySortType["DATE_DESC"] = "DATE_DESC";
})(ActivitySortType || (ActivitySortType = {}));
var PaginatedListOfComponentActivityDto = /** @class */ (function () {
    function PaginatedListOfComponentActivityDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfComponentActivityDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ComponentActivityDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfComponentActivityDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfComponentActivityDto();
        result.init(data);
        return result;
    };
    PaginatedListOfComponentActivityDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfComponentActivityDto;
}());
export { PaginatedListOfComponentActivityDto };
var ComponentActivityDto = /** @class */ (function () {
    function ComponentActivityDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ComponentActivityDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.enrollmentId = _data["enrollmentId"];
            this.type = _data["type"];
            this.date = _data["date"] ? dayjs(_data["date"].toString()) : undefined;
            this.completedAt = _data["completedAt"] ? dayjs(_data["completedAt"].toString()) : undefined;
            this.submittedAt = _data["submittedAt"] ? dayjs(_data["submittedAt"].toString()) : undefined;
            this.answers = _data["answers"];
            this.editedAt = _data["editedAt"] ? dayjs(_data["editedAt"].toString()) : undefined;
            this.edited = _data["edited"];
            this.coachArchived = _data["coachArchived"];
            this.coachReadAnswers = _data["coachReadAnswers"];
            this.component = _data["component"] ? ComponentDto.fromJS(_data["component"]) : undefined;
            this.program = _data["program"] ? ProgramInfoDto.fromJS(_data["program"]) : undefined;
        }
    };
    ComponentActivityDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ComponentActivityDto();
        result.init(data);
        return result;
    };
    ComponentActivityDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enrollmentId"] = this.enrollmentId;
        data["type"] = this.type;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined;
        data["submittedAt"] = this.submittedAt ? this.submittedAt.toISOString() : undefined;
        data["answers"] = this.answers;
        data["editedAt"] = this.editedAt ? this.editedAt.toISOString() : undefined;
        data["edited"] = this.edited;
        data["coachArchived"] = this.coachArchived;
        data["coachReadAnswers"] = this.coachReadAnswers;
        data["component"] = this.component ? this.component.toJSON() : undefined;
        data["program"] = this.program ? this.program.toJSON() : undefined;
        return data;
    };
    return ComponentActivityDto;
}());
export { ComponentActivityDto };
var ComponentDto = /** @class */ (function () {
    function ComponentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ComponentDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.baseComponentId = _data["baseComponentId"];
            this.iconName = _data["iconName"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.slug = _data["slug"];
            this.days = _data["days"];
            this.locked = _data["locked"];
            this.image = _data["image"];
            this.teaser = _data["teaser"];
        }
    };
    ComponentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ComponentDto();
        result.init(data);
        return result;
    };
    ComponentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["baseComponentId"] = this.baseComponentId;
        data["iconName"] = this.iconName;
        data["type"] = this.type;
        data["title"] = this.title;
        data["slug"] = this.slug;
        data["days"] = this.days;
        data["locked"] = this.locked;
        data["image"] = this.image;
        data["teaser"] = this.teaser;
        return data;
    };
    return ComponentDto;
}());
export { ComponentDto };
var UpsertActivityCommand = /** @class */ (function () {
    function UpsertActivityCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpsertActivityCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
            this.completed = _data["completed"];
            this.submitted = _data["submitted"];
            this.edited = _data["edited"];
            this.startWorkout = _data["startWorkout"];
            this.endWorkout = _data["endWorkout"];
        }
    };
    UpsertActivityCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpsertActivityCommand();
        result.init(data);
        return result;
    };
    UpsertActivityCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        data["completed"] = this.completed;
        data["submitted"] = this.submitted;
        data["edited"] = this.edited;
        data["startWorkout"] = this.startWorkout;
        data["endWorkout"] = this.endWorkout;
        return data;
    };
    return UpsertActivityCommand;
}());
export { UpsertActivityCommand };
var ToggleActivityArchivedCommand = /** @class */ (function () {
    function ToggleActivityArchivedCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ToggleActivityArchivedCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.archived = _data["archived"];
        }
    };
    ToggleActivityArchivedCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ToggleActivityArchivedCommand();
        result.init(data);
        return result;
    };
    ToggleActivityArchivedCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["archived"] = this.archived;
        return data;
    };
    return ToggleActivityArchivedCommand;
}());
export { ToggleActivityArchivedCommand };
var MarkAnswersReadCommand = /** @class */ (function () {
    function MarkAnswersReadCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MarkAnswersReadCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
        }
    };
    MarkAnswersReadCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MarkAnswersReadCommand();
        result.init(data);
        return result;
    };
    MarkAnswersReadCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return MarkAnswersReadCommand;
}());
export { MarkAnswersReadCommand };
var HabitsCheckInsActivityDto = /** @class */ (function () {
    function HabitsCheckInsActivityDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HabitsCheckInsActivityDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? dayjs(_data["date"].toString()) : undefined;
            this.completion = _data["completion"] ? ComponentCompletionDto.fromJS(_data["completion"]) : undefined;
            this.activeStreak = _data["activeStreak"];
            this.component = _data["component"] ? ComponentInfoDto.fromJS(_data["component"]) : undefined;
        }
    };
    HabitsCheckInsActivityDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HabitsCheckInsActivityDto();
        result.init(data);
        return result;
    };
    HabitsCheckInsActivityDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined;
        data["completion"] = this.completion ? this.completion.toJSON() : undefined;
        data["activeStreak"] = this.activeStreak;
        data["component"] = this.component ? this.component.toJSON() : undefined;
        return data;
    };
    return HabitsCheckInsActivityDto;
}());
export { HabitsCheckInsActivityDto };
var ComponentCompletionDto = /** @class */ (function () {
    function ComponentCompletionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ComponentCompletionDto.prototype.init = function (_data) {
        if (_data) {
            this.total = _data["total"];
            this.completed = _data["completed"];
            this.rate = _data["rate"];
        }
    };
    ComponentCompletionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ComponentCompletionDto();
        result.init(data);
        return result;
    };
    ComponentCompletionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["completed"] = this.completed;
        data["rate"] = this.rate;
        return data;
    };
    return ComponentCompletionDto;
}());
export { ComponentCompletionDto };
var ComponentInfoDto = /** @class */ (function () {
    function ComponentInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ComponentInfoDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.slug = _data["slug"];
            this.baseComponentId = _data["baseComponentId"];
        }
    };
    ComponentInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ComponentInfoDto();
        result.init(data);
        return result;
    };
    ComponentInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["title"] = this.title;
        data["slug"] = this.slug;
        data["baseComponentId"] = this.baseComponentId;
        return data;
    };
    return ComponentInfoDto;
}());
export { ComponentInfoDto };
var MealLoggingActivityDto = /** @class */ (function () {
    function MealLoggingActivityDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MealLoggingActivityDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.coachReadAnswers = _data["coachReadAnswers"];
            this.client = _data["client"] ? MealLoggingActivityBriefUserDto.fromJS(_data["client"]) : undefined;
            this.feedbacksCount = _data["feedbacksCount"];
        }
    };
    MealLoggingActivityDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MealLoggingActivityDto();
        result.init(data);
        return result;
    };
    MealLoggingActivityDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["coachReadAnswers"] = this.coachReadAnswers;
        data["client"] = this.client ? this.client.toJSON() : undefined;
        data["feedbacksCount"] = this.feedbacksCount;
        return data;
    };
    return MealLoggingActivityDto;
}());
export { MealLoggingActivityDto };
var MealLoggingActivityBriefUserDto = /** @class */ (function () {
    function MealLoggingActivityBriefUserDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MealLoggingActivityBriefUserDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.photoUrl = _data["photoUrl"];
        }
    };
    MealLoggingActivityBriefUserDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MealLoggingActivityBriefUserDto();
        result.init(data);
        return result;
    };
    MealLoggingActivityBriefUserDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["photoUrl"] = this.photoUrl;
        return data;
    };
    return MealLoggingActivityBriefUserDto;
}());
export { MealLoggingActivityBriefUserDto };
var CreateActivityFeedbackResponse = /** @class */ (function () {
    function CreateActivityFeedbackResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateActivityFeedbackResponse.prototype.init = function (_data) {
        if (_data) {
            this.feedbacksCount = _data["feedbacksCount"];
        }
    };
    CreateActivityFeedbackResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateActivityFeedbackResponse();
        result.init(data);
        return result;
    };
    CreateActivityFeedbackResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["feedbacksCount"] = this.feedbacksCount;
        return data;
    };
    return CreateActivityFeedbackResponse;
}());
export { CreateActivityFeedbackResponse };
var CreateActivityFeedbackCommand = /** @class */ (function () {
    function CreateActivityFeedbackCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateActivityFeedbackCommand.prototype.init = function (_data) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.content = _data["content"];
        }
    };
    CreateActivityFeedbackCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateActivityFeedbackCommand();
        result.init(data);
        return result;
    };
    CreateActivityFeedbackCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["content"] = this.content;
        return data;
    };
    return CreateActivityFeedbackCommand;
}());
export { CreateActivityFeedbackCommand };
var UpdateActivityFeedbackCommand = /** @class */ (function () {
    function UpdateActivityFeedbackCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateActivityFeedbackCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
        }
    };
    UpdateActivityFeedbackCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateActivityFeedbackCommand();
        result.init(data);
        return result;
    };
    UpdateActivityFeedbackCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        return data;
    };
    return UpdateActivityFeedbackCommand;
}());
export { UpdateActivityFeedbackCommand };
var PaginatedListOfProgramAdminDto = /** @class */ (function () {
    function PaginatedListOfProgramAdminDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfProgramAdminDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ProgramAdminDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfProgramAdminDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfProgramAdminDto();
        result.init(data);
        return result;
    };
    PaginatedListOfProgramAdminDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfProgramAdminDto;
}());
export { PaginatedListOfProgramAdminDto };
var ProgramAdminDto = /** @class */ (function () {
    function ProgramAdminDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProgramAdminDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.slug = _data["slug"];
            this.name = _data["name"];
            this.length = _data["length"];
            this.weeksCount = _data["weeksCount"];
            this.author = _data["author"] ? UserBriefInfoDto.fromJS(_data["author"]) : undefined;
            this.legacyEntityId = _data["legacyEntityId"];
            this.created = _data["created"] ? dayjs(_data["created"].toString()) : undefined;
            this.lastModified = _data["lastModified"] ? dayjs(_data["lastModified"].toString()) : undefined;
            this.componentDuplicatesDueRepeatCount = _data["componentDuplicatesDueRepeatCount"];
            this.componentDuplicatesSameWeekCount = _data["componentDuplicatesSameWeekCount"];
            this.componentDuplicatesBaseCount = _data["componentDuplicatesBaseCount"];
        }
    };
    ProgramAdminDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProgramAdminDto();
        result.init(data);
        return result;
    };
    ProgramAdminDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["slug"] = this.slug;
        data["name"] = this.name;
        data["length"] = this.length;
        data["weeksCount"] = this.weeksCount;
        data["author"] = this.author ? this.author.toJSON() : undefined;
        data["legacyEntityId"] = this.legacyEntityId;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined;
        data["componentDuplicatesDueRepeatCount"] = this.componentDuplicatesDueRepeatCount;
        data["componentDuplicatesSameWeekCount"] = this.componentDuplicatesSameWeekCount;
        data["componentDuplicatesBaseCount"] = this.componentDuplicatesBaseCount;
        return data;
    };
    return ProgramAdminDto;
}());
export { ProgramAdminDto };
export var ProgramStatus;
(function (ProgramStatus) {
    ProgramStatus["DRAFT"] = "DRAFT";
    ProgramStatus["PUBLISHED"] = "PUBLISHED";
    ProgramStatus["ARCHIVED"] = "ARCHIVED";
})(ProgramStatus || (ProgramStatus = {}));
var AdminStats = /** @class */ (function () {
    function AdminStats(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AdminStats.prototype.init = function (_data) {
        if (_data) {
            this.total = _data["total"];
            this.totalTouchedByUsers = _data["totalTouchedByUsers"];
            this.programTotal = _data["programTotal"];
            this.programTotalTouchedByUsers = _data["programTotalTouchedByUsers"];
            this.formRequestsCount = _data["formRequestsCount"];
            this.werCount = _data["werCount"];
            this.userExercisesCount = _data["userExercisesCount"];
            this.bodyMeasurementsCount = _data["bodyMeasurementsCount"];
            this.bodyWeightCount = _data["bodyWeightCount"];
            this.checkInAnswersCount = _data["checkInAnswersCount"];
            this.photoSetsCount = _data["photoSetsCount"];
            this.feedbackCount = _data["feedbackCount"];
        }
    };
    AdminStats.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdminStats();
        result.init(data);
        return result;
    };
    AdminStats.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["totalTouchedByUsers"] = this.totalTouchedByUsers;
        data["programTotal"] = this.programTotal;
        data["programTotalTouchedByUsers"] = this.programTotalTouchedByUsers;
        data["formRequestsCount"] = this.formRequestsCount;
        data["werCount"] = this.werCount;
        data["userExercisesCount"] = this.userExercisesCount;
        data["bodyMeasurementsCount"] = this.bodyMeasurementsCount;
        data["bodyWeightCount"] = this.bodyWeightCount;
        data["checkInAnswersCount"] = this.checkInAnswersCount;
        data["photoSetsCount"] = this.photoSetsCount;
        data["feedbackCount"] = this.feedbackCount;
        return data;
    };
    return AdminStats;
}());
export { AdminStats };
var ComponentDuplicateInfo = /** @class */ (function () {
    function ComponentDuplicateInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ComponentDuplicateInfo.prototype.init = function (_data) {
        if (_data) {
            this.rootWeekId = _data["rootWeekId"];
            this.rootWeekNum = _data["rootWeekNum"];
            this.scheduledWeekNum = _data["scheduledWeekNum"];
            this.componentId = _data["componentId"];
            this.title = _data["title"];
            this.draftTitle = _data["draftTitle"];
            this.content = _data["content"];
            this.draftContent = _data["draftContent"];
            this.days = _data["days"];
            this.duration = _data["duration"];
            this.repeat = _data["repeat"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.lastModified = _data["lastModified"] ? dayjs(_data["lastModified"].toString()) : undefined;
        }
    };
    ComponentDuplicateInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ComponentDuplicateInfo();
        result.init(data);
        return result;
    };
    ComponentDuplicateInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["rootWeekId"] = this.rootWeekId;
        data["rootWeekNum"] = this.rootWeekNum;
        data["scheduledWeekNum"] = this.scheduledWeekNum;
        data["componentId"] = this.componentId;
        data["title"] = this.title;
        data["draftTitle"] = this.draftTitle;
        data["content"] = this.content;
        data["draftContent"] = this.draftContent;
        data["days"] = this.days;
        data["duration"] = this.duration;
        data["repeat"] = this.repeat;
        data["type"] = this.type;
        data["status"] = this.status;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined;
        return data;
    };
    return ComponentDuplicateInfo;
}());
export { ComponentDuplicateInfo };
export var ComponentRepeat;
(function (ComponentRepeat) {
    ComponentRepeat["WEEKLY"] = "WEEKLY";
    ComponentRepeat["BIWEEKLY"] = "BIWEEKLY";
    ComponentRepeat["NONE"] = "NONE";
    ComponentRepeat["EVERY_3_WEEKS"] = "EVERY_3_WEEKS";
    ComponentRepeat["EVERY_4_WEEKS"] = "EVERY_4_WEEKS";
})(ComponentRepeat || (ComponentRepeat = {}));
export var ComponentStatus;
(function (ComponentStatus) {
    ComponentStatus["DRAFT"] = "DRAFT";
    ComponentStatus["PUBLISHED"] = "PUBLISHED";
    ComponentStatus["ARCHIVED"] = "ARCHIVED";
})(ComponentStatus || (ComponentStatus = {}));
var ComponentDuplicatesProgramSummary = /** @class */ (function () {
    function ComponentDuplicatesProgramSummary(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ComponentDuplicatesProgramSummary.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["dueRepeat"])) {
                this.dueRepeat = [];
                for (var _i = 0, _a = _data["dueRepeat"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.dueRepeat.push(ComponentDuplicatesGroup.fromJS(item));
                }
            }
            if (Array.isArray(_data["sameWeek"])) {
                this.sameWeek = [];
                for (var _b = 0, _c = _data["sameWeek"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.sameWeek.push(ComponentDuplicatesGroup.fromJS(item));
                }
            }
            this.dueRepeatCount = _data["dueRepeatCount"];
            this.sameWeekCount = _data["sameWeekCount"];
            this.baseCount = _data["baseCount"];
        }
    };
    ComponentDuplicatesProgramSummary.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ComponentDuplicatesProgramSummary();
        result.init(data);
        return result;
    };
    ComponentDuplicatesProgramSummary.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dueRepeat)) {
            data["dueRepeat"] = [];
            for (var _i = 0, _a = this.dueRepeat; _i < _a.length; _i++) {
                var item = _a[_i];
                data["dueRepeat"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.sameWeek)) {
            data["sameWeek"] = [];
            for (var _b = 0, _c = this.sameWeek; _b < _c.length; _b++) {
                var item = _c[_b];
                data["sameWeek"].push(item.toJSON());
            }
        }
        data["dueRepeatCount"] = this.dueRepeatCount;
        data["sameWeekCount"] = this.sameWeekCount;
        data["baseCount"] = this.baseCount;
        return data;
    };
    return ComponentDuplicatesProgramSummary;
}());
export { ComponentDuplicatesProgramSummary };
var ComponentDuplicatesGroup = /** @class */ (function () {
    function ComponentDuplicatesGroup(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ComponentDuplicatesGroup.prototype.init = function (_data) {
        if (_data) {
            this.title = _data["title"];
            this.days = _data["days"];
            if (Array.isArray(_data["duplicatesOnWeeks"])) {
                this.duplicatesOnWeeks = [];
                for (var _i = 0, _a = _data["duplicatesOnWeeks"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.duplicatesOnWeeks.push(WeekWithDuplicates.fromJS(item));
                }
            }
        }
    };
    ComponentDuplicatesGroup.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ComponentDuplicatesGroup();
        result.init(data);
        return result;
    };
    ComponentDuplicatesGroup.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["days"] = this.days;
        if (Array.isArray(this.duplicatesOnWeeks)) {
            data["duplicatesOnWeeks"] = [];
            for (var _i = 0, _a = this.duplicatesOnWeeks; _i < _a.length; _i++) {
                var item = _a[_i];
                data["duplicatesOnWeeks"].push(item.toJSON());
            }
        }
        return data;
    };
    return ComponentDuplicatesGroup;
}());
export { ComponentDuplicatesGroup };
var WeekWithDuplicates = /** @class */ (function () {
    function WeekWithDuplicates(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WeekWithDuplicates.prototype.init = function (_data) {
        if (_data) {
            this.week = _data["week"];
            this.count = _data["count"];
        }
    };
    WeekWithDuplicates.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WeekWithDuplicates();
        result.init(data);
        return result;
    };
    WeekWithDuplicates.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["week"] = this.week;
        data["count"] = this.count;
        return data;
    };
    return WeekWithDuplicates;
}());
export { WeekWithDuplicates };
var FixDuplicatesResult = /** @class */ (function () {
    function FixDuplicatesResult(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FixDuplicatesResult.prototype.init = function (_data) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.isFailure = _data["isFailure"];
            if (Array.isArray(_data["updatedActivities"])) {
                this.updatedActivities = [];
                for (var _i = 0, _a = _data["updatedActivities"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.updatedActivities.push(item);
                }
            }
            if (_data["typeFailedComponents"]) {
                this.typeFailedComponents = {};
                for (var key in _data["typeFailedComponents"]) {
                    if (_data["typeFailedComponents"].hasOwnProperty(key))
                        this.typeFailedComponents[key] = _data["typeFailedComponents"][key];
                }
            }
            if (_data["activitiesNotBySchedule"]) {
                this.activitiesNotBySchedule = {};
                for (var key in _data["activitiesNotBySchedule"]) {
                    if (_data["activitiesNotBySchedule"].hasOwnProperty(key))
                        this.activitiesNotBySchedule[key] = _data["activitiesNotBySchedule"][key];
                }
            }
        }
    };
    FixDuplicatesResult.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FixDuplicatesResult();
        result.init(data);
        return result;
    };
    FixDuplicatesResult.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["isFailure"] = this.isFailure;
        if (Array.isArray(this.updatedActivities)) {
            data["updatedActivities"] = [];
            for (var _i = 0, _a = this.updatedActivities; _i < _a.length; _i++) {
                var item = _a[_i];
                data["updatedActivities"].push(item);
            }
        }
        if (this.typeFailedComponents) {
            data["typeFailedComponents"] = {};
            for (var key in this.typeFailedComponents) {
                if (this.typeFailedComponents.hasOwnProperty(key))
                    data["typeFailedComponents"][key] = this.typeFailedComponents[key];
            }
        }
        if (this.activitiesNotBySchedule) {
            data["activitiesNotBySchedule"] = {};
            for (var key in this.activitiesNotBySchedule) {
                if (this.activitiesNotBySchedule.hasOwnProperty(key))
                    data["activitiesNotBySchedule"][key] = this.activitiesNotBySchedule[key];
            }
        }
        return data;
    };
    return FixDuplicatesResult;
}());
export { FixDuplicatesResult };
var FixComponentDuplicatesCommand = /** @class */ (function () {
    function FixComponentDuplicatesCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FixComponentDuplicatesCommand.prototype.init = function (_data) {
        if (_data) {
            this.programId = _data["programId"];
            if (Array.isArray(_data["toDelete"])) {
                this.toDelete = [];
                for (var _i = 0, _a = _data["toDelete"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.toDelete.push(item);
                }
            }
            this.replaceWith = _data["replaceWith"];
        }
    };
    FixComponentDuplicatesCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FixComponentDuplicatesCommand();
        result.init(data);
        return result;
    };
    FixComponentDuplicatesCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        if (Array.isArray(this.toDelete)) {
            data["toDelete"] = [];
            for (var _i = 0, _a = this.toDelete; _i < _a.length; _i++) {
                var item = _a[_i];
                data["toDelete"].push(item);
            }
        }
        data["replaceWith"] = this.replaceWith;
        return data;
    };
    return FixComponentDuplicatesCommand;
}());
export { FixComponentDuplicatesCommand };
var ProgramDetailsAdminDto = /** @class */ (function (_super) {
    __extends(ProgramDetailsAdminDto, _super);
    function ProgramDetailsAdminDto(data) {
        return _super.call(this, data) || this;
    }
    ProgramDetailsAdminDto.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.componentDuplicates = _data["componentDuplicates"] ? ComponentDuplicatesProgramSummary.fromJS(_data["componentDuplicates"]) : undefined;
            if (Array.isArray(_data["scheduledWeeks"])) {
                this.scheduledWeeks = [];
                for (var _i = 0, _a = _data["scheduledWeeks"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.scheduledWeeks.push(ScheduledWeek.fromJS(item));
                }
            }
            if (Array.isArray(_data["enrollments"])) {
                this.enrollments = [];
                for (var _b = 0, _c = _data["enrollments"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.enrollments.push(ProgramEnrollmentDto.fromJS(item));
                }
            }
            this.enrollmentCount = _data["enrollmentCount"];
            this.actualActivityCount = _data["actualActivityCount"];
            this.miniumExpectedActivityCount = _data["miniumExpectedActivityCount"];
            this.completedActivityCount = _data["completedActivityCount"];
            this.displayedActivityCount = _data["displayedActivityCount"];
            if (Array.isArray(_data["enrollmentRelatedActivities"])) {
                this.enrollmentRelatedActivities = [];
                for (var _d = 0, _e = _data["enrollmentRelatedActivities"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.enrollmentRelatedActivities.push(item);
                }
            }
            if (Array.isArray(_data["componentRelatedActivities"])) {
                this.componentRelatedActivities = [];
                for (var _f = 0, _g = _data["componentRelatedActivities"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.componentRelatedActivities.push(item);
                }
            }
            if (Array.isArray(_data["activitiesWithoutComponent"])) {
                this.activitiesWithoutComponent = [];
                for (var _h = 0, _j = _data["activitiesWithoutComponent"]; _h < _j.length; _h++) {
                    var item = _j[_h];
                    this.activitiesWithoutComponent.push(item);
                }
            }
            if (Array.isArray(_data["activitiesWithoutEnrollment"])) {
                this.activitiesWithoutEnrollment = [];
                for (var _k = 0, _l = _data["activitiesWithoutEnrollment"]; _k < _l.length; _k++) {
                    var item = _l[_k];
                    this.activitiesWithoutEnrollment.push(item);
                }
            }
        }
    };
    ProgramDetailsAdminDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProgramDetailsAdminDto();
        result.init(data);
        return result;
    };
    ProgramDetailsAdminDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["componentDuplicates"] = this.componentDuplicates ? this.componentDuplicates.toJSON() : undefined;
        if (Array.isArray(this.scheduledWeeks)) {
            data["scheduledWeeks"] = [];
            for (var _i = 0, _a = this.scheduledWeeks; _i < _a.length; _i++) {
                var item = _a[_i];
                data["scheduledWeeks"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.enrollments)) {
            data["enrollments"] = [];
            for (var _b = 0, _c = this.enrollments; _b < _c.length; _b++) {
                var item = _c[_b];
                data["enrollments"].push(item.toJSON());
            }
        }
        data["enrollmentCount"] = this.enrollmentCount;
        data["actualActivityCount"] = this.actualActivityCount;
        data["miniumExpectedActivityCount"] = this.miniumExpectedActivityCount;
        data["completedActivityCount"] = this.completedActivityCount;
        data["displayedActivityCount"] = this.displayedActivityCount;
        if (Array.isArray(this.enrollmentRelatedActivities)) {
            data["enrollmentRelatedActivities"] = [];
            for (var _d = 0, _e = this.enrollmentRelatedActivities; _d < _e.length; _d++) {
                var item = _e[_d];
                data["enrollmentRelatedActivities"].push(item);
            }
        }
        if (Array.isArray(this.componentRelatedActivities)) {
            data["componentRelatedActivities"] = [];
            for (var _f = 0, _g = this.componentRelatedActivities; _f < _g.length; _f++) {
                var item = _g[_f];
                data["componentRelatedActivities"].push(item);
            }
        }
        if (Array.isArray(this.activitiesWithoutComponent)) {
            data["activitiesWithoutComponent"] = [];
            for (var _h = 0, _j = this.activitiesWithoutComponent; _h < _j.length; _h++) {
                var item = _j[_h];
                data["activitiesWithoutComponent"].push(item);
            }
        }
        if (Array.isArray(this.activitiesWithoutEnrollment)) {
            data["activitiesWithoutEnrollment"] = [];
            for (var _k = 0, _l = this.activitiesWithoutEnrollment; _k < _l.length; _k++) {
                var item = _l[_k];
                data["activitiesWithoutEnrollment"].push(item);
            }
        }
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return ProgramDetailsAdminDto;
}(ProgramAdminDto));
export { ProgramDetailsAdminDto };
var ScheduledWeek = /** @class */ (function () {
    function ScheduledWeek(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ScheduledWeek.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.weekNumber = _data["weekNumber"];
            if (Array.isArray(_data["scheduledComponents"])) {
                this.scheduledComponents = [];
                for (var _i = 0, _a = _data["scheduledComponents"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.scheduledComponents.push(ScheduledComponent.fromJS(item));
                }
            }
            if (Array.isArray(_data["outOfScheduleActivities"])) {
                this.outOfScheduleActivities = [];
                for (var _b = 0, _c = _data["outOfScheduleActivities"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.outOfScheduleActivities.push(ClientActivityInfo.fromJS(item));
                }
            }
        }
    };
    ScheduledWeek.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ScheduledWeek();
        result.init(data);
        return result;
    };
    ScheduledWeek.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["weekNumber"] = this.weekNumber;
        if (Array.isArray(this.scheduledComponents)) {
            data["scheduledComponents"] = [];
            for (var _i = 0, _a = this.scheduledComponents; _i < _a.length; _i++) {
                var item = _a[_i];
                data["scheduledComponents"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.outOfScheduleActivities)) {
            data["outOfScheduleActivities"] = [];
            for (var _b = 0, _c = this.outOfScheduleActivities; _b < _c.length; _b++) {
                var item = _c[_b];
                data["outOfScheduleActivities"].push(item.toJSON());
            }
        }
        return data;
    };
    return ScheduledWeek;
}());
export { ScheduledWeek };
var ScheduledComponent = /** @class */ (function () {
    function ScheduledComponent(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ScheduledComponent.prototype.init = function (_data) {
        if (_data) {
            this.day = _data["day"];
            this.weekNumber = _data["weekNumber"];
            this.componentId = _data["componentId"];
            this.title = _data["title"];
            this.isStartingWeek = _data["isStartingWeek"];
            this.isBaseComponent = _data["isBaseComponent"];
            if (Array.isArray(_data["clients"])) {
                this.clients = [];
                for (var _i = 0, _a = _data["clients"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.clients.push(ClientActivityInfo.fromJS(item));
                }
            }
            this.isOverridingComponent = _data["isOverridingComponent"];
            this.expectedActivityCount = _data["expectedActivityCount"];
            this.actualActivityCount = _data["actualActivityCount"];
        }
    };
    ScheduledComponent.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ScheduledComponent();
        result.init(data);
        return result;
    };
    ScheduledComponent.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        data["weekNumber"] = this.weekNumber;
        data["componentId"] = this.componentId;
        data["title"] = this.title;
        data["isStartingWeek"] = this.isStartingWeek;
        data["isBaseComponent"] = this.isBaseComponent;
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (var _i = 0, _a = this.clients; _i < _a.length; _i++) {
                var item = _a[_i];
                data["clients"].push(item.toJSON());
            }
        }
        data["isOverridingComponent"] = this.isOverridingComponent;
        data["expectedActivityCount"] = this.expectedActivityCount;
        data["actualActivityCount"] = this.actualActivityCount;
        return data;
    };
    return ScheduledComponent;
}());
export { ScheduledComponent };
var ClientActivityInfo = /** @class */ (function () {
    function ClientActivityInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientActivityInfo.prototype.init = function (_data) {
        if (_data) {
            this.client = _data["client"] ? UserBriefInfoDto.fromJS(_data["client"]) : undefined;
            this.enrollmentId = _data["enrollmentId"];
            this.activity = _data["activity"] ? ActivityBriefInfo.fromJS(_data["activity"]) : undefined;
            this.dateCalculatedDay = _data["dateCalculatedDay"] ? WeekDayPair.fromJS(_data["dateCalculatedDay"]) : undefined;
            this.isMissingActivity = _data["isMissingActivity"];
        }
    };
    ClientActivityInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientActivityInfo();
        result.init(data);
        return result;
    };
    ClientActivityInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["client"] = this.client ? this.client.toJSON() : undefined;
        data["enrollmentId"] = this.enrollmentId;
        data["activity"] = this.activity ? this.activity.toJSON() : undefined;
        data["dateCalculatedDay"] = this.dateCalculatedDay ? this.dateCalculatedDay.toJSON() : undefined;
        data["isMissingActivity"] = this.isMissingActivity;
        return data;
    };
    return ClientActivityInfo;
}());
export { ClientActivityInfo };
var ActivityBriefInfo = /** @class */ (function () {
    function ActivityBriefInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ActivityBriefInfo.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.enrollmentId = _data["enrollmentId"];
            this.componentId = _data["componentId"];
            this.clientId = _data["clientId"];
            this.date = _data["date"] ? dayjs(_data["date"].toString()) : undefined;
            this.week = _data["week"];
            this.completedAt = _data["completedAt"] ? dayjs(_data["completedAt"].toString()) : undefined;
            this.coachArchived = _data["coachArchived"];
            this.answers = _data["answers"];
            this.coachReadAnswers = _data["coachReadAnswers"];
            this.submittedAt = _data["submittedAt"] ? dayjs(_data["submittedAt"].toString()) : undefined;
            this.editedAt = _data["editedAt"] ? dayjs(_data["editedAt"].toString()) : undefined;
            this.isOldApi = _data["isOldApi"];
            this.legacyEntityId = _data["legacyEntityId"];
        }
    };
    ActivityBriefInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ActivityBriefInfo();
        result.init(data);
        return result;
    };
    ActivityBriefInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enrollmentId"] = this.enrollmentId;
        data["componentId"] = this.componentId;
        data["clientId"] = this.clientId;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined;
        data["week"] = this.week;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined;
        data["coachArchived"] = this.coachArchived;
        data["answers"] = this.answers;
        data["coachReadAnswers"] = this.coachReadAnswers;
        data["submittedAt"] = this.submittedAt ? this.submittedAt.toISOString() : undefined;
        data["editedAt"] = this.editedAt ? this.editedAt.toISOString() : undefined;
        data["isOldApi"] = this.isOldApi;
        data["legacyEntityId"] = this.legacyEntityId;
        return data;
    };
    return ActivityBriefInfo;
}());
export { ActivityBriefInfo };
var WeekDayPair = /** @class */ (function () {
    function WeekDayPair(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WeekDayPair.prototype.init = function (_data) {
        if (_data) {
            this.weekNumber = _data["weekNumber"];
            this.day = _data["day"];
        }
    };
    WeekDayPair.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WeekDayPair();
        result.init(data);
        return result;
    };
    WeekDayPair.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["weekNumber"] = this.weekNumber;
        data["day"] = this.day;
        return data;
    };
    return WeekDayPair;
}());
export { WeekDayPair };
var ProgramEnrollmentDto = /** @class */ (function () {
    function ProgramEnrollmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProgramEnrollmentDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? dayjs(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? dayjs(_data["endDate"].toString()) : undefined;
            this.user = _data["user"] ? UserBriefInfoDto.fromJS(_data["user"]) : undefined;
        }
    };
    ProgramEnrollmentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProgramEnrollmentDto();
        result.init(data);
        return result;
    };
    ProgramEnrollmentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : undefined;
        data["endDate"] = this.endDate ? this.endDate.format('YYYY-MM-DD') : undefined;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        return data;
    };
    return ProgramEnrollmentDto;
}());
export { ProgramEnrollmentDto };
var PaginatedListOfExerciseCustomAssetDto = /** @class */ (function () {
    function PaginatedListOfExerciseCustomAssetDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfExerciseCustomAssetDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ExerciseCustomAssetDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfExerciseCustomAssetDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfExerciseCustomAssetDto();
        result.init(data);
        return result;
    };
    PaginatedListOfExerciseCustomAssetDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfExerciseCustomAssetDto;
}());
export { PaginatedListOfExerciseCustomAssetDto };
var ExerciseCustomAssetDto = /** @class */ (function () {
    function ExerciseCustomAssetDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExerciseCustomAssetDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.coachId = _data["coachId"];
            this.name = _data["name"];
            this.content = _data["content"];
            this.lastModified = _data["lastModified"] ? dayjs(_data["lastModified"].toString()) : undefined;
            this.created = _data["created"] ? dayjs(_data["created"].toString()) : undefined;
            this.legacyAssetId = _data["legacyAssetId"];
        }
    };
    ExerciseCustomAssetDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExerciseCustomAssetDto();
        result.init(data);
        return result;
    };
    ExerciseCustomAssetDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["coachId"] = this.coachId;
        data["name"] = this.name;
        data["content"] = this.content;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["legacyAssetId"] = this.legacyAssetId;
        return data;
    };
    return ExerciseCustomAssetDto;
}());
export { ExerciseCustomAssetDto };
export var ExerciseAssetsType;
(function (ExerciseAssetsType) {
    ExerciseAssetsType["LIBRARY"] = "LIBRARY";
    ExerciseAssetsType["PRIVATE"] = "PRIVATE";
})(ExerciseAssetsType || (ExerciseAssetsType = {}));
var UpdateAdminExerciseCustomLibraryAssetCommand = /** @class */ (function () {
    function UpdateAdminExerciseCustomLibraryAssetCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateAdminExerciseCustomLibraryAssetCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.content = _data["content"];
            this.metadata = _data["metadata"];
        }
    };
    UpdateAdminExerciseCustomLibraryAssetCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateAdminExerciseCustomLibraryAssetCommand();
        result.init(data);
        return result;
    };
    UpdateAdminExerciseCustomLibraryAssetCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["content"] = this.content;
        data["metadata"] = this.metadata;
        return data;
    };
    return UpdateAdminExerciseCustomLibraryAssetCommand;
}());
export { UpdateAdminExerciseCustomLibraryAssetCommand };
var CreateAdminExerciseCustomLibraryAssetCommand = /** @class */ (function () {
    function CreateAdminExerciseCustomLibraryAssetCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateAdminExerciseCustomLibraryAssetCommand.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.content = _data["content"];
            this.metadata = _data["metadata"];
        }
    };
    CreateAdminExerciseCustomLibraryAssetCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateAdminExerciseCustomLibraryAssetCommand();
        result.init(data);
        return result;
    };
    CreateAdminExerciseCustomLibraryAssetCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["content"] = this.content;
        data["metadata"] = this.metadata;
        return data;
    };
    return CreateAdminExerciseCustomLibraryAssetCommand;
}());
export { CreateAdminExerciseCustomLibraryAssetCommand };
var RegenerateActivitiesCommand = /** @class */ (function () {
    function RegenerateActivitiesCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegenerateActivitiesCommand.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["enrollmentIds"])) {
                this.enrollmentIds = [];
                for (var _i = 0, _a = _data["enrollmentIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.enrollmentIds.push(item);
                }
            }
        }
    };
    RegenerateActivitiesCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegenerateActivitiesCommand();
        result.init(data);
        return result;
    };
    RegenerateActivitiesCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.enrollmentIds)) {
            data["enrollmentIds"] = [];
            for (var _i = 0, _a = this.enrollmentIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["enrollmentIds"].push(item);
            }
        }
        return data;
    };
    return RegenerateActivitiesCommand;
}());
export { RegenerateActivitiesCommand };
var FixProgramLengthCommand = /** @class */ (function () {
    function FixProgramLengthCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FixProgramLengthCommand.prototype.init = function (_data) {
        if (_data) {
            this.programId = _data["programId"];
        }
    };
    FixProgramLengthCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FixProgramLengthCommand();
        result.init(data);
        return result;
    };
    FixProgramLengthCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        return data;
    };
    return FixProgramLengthCommand;
}());
export { FixProgramLengthCommand };
var SendAnalyticsCommand = /** @class */ (function () {
    function SendAnalyticsCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SendAnalyticsCommand.prototype.init = function (_data) {
        if (_data) {
            this.type = _data["type"];
            this.payload = _data["payload"];
        }
    };
    SendAnalyticsCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SendAnalyticsCommand();
        result.init(data);
        return result;
    };
    SendAnalyticsCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["payload"] = this.payload;
        return data;
    };
    return SendAnalyticsCommand;
}());
export { SendAnalyticsCommand };
export var AnalyticsRequestType;
(function (AnalyticsRequestType) {
    AnalyticsRequestType["PAGE"] = "PAGE";
    AnalyticsRequestType["IDENTIFY"] = "IDENTIFY";
    AnalyticsRequestType["TRACK"] = "TRACK";
    AnalyticsRequestType["DEVICE"] = "DEVICE";
})(AnalyticsRequestType || (AnalyticsRequestType = {}));
var GetSubAccountsVm = /** @class */ (function () {
    function GetSubAccountsVm(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetSubAccountsVm.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["notFoundEmails"])) {
                this.notFoundEmails = [];
                for (var _i = 0, _a = _data["notFoundEmails"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.notFoundEmails.push(item);
                }
            }
            this.notFoundCount = _data["notFoundCount"];
        }
    };
    GetSubAccountsVm.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetSubAccountsVm();
        result.init(data);
        return result;
    };
    GetSubAccountsVm.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notFoundEmails)) {
            data["notFoundEmails"] = [];
            for (var _i = 0, _a = this.notFoundEmails; _i < _a.length; _i++) {
                var item = _a[_i];
                data["notFoundEmails"].push(item);
            }
        }
        data["notFoundCount"] = this.notFoundCount;
        return data;
    };
    return GetSubAccountsVm;
}());
export { GetSubAccountsVm };
var PauseAllSubAccountForLapsedCoachesCommand = /** @class */ (function () {
    function PauseAllSubAccountForLapsedCoachesCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PauseAllSubAccountForLapsedCoachesCommand.prototype.init = function (_data) {
        if (_data) {
            this.userIdFrom = _data["userIdFrom"];
            this.userIdTo = _data["userIdTo"];
        }
    };
    PauseAllSubAccountForLapsedCoachesCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PauseAllSubAccountForLapsedCoachesCommand();
        result.init(data);
        return result;
    };
    PauseAllSubAccountForLapsedCoachesCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userIdFrom"] = this.userIdFrom;
        data["userIdTo"] = this.userIdTo;
        return data;
    };
    return PauseAllSubAccountForLapsedCoachesCommand;
}());
export { PauseAllSubAccountForLapsedCoachesCommand };
var CreateSubAccountResponse = /** @class */ (function () {
    function CreateSubAccountResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateSubAccountResponse.prototype.init = function (_data) {
        if (_data) {
            this.alreadyExists = _data["alreadyExists"];
        }
    };
    CreateSubAccountResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateSubAccountResponse();
        result.init(data);
        return result;
    };
    CreateSubAccountResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["alreadyExists"] = this.alreadyExists;
        return data;
    };
    return CreateSubAccountResponse;
}());
export { CreateSubAccountResponse };
var CreateSubAccountForExistingUserCommand = /** @class */ (function () {
    function CreateSubAccountForExistingUserCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateSubAccountForExistingUserCommand.prototype.init = function (_data) {
        if (_data) {
            this.coachId = _data["coachId"];
        }
    };
    CreateSubAccountForExistingUserCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateSubAccountForExistingUserCommand();
        result.init(data);
        return result;
    };
    CreateSubAccountForExistingUserCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["coachId"] = this.coachId;
        return data;
    };
    return CreateSubAccountForExistingUserCommand;
}());
export { CreateSubAccountForExistingUserCommand };
var BillingAddressDataCommand = /** @class */ (function () {
    function BillingAddressDataCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BillingAddressDataCommand.prototype.init = function (_data) {
        if (_data) {
            this.street = _data["street"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
        }
    };
    BillingAddressDataCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BillingAddressDataCommand();
        result.init(data);
        return result;
    };
    BillingAddressDataCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        return data;
    };
    return BillingAddressDataCommand;
}());
export { BillingAddressDataCommand };
var CreateBillingAddressCommand = /** @class */ (function (_super) {
    __extends(CreateBillingAddressCommand, _super);
    function CreateBillingAddressCommand(data) {
        return _super.call(this, data) || this;
    }
    CreateBillingAddressCommand.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.password = _data["password"];
        }
    };
    CreateBillingAddressCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateBillingAddressCommand();
        result.init(data);
        return result;
    };
    CreateBillingAddressCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return CreateBillingAddressCommand;
}(BillingAddressDataCommand));
export { CreateBillingAddressCommand };
var UpdateBillingAddressCommand = /** @class */ (function (_super) {
    __extends(UpdateBillingAddressCommand, _super);
    function UpdateBillingAddressCommand(data) {
        return _super.call(this, data) || this;
    }
    UpdateBillingAddressCommand.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
    };
    UpdateBillingAddressCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateBillingAddressCommand();
        result.init(data);
        return result;
    };
    UpdateBillingAddressCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return UpdateBillingAddressCommand;
}(BillingAddressDataCommand));
export { UpdateBillingAddressCommand };
var ResendGoHighLevelEmailCommand = /** @class */ (function () {
    function ResendGoHighLevelEmailCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResendGoHighLevelEmailCommand.prototype.init = function (_data) {
    };
    ResendGoHighLevelEmailCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResendGoHighLevelEmailCommand();
        result.init(data);
        return result;
    };
    ResendGoHighLevelEmailCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        return data;
    };
    return ResendGoHighLevelEmailCommand;
}());
export { ResendGoHighLevelEmailCommand };
var PauseAllSubAccountForLapsedCoachesResponse = /** @class */ (function () {
    function PauseAllSubAccountForLapsedCoachesResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PauseAllSubAccountForLapsedCoachesResponse.prototype.init = function (_data) {
        if (_data) {
            this.successUserCount = _data["successUserCount"];
            this.failedUserCount = _data["failedUserCount"];
            if (Array.isArray(_data["failedUserIds"])) {
                this.failedUserIds = [];
                for (var _i = 0, _a = _data["failedUserIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.failedUserIds.push(item);
                }
            }
        }
    };
    PauseAllSubAccountForLapsedCoachesResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PauseAllSubAccountForLapsedCoachesResponse();
        result.init(data);
        return result;
    };
    PauseAllSubAccountForLapsedCoachesResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["successUserCount"] = this.successUserCount;
        data["failedUserCount"] = this.failedUserCount;
        if (Array.isArray(this.failedUserIds)) {
            data["failedUserIds"] = [];
            for (var _i = 0, _a = this.failedUserIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["failedUserIds"].push(item);
            }
        }
        return data;
    };
    return PauseAllSubAccountForLapsedCoachesResponse;
}());
export { PauseAllSubAccountForLapsedCoachesResponse };
var UpdateUserGHLAccountStateCommand = /** @class */ (function () {
    function UpdateUserGHLAccountStateCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateUserGHLAccountStateCommand.prototype.init = function (_data) {
        if (_data) {
            this.userIdFrom = _data["userIdFrom"];
            this.userIdTo = _data["userIdTo"];
        }
    };
    UpdateUserGHLAccountStateCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateUserGHLAccountStateCommand();
        result.init(data);
        return result;
    };
    UpdateUserGHLAccountStateCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userIdFrom"] = this.userIdFrom;
        data["userIdTo"] = this.userIdTo;
        return data;
    };
    return UpdateUserGHLAccountStateCommand;
}());
export { UpdateUserGHLAccountStateCommand };
var ToggleStopSubAccountCommand = /** @class */ (function () {
    function ToggleStopSubAccountCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ToggleStopSubAccountCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.pause = _data["pause"];
        }
    };
    ToggleStopSubAccountCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ToggleStopSubAccountCommand();
        result.init(data);
        return result;
    };
    ToggleStopSubAccountCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pause"] = this.pause;
        return data;
    };
    return ToggleStopSubAccountCommand;
}());
export { ToggleStopSubAccountCommand };
var HostedInvoiceUrlDto = /** @class */ (function () {
    function HostedInvoiceUrlDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HostedInvoiceUrlDto.prototype.init = function (_data) {
        if (_data) {
            this.hostedInvoiceUrl = _data["hostedInvoiceUrl"];
        }
    };
    HostedInvoiceUrlDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HostedInvoiceUrlDto();
        result.init(data);
        return result;
    };
    HostedInvoiceUrlDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["hostedInvoiceUrl"] = this.hostedInvoiceUrl;
        return data;
    };
    return HostedInvoiceUrlDto;
}());
export { HostedInvoiceUrlDto };
var SubscriptionStatusDto = /** @class */ (function () {
    function SubscriptionStatusDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SubscriptionStatusDto.prototype.init = function (_data) {
        if (_data) {
            this.status = _data["status"];
        }
    };
    SubscriptionStatusDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SubscriptionStatusDto();
        result.init(data);
        return result;
    };
    SubscriptionStatusDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    };
    return SubscriptionStatusDto;
}());
export { SubscriptionStatusDto };
var ClientSecretDto = /** @class */ (function () {
    function ClientSecretDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientSecretDto.prototype.init = function (_data) {
        if (_data) {
            this.clientSecret = _data["clientSecret"];
        }
    };
    ClientSecretDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientSecretDto();
        result.init(data);
        return result;
    };
    ClientSecretDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientSecret"] = this.clientSecret;
        return data;
    };
    return ClientSecretDto;
}());
export { ClientSecretDto };
var UpdateUserSubscriptionCommand = /** @class */ (function () {
    function UpdateUserSubscriptionCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateUserSubscriptionCommand.prototype.init = function (_data) {
        if (_data) {
            this.plan = _data["plan"];
        }
    };
    UpdateUserSubscriptionCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateUserSubscriptionCommand();
        result.init(data);
        return result;
    };
    UpdateUserSubscriptionCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["plan"] = this.plan;
        return data;
    };
    return UpdateUserSubscriptionCommand;
}());
export { UpdateUserSubscriptionCommand };
export var Plan;
(function (Plan) {
    Plan["FREE"] = "FREE";
    Plan["STARTER"] = "STARTER";
    Plan["PRO"] = "PRO";
    Plan["PROMO"] = "PROMO";
    Plan["UP_TO_5"] = "UP_TO_5";
    Plan["UP_TO_15"] = "UP_TO_15";
    Plan["UP_TO_30"] = "UP_TO_30";
    Plan["UP_TO_50"] = "UP_TO_50";
    Plan["UP_TO_75"] = "UP_TO_75";
    Plan["UP_TO_100"] = "UP_TO_100";
    Plan["UP_TO_200"] = "UP_TO_200";
    Plan["UP_TO_INFINITY"] = "UP_TO_INFINITY";
    Plan["UP_TO_UNLIMITED"] = "UP_TO_UNLIMITED";
    Plan["YEARLY_UP_TO_50"] = "YEARLY_UP_TO_50";
    Plan["YEARLY_UP_TO_100"] = "YEARLY_UP_TO_100";
    Plan["YEARLY_UP_TO_200"] = "YEARLY_UP_TO_200";
    Plan["YEARLY_UNLIMITED"] = "YEARLY_UNLIMITED";
    Plan["CustomBrandedApp"] = "CustomBrandedApp";
})(Plan || (Plan = {}));
var CreateCheckoutSessionDto = /** @class */ (function () {
    function CreateCheckoutSessionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateCheckoutSessionDto.prototype.init = function (_data) {
        if (_data) {
            this.sessionId = _data["sessionId"];
        }
    };
    CreateCheckoutSessionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateCheckoutSessionDto();
        result.init(data);
        return result;
    };
    CreateCheckoutSessionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        return data;
    };
    return CreateCheckoutSessionDto;
}());
export { CreateCheckoutSessionDto };
var ContinueOldPlanCommand = /** @class */ (function () {
    function ContinueOldPlanCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ContinueOldPlanCommand.prototype.init = function (_data) {
        if (_data) {
            this.successUrl = _data["successUrl"];
            this.cancelUrl = _data["cancelUrl"];
        }
    };
    ContinueOldPlanCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ContinueOldPlanCommand();
        result.init(data);
        return result;
    };
    ContinueOldPlanCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["successUrl"] = this.successUrl;
        data["cancelUrl"] = this.cancelUrl;
        return data;
    };
    return ContinueOldPlanCommand;
}());
export { ContinueOldPlanCommand };
var CreateCheckoutSessionCommand = /** @class */ (function () {
    function CreateCheckoutSessionCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateCheckoutSessionCommand.prototype.init = function (_data) {
        if (_data) {
            this.plan = _data["plan"];
            this.successUrl = _data["successUrl"];
            this.cancelUrl = _data["cancelUrl"];
        }
    };
    CreateCheckoutSessionCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateCheckoutSessionCommand();
        result.init(data);
        return result;
    };
    CreateCheckoutSessionCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["plan"] = this.plan;
        data["successUrl"] = this.successUrl;
        data["cancelUrl"] = this.cancelUrl;
        return data;
    };
    return CreateCheckoutSessionCommand;
}());
export { CreateCheckoutSessionCommand };
var CreateSignUpCheckoutSessionCommand = /** @class */ (function () {
    function CreateSignUpCheckoutSessionCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateSignUpCheckoutSessionCommand.prototype.init = function (_data) {
        if (_data) {
            this.plan = _data["plan"];
            this.successUrl = _data["successUrl"];
            this.cancelUrl = _data["cancelUrl"];
        }
    };
    CreateSignUpCheckoutSessionCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateSignUpCheckoutSessionCommand();
        result.init(data);
        return result;
    };
    CreateSignUpCheckoutSessionCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["plan"] = this.plan;
        data["successUrl"] = this.successUrl;
        data["cancelUrl"] = this.cancelUrl;
        return data;
    };
    return CreateSignUpCheckoutSessionCommand;
}());
export { CreateSignUpCheckoutSessionCommand };
var SessionUrlDto = /** @class */ (function () {
    function SessionUrlDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SessionUrlDto.prototype.init = function (_data) {
        if (_data) {
            this.sessionUrl = _data["sessionUrl"];
        }
    };
    SessionUrlDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SessionUrlDto();
        result.init(data);
        return result;
    };
    SessionUrlDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sessionUrl"] = this.sessionUrl;
        return data;
    };
    return SessionUrlDto;
}());
export { SessionUrlDto };
var CreateCustomerPortalSessionCommand = /** @class */ (function () {
    function CreateCustomerPortalSessionCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateCustomerPortalSessionCommand.prototype.init = function (_data) {
        if (_data) {
            this.customerPortalFlowType = _data["customerPortalFlowType"];
            this.plan = _data["plan"];
            this.successUrl = _data["successUrl"];
        }
    };
    CreateCustomerPortalSessionCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateCustomerPortalSessionCommand();
        result.init(data);
        return result;
    };
    CreateCustomerPortalSessionCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["customerPortalFlowType"] = this.customerPortalFlowType;
        data["plan"] = this.plan;
        data["successUrl"] = this.successUrl;
        return data;
    };
    return CreateCustomerPortalSessionCommand;
}());
export { CreateCustomerPortalSessionCommand };
export var CustomerPortalFlowType;
(function (CustomerPortalFlowType) {
    CustomerPortalFlowType["Payment_method_update"] = "payment_method_update";
    CustomerPortalFlowType["Subscription_cancel"] = "subscription_cancel";
    CustomerPortalFlowType["Subscription_update"] = "subscription_update";
    CustomerPortalFlowType["Subscription_update_confirm"] = "subscription_update_confirm";
})(CustomerPortalFlowType || (CustomerPortalFlowType = {}));
var CreatePromoSubscriptionCommand = /** @class */ (function () {
    function CreatePromoSubscriptionCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreatePromoSubscriptionCommand.prototype.init = function (_data) {
        if (_data) {
            this.successUrl = _data["successUrl"];
            this.cancelUrl = _data["cancelUrl"];
        }
    };
    CreatePromoSubscriptionCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreatePromoSubscriptionCommand();
        result.init(data);
        return result;
    };
    CreatePromoSubscriptionCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["successUrl"] = this.successUrl;
        data["cancelUrl"] = this.cancelUrl;
        return data;
    };
    return CreatePromoSubscriptionCommand;
}());
export { CreatePromoSubscriptionCommand };
var UpdateCoachesPricesResponsedDto = /** @class */ (function () {
    function UpdateCoachesPricesResponsedDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateCoachesPricesResponsedDto.prototype.init = function (_data) {
        if (_data) {
            this.successUpdatesCount = _data["successUpdatesCount"];
            this.failedUpdatesCount = _data["failedUpdatesCount"];
            if (Array.isArray(_data["failedUserEmails"])) {
                this.failedUserEmails = [];
                for (var _i = 0, _a = _data["failedUserEmails"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.failedUserEmails.push(item);
                }
            }
        }
    };
    UpdateCoachesPricesResponsedDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateCoachesPricesResponsedDto();
        result.init(data);
        return result;
    };
    UpdateCoachesPricesResponsedDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["successUpdatesCount"] = this.successUpdatesCount;
        data["failedUpdatesCount"] = this.failedUpdatesCount;
        if (Array.isArray(this.failedUserEmails)) {
            data["failedUserEmails"] = [];
            for (var _i = 0, _a = this.failedUserEmails; _i < _a.length; _i++) {
                var item = _a[_i];
                data["failedUserEmails"].push(item);
            }
        }
        return data;
    };
    return UpdateCoachesPricesResponsedDto;
}());
export { UpdateCoachesPricesResponsedDto };
var UpdateCoachesPricesCommand = /** @class */ (function () {
    function UpdateCoachesPricesCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateCoachesPricesCommand.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["emails"])) {
                this.emails = [];
                for (var _i = 0, _a = _data["emails"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.emails.push(item);
                }
            }
        }
    };
    UpdateCoachesPricesCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateCoachesPricesCommand();
        result.init(data);
        return result;
    };
    UpdateCoachesPricesCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (var _i = 0, _a = this.emails; _i < _a.length; _i++) {
                var item = _a[_i];
                data["emails"].push(item);
            }
        }
        return data;
    };
    return UpdateCoachesPricesCommand;
}());
export { UpdateCoachesPricesCommand };
var CreateBodyMeasurementCommand = /** @class */ (function () {
    function CreateBodyMeasurementCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateBodyMeasurementCommand.prototype.init = function (_data) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.value = _data["value"];
            this.unit = _data["unit"];
            this.measuredOn = _data["measuredOn"] ? dayjs(_data["measuredOn"].toString()) : undefined;
        }
    };
    CreateBodyMeasurementCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateBodyMeasurementCommand();
        result.init(data);
        return result;
    };
    CreateBodyMeasurementCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["type"] = this.type;
        data["value"] = this.value;
        data["unit"] = this.unit;
        data["measuredOn"] = this.measuredOn ? this.measuredOn.format('YYYY-MM-DD') : undefined;
        return data;
    };
    return CreateBodyMeasurementCommand;
}());
export { CreateBodyMeasurementCommand };
export var MeasurementType;
(function (MeasurementType) {
    MeasurementType["BODYFAT"] = "BODYFAT";
    MeasurementType["SHOULDER"] = "SHOULDER";
    MeasurementType["CHEST"] = "CHEST";
    MeasurementType["UPPER_ARM"] = "UPPER_ARM";
    MeasurementType["WAIST"] = "WAIST";
    MeasurementType["HIP"] = "HIP";
    MeasurementType["THIGH"] = "THIGH";
    MeasurementType["CALF"] = "CALF";
})(MeasurementType || (MeasurementType = {}));
export var MeasurementUnit;
(function (MeasurementUnit) {
    MeasurementUnit["KG"] = "KG";
    MeasurementUnit["LBS"] = "LBS";
    MeasurementUnit["CM"] = "CM";
    MeasurementUnit["IN"] = "IN";
    MeasurementUnit["PERCENTAGE"] = "PERCENTAGE";
})(MeasurementUnit || (MeasurementUnit = {}));
var UpdateBodyMeasurementCommand = /** @class */ (function () {
    function UpdateBodyMeasurementCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateBodyMeasurementCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.measuredOn = _data["measuredOn"] ? dayjs(_data["measuredOn"].toString()) : undefined;
        }
    };
    UpdateBodyMeasurementCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateBodyMeasurementCommand();
        result.init(data);
        return result;
    };
    UpdateBodyMeasurementCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["measuredOn"] = this.measuredOn ? this.measuredOn.format('YYYY-MM-DD') : undefined;
        return data;
    };
    return UpdateBodyMeasurementCommand;
}());
export { UpdateBodyMeasurementCommand };
var ClientBodyMeasurementsVm = /** @class */ (function () {
    function ClientBodyMeasurementsVm(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientBodyMeasurementsVm.prototype.init = function (_data) {
        if (_data) {
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? dayjs(_data["lastUpdatedAt"].toString()) : undefined;
            if (Array.isArray(_data["measurements"])) {
                this.measurements = [];
                for (var _i = 0, _a = _data["measurements"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.measurements.push(BodyMeasurementInfoVm.fromJS(item));
                }
            }
        }
    };
    ClientBodyMeasurementsVm.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientBodyMeasurementsVm();
        result.init(data);
        return result;
    };
    ClientBodyMeasurementsVm.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.format('YYYY-MM-DD') : undefined;
        if (Array.isArray(this.measurements)) {
            data["measurements"] = [];
            for (var _i = 0, _a = this.measurements; _i < _a.length; _i++) {
                var item = _a[_i];
                data["measurements"].push(item.toJSON());
            }
        }
        return data;
    };
    return ClientBodyMeasurementsVm;
}());
export { ClientBodyMeasurementsVm };
var BodyMeasurementInfoVm = /** @class */ (function () {
    function BodyMeasurementInfoVm(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BodyMeasurementInfoVm.prototype.init = function (_data) {
        if (_data) {
            this.measurementType = _data["measurementType"];
            if (Array.isArray(_data["records"])) {
                this.records = [];
                for (var _i = 0, _a = _data["records"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.records.push(BodyMeasurementRecordDto.fromJS(item));
                }
            }
        }
    };
    BodyMeasurementInfoVm.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BodyMeasurementInfoVm();
        result.init(data);
        return result;
    };
    BodyMeasurementInfoVm.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["measurementType"] = this.measurementType;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (var _i = 0, _a = this.records; _i < _a.length; _i++) {
                var item = _a[_i];
                data["records"].push(item.toJSON());
            }
        }
        return data;
    };
    return BodyMeasurementInfoVm;
}());
export { BodyMeasurementInfoVm };
var BodyMeasurementRecordDto = /** @class */ (function () {
    function BodyMeasurementRecordDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BodyMeasurementRecordDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.measuredOn = _data["measuredOn"] ? dayjs(_data["measuredOn"].toString()) : undefined;
            this.unit = _data["unit"];
            this.value = _data["value"];
        }
    };
    BodyMeasurementRecordDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BodyMeasurementRecordDto();
        result.init(data);
        return result;
    };
    BodyMeasurementRecordDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["measuredOn"] = this.measuredOn ? this.measuredOn.format('YYYY-MM-DD') : undefined;
        data["unit"] = this.unit;
        data["value"] = this.value;
        return data;
    };
    return BodyMeasurementRecordDto;
}());
export { BodyMeasurementRecordDto };
var BodyMeasurementDto = /** @class */ (function () {
    function BodyMeasurementDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BodyMeasurementDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.measuredOn = _data["measuredOn"] ? dayjs(_data["measuredOn"].toString()) : undefined;
            this.type = _data["type"];
            this.unit = _data["unit"];
            this.value = _data["value"];
        }
    };
    BodyMeasurementDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BodyMeasurementDto();
        result.init(data);
        return result;
    };
    BodyMeasurementDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["measuredOn"] = this.measuredOn ? this.measuredOn.format('YYYY-MM-DD') : undefined;
        data["type"] = this.type;
        data["unit"] = this.unit;
        data["value"] = this.value;
        return data;
    };
    return BodyMeasurementDto;
}());
export { BodyMeasurementDto };
var CreateBodyWeightCommand = /** @class */ (function () {
    function CreateBodyWeightCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateBodyWeightCommand.prototype.init = function (_data) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.unit = _data["unit"];
            this.measuredOn = _data["measuredOn"] ? dayjs(_data["measuredOn"].toString()) : undefined;
        }
    };
    CreateBodyWeightCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateBodyWeightCommand();
        result.init(data);
        return result;
    };
    CreateBodyWeightCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["unit"] = this.unit;
        data["measuredOn"] = this.measuredOn ? this.measuredOn.format('YYYY-MM-DD') : undefined;
        return data;
    };
    return CreateBodyWeightCommand;
}());
export { CreateBodyWeightCommand };
var UpdateBodyWeightCommand = /** @class */ (function () {
    function UpdateBodyWeightCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateBodyWeightCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.measuredOn = _data["measuredOn"] ? dayjs(_data["measuredOn"].toString()) : undefined;
        }
    };
    UpdateBodyWeightCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateBodyWeightCommand();
        result.init(data);
        return result;
    };
    UpdateBodyWeightCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["measuredOn"] = this.measuredOn ? this.measuredOn.format('YYYY-MM-DD') : undefined;
        return data;
    };
    return UpdateBodyWeightCommand;
}());
export { UpdateBodyWeightCommand };
var BodyWeightDto = /** @class */ (function () {
    function BodyWeightDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BodyWeightDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.measuredOn = _data["measuredOn"] ? dayjs(_data["measuredOn"].toString()) : undefined;
            this.unit = _data["unit"];
            this.value = _data["value"];
        }
    };
    BodyWeightDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BodyWeightDto();
        result.init(data);
        return result;
    };
    BodyWeightDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["measuredOn"] = this.measuredOn ? this.measuredOn.format('YYYY-MM-DD') : undefined;
        data["unit"] = this.unit;
        data["value"] = this.value;
        return data;
    };
    return BodyWeightDto;
}());
export { BodyWeightDto };
var CreateCheckInAnswerCommand = /** @class */ (function () {
    function CreateCheckInAnswerCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateCheckInAnswerCommand.prototype.init = function (_data) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.activityDate = _data["activityDate"] ? dayjs(_data["activityDate"].toString()) : undefined;
            this.name = _data["name"];
            this.type = _data["type"];
            this.jsonValue = _data["jsonValue"];
        }
    };
    CreateCheckInAnswerCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateCheckInAnswerCommand();
        result.init(data);
        return result;
    };
    CreateCheckInAnswerCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["activityDate"] = this.activityDate ? this.activityDate.format('YYYY-MM-DD') : undefined;
        data["name"] = this.name;
        data["type"] = this.type;
        data["jsonValue"] = this.jsonValue;
        return data;
    };
    return CreateCheckInAnswerCommand;
}());
export { CreateCheckInAnswerCommand };
export var CheckInType;
(function (CheckInType) {
    CheckInType["CHECKIN_ANSWER_BINARY"] = "CHECKIN_ANSWER_BINARY";
    CheckInType["CHECKIN_ANSWER_RATING_SCALE"] = "CHECKIN_ANSWER_RATING_SCALE";
    CheckInType["CHECKIN_ANSWER_LONG_TEXT"] = "CHECKIN_ANSWER_LONG_TEXT";
    CheckInType["CHECKIN_ANSWER_FILE"] = "CHECKIN_ANSWER_FILE";
    CheckInType["CHECKIN_ANSWER_MULTIPLE_CHOICE"] = "CHECKIN_ANSWER_MULTIPLE_CHOICE";
    CheckInType["CHECKIN_ANSWER_NUMBER"] = "CHECKIN_ANSWER_NUMBER";
    CheckInType["CHECKIN_ANSWER_SHORT_TEXT"] = "CHECKIN_ANSWER_SHORT_TEXT";
    CheckInType["CHECKIN_ANSWER_MULTIPLE_CHOICE_CHECKBOX"] = "CHECKIN_ANSWER_MULTIPLE_CHOICE_CHECKBOX";
    CheckInType["CHECKIN_ANSWER_DATE"] = "CHECKIN_ANSWER_DATE";
    CheckInType["CHECKIN_ANSWER_EMOJI"] = "CHECKIN_ANSWER_EMOJI";
    CheckInType["CHECKIN_ANSWER_STAR_RATING"] = "CHECKIN_ANSWER_STAR_RATING";
    CheckInType["CHECKIN_ANSWER_NUTRITION_TARGET"] = "CHECKIN_ANSWER_NUTRITION_TARGET";
})(CheckInType || (CheckInType = {}));
var UpdateCheckInAnswerCommand = /** @class */ (function () {
    function UpdateCheckInAnswerCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateCheckInAnswerCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.activityDate = _data["activityDate"] ? dayjs(_data["activityDate"].toString()) : undefined;
            this.jsonValue = _data["jsonValue"];
        }
    };
    UpdateCheckInAnswerCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateCheckInAnswerCommand();
        result.init(data);
        return result;
    };
    UpdateCheckInAnswerCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityDate"] = this.activityDate ? this.activityDate.format('YYYY-MM-DD') : undefined;
        data["jsonValue"] = this.jsonValue;
        return data;
    };
    return UpdateCheckInAnswerCommand;
}());
export { UpdateCheckInAnswerCommand };
var CheckInAnswerDto = /** @class */ (function () {
    function CheckInAnswerDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CheckInAnswerDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.activityId = _data["activityId"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.activityDate = _data["activityDate"] ? dayjs(_data["activityDate"].toString()) : undefined;
            this.clientId = _data["clientId"];
            this.clientFormRequestId = _data["clientFormRequestId"];
        }
    };
    CheckInAnswerDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CheckInAnswerDto();
        result.init(data);
        return result;
    };
    CheckInAnswerDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityId"] = this.activityId;
        data["type"] = this.type;
        data["name"] = this.name;
        data["value"] = this.value;
        data["activityDate"] = this.activityDate ? this.activityDate.format('YYYY-MM-DD') : undefined;
        data["clientId"] = this.clientId;
        data["clientFormRequestId"] = this.clientFormRequestId;
        return data;
    };
    return CheckInAnswerDto;
}());
export { CheckInAnswerDto };
export var CheckInType2;
(function (CheckInType2) {
    CheckInType2[CheckInType2["CHECKIN_ANSWER_BINARY"] = 0] = "CHECKIN_ANSWER_BINARY";
    CheckInType2[CheckInType2["CHECKIN_ANSWER_RATING_SCALE"] = 1] = "CHECKIN_ANSWER_RATING_SCALE";
    CheckInType2[CheckInType2["CHECKIN_ANSWER_LONG_TEXT"] = 2] = "CHECKIN_ANSWER_LONG_TEXT";
    CheckInType2[CheckInType2["CHECKIN_ANSWER_FILE"] = 3] = "CHECKIN_ANSWER_FILE";
    CheckInType2[CheckInType2["CHECKIN_ANSWER_MULTIPLE_CHOICE"] = 4] = "CHECKIN_ANSWER_MULTIPLE_CHOICE";
    CheckInType2[CheckInType2["CHECKIN_ANSWER_NUMBER"] = 5] = "CHECKIN_ANSWER_NUMBER";
    CheckInType2[CheckInType2["CHECKIN_ANSWER_SHORT_TEXT"] = 6] = "CHECKIN_ANSWER_SHORT_TEXT";
    CheckInType2[CheckInType2["CHECKIN_ANSWER_MULTIPLE_CHOICE_CHECKBOX"] = 7] = "CHECKIN_ANSWER_MULTIPLE_CHOICE_CHECKBOX";
    CheckInType2[CheckInType2["CHECKIN_ANSWER_DATE"] = 8] = "CHECKIN_ANSWER_DATE";
    CheckInType2[CheckInType2["CHECKIN_ANSWER_EMOJI"] = 9] = "CHECKIN_ANSWER_EMOJI";
    CheckInType2[CheckInType2["CHECKIN_ANSWER_STAR_RATING"] = 10] = "CHECKIN_ANSWER_STAR_RATING";
    CheckInType2[CheckInType2["CHECKIN_ANSWER_NUTRITION_TARGET"] = 11] = "CHECKIN_ANSWER_NUTRITION_TARGET";
})(CheckInType2 || (CheckInType2 = {}));
var ClientFormCreatedInfoDto = /** @class */ (function () {
    function ClientFormCreatedInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientFormCreatedInfoDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.slug = _data["slug"];
        }
    };
    ClientFormCreatedInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientFormCreatedInfoDto();
        result.init(data);
        return result;
    };
    ClientFormCreatedInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slug"] = this.slug;
        return data;
    };
    return ClientFormCreatedInfoDto;
}());
export { ClientFormCreatedInfoDto };
var CreateClientFormCommand = /** @class */ (function () {
    function CreateClientFormCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateClientFormCommand.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.image = _data["image"];
            this.description = _data["description"];
            this.content = _data["content"];
        }
    };
    CreateClientFormCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateClientFormCommand();
        result.init(data);
        return result;
    };
    CreateClientFormCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["image"] = this.image;
        data["description"] = this.description;
        data["content"] = this.content;
        return data;
    };
    return CreateClientFormCommand;
}());
export { CreateClientFormCommand };
var ClientFormDto = /** @class */ (function () {
    function ClientFormDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientFormDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.slug = _data["slug"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.image = _data["image"];
            this.content = _data["content"];
            this.lastModified = _data["lastModified"] ? dayjs(_data["lastModified"].toString()) : undefined;
        }
    };
    ClientFormDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientFormDto();
        result.init(data);
        return result;
    };
    ClientFormDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slug"] = this.slug;
        data["name"] = this.name;
        data["description"] = this.description;
        data["image"] = this.image;
        data["content"] = this.content;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined;
        return data;
    };
    return ClientFormDto;
}());
export { ClientFormDto };
var UpdateClientFormCommand = /** @class */ (function () {
    function UpdateClientFormCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateClientFormCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.image = _data["image"];
            this.description = _data["description"];
            this.content = _data["content"];
        }
    };
    UpdateClientFormCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateClientFormCommand();
        result.init(data);
        return result;
    };
    UpdateClientFormCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["image"] = this.image;
        data["description"] = this.description;
        data["content"] = this.content;
        return data;
    };
    return UpdateClientFormCommand;
}());
export { UpdateClientFormCommand };
var ClientFormCoachInfoDto = /** @class */ (function () {
    function ClientFormCoachInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientFormCoachInfoDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.slug = _data["slug"];
            this.slugId = _data["slugId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.image = _data["image"];
            this.content = _data["content"];
            this.lastModified = _data["lastModified"] ? dayjs(_data["lastModified"].toString()) : undefined;
            if (Array.isArray(_data["clients"])) {
                this.clients = [];
                for (var _i = 0, _a = _data["clients"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.clients.push(UserBriefInfoDto.fromJS(item));
                }
            }
        }
    };
    ClientFormCoachInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientFormCoachInfoDto();
        result.init(data);
        return result;
    };
    ClientFormCoachInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slug"] = this.slug;
        data["slugId"] = this.slugId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["image"] = this.image;
        data["content"] = this.content;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined;
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (var _i = 0, _a = this.clients; _i < _a.length; _i++) {
                var item = _a[_i];
                data["clients"].push(item.toJSON());
            }
        }
        return data;
    };
    return ClientFormCoachInfoDto;
}());
export { ClientFormCoachInfoDto };
var ClientFormClientInfoDto = /** @class */ (function () {
    function ClientFormClientInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientFormClientInfoDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.slug = _data["slug"];
            this.slugId = _data["slugId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.image = _data["image"];
            this.content = _data["content"];
            this.formRequestId = _data["formRequestId"];
            this.updatedAt = _data["updatedAt"] ? dayjs(_data["updatedAt"].toString()) : undefined;
            this.submittedAt = _data["submittedAt"] ? dayjs(_data["submittedAt"].toString()) : undefined;
            this.activity = _data["activity"] ? ClientFormActivityDto.fromJS(_data["activity"]) : undefined;
        }
    };
    ClientFormClientInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientFormClientInfoDto();
        result.init(data);
        return result;
    };
    ClientFormClientInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slug"] = this.slug;
        data["slugId"] = this.slugId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["image"] = this.image;
        data["content"] = this.content;
        data["formRequestId"] = this.formRequestId;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        data["submittedAt"] = this.submittedAt ? this.submittedAt.toISOString() : undefined;
        data["activity"] = this.activity ? this.activity.toJSON() : undefined;
        return data;
    };
    return ClientFormClientInfoDto;
}());
export { ClientFormClientInfoDto };
var ClientFormActivityDto = /** @class */ (function () {
    function ClientFormActivityDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientFormActivityDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.client = _data["client"] ? UserBriefInfoDto.fromJS(_data["client"]) : undefined;
            this.coachReadAnswers = _data["coachReadAnswers"];
            this.feedbacksCount = _data["feedbacksCount"];
        }
    };
    ClientFormActivityDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientFormActivityDto();
        result.init(data);
        return result;
    };
    ClientFormActivityDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["client"] = this.client ? this.client.toJSON() : undefined;
        data["coachReadAnswers"] = this.coachReadAnswers;
        data["feedbacksCount"] = this.feedbacksCount;
        return data;
    };
    return ClientFormActivityDto;
}());
export { ClientFormActivityDto };
var SendClientFormBatchCommand = /** @class */ (function () {
    function SendClientFormBatchCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SendClientFormBatchCommand.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["clients"])) {
                this.clients = [];
                for (var _i = 0, _a = _data["clients"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.clients.push(item);
                }
            }
            this.formId = _data["formId"];
        }
    };
    SendClientFormBatchCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SendClientFormBatchCommand();
        result.init(data);
        return result;
    };
    SendClientFormBatchCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (var _i = 0, _a = this.clients; _i < _a.length; _i++) {
                var item = _a[_i];
                data["clients"].push(item);
            }
        }
        data["formId"] = this.formId;
        return data;
    };
    return SendClientFormBatchCommand;
}());
export { SendClientFormBatchCommand };
var SubmitClientFormCommand = /** @class */ (function () {
    function SubmitClientFormCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SubmitClientFormCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
        }
    };
    SubmitClientFormCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SubmitClientFormCommand();
        result.init(data);
        return result;
    };
    SubmitClientFormCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        return data;
    };
    return SubmitClientFormCommand;
}());
export { SubmitClientFormCommand };
var PaginatedListOfClientFormClientListDto = /** @class */ (function () {
    function PaginatedListOfClientFormClientListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfClientFormClientListDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ClientFormClientListDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfClientFormClientListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfClientFormClientListDto();
        result.init(data);
        return result;
    };
    PaginatedListOfClientFormClientListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfClientFormClientListDto;
}());
export { PaginatedListOfClientFormClientListDto };
var ClientFormClientListDto = /** @class */ (function () {
    function ClientFormClientListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientFormClientListDto.prototype.init = function (_data) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.formId = _data["formId"];
            this.slug = _data["slug"];
            this.name = _data["name"];
            this.created = _data["created"] ? dayjs(_data["created"].toString()) : undefined;
            this.submittedAt = _data["submittedAt"] ? dayjs(_data["submittedAt"].toString()) : undefined;
        }
    };
    ClientFormClientListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientFormClientListDto();
        result.init(data);
        return result;
    };
    ClientFormClientListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["formId"] = this.formId;
        data["slug"] = this.slug;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["submittedAt"] = this.submittedAt ? this.submittedAt.toISOString() : undefined;
        return data;
    };
    return ClientFormClientListDto;
}());
export { ClientFormClientListDto };
var PaginatedListOfClientFormCoachListDto = /** @class */ (function () {
    function PaginatedListOfClientFormCoachListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfClientFormCoachListDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ClientFormCoachListDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfClientFormCoachListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfClientFormCoachListDto();
        result.init(data);
        return result;
    };
    PaginatedListOfClientFormCoachListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfClientFormCoachListDto;
}());
export { PaginatedListOfClientFormCoachListDto };
var ClientFormCoachListDto = /** @class */ (function () {
    function ClientFormCoachListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientFormCoachListDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.slug = _data["slug"];
            this.name = _data["name"];
            this.totalQuestions = _data["totalQuestions"];
            this.created = _data["created"] ? dayjs(_data["created"].toString()) : undefined;
        }
    };
    ClientFormCoachListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientFormCoachListDto();
        result.init(data);
        return result;
    };
    ClientFormCoachListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slug"] = this.slug;
        data["name"] = this.name;
        data["totalQuestions"] = this.totalQuestions;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        return data;
    };
    return ClientFormCoachListDto;
}());
export { ClientFormCoachListDto };
var DuplicateClientFormCommand = /** @class */ (function () {
    function DuplicateClientFormCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DuplicateClientFormCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
        }
    };
    DuplicateClientFormCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DuplicateClientFormCommand();
        result.init(data);
        return result;
    };
    DuplicateClientFormCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return DuplicateClientFormCommand;
}());
export { DuplicateClientFormCommand };
var PaginatedListOfClientGoalDto = /** @class */ (function () {
    function PaginatedListOfClientGoalDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfClientGoalDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ClientGoalDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfClientGoalDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfClientGoalDto();
        result.init(data);
        return result;
    };
    PaginatedListOfClientGoalDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfClientGoalDto;
}());
export { PaginatedListOfClientGoalDto };
var ClientGoalDto = /** @class */ (function () {
    function ClientGoalDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientGoalDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.date = _data["date"] ? dayjs(_data["date"].toString()) : undefined;
            this.completed = _data["completed"];
            this.ordinal = _data["ordinal"];
            this.currentValue = _data["currentValue"];
            this.targetValue = _data["targetValue"];
            this.lastModified = _data["lastModified"] ? dayjs(_data["lastModified"].toString()) : undefined;
        }
    };
    ClientGoalDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientGoalDto();
        result.init(data);
        return result;
    };
    ClientGoalDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined;
        data["completed"] = this.completed;
        data["ordinal"] = this.ordinal;
        data["currentValue"] = this.currentValue;
        data["targetValue"] = this.targetValue;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined;
        return data;
    };
    return ClientGoalDto;
}());
export { ClientGoalDto };
var CreateClientGoalCommand = /** @class */ (function () {
    function CreateClientGoalCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateClientGoalCommand.prototype.init = function (_data) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.targetValue = _data["targetValue"];
            this.date = _data["date"] ? dayjs(_data["date"].toString()) : undefined;
        }
    };
    CreateClientGoalCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateClientGoalCommand();
        result.init(data);
        return result;
    };
    CreateClientGoalCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["targetValue"] = this.targetValue;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined;
        return data;
    };
    return CreateClientGoalCommand;
}());
export { CreateClientGoalCommand };
var UpdateClientGoalCommand = /** @class */ (function () {
    function UpdateClientGoalCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateClientGoalCommand.prototype.init = function (_data) {
        if (_data) {
            this.goalId = _data["goalId"];
            this.name = _data["name"];
            this.targetValue = _data["targetValue"];
            this.date = _data["date"] ? dayjs(_data["date"].toString()) : undefined;
        }
    };
    UpdateClientGoalCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateClientGoalCommand();
        result.init(data);
        return result;
    };
    UpdateClientGoalCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["goalId"] = this.goalId;
        data["name"] = this.name;
        data["targetValue"] = this.targetValue;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined;
        return data;
    };
    return UpdateClientGoalCommand;
}());
export { UpdateClientGoalCommand };
var ToggleCompletedClientGoalCommand = /** @class */ (function () {
    function ToggleCompletedClientGoalCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ToggleCompletedClientGoalCommand.prototype.init = function (_data) {
        if (_data) {
            this.goalId = _data["goalId"];
            this.completed = _data["completed"];
        }
    };
    ToggleCompletedClientGoalCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ToggleCompletedClientGoalCommand();
        result.init(data);
        return result;
    };
    ToggleCompletedClientGoalCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["goalId"] = this.goalId;
        data["completed"] = this.completed;
        return data;
    };
    return ToggleCompletedClientGoalCommand;
}());
export { ToggleCompletedClientGoalCommand };
var UpdateCurrentValueClientGoalCommand = /** @class */ (function () {
    function UpdateCurrentValueClientGoalCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateCurrentValueClientGoalCommand.prototype.init = function (_data) {
        if (_data) {
            this.goalId = _data["goalId"];
            this.currentValue = _data["currentValue"];
        }
    };
    UpdateCurrentValueClientGoalCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateCurrentValueClientGoalCommand();
        result.init(data);
        return result;
    };
    UpdateCurrentValueClientGoalCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["goalId"] = this.goalId;
        data["currentValue"] = this.currentValue;
        return data;
    };
    return UpdateCurrentValueClientGoalCommand;
}());
export { UpdateCurrentValueClientGoalCommand };
var ReorderClientGoalsCommand = /** @class */ (function () {
    function ReorderClientGoalsCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReorderClientGoalsCommand.prototype.init = function (_data) {
        if (_data) {
            this.clientId = _data["clientId"];
            if (_data["idsToOrdinals"]) {
                this.idsToOrdinals = {};
                for (var key in _data["idsToOrdinals"]) {
                    if (_data["idsToOrdinals"].hasOwnProperty(key))
                        this.idsToOrdinals[key] = _data["idsToOrdinals"][key];
                }
            }
        }
    };
    ReorderClientGoalsCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReorderClientGoalsCommand();
        result.init(data);
        return result;
    };
    ReorderClientGoalsCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        if (this.idsToOrdinals) {
            data["idsToOrdinals"] = {};
            for (var key in this.idsToOrdinals) {
                if (this.idsToOrdinals.hasOwnProperty(key))
                    data["idsToOrdinals"][key] = this.idsToOrdinals[key];
            }
        }
        return data;
    };
    return ReorderClientGoalsCommand;
}());
export { ReorderClientGoalsCommand };
var ApplySingleOrdinalClientGoalsCommand = /** @class */ (function () {
    function ApplySingleOrdinalClientGoalsCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApplySingleOrdinalClientGoalsCommand.prototype.init = function (_data) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.id = _data["id"];
            this.ordinal = _data["ordinal"];
        }
    };
    ApplySingleOrdinalClientGoalsCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApplySingleOrdinalClientGoalsCommand();
        result.init(data);
        return result;
    };
    ApplySingleOrdinalClientGoalsCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["id"] = this.id;
        data["ordinal"] = this.ordinal;
        return data;
    };
    return ApplySingleOrdinalClientGoalsCommand;
}());
export { ApplySingleOrdinalClientGoalsCommand };
var UpdateGroupClientsCommand = /** @class */ (function () {
    function UpdateGroupClientsCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateGroupClientsCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [];
                for (var _i = 0, _a = _data["emails"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.emails.push(item);
                }
            }
        }
    };
    UpdateGroupClientsCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateGroupClientsCommand();
        result.init(data);
        return result;
    };
    UpdateGroupClientsCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (var _i = 0, _a = this.emails; _i < _a.length; _i++) {
                var item = _a[_i];
                data["emails"].push(item);
            }
        }
        return data;
    };
    return UpdateGroupClientsCommand;
}());
export { UpdateGroupClientsCommand };
var PaginatedListOfClientBriefDto = /** @class */ (function () {
    function PaginatedListOfClientBriefDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfClientBriefDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ClientBriefDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfClientBriefDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfClientBriefDto();
        result.init(data);
        return result;
    };
    PaginatedListOfClientBriefDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfClientBriefDto;
}());
export { PaginatedListOfClientBriefDto };
var BaseUserDto = /** @class */ (function () {
    function BaseUserDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BaseUserDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.email = _data["email"];
            this.displayName = _data["displayName"];
            this.photoUrl = _data["photoUrl"];
        }
    };
    BaseUserDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BaseUserDto();
        result.init(data);
        return result;
    };
    BaseUserDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["email"] = this.email;
        data["displayName"] = this.displayName;
        data["photoUrl"] = this.photoUrl;
        return data;
    };
    return BaseUserDto;
}());
export { BaseUserDto };
var ClientBriefDto = /** @class */ (function (_super) {
    __extends(ClientBriefDto, _super);
    function ClientBriefDto(data) {
        return _super.call(this, data) || this;
    }
    ClientBriefDto.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.status = _data["status"];
            this.lastLoginAt = _data["lastLoginAt"] ? dayjs(_data["lastLoginAt"].toString()) : undefined;
            this.targetBool = _data["targetBool"];
        }
    };
    ClientBriefDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientBriefDto();
        result.init(data);
        return result;
    };
    ClientBriefDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["lastLoginAt"] = this.lastLoginAt ? this.lastLoginAt.toISOString() : undefined;
        data["targetBool"] = this.targetBool;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return ClientBriefDto;
}(BaseUserDto));
export { ClientBriefDto };
export var UserInviteStatus;
(function (UserInviteStatus) {
    UserInviteStatus["ARCHIVED"] = "ARCHIVED";
    UserInviteStatus["PENDING"] = "PENDING";
    UserInviteStatus["ADDED"] = "ADDED";
    UserInviteStatus["ACTIVE"] = "ACTIVE";
})(UserInviteStatus || (UserInviteStatus = {}));
var InternalBriefClientInfo = /** @class */ (function () {
    function InternalBriefClientInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InternalBriefClientInfo.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.email = _data["email"];
            this.rawEmail = _data["rawEmail"];
            this.displayName = _data["displayName"];
            this.photoUrl = _data["photoUrl"];
            this.timeZone = _data["timeZone"];
            this.height = _data["height"];
            this.weight = _data["weight"];
            this.birthday = _data["birthday"];
            this.location = _data["location"];
            this.gender = _data["gender"];
            this.units = _data["units"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [];
                for (var _i = 0, _a = _data["tags"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.tags.push(TagDto.fromJS(item));
                }
            }
            this.lastLoginAt = _data["lastLoginAt"] ? dayjs(_data["lastLoginAt"].toString()) : undefined;
            this.archived = _data["archived"];
            this.pending = _data["pending"];
            this.addedBeforeInvite = _data["addedBeforeInvite"];
        }
    };
    InternalBriefClientInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InternalBriefClientInfo();
        result.init(data);
        return result;
    };
    InternalBriefClientInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["email"] = this.email;
        data["rawEmail"] = this.rawEmail;
        data["displayName"] = this.displayName;
        data["photoUrl"] = this.photoUrl;
        data["timeZone"] = this.timeZone;
        data["height"] = this.height;
        data["weight"] = this.weight;
        data["birthday"] = this.birthday;
        data["location"] = this.location;
        data["gender"] = this.gender;
        data["units"] = this.units;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (var _i = 0, _a = this.tags; _i < _a.length; _i++) {
                var item = _a[_i];
                data["tags"].push(item.toJSON());
            }
        }
        data["lastLoginAt"] = this.lastLoginAt ? this.lastLoginAt.toISOString() : undefined;
        data["archived"] = this.archived;
        data["pending"] = this.pending;
        data["addedBeforeInvite"] = this.addedBeforeInvite;
        return data;
    };
    return InternalBriefClientInfo;
}());
export { InternalBriefClientInfo };
var BriefClientInfo = /** @class */ (function (_super) {
    __extends(BriefClientInfo, _super);
    function BriefClientInfo(data) {
        return _super.call(this, data) || this;
    }
    BriefClientInfo.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.status = _data["status"];
            this.lastLoginAtRelative = _data["lastLoginAtRelative"];
            this.age = _data["age"];
        }
    };
    BriefClientInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BriefClientInfo();
        result.init(data);
        return result;
    };
    BriefClientInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["lastLoginAtRelative"] = this.lastLoginAtRelative;
        data["age"] = this.age;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return BriefClientInfo;
}(InternalBriefClientInfo));
export { BriefClientInfo };
var TagDto = /** @class */ (function () {
    function TagDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TagDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    };
    TagDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TagDto();
        result.init(data);
        return result;
    };
    TagDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    };
    return TagDto;
}());
export { TagDto };
var ClientsVm = /** @class */ (function () {
    function ClientsVm(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientsVm.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [];
                for (var _i = 0, _a = _data["tags"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.tags.push(TagDto.fromJS(item));
                }
            }
            this.clients = _data["clients"] ? PaginatedListOfClientDto.fromJS(_data["clients"]) : undefined;
        }
    };
    ClientsVm.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientsVm();
        result.init(data);
        return result;
    };
    ClientsVm.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (var _i = 0, _a = this.tags; _i < _a.length; _i++) {
                var item = _a[_i];
                data["tags"].push(item.toJSON());
            }
        }
        data["clients"] = this.clients ? this.clients.toJSON() : undefined;
        return data;
    };
    return ClientsVm;
}());
export { ClientsVm };
var PaginatedListOfClientDto = /** @class */ (function () {
    function PaginatedListOfClientDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfClientDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ClientDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfClientDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfClientDto();
        result.init(data);
        return result;
    };
    PaginatedListOfClientDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfClientDto;
}());
export { PaginatedListOfClientDto };
var ClientDto = /** @class */ (function (_super) {
    __extends(ClientDto, _super);
    function ClientDto(data) {
        return _super.call(this, data) || this;
    }
    ClientDto.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.clientStatus = _data["clientStatus"];
            this.lastLoginAt = _data["lastLoginAt"] ? dayjs(_data["lastLoginAt"].toString()) : undefined;
            this.invite = _data["invite"] ? InviteDto.fromJS(_data["invite"]) : undefined;
            this.tag = _data["tag"] ? TagDto.fromJS(_data["tag"]) : undefined;
        }
    };
    ClientDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientDto();
        result.init(data);
        return result;
    };
    ClientDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientStatus"] = this.clientStatus;
        data["lastLoginAt"] = this.lastLoginAt ? this.lastLoginAt.toISOString() : undefined;
        data["invite"] = this.invite ? this.invite.toJSON() : undefined;
        data["tag"] = this.tag ? this.tag.toJSON() : undefined;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return ClientDto;
}(BaseUserDto));
export { ClientDto };
var InviteDto = /** @class */ (function () {
    function InviteDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InviteDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.inivitedAt = _data["inivitedAt"] ? dayjs(_data["inivitedAt"].toString()) : undefined;
            this.source = _data["source"];
        }
    };
    InviteDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InviteDto();
        result.init(data);
        return result;
    };
    InviteDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inivitedAt"] = this.inivitedAt ? this.inivitedAt.toISOString() : undefined;
        data["source"] = this.source;
        return data;
    };
    return InviteDto;
}());
export { InviteDto };
export var SourceType;
(function (SourceType) {
    SourceType[SourceType["EMAIL"] = 0] = "EMAIL";
    SourceType[SourceType["LINK"] = 1] = "LINK";
})(SourceType || (SourceType = {}));
var PaginatedListOfClientInfoDto = /** @class */ (function () {
    function PaginatedListOfClientInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfClientInfoDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ClientInfoDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfClientInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfClientInfoDto();
        result.init(data);
        return result;
    };
    PaginatedListOfClientInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfClientInfoDto;
}());
export { PaginatedListOfClientInfoDto };
var ClientInfoDto = /** @class */ (function () {
    function ClientInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientInfoDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.isSample = _data["isSample"];
            this.status = _data["status"];
            this.email = _data["email"];
            this.displayName = _data["displayName"];
            this.photoUrl = _data["photoUrl"];
            this.lastLoginAt = _data["lastLoginAt"] ? dayjs(_data["lastLoginAt"].toString()) : undefined;
            this.invite = _data["invite"] ? InviteDto.fromJS(_data["invite"]) : undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [];
                for (var _i = 0, _a = _data["tags"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.tags.push(TagDto.fromJS(item));
                }
            }
            this.endPrograms = _data["endPrograms"];
        }
    };
    ClientInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientInfoDto();
        result.init(data);
        return result;
    };
    ClientInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["isSample"] = this.isSample;
        data["status"] = this.status;
        data["email"] = this.email;
        data["displayName"] = this.displayName;
        data["photoUrl"] = this.photoUrl;
        data["lastLoginAt"] = this.lastLoginAt ? this.lastLoginAt.toISOString() : undefined;
        data["invite"] = this.invite ? this.invite.toJSON() : undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (var _i = 0, _a = this.tags; _i < _a.length; _i++) {
                var item = _a[_i];
                data["tags"].push(item.toJSON());
            }
        }
        data["endPrograms"] = this.endPrograms;
        return data;
    };
    return ClientInfoDto;
}());
export { ClientInfoDto };
export var ClientSort;
(function (ClientSort) {
    ClientSort["NAME_ASC"] = "NAME_ASC";
    ClientSort["NAME_DESC"] = "NAME_DESC";
    ClientSort["LAST_ACTIVE_ASC"] = "LAST_ACTIVE_ASC";
    ClientSort["LAST_ACTIVE_DESC"] = "LAST_ACTIVE_DESC";
    ClientSort["PROGRESS_ASC"] = "PROGRESS_ASC";
    ClientSort["PROGRESS_DESC"] = "PROGRESS_DESC";
    ClientSort["DATE_ADDED_ASC"] = "DATE_ADDED_ASC";
    ClientSort["DATE_ADDED_DESC"] = "DATE_ADDED_DESC";
    ClientSort["PROGRAM_END_ASC"] = "PROGRAM_END_ASC";
    ClientSort["PROGRAM_END_DESC"] = "PROGRAM_END_DESC";
})(ClientSort || (ClientSort = {}));
var ClientsCountDto = /** @class */ (function () {
    function ClientsCountDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientsCountDto.prototype.init = function (_data) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [];
                for (var _i = 0, _a = _data["statuses"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.statuses.push(item);
                }
            }
        }
    };
    ClientsCountDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientsCountDto();
        result.init(data);
        return result;
    };
    ClientsCountDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (var _i = 0, _a = this.statuses; _i < _a.length; _i++) {
                var item = _a[_i];
                data["statuses"].push(item);
            }
        }
        return data;
    };
    return ClientsCountDto;
}());
export { ClientsCountDto };
var ClientStatsDto = /** @class */ (function () {
    function ClientStatsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientStatsDto.prototype.init = function (_data) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.completion30Days = _data["completion30Days"] ? BaseCompletion.fromJS(_data["completion30Days"]) : undefined;
            if (Array.isArray(_data["completionByDate7Days"])) {
                this.completionByDate7Days = [];
                for (var _i = 0, _a = _data["completionByDate7Days"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.completionByDate7Days.push(CompletionByDateDto.fromJS(item));
                }
            }
        }
    };
    ClientStatsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientStatsDto();
        result.init(data);
        return result;
    };
    ClientStatsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["completion30Days"] = this.completion30Days ? this.completion30Days.toJSON() : undefined;
        if (Array.isArray(this.completionByDate7Days)) {
            data["completionByDate7Days"] = [];
            for (var _i = 0, _a = this.completionByDate7Days; _i < _a.length; _i++) {
                var item = _a[_i];
                data["completionByDate7Days"].push(item.toJSON());
            }
        }
        return data;
    };
    return ClientStatsDto;
}());
export { ClientStatsDto };
var CompletionByDateDto = /** @class */ (function () {
    function CompletionByDateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompletionByDateDto.prototype.init = function (_data) {
        if (_data) {
            this.date = _data["date"] ? dayjs(_data["date"].toString()) : undefined;
            this.completion = _data["completion"] ? BaseCompletion.fromJS(_data["completion"]) : undefined;
        }
    };
    CompletionByDateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CompletionByDateDto();
        result.init(data);
        return result;
    };
    CompletionByDateDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined;
        data["completion"] = this.completion ? this.completion.toJSON() : undefined;
        return data;
    };
    return CompletionByDateDto;
}());
export { CompletionByDateDto };
var ArchiveClientCommand = /** @class */ (function () {
    function ArchiveClientCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ArchiveClientCommand.prototype.init = function (_data) {
        if (_data) {
            this.archived = _data["archived"];
            this.clientId = _data["clientId"];
        }
    };
    ArchiveClientCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ArchiveClientCommand();
        result.init(data);
        return result;
    };
    ArchiveClientCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["archived"] = this.archived;
        data["clientId"] = this.clientId;
        return data;
    };
    return ArchiveClientCommand;
}());
export { ArchiveClientCommand };
var BatchArchiveClientsCommand = /** @class */ (function () {
    function BatchArchiveClientsCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchArchiveClientsCommand.prototype.init = function (_data) {
        if (_data) {
            this.archived = _data["archived"];
            if (Array.isArray(_data["clientIds"])) {
                this.clientIds = [];
                for (var _i = 0, _a = _data["clientIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.clientIds.push(item);
                }
            }
        }
    };
    BatchArchiveClientsCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchArchiveClientsCommand();
        result.init(data);
        return result;
    };
    BatchArchiveClientsCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["archived"] = this.archived;
        if (Array.isArray(this.clientIds)) {
            data["clientIds"] = [];
            for (var _i = 0, _a = this.clientIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["clientIds"].push(item);
            }
        }
        return data;
    };
    return BatchArchiveClientsCommand;
}());
export { BatchArchiveClientsCommand };
var DialogInviteVm = /** @class */ (function () {
    function DialogInviteVm(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DialogInviteVm.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["dialogInvitesInfos"])) {
                this.dialogInvitesInfos = [];
                for (var _i = 0, _a = _data["dialogInvitesInfos"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.dialogInvitesInfos.push(DialogInvitesInfoDto.fromJS(item));
                }
            }
            if (Array.isArray(_data["problems"])) {
                this.problems = [];
                for (var _b = 0, _c = _data["problems"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.problems.push(ProblemDto.fromJS(item));
                }
            }
        }
    };
    DialogInviteVm.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DialogInviteVm();
        result.init(data);
        return result;
    };
    DialogInviteVm.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dialogInvitesInfos)) {
            data["dialogInvitesInfos"] = [];
            for (var _i = 0, _a = this.dialogInvitesInfos; _i < _a.length; _i++) {
                var item = _a[_i];
                data["dialogInvitesInfos"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.problems)) {
            data["problems"] = [];
            for (var _b = 0, _c = this.problems; _b < _c.length; _b++) {
                var item = _c[_b];
                data["problems"].push(item.toJSON());
            }
        }
        return data;
    };
    return DialogInviteVm;
}());
export { DialogInviteVm };
var DialogInvitesInfoDto = /** @class */ (function () {
    function DialogInvitesInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DialogInvitesInfoDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.source = _data["source"];
            this.createdAt = _data["createdAt"];
            this.client = _data["client"] ? ClientInfoDto2.fromJS(_data["client"]) : undefined;
        }
    };
    DialogInvitesInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DialogInvitesInfoDto();
        result.init(data);
        return result;
    };
    DialogInvitesInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["source"] = this.source;
        data["createdAt"] = this.createdAt;
        data["client"] = this.client ? this.client.toJSON() : undefined;
        return data;
    };
    return DialogInvitesInfoDto;
}());
export { DialogInvitesInfoDto };
var ClientInfoDto2 = /** @class */ (function () {
    function ClientInfoDto2(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientInfoDto2.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.clientStatus = _data["clientStatus"];
        }
    };
    ClientInfoDto2.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientInfoDto2();
        result.init(data);
        return result;
    };
    ClientInfoDto2.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientStatus"] = this.clientStatus;
        return data;
    };
    return ClientInfoDto2;
}());
export { ClientInfoDto2 };
var ProblemDto = /** @class */ (function () {
    function ProblemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProblemDto.prototype.init = function (_data) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
        }
    };
    ProblemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProblemDto();
        result.init(data);
        return result;
    };
    ProblemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        return data;
    };
    return ProblemDto;
}());
export { ProblemDto };
var AddClientsWithoutInviteCommand = /** @class */ (function () {
    function AddClientsWithoutInviteCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddClientsWithoutInviteCommand.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["emails"])) {
                this.emails = [];
                for (var _i = 0, _a = _data["emails"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.emails.push(item);
                }
            }
        }
    };
    AddClientsWithoutInviteCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddClientsWithoutInviteCommand();
        result.init(data);
        return result;
    };
    AddClientsWithoutInviteCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (var _i = 0, _a = this.emails; _i < _a.length; _i++) {
                var item = _a[_i];
                data["emails"].push(item);
            }
        }
        return data;
    };
    return AddClientsWithoutInviteCommand;
}());
export { AddClientsWithoutInviteCommand };
var BatchDeleteClientsCommand = /** @class */ (function () {
    function BatchDeleteClientsCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchDeleteClientsCommand.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["clientIds"])) {
                this.clientIds = [];
                for (var _i = 0, _a = _data["clientIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.clientIds.push(item);
                }
            }
        }
    };
    BatchDeleteClientsCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchDeleteClientsCommand();
        result.init(data);
        return result;
    };
    BatchDeleteClientsCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clientIds)) {
            data["clientIds"] = [];
            for (var _i = 0, _a = this.clientIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["clientIds"].push(item);
            }
        }
        return data;
    };
    return BatchDeleteClientsCommand;
}());
export { BatchDeleteClientsCommand };
var BulkClientsResponse = /** @class */ (function () {
    function BulkClientsResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BulkClientsResponse.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["successfulEmails"])) {
                this.successfulEmails = [];
                for (var _i = 0, _a = _data["successfulEmails"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.successfulEmails.push(item);
                }
            }
            if (Array.isArray(_data["failedEmails"])) {
                this.failedEmails = [];
                for (var _b = 0, _c = _data["failedEmails"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.failedEmails.push(item);
                }
            }
        }
    };
    BulkClientsResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BulkClientsResponse();
        result.init(data);
        return result;
    };
    BulkClientsResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.successfulEmails)) {
            data["successfulEmails"] = [];
            for (var _i = 0, _a = this.successfulEmails; _i < _a.length; _i++) {
                var item = _a[_i];
                data["successfulEmails"].push(item);
            }
        }
        if (Array.isArray(this.failedEmails)) {
            data["failedEmails"] = [];
            for (var _b = 0, _c = this.failedEmails; _b < _c.length; _b++) {
                var item = _c[_b];
                data["failedEmails"].push(item);
            }
        }
        return data;
    };
    return BulkClientsResponse;
}());
export { BulkClientsResponse };
var GenerateBulkClientsCommand = /** @class */ (function () {
    function GenerateBulkClientsCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GenerateBulkClientsCommand.prototype.init = function (_data) {
        if (_data) {
            this.coachEmail = _data["coachEmail"];
            this.quantity = _data["quantity"];
        }
    };
    GenerateBulkClientsCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GenerateBulkClientsCommand();
        result.init(data);
        return result;
    };
    GenerateBulkClientsCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["coachEmail"] = this.coachEmail;
        data["quantity"] = this.quantity;
        return data;
    };
    return GenerateBulkClientsCommand;
}());
export { GenerateBulkClientsCommand };
var AssignTagsToClientCommand = /** @class */ (function () {
    function AssignTagsToClientCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AssignTagsToClientCommand.prototype.init = function (_data) {
        if (_data) {
            this.clientId = _data["clientId"];
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [];
                for (var _i = 0, _a = _data["tagIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.tagIds.push(item);
                }
            }
        }
    };
    AssignTagsToClientCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AssignTagsToClientCommand();
        result.init(data);
        return result;
    };
    AssignTagsToClientCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (var _i = 0, _a = this.tagIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["tagIds"].push(item);
            }
        }
        return data;
    };
    return AssignTagsToClientCommand;
}());
export { AssignTagsToClientCommand };
var CreatedComponentResult = /** @class */ (function () {
    function CreatedComponentResult(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreatedComponentResult.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.slugId = _data["slugId"];
            this.slug = _data["slug"];
            this.copiedFrom = _data["copiedFrom"];
        }
    };
    CreatedComponentResult.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreatedComponentResult();
        result.init(data);
        return result;
    };
    CreatedComponentResult.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slugId"] = this.slugId;
        data["slug"] = this.slug;
        data["copiedFrom"] = this.copiedFrom;
        return data;
    };
    return CreatedComponentResult;
}());
export { CreatedComponentResult };
var SplitUnlinkRepeatCommand = /** @class */ (function () {
    function SplitUnlinkRepeatCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SplitUnlinkRepeatCommand.prototype.init = function (_data) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.splitAtWeekId = _data["splitAtWeekId"];
            this.splitAtWeek = _data["splitAtWeek"];
        }
    };
    SplitUnlinkRepeatCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SplitUnlinkRepeatCommand();
        result.init(data);
        return result;
    };
    SplitUnlinkRepeatCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["splitAtWeekId"] = this.splitAtWeekId;
        data["splitAtWeek"] = this.splitAtWeek;
        return data;
    };
    return SplitUnlinkRepeatCommand;
}());
export { SplitUnlinkRepeatCommand };
var AddComponentTemplateCommand = /** @class */ (function () {
    function AddComponentTemplateCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddComponentTemplateCommand.prototype.init = function (_data) {
        if (_data) {
            this.componentType = _data["componentType"];
            this.content = _data["content"];
            this.habitPrompt = _data["habitPrompt"];
            this.title = _data["title"];
            this.image = _data["image"];
            this.iconName = _data["iconName"];
        }
    };
    AddComponentTemplateCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddComponentTemplateCommand();
        result.init(data);
        return result;
    };
    AddComponentTemplateCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["componentType"] = this.componentType;
        data["content"] = this.content;
        data["habitPrompt"] = this.habitPrompt;
        data["title"] = this.title;
        data["image"] = this.image;
        data["iconName"] = this.iconName;
        return data;
    };
    return AddComponentTemplateCommand;
}());
export { AddComponentTemplateCommand };
var ArchiveComponentCommand = /** @class */ (function () {
    function ArchiveComponentCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ArchiveComponentCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
        }
    };
    ArchiveComponentCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ArchiveComponentCommand();
        result.init(data);
        return result;
    };
    ArchiveComponentCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return ArchiveComponentCommand;
}());
export { ArchiveComponentCommand };
var CreateComponentCommand = /** @class */ (function () {
    function CreateComponentCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateComponentCommand.prototype.init = function (_data) {
        if (_data) {
            this.weekId = _data["weekId"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.days = _data["days"];
            this.repeat = _data["repeat"];
            this.duration = _data["duration"];
            this.locked = _data["locked"];
            this.reminderType = _data["reminderType"];
            this.reminderTimeString = _data["reminderTimeString"];
            this.messageTimeString = _data["messageTimeString"];
            this.messageContent = _data["messageContent"];
            this.content = _data["content"];
            this.habitPrompt = _data["habitPrompt"];
            this.iconName = _data["iconName"];
            this.image = _data["image"];
        }
    };
    CreateComponentCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateComponentCommand();
        result.init(data);
        return result;
    };
    CreateComponentCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["weekId"] = this.weekId;
        data["type"] = this.type;
        data["title"] = this.title;
        data["days"] = this.days;
        data["repeat"] = this.repeat;
        data["duration"] = this.duration;
        data["locked"] = this.locked;
        data["reminderType"] = this.reminderType;
        data["reminderTimeString"] = this.reminderTimeString;
        data["messageTimeString"] = this.messageTimeString;
        data["messageContent"] = this.messageContent;
        data["content"] = this.content;
        data["habitPrompt"] = this.habitPrompt;
        data["iconName"] = this.iconName;
        data["image"] = this.image;
        return data;
    };
    return CreateComponentCommand;
}());
export { CreateComponentCommand };
export var ReminderType;
(function (ReminderType) {
    ReminderType["AUTOMATIC"] = "AUTOMATIC";
    ReminderType["CUSTOM"] = "CUSTOM";
})(ReminderType || (ReminderType = {}));
var DuplicateComponentCommand = /** @class */ (function () {
    function DuplicateComponentCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DuplicateComponentCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.newWeekId = _data["newWeekId"];
        }
    };
    DuplicateComponentCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DuplicateComponentCommand();
        result.init(data);
        return result;
    };
    DuplicateComponentCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newWeekId"] = this.newWeekId;
        return data;
    };
    return DuplicateComponentCommand;
}());
export { DuplicateComponentCommand };
var PasteComponentCommand = /** @class */ (function () {
    function PasteComponentCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PasteComponentCommand.prototype.init = function (_data) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.weekId = _data["weekId"];
            this.day = _data["day"];
        }
    };
    PasteComponentCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PasteComponentCommand();
        result.init(data);
        return result;
    };
    PasteComponentCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["weekId"] = this.weekId;
        data["day"] = this.day;
        return data;
    };
    return PasteComponentCommand;
}());
export { PasteComponentCommand };
var UpdateComponentResponse = /** @class */ (function () {
    function UpdateComponentResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateComponentResponse.prototype.init = function (_data) {
        if (_data) {
            this.status = _data["status"];
            this.draftExist = _data["draftExist"];
            this.slug = _data["slug"];
            this.slugId = _data["slugId"];
        }
    };
    UpdateComponentResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateComponentResponse();
        result.init(data);
        return result;
    };
    UpdateComponentResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["draftExist"] = this.draftExist;
        data["slug"] = this.slug;
        data["slugId"] = this.slugId;
        return data;
    };
    return UpdateComponentResponse;
}());
export { UpdateComponentResponse };
var UpdateComponentCommand = /** @class */ (function () {
    function UpdateComponentCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateComponentCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.weekId = _data["weekId"];
            this.title = _data["title"];
            this.days = _data["days"];
            this.repeat = _data["repeat"];
            this.status = _data["status"];
            this.shouldApplyDraft = _data["shouldApplyDraft"];
            this.duration = _data["duration"];
            this.locked = _data["locked"];
            this.reminderType = _data["reminderType"];
            this.reminderTimeString = _data["reminderTimeString"];
            this.messageTimeString = _data["messageTimeString"];
            this.messageContent = _data["messageContent"];
            this.content = _data["content"];
            this.habitPrompt = _data["habitPrompt"];
            this.iconName = _data["iconName"];
            this.image = _data["image"];
        }
    };
    UpdateComponentCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateComponentCommand();
        result.init(data);
        return result;
    };
    UpdateComponentCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["weekId"] = this.weekId;
        data["title"] = this.title;
        data["days"] = this.days;
        data["repeat"] = this.repeat;
        data["status"] = this.status;
        data["shouldApplyDraft"] = this.shouldApplyDraft;
        data["duration"] = this.duration;
        data["locked"] = this.locked;
        data["reminderType"] = this.reminderType;
        data["reminderTimeString"] = this.reminderTimeString;
        data["messageTimeString"] = this.messageTimeString;
        data["messageContent"] = this.messageContent;
        data["content"] = this.content;
        data["habitPrompt"] = this.habitPrompt;
        data["iconName"] = this.iconName;
        data["image"] = this.image;
        return data;
    };
    return UpdateComponentCommand;
}());
export { UpdateComponentCommand };
var UpdateComponentsLockedStatusCommand = /** @class */ (function () {
    function UpdateComponentsLockedStatusCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateComponentsLockedStatusCommand.prototype.init = function (_data) {
        if (_data) {
            if (_data["idsToLockedStatus"]) {
                this.idsToLockedStatus = {};
                for (var key in _data["idsToLockedStatus"]) {
                    if (_data["idsToLockedStatus"].hasOwnProperty(key))
                        this.idsToLockedStatus[key] = _data["idsToLockedStatus"][key];
                }
            }
        }
    };
    UpdateComponentsLockedStatusCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateComponentsLockedStatusCommand();
        result.init(data);
        return result;
    };
    UpdateComponentsLockedStatusCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.idsToLockedStatus) {
            data["idsToLockedStatus"] = {};
            for (var key in this.idsToLockedStatus) {
                if (this.idsToLockedStatus.hasOwnProperty(key))
                    data["idsToLockedStatus"][key] = this.idsToLockedStatus[key];
            }
        }
        return data;
    };
    return UpdateComponentsLockedStatusCommand;
}());
export { UpdateComponentsLockedStatusCommand };
var UpdateComponentsLockedStatusByProgramIdCommand = /** @class */ (function () {
    function UpdateComponentsLockedStatusByProgramIdCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateComponentsLockedStatusByProgramIdCommand.prototype.init = function (_data) {
        if (_data) {
            this.programId = _data["programId"];
            this.locked = _data["locked"];
        }
    };
    UpdateComponentsLockedStatusByProgramIdCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateComponentsLockedStatusByProgramIdCommand();
        result.init(data);
        return result;
    };
    UpdateComponentsLockedStatusByProgramIdCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        data["locked"] = this.locked;
        return data;
    };
    return UpdateComponentsLockedStatusByProgramIdCommand;
}());
export { UpdateComponentsLockedStatusByProgramIdCommand };
var UpdateComponentTemplateCommand = /** @class */ (function () {
    function UpdateComponentTemplateCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateComponentTemplateCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
            this.habitPrompt = _data["habitPrompt"];
            this.title = _data["title"];
            this.image = _data["image"];
            this.iconName = _data["iconName"];
        }
    };
    UpdateComponentTemplateCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateComponentTemplateCommand();
        result.init(data);
        return result;
    };
    UpdateComponentTemplateCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        data["habitPrompt"] = this.habitPrompt;
        data["title"] = this.title;
        data["image"] = this.image;
        data["iconName"] = this.iconName;
        return data;
    };
    return UpdateComponentTemplateCommand;
}());
export { UpdateComponentTemplateCommand };
var UpdateDefaultIconCommand = /** @class */ (function () {
    function UpdateDefaultIconCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateDefaultIconCommand.prototype.init = function (_data) {
        if (_data) {
            this.programId = _data["programId"];
            this.iconName = _data["iconName"];
            this.componentType = _data["componentType"];
        }
    };
    UpdateDefaultIconCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateDefaultIconCommand();
        result.init(data);
        return result;
    };
    UpdateDefaultIconCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        data["iconName"] = this.iconName;
        data["componentType"] = this.componentType;
        return data;
    };
    return UpdateDefaultIconCommand;
}());
export { UpdateDefaultIconCommand };
var ComponentDto2 = /** @class */ (function () {
    function ComponentDto2(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ComponentDto2.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.weekId = _data["weekId"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.title = _data["title"];
            this.days = _data["days"];
            this.duration = _data["duration"];
            this.repeat = _data["repeat"];
            this.locked = _data["locked"];
            this.content = _data["content"];
            this.draftExist = _data["draftExist"];
            this.habitPrompt = _data["habitPrompt"];
            this.iconName = _data["iconName"];
            this.reminderTime = _data["reminderTime"];
            this.slugId = _data["slugId"];
            this.slug = _data["slug"];
            this.image = _data["image"];
            this.reminderType = _data["reminderType"];
            this.previousStatus = _data["previousStatus"];
            this.messageTime = _data["messageTime"];
            this.messageContent = _data["messageContent"];
            this.updatedAt = _data["updatedAt"] ? dayjs(_data["updatedAt"].toString()) : undefined;
            this.lastPublished = _data["lastPublished"] ? dayjs(_data["lastPublished"].toString()) : undefined;
            if (Array.isArray(_data["overrides"])) {
                this.overrides = [];
                for (var _i = 0, _a = _data["overrides"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.overrides.push(ComponentOverrideBriefDto.fromJS(item));
                }
            }
            this.baseComponentId = _data["baseComponentId"];
        }
    };
    ComponentDto2.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ComponentDto2();
        result.init(data);
        return result;
    };
    ComponentDto2.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["weekId"] = this.weekId;
        data["type"] = this.type;
        data["status"] = this.status;
        data["title"] = this.title;
        data["days"] = this.days;
        data["duration"] = this.duration;
        data["repeat"] = this.repeat;
        data["locked"] = this.locked;
        data["content"] = this.content;
        data["draftExist"] = this.draftExist;
        data["habitPrompt"] = this.habitPrompt;
        data["iconName"] = this.iconName;
        data["reminderTime"] = this.reminderTime;
        data["slugId"] = this.slugId;
        data["slug"] = this.slug;
        data["image"] = this.image;
        data["reminderType"] = this.reminderType;
        data["previousStatus"] = this.previousStatus;
        data["messageTime"] = this.messageTime;
        data["messageContent"] = this.messageContent;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        data["lastPublished"] = this.lastPublished ? this.lastPublished.toISOString() : undefined;
        if (Array.isArray(this.overrides)) {
            data["overrides"] = [];
            for (var _i = 0, _a = this.overrides; _i < _a.length; _i++) {
                var item = _a[_i];
                data["overrides"].push(item.toJSON());
            }
        }
        data["baseComponentId"] = this.baseComponentId;
        return data;
    };
    return ComponentDto2;
}());
export { ComponentDto2 };
var ComponentOverrideBriefDto = /** @class */ (function () {
    function ComponentOverrideBriefDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ComponentOverrideBriefDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
        }
    };
    ComponentOverrideBriefDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ComponentOverrideBriefDto();
        result.init(data);
        return result;
    };
    ComponentOverrideBriefDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return ComponentOverrideBriefDto;
}());
export { ComponentOverrideBriefDto };
var ComponentVersions = /** @class */ (function () {
    function ComponentVersions(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ComponentVersions.prototype.init = function (_data) {
        if (_data) {
            this.draft = _data["draft"] ? ComponentDto2.fromJS(_data["draft"]) : undefined;
            this.lastPublishedValues = _data["lastPublishedValues"] ? DraftableDto.fromJS(_data["lastPublishedValues"]) : undefined;
        }
    };
    ComponentVersions.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ComponentVersions();
        result.init(data);
        return result;
    };
    ComponentVersions.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["draft"] = this.draft ? this.draft.toJSON() : undefined;
        data["lastPublishedValues"] = this.lastPublishedValues ? this.lastPublishedValues.toJSON() : undefined;
        return data;
    };
    return ComponentVersions;
}());
export { ComponentVersions };
var DraftableDto = /** @class */ (function () {
    function DraftableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DraftableDto.prototype.init = function (_data) {
        if (_data) {
            this.title = _data["title"];
            this.content = _data["content"];
            this.habitPrompt = _data["habitPrompt"];
            this.reminderTime = _data["reminderTime"];
            this.image = _data["image"];
            this.reminderType = _data["reminderType"];
            this.messageTime = _data["messageTime"];
            this.messageContent = _data["messageContent"];
        }
    };
    DraftableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DraftableDto();
        result.init(data);
        return result;
    };
    DraftableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["content"] = this.content;
        data["habitPrompt"] = this.habitPrompt;
        data["reminderTime"] = this.reminderTime;
        data["image"] = this.image;
        data["reminderType"] = this.reminderType;
        data["messageTime"] = this.messageTime;
        data["messageContent"] = this.messageContent;
        return data;
    };
    return DraftableDto;
}());
export { DraftableDto };
var ComponentTemplateDto = /** @class */ (function () {
    function ComponentTemplateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ComponentTemplateDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.coachId = _data["coachId"];
            this.title = _data["title"];
            this.type = _data["type"];
            this.iconName = _data["iconName"];
            this.content = _data["content"];
            this.image = _data["image"];
            this.habitPrompt = _data["habitPrompt"];
            this.category = _data["category"];
            this.private = _data["private"];
        }
    };
    ComponentTemplateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ComponentTemplateDto();
        result.init(data);
        return result;
    };
    ComponentTemplateDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["coachId"] = this.coachId;
        data["title"] = this.title;
        data["type"] = this.type;
        data["iconName"] = this.iconName;
        data["content"] = this.content;
        data["image"] = this.image;
        data["habitPrompt"] = this.habitPrompt;
        data["category"] = this.category;
        data["private"] = this.private;
        return data;
    };
    return ComponentTemplateDto;
}());
export { ComponentTemplateDto };
var PaginatedListOfComponentTemplateBriefDto = /** @class */ (function () {
    function PaginatedListOfComponentTemplateBriefDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfComponentTemplateBriefDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ComponentTemplateBriefDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfComponentTemplateBriefDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfComponentTemplateBriefDto();
        result.init(data);
        return result;
    };
    PaginatedListOfComponentTemplateBriefDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfComponentTemplateBriefDto;
}());
export { PaginatedListOfComponentTemplateBriefDto };
var ComponentTemplateBriefDto = /** @class */ (function () {
    function ComponentTemplateBriefDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ComponentTemplateBriefDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.category = _data["category"];
            this.private = _data["private"];
        }
    };
    ComponentTemplateBriefDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ComponentTemplateBriefDto();
        result.init(data);
        return result;
    };
    ComponentTemplateBriefDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["category"] = this.category;
        data["private"] = this.private;
        return data;
    };
    return ComponentTemplateBriefDto;
}());
export { ComponentTemplateBriefDto };
var CreatedOverrideResult = /** @class */ (function (_super) {
    __extends(CreatedOverrideResult, _super);
    function CreatedOverrideResult(data) {
        return _super.call(this, data) || this;
    }
    CreatedOverrideResult.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.preDraft = _data["preDraft"] ? DraftableDto.fromJS(_data["preDraft"]) : undefined;
        }
    };
    CreatedOverrideResult.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreatedOverrideResult();
        result.init(data);
        return result;
    };
    CreatedOverrideResult.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["preDraft"] = this.preDraft ? this.preDraft.toJSON() : undefined;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return CreatedOverrideResult;
}(CreatedComponentResult));
export { CreatedOverrideResult };
var CreateComponentOverrideCommand = /** @class */ (function () {
    function CreateComponentOverrideCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateComponentOverrideCommand.prototype.init = function (_data) {
        if (_data) {
            this.baseComponentId = _data["baseComponentId"];
            this.weekId = _data["weekId"];
            this.days = _data["days"];
            this.reminderType = _data["reminderType"];
            this.reminderTimeString = _data["reminderTimeString"];
            this.messageTimeString = _data["messageTimeString"];
            this.messageContent = _data["messageContent"];
            this.content = _data["content"];
            this.habitPrompt = _data["habitPrompt"];
            this.noDiscard = _data["noDiscard"];
        }
    };
    CreateComponentOverrideCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateComponentOverrideCommand();
        result.init(data);
        return result;
    };
    CreateComponentOverrideCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["baseComponentId"] = this.baseComponentId;
        data["weekId"] = this.weekId;
        data["days"] = this.days;
        data["reminderType"] = this.reminderType;
        data["reminderTimeString"] = this.reminderTimeString;
        data["messageTimeString"] = this.messageTimeString;
        data["messageContent"] = this.messageContent;
        data["content"] = this.content;
        data["habitPrompt"] = this.habitPrompt;
        data["noDiscard"] = this.noDiscard;
        return data;
    };
    return CreateComponentOverrideCommand;
}());
export { CreateComponentOverrideCommand };
var UpdateComponentOverrideCommand = /** @class */ (function () {
    function UpdateComponentOverrideCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateComponentOverrideCommand.prototype.init = function (_data) {
        if (_data) {
            this.overrideComponentId = _data["overrideComponentId"];
            this.applyDraft = _data["applyDraft"];
            this.reminderType = _data["reminderType"];
            this.reminderTimeString = _data["reminderTimeString"];
            this.messageTimeString = _data["messageTimeString"];
            this.messageContent = _data["messageContent"];
            this.content = _data["content"];
            this.habitPrompt = _data["habitPrompt"];
        }
    };
    UpdateComponentOverrideCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateComponentOverrideCommand();
        result.init(data);
        return result;
    };
    UpdateComponentOverrideCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["overrideComponentId"] = this.overrideComponentId;
        data["applyDraft"] = this.applyDraft;
        data["reminderType"] = this.reminderType;
        data["reminderTimeString"] = this.reminderTimeString;
        data["messageTimeString"] = this.messageTimeString;
        data["messageContent"] = this.messageContent;
        data["content"] = this.content;
        data["habitPrompt"] = this.habitPrompt;
        return data;
    };
    return UpdateComponentOverrideCommand;
}());
export { UpdateComponentOverrideCommand };
var CreateCustomAssetCommand = /** @class */ (function () {
    function CreateCustomAssetCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateCustomAssetCommand.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.content = _data["content"];
            this.assetType = _data["assetType"];
            this.metadata = _data["metadata"];
        }
    };
    CreateCustomAssetCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateCustomAssetCommand();
        result.init(data);
        return result;
    };
    CreateCustomAssetCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["content"] = this.content;
        data["assetType"] = this.assetType;
        data["metadata"] = this.metadata;
        return data;
    };
    return CreateCustomAssetCommand;
}());
export { CreateCustomAssetCommand };
export var CustomAssetType;
(function (CustomAssetType) {
    CustomAssetType["IMAGE"] = "IMAGE";
    CustomAssetType["VIDEO"] = "VIDEO";
    CustomAssetType["AUDIO"] = "AUDIO";
    CustomAssetType["FILE"] = "FILE";
    CustomAssetType["OTHER"] = "OTHER";
    CustomAssetType["COMPONENT_TEMPLATE"] = "COMPONENT_TEMPLATE";
    CustomAssetType["WORKOUT_EXERCISE"] = "WORKOUT_EXERCISE";
    CustomAssetType["CLIENT_FORM"] = "CLIENT_FORM";
})(CustomAssetType || (CustomAssetType = {}));
export var EntityToUpdateAssetId;
(function (EntityToUpdateAssetId) {
    EntityToUpdateAssetId["ACTIVITY_WITH_RESULTS"] = "ACTIVITY_WITH_RESULTS";
    EntityToUpdateAssetId["COMPONENTS"] = "COMPONENTS";
})(EntityToUpdateAssetId || (EntityToUpdateAssetId = {}));
var PaginatedListOfCustomAssetDto = /** @class */ (function () {
    function PaginatedListOfCustomAssetDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfCustomAssetDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(CustomAssetDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfCustomAssetDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfCustomAssetDto();
        result.init(data);
        return result;
    };
    PaginatedListOfCustomAssetDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfCustomAssetDto;
}());
export { PaginatedListOfCustomAssetDto };
var CustomAssetDto = /** @class */ (function () {
    function CustomAssetDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CustomAssetDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.content = _data["content"];
            this.assetType = _data["assetType"];
            this.coachId = _data["coachId"];
            this.lastModified = _data["lastModified"] ? dayjs(_data["lastModified"].toString()) : undefined;
        }
    };
    CustomAssetDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CustomAssetDto();
        result.init(data);
        return result;
    };
    CustomAssetDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["content"] = this.content;
        data["assetType"] = this.assetType;
        data["coachId"] = this.coachId;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined;
        return data;
    };
    return CustomAssetDto;
}());
export { CustomAssetDto };
var UpdateCustomAssetCommand = /** @class */ (function () {
    function UpdateCustomAssetCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateCustomAssetCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.content = _data["content"];
            this.assetType = _data["assetType"];
            this.metadata = _data["metadata"];
        }
    };
    UpdateCustomAssetCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateCustomAssetCommand();
        result.init(data);
        return result;
    };
    UpdateCustomAssetCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["content"] = this.content;
        data["assetType"] = this.assetType;
        data["metadata"] = this.metadata;
        return data;
    };
    return UpdateCustomAssetCommand;
}());
export { UpdateCustomAssetCommand };
var EnrollmentsVm = /** @class */ (function () {
    function EnrollmentsVm(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EnrollmentsVm.prototype.init = function (_data) {
        if (_data) {
            this.program = _data["program"] ? EnrollmentProgramDto.fromJS(_data["program"]) : undefined;
            if (Array.isArray(_data["enrollments"])) {
                this.enrollments = [];
                for (var _i = 0, _a = _data["enrollments"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.enrollments.push(EnrollmentDto.fromJS(item));
                }
            }
            if (Array.isArray(_data["groupEnrollments"])) {
                this.groupEnrollments = [];
                for (var _b = 0, _c = _data["groupEnrollments"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.groupEnrollments.push(EnrollmentGroupDto.fromJS(item));
                }
            }
        }
    };
    EnrollmentsVm.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EnrollmentsVm();
        result.init(data);
        return result;
    };
    EnrollmentsVm.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["program"] = this.program ? this.program.toJSON() : undefined;
        if (Array.isArray(this.enrollments)) {
            data["enrollments"] = [];
            for (var _i = 0, _a = this.enrollments; _i < _a.length; _i++) {
                var item = _a[_i];
                data["enrollments"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.groupEnrollments)) {
            data["groupEnrollments"] = [];
            for (var _b = 0, _c = this.groupEnrollments; _b < _c.length; _b++) {
                var item = _c[_b];
                data["groupEnrollments"].push(item.toJSON());
            }
        }
        return data;
    };
    return EnrollmentsVm;
}());
export { EnrollmentsVm };
var BaseProgramDto = /** @class */ (function () {
    function BaseProgramDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BaseProgramDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.slug = _data["slug"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.length = _data["length"];
            this.image = _data["image"];
            this.created = _data["created"] ? dayjs(_data["created"].toString()) : undefined;
        }
    };
    BaseProgramDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BaseProgramDto();
        result.init(data);
        return result;
    };
    BaseProgramDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["slug"] = this.slug;
        data["name"] = this.name;
        data["description"] = this.description;
        data["length"] = this.length;
        data["image"] = this.image;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        return data;
    };
    return BaseProgramDto;
}());
export { BaseProgramDto };
var EnrollmentProgramDto = /** @class */ (function (_super) {
    __extends(EnrollmentProgramDto, _super);
    function EnrollmentProgramDto(data) {
        return _super.call(this, data) || this;
    }
    EnrollmentProgramDto.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.slugId = _data["slugId"];
            this.defaultView = _data["defaultView"];
        }
    };
    EnrollmentProgramDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EnrollmentProgramDto();
        result.init(data);
        return result;
    };
    EnrollmentProgramDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["slugId"] = this.slugId;
        data["defaultView"] = this.defaultView;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return EnrollmentProgramDto;
}(BaseProgramDto));
export { EnrollmentProgramDto };
export var ProgramDefaultView;
(function (ProgramDefaultView) {
    ProgramDefaultView["LIST"] = "LIST";
    ProgramDefaultView["CALENDAR"] = "CALENDAR";
    ProgramDefaultView["SPREADSHEET"] = "SPREADSHEET";
})(ProgramDefaultView || (ProgramDefaultView = {}));
var EnrollmentDto = /** @class */ (function () {
    function EnrollmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EnrollmentDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"];
            this.isoStartDate = _data["isoStartDate"];
            this.endDate = _data["endDate"];
            this.user = _data["user"] ? UserBriefInfoDto.fromJS(_data["user"]) : undefined;
            this.viaGroup = _data["viaGroup"];
            this.groupId = _data["groupId"];
            this.created = _data["created"] ? dayjs(_data["created"].toString()) : undefined;
        }
    };
    EnrollmentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EnrollmentDto();
        result.init(data);
        return result;
    };
    EnrollmentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate;
        data["isoStartDate"] = this.isoStartDate;
        data["endDate"] = this.endDate;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        data["viaGroup"] = this.viaGroup;
        data["groupId"] = this.groupId;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        return data;
    };
    return EnrollmentDto;
}());
export { EnrollmentDto };
var EnrollmentGroupDto = /** @class */ (function () {
    function EnrollmentGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EnrollmentGroupDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.group = _data["group"] ? GroupDto.fromJS(_data["group"]) : undefined;
        }
    };
    EnrollmentGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EnrollmentGroupDto();
        result.init(data);
        return result;
    };
    EnrollmentGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["group"] = this.group ? this.group.toJSON() : undefined;
        return data;
    };
    return EnrollmentGroupDto;
}());
export { EnrollmentGroupDto };
var GroupDto = /** @class */ (function () {
    function GroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GroupDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.size = _data["size"];
            this.created = _data["created"] ? dayjs(_data["created"].toString()) : undefined;
        }
    };
    GroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GroupDto();
        result.init(data);
        return result;
    };
    GroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["size"] = this.size;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        return data;
    };
    return GroupDto;
}());
export { GroupDto };
var ProgramEnrollmentsAvatarsVm = /** @class */ (function () {
    function ProgramEnrollmentsAvatarsVm(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProgramEnrollmentsAvatarsVm.prototype.init = function (_data) {
        if (_data) {
            this.programInfo = _data["programInfo"] ? ProgramProfileDto.fromJS(_data["programInfo"]) : undefined;
            this.totalEnrollmentsCount = _data["totalEnrollmentsCount"];
            if (Array.isArray(_data["enrollmentAvatars"])) {
                this.enrollmentAvatars = [];
                for (var _i = 0, _a = _data["enrollmentAvatars"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.enrollmentAvatars.push(AvatarsDto.fromJS(item));
                }
            }
            this.totalClientsCount = _data["totalClientsCount"];
            this.totalGroupsCount = _data["totalGroupsCount"];
        }
    };
    ProgramEnrollmentsAvatarsVm.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProgramEnrollmentsAvatarsVm();
        result.init(data);
        return result;
    };
    ProgramEnrollmentsAvatarsVm.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["programInfo"] = this.programInfo ? this.programInfo.toJSON() : undefined;
        data["totalEnrollmentsCount"] = this.totalEnrollmentsCount;
        if (Array.isArray(this.enrollmentAvatars)) {
            data["enrollmentAvatars"] = [];
            for (var _i = 0, _a = this.enrollmentAvatars; _i < _a.length; _i++) {
                var item = _a[_i];
                data["enrollmentAvatars"].push(item.toJSON());
            }
        }
        data["totalClientsCount"] = this.totalClientsCount;
        data["totalGroupsCount"] = this.totalGroupsCount;
        return data;
    };
    return ProgramEnrollmentsAvatarsVm;
}());
export { ProgramEnrollmentsAvatarsVm };
var ProgramProfileDto = /** @class */ (function () {
    function ProgramProfileDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProgramProfileDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.defaultView = _data["defaultView"];
            this.slug = _data["slug"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.length = _data["length"];
            this.image = _data["image"];
            this.created = _data["created"] ? dayjs(_data["created"].toString()) : undefined;
        }
    };
    ProgramProfileDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProgramProfileDto();
        result.init(data);
        return result;
    };
    ProgramProfileDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["defaultView"] = this.defaultView;
        data["slug"] = this.slug;
        data["name"] = this.name;
        data["description"] = this.description;
        data["length"] = this.length;
        data["image"] = this.image;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        return data;
    };
    return ProgramProfileDto;
}());
export { ProgramProfileDto };
var AvatarsDto = /** @class */ (function () {
    function AvatarsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AvatarsDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? UserBriefInfoDto.fromJS(_data["user"]) : undefined;
        }
    };
    AvatarsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AvatarsDto();
        result.init(data);
        return result;
    };
    AvatarsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        return data;
    };
    return AvatarsDto;
}());
export { AvatarsDto };
var EnrollmentsStatsDto = /** @class */ (function () {
    function EnrollmentsStatsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EnrollmentsStatsDto.prototype.init = function (_data) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.completionRate = _data["completionRate"] ? CompletionRateDto.fromJS(_data["completionRate"]) : undefined;
        }
    };
    EnrollmentsStatsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EnrollmentsStatsDto();
        result.init(data);
        return result;
    };
    EnrollmentsStatsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["completionRate"] = this.completionRate ? this.completionRate.toJSON() : undefined;
        return data;
    };
    return EnrollmentsStatsDto;
}());
export { EnrollmentsStatsDto };
var CompletionRateDto = /** @class */ (function () {
    function CompletionRateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompletionRateDto.prototype.init = function (_data) {
        if (_data) {
            this.total = _data["total"];
            this.completed = _data["completed"];
            this.score = _data["score"];
        }
    };
    CompletionRateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CompletionRateDto();
        result.init(data);
        return result;
    };
    CompletionRateDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["completed"] = this.completed;
        data["score"] = this.score;
        return data;
    };
    return CompletionRateDto;
}());
export { CompletionRateDto };
var PaginatedListOfClientEnrollmentDto = /** @class */ (function () {
    function PaginatedListOfClientEnrollmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfClientEnrollmentDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ClientEnrollmentDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfClientEnrollmentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfClientEnrollmentDto();
        result.init(data);
        return result;
    };
    PaginatedListOfClientEnrollmentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfClientEnrollmentDto;
}());
export { PaginatedListOfClientEnrollmentDto };
var ClientEnrollmentDto = /** @class */ (function () {
    function ClientEnrollmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientEnrollmentDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.program = _data["program"] ? BriefProgramDto.fromJS(_data["program"]) : undefined;
            this.status = _data["status"];
            this.currentDay = _data["currentDay"];
            this.totalDays = _data["totalDays"];
            this.startDate = _data["startDate"] ? dayjs(_data["startDate"].toString()) : undefined;
            this.endDate = _data["endDate"] ? dayjs(_data["endDate"].toString()) : undefined;
            this.completion7DaysRate = _data["completion7DaysRate"];
            this.lessons7Days = _data["lessons7Days"] ? BaseCompletion.fromJS(_data["lessons7Days"]) : undefined;
            this.habits7Days = _data["habits7Days"] ? BaseCompletion.fromJS(_data["habits7Days"]) : undefined;
            this.checkins7Days = _data["checkins7Days"] ? BaseCompletion.fromJS(_data["checkins7Days"]) : undefined;
            if (Array.isArray(_data["completionByDate7Days"])) {
                this.completionByDate7Days = [];
                for (var _i = 0, _a = _data["completionByDate7Days"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.completionByDate7Days.push(CompletionByDateDto.fromJS(item));
                }
            }
            this.client = _data["client"] ? UserBriefInfoDto.fromJS(_data["client"]) : undefined;
            if (Array.isArray(_data["checkinsByWeeks"])) {
                this.checkinsByWeeks = [];
                for (var _b = 0, _c = _data["checkinsByWeeks"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.checkinsByWeeks.push(WeeklyCompletionDto.fromJS(item));
                }
            }
            if (Array.isArray(_data["habitsByWeeks"])) {
                this.habitsByWeeks = [];
                for (var _d = 0, _e = _data["habitsByWeeks"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.habitsByWeeks.push(WeeklyCompletionDto.fromJS(item));
                }
            }
            if (Array.isArray(_data["lessonsByWeeks"])) {
                this.lessonsByWeeks = [];
                for (var _f = 0, _g = _data["lessonsByWeeks"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.lessonsByWeeks.push(WeeklyCompletionDto.fromJS(item));
                }
            }
            this.startFromNow = _data["startFromNow"];
            this.completion = _data["completion"] ? BaseCompletion.fromJS(_data["completion"]) : undefined;
            this.completion30Days = _data["completion30Days"] ? BaseCompletion.fromJS(_data["completion30Days"]) : undefined;
        }
    };
    ClientEnrollmentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientEnrollmentDto();
        result.init(data);
        return result;
    };
    ClientEnrollmentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["program"] = this.program ? this.program.toJSON() : undefined;
        data["status"] = this.status;
        data["currentDay"] = this.currentDay;
        data["totalDays"] = this.totalDays;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : undefined;
        data["endDate"] = this.endDate ? this.endDate.format('YYYY-MM-DD') : undefined;
        data["completion7DaysRate"] = this.completion7DaysRate;
        data["lessons7Days"] = this.lessons7Days ? this.lessons7Days.toJSON() : undefined;
        data["habits7Days"] = this.habits7Days ? this.habits7Days.toJSON() : undefined;
        data["checkins7Days"] = this.checkins7Days ? this.checkins7Days.toJSON() : undefined;
        if (Array.isArray(this.completionByDate7Days)) {
            data["completionByDate7Days"] = [];
            for (var _i = 0, _a = this.completionByDate7Days; _i < _a.length; _i++) {
                var item = _a[_i];
                data["completionByDate7Days"].push(item.toJSON());
            }
        }
        data["client"] = this.client ? this.client.toJSON() : undefined;
        if (Array.isArray(this.checkinsByWeeks)) {
            data["checkinsByWeeks"] = [];
            for (var _b = 0, _c = this.checkinsByWeeks; _b < _c.length; _b++) {
                var item = _c[_b];
                data["checkinsByWeeks"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.habitsByWeeks)) {
            data["habitsByWeeks"] = [];
            for (var _d = 0, _e = this.habitsByWeeks; _d < _e.length; _d++) {
                var item = _e[_d];
                data["habitsByWeeks"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.lessonsByWeeks)) {
            data["lessonsByWeeks"] = [];
            for (var _f = 0, _g = this.lessonsByWeeks; _f < _g.length; _f++) {
                var item = _g[_f];
                data["lessonsByWeeks"].push(item.toJSON());
            }
        }
        data["startFromNow"] = this.startFromNow;
        data["completion"] = this.completion ? this.completion.toJSON() : undefined;
        data["completion30Days"] = this.completion30Days ? this.completion30Days.toJSON() : undefined;
        return data;
    };
    return ClientEnrollmentDto;
}());
export { ClientEnrollmentDto };
var BriefProgramDto = /** @class */ (function () {
    function BriefProgramDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BriefProgramDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.slug = _data["slug"];
            this.name = _data["name"];
            this.image = _data["image"];
        }
    };
    BriefProgramDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BriefProgramDto();
        result.init(data);
        return result;
    };
    BriefProgramDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slug"] = this.slug;
        data["name"] = this.name;
        data["image"] = this.image;
        return data;
    };
    return BriefProgramDto;
}());
export { BriefProgramDto };
export var EnrollmentStatus;
(function (EnrollmentStatus) {
    EnrollmentStatus["ACTIVE"] = "ACTIVE";
    EnrollmentStatus["UPCOMING"] = "UPCOMING";
    EnrollmentStatus["PAST"] = "PAST";
    EnrollmentStatus["ALL"] = "ALL";
})(EnrollmentStatus || (EnrollmentStatus = {}));
var WeeklyCompletionDto = /** @class */ (function () {
    function WeeklyCompletionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WeeklyCompletionDto.prototype.init = function (_data) {
        if (_data) {
            this.startWeekDate = _data["startWeekDate"] ? dayjs(_data["startWeekDate"].toString()) : undefined;
            this.completed = _data["completed"];
            this.total = _data["total"];
        }
    };
    WeeklyCompletionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WeeklyCompletionDto();
        result.init(data);
        return result;
    };
    WeeklyCompletionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["startWeekDate"] = this.startWeekDate ? this.startWeekDate.format('YYYY-MM-DD') : undefined;
        data["completed"] = this.completed;
        data["total"] = this.total;
        return data;
    };
    return WeeklyCompletionDto;
}());
export { WeeklyCompletionDto };
var EnrollmentsStatusCountDto = /** @class */ (function () {
    function EnrollmentsStatusCountDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EnrollmentsStatusCountDto.prototype.init = function (_data) {
        if (_data) {
            this.active = _data["active"];
            this.upcoming = _data["upcoming"];
            this.past = _data["past"];
        }
    };
    EnrollmentsStatusCountDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EnrollmentsStatusCountDto();
        result.init(data);
        return result;
    };
    EnrollmentsStatusCountDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["upcoming"] = this.upcoming;
        data["past"] = this.past;
        return data;
    };
    return EnrollmentsStatusCountDto;
}());
export { EnrollmentsStatusCountDto };
var ProgramWeeksDto = /** @class */ (function () {
    function ProgramWeeksDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProgramWeeksDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.slug = _data["slug"];
            this.name = _data["name"];
            this.length = _data["length"];
            this.slugId = _data["slugId"];
            this.description = _data["description"];
            this.image = _data["image"];
            if (Array.isArray(_data["weeks"])) {
                this.weeks = [];
                for (var _i = 0, _a = _data["weeks"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.weeks.push(BaseWeekDto.fromJS(item));
                }
            }
            this.currentWeek = _data["currentWeek"];
        }
    };
    ProgramWeeksDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProgramWeeksDto();
        result.init(data);
        return result;
    };
    ProgramWeeksDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slug"] = this.slug;
        data["name"] = this.name;
        data["length"] = this.length;
        data["slugId"] = this.slugId;
        data["description"] = this.description;
        data["image"] = this.image;
        if (Array.isArray(this.weeks)) {
            data["weeks"] = [];
            for (var _i = 0, _a = this.weeks; _i < _a.length; _i++) {
                var item = _a[_i];
                data["weeks"].push(item.toJSON());
            }
        }
        data["currentWeek"] = this.currentWeek;
        return data;
    };
    return ProgramWeeksDto;
}());
export { ProgramWeeksDto };
var BaseWeekDto = /** @class */ (function () {
    function BaseWeekDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BaseWeekDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.weekNumber = _data["weekNumber"];
            this.description = _data["description"];
            if (Array.isArray(_data["positions"])) {
                this.positions = [];
                for (var _i = 0, _a = _data["positions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.positions.push(item);
                }
            }
        }
    };
    BaseWeekDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BaseWeekDto();
        result.init(data);
        return result;
    };
    BaseWeekDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["weekNumber"] = this.weekNumber;
        data["description"] = this.description;
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (var _i = 0, _a = this.positions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["positions"].push(item);
            }
        }
        return data;
    };
    return BaseWeekDto;
}());
export { BaseWeekDto };
var ClientEnrollmentWeekDto = /** @class */ (function () {
    function ClientEnrollmentWeekDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientEnrollmentWeekDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? dayjs(_data["startDate"].toString()) : undefined;
            this.completionRate = _data["completionRate"];
            if (Array.isArray(_data["activities"])) {
                this.activities = [];
                for (var _i = 0, _a = _data["activities"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.activities.push(ActivitiesDto.fromJS(item));
                }
            }
        }
    };
    ClientEnrollmentWeekDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientEnrollmentWeekDto();
        result.init(data);
        return result;
    };
    ClientEnrollmentWeekDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : undefined;
        data["completionRate"] = this.completionRate;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (var _i = 0, _a = this.activities; _i < _a.length; _i++) {
                var item = _a[_i];
                data["activities"].push(item.toJSON());
            }
        }
        return data;
    };
    return ClientEnrollmentWeekDto;
}());
export { ClientEnrollmentWeekDto };
var ActivitiesDto = /** @class */ (function () {
    function ActivitiesDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ActivitiesDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.week = _data["week"];
            this.formattedDate = _data["formattedDate"];
            this.date = _data["date"] ? dayjs(_data["date"].toString()) : undefined;
            this.completedAt = _data["completedAt"] ? dayjs(_data["completedAt"].toString()) : undefined;
            this.submittedAt = _data["submittedAt"] ? dayjs(_data["submittedAt"].toString()) : undefined;
            this.component = _data["component"] ? ComponentDto.fromJS(_data["component"]) : undefined;
        }
    };
    ActivitiesDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ActivitiesDto();
        result.init(data);
        return result;
    };
    ActivitiesDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["week"] = this.week;
        data["formattedDate"] = this.formattedDate;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined;
        data["submittedAt"] = this.submittedAt ? this.submittedAt.toISOString() : undefined;
        data["component"] = this.component ? this.component.toJSON() : undefined;
        return data;
    };
    return ActivitiesDto;
}());
export { ActivitiesDto };
var EnrollmentsForCalendarDto = /** @class */ (function () {
    function EnrollmentsForCalendarDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EnrollmentsForCalendarDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"];
            this.program = _data["program"] ? BriefProgramDto.fromJS(_data["program"]) : undefined;
            if (Array.isArray(_data["activities"])) {
                this.activities = [];
                for (var _i = 0, _a = _data["activities"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.activities.push(ActivitiesForCalendarDto.fromJS(item));
                }
            }
            this.startFromNow = _data["startFromNow"];
            this.startDateShort = _data["startDateShort"];
            this.endDateShort = _data["endDateShort"];
            this.client = _data["client"] ? BriefClientDto.fromJS(_data["client"]) : undefined;
        }
    };
    EnrollmentsForCalendarDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EnrollmentsForCalendarDto();
        result.init(data);
        return result;
    };
    EnrollmentsForCalendarDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate;
        data["program"] = this.program ? this.program.toJSON() : undefined;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (var _i = 0, _a = this.activities; _i < _a.length; _i++) {
                var item = _a[_i];
                data["activities"].push(item.toJSON());
            }
        }
        data["startFromNow"] = this.startFromNow;
        data["startDateShort"] = this.startDateShort;
        data["endDateShort"] = this.endDateShort;
        data["client"] = this.client ? this.client.toJSON() : undefined;
        return data;
    };
    return EnrollmentsForCalendarDto;
}());
export { EnrollmentsForCalendarDto };
var ActivitiesForCalendarDto = /** @class */ (function () {
    function ActivitiesForCalendarDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ActivitiesForCalendarDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? dayjs(_data["date"].toString()) : undefined;
            this.component = _data["component"] ? ComponentForCalendarDto.fromJS(_data["component"]) : undefined;
            this.completed = _data["completed"];
            this.enrollment = _data["enrollment"] ? EnrollmentWithClientAndProgramDto.fromJS(_data["enrollment"]) : undefined;
        }
    };
    ActivitiesForCalendarDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ActivitiesForCalendarDto();
        result.init(data);
        return result;
    };
    ActivitiesForCalendarDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined;
        data["component"] = this.component ? this.component.toJSON() : undefined;
        data["completed"] = this.completed;
        data["enrollment"] = this.enrollment ? this.enrollment.toJSON() : undefined;
        return data;
    };
    return ActivitiesForCalendarDto;
}());
export { ActivitiesForCalendarDto };
var ComponentForCalendarDto = /** @class */ (function () {
    function ComponentForCalendarDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ComponentForCalendarDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.slug = _data["slug"];
            this.locked = _data["locked"];
            this.iconName = _data["iconName"];
            this.baseComponentId = _data["baseComponentId"];
        }
    };
    ComponentForCalendarDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ComponentForCalendarDto();
        result.init(data);
        return result;
    };
    ComponentForCalendarDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["slug"] = this.slug;
        data["locked"] = this.locked;
        data["iconName"] = this.iconName;
        data["baseComponentId"] = this.baseComponentId;
        return data;
    };
    return ComponentForCalendarDto;
}());
export { ComponentForCalendarDto };
var EnrollmentWithClientAndProgramDto = /** @class */ (function () {
    function EnrollmentWithClientAndProgramDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EnrollmentWithClientAndProgramDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.program = _data["program"] ? ProgramWithIdAndSlugDto.fromJS(_data["program"]) : undefined;
            this.client = _data["client"] ? BriefClientDto.fromJS(_data["client"]) : undefined;
        }
    };
    EnrollmentWithClientAndProgramDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EnrollmentWithClientAndProgramDto();
        result.init(data);
        return result;
    };
    EnrollmentWithClientAndProgramDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["program"] = this.program ? this.program.toJSON() : undefined;
        data["client"] = this.client ? this.client.toJSON() : undefined;
        return data;
    };
    return EnrollmentWithClientAndProgramDto;
}());
export { EnrollmentWithClientAndProgramDto };
var ProgramWithIdAndSlugDto = /** @class */ (function () {
    function ProgramWithIdAndSlugDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProgramWithIdAndSlugDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.slug = _data["slug"];
        }
    };
    ProgramWithIdAndSlugDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProgramWithIdAndSlugDto();
        result.init(data);
        return result;
    };
    ProgramWithIdAndSlugDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slug"] = this.slug;
        return data;
    };
    return ProgramWithIdAndSlugDto;
}());
export { ProgramWithIdAndSlugDto };
var BriefClientDto = /** @class */ (function () {
    function BriefClientDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BriefClientDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.username = _data["username"];
            this.email = _data["email"];
        }
    };
    BriefClientDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BriefClientDto();
        result.init(data);
        return result;
    };
    BriefClientDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["username"] = this.username;
        data["email"] = this.email;
        return data;
    };
    return BriefClientDto;
}());
export { BriefClientDto };
var PaginatedListOfEnrollGroupDto = /** @class */ (function () {
    function PaginatedListOfEnrollGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfEnrollGroupDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(EnrollGroupDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfEnrollGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfEnrollGroupDto();
        result.init(data);
        return result;
    };
    PaginatedListOfEnrollGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfEnrollGroupDto;
}());
export { PaginatedListOfEnrollGroupDto };
var EnrollGroupDto = /** @class */ (function () {
    function EnrollGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EnrollGroupDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.size = _data["size"];
            if (Array.isArray(_data["programs"])) {
                this.programs = [];
                for (var _i = 0, _a = _data["programs"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.programs.push(ProgramIdDto.fromJS(item));
                }
            }
        }
    };
    EnrollGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EnrollGroupDto();
        result.init(data);
        return result;
    };
    EnrollGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["size"] = this.size;
        if (Array.isArray(this.programs)) {
            data["programs"] = [];
            for (var _i = 0, _a = this.programs; _i < _a.length; _i++) {
                var item = _a[_i];
                data["programs"].push(item.toJSON());
            }
        }
        return data;
    };
    return EnrollGroupDto;
}());
export { EnrollGroupDto };
var ProgramIdDto = /** @class */ (function () {
    function ProgramIdDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProgramIdDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
        }
    };
    ProgramIdDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProgramIdDto();
        result.init(data);
        return result;
    };
    ProgramIdDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return ProgramIdDto;
}());
export { ProgramIdDto };
var BatchEnrollClientsCommand = /** @class */ (function () {
    function BatchEnrollClientsCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchEnrollClientsCommand.prototype.init = function (_data) {
        if (_data) {
            this.programId = _data["programId"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [];
                for (var _i = 0, _a = _data["emails"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.emails.push(item);
                }
            }
            this.startDate = _data["startDate"];
        }
    };
    BatchEnrollClientsCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchEnrollClientsCommand();
        result.init(data);
        return result;
    };
    BatchEnrollClientsCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (var _i = 0, _a = this.emails; _i < _a.length; _i++) {
                var item = _a[_i];
                data["emails"].push(item);
            }
        }
        data["startDate"] = this.startDate;
        return data;
    };
    return BatchEnrollClientsCommand;
}());
export { BatchEnrollClientsCommand };
var BatchEnrollGroupsCommand = /** @class */ (function () {
    function BatchEnrollGroupsCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchEnrollGroupsCommand.prototype.init = function (_data) {
        if (_data) {
            this.programId = _data["programId"];
            if (Array.isArray(_data["groupIds"])) {
                this.groupIds = [];
                for (var _i = 0, _a = _data["groupIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.groupIds.push(item);
                }
            }
            this.startDate = _data["startDate"];
        }
    };
    BatchEnrollGroupsCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchEnrollGroupsCommand();
        result.init(data);
        return result;
    };
    BatchEnrollGroupsCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        if (Array.isArray(this.groupIds)) {
            data["groupIds"] = [];
            for (var _i = 0, _a = this.groupIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["groupIds"].push(item);
            }
        }
        data["startDate"] = this.startDate;
        return data;
    };
    return BatchEnrollGroupsCommand;
}());
export { BatchEnrollGroupsCommand };
var UnenrollEnrollClientCommand = /** @class */ (function () {
    function UnenrollEnrollClientCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UnenrollEnrollClientCommand.prototype.init = function (_data) {
        if (_data) {
            this.enrollmentId = _data["enrollmentId"];
            this.programId = _data["programId"];
            this.startDate = _data["startDate"];
        }
    };
    UnenrollEnrollClientCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UnenrollEnrollClientCommand();
        result.init(data);
        return result;
    };
    UnenrollEnrollClientCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["enrollmentId"] = this.enrollmentId;
        data["programId"] = this.programId;
        data["startDate"] = this.startDate;
        return data;
    };
    return UnenrollEnrollClientCommand;
}());
export { UnenrollEnrollClientCommand };
var CreatePreviewEnrollmentCommand = /** @class */ (function () {
    function CreatePreviewEnrollmentCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreatePreviewEnrollmentCommand.prototype.init = function (_data) {
        if (_data) {
            this.programId = _data["programId"];
            this.startDate = _data["startDate"];
        }
    };
    CreatePreviewEnrollmentCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreatePreviewEnrollmentCommand();
        result.init(data);
        return result;
    };
    CreatePreviewEnrollmentCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        data["startDate"] = this.startDate;
        return data;
    };
    return CreatePreviewEnrollmentCommand;
}());
export { CreatePreviewEnrollmentCommand };
var ChangeEnrollmentStartDateCommand = /** @class */ (function () {
    function ChangeEnrollmentStartDateCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ChangeEnrollmentStartDateCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"];
        }
    };
    ChangeEnrollmentStartDateCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ChangeEnrollmentStartDateCommand();
        result.init(data);
        return result;
    };
    ChangeEnrollmentStartDateCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate;
        return data;
    };
    return ChangeEnrollmentStartDateCommand;
}());
export { ChangeEnrollmentStartDateCommand };
var CreateGroupPostCommentBaseCommand = /** @class */ (function () {
    function CreateGroupPostCommentBaseCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateGroupPostCommentBaseCommand.prototype.init = function (_data) {
        if (_data) {
            this.postId = _data["postId"];
            this.content = _data["content"];
        }
    };
    CreateGroupPostCommentBaseCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateGroupPostCommentBaseCommand();
        result.init(data);
        return result;
    };
    CreateGroupPostCommentBaseCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["postId"] = this.postId;
        data["content"] = this.content;
        return data;
    };
    return CreateGroupPostCommentBaseCommand;
}());
export { CreateGroupPostCommentBaseCommand };
var CreateGroupPostCommentCommand = /** @class */ (function (_super) {
    __extends(CreateGroupPostCommentCommand, _super);
    function CreateGroupPostCommentCommand(data) {
        return _super.call(this, data) || this;
    }
    CreateGroupPostCommentCommand.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
    };
    CreateGroupPostCommentCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateGroupPostCommentCommand();
        result.init(data);
        return result;
    };
    CreateGroupPostCommentCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return CreateGroupPostCommentCommand;
}(CreateGroupPostCommentBaseCommand));
export { CreateGroupPostCommentCommand };
var CreateReplyCommentCommand = /** @class */ (function (_super) {
    __extends(CreateReplyCommentCommand, _super);
    function CreateReplyCommentCommand(data) {
        return _super.call(this, data) || this;
    }
    CreateReplyCommentCommand.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.parentCommentId = _data["parentCommentId"];
        }
    };
    CreateReplyCommentCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateReplyCommentCommand();
        result.init(data);
        return result;
    };
    CreateReplyCommentCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentCommentId"] = this.parentCommentId;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return CreateReplyCommentCommand;
}(CreateGroupPostCommentBaseCommand));
export { CreateReplyCommentCommand };
var AddLikePostCommentCommand = /** @class */ (function () {
    function AddLikePostCommentCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddLikePostCommentCommand.prototype.init = function (_data) {
        if (_data) {
            this.commentId = _data["commentId"];
        }
    };
    AddLikePostCommentCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddLikePostCommentCommand();
        result.init(data);
        return result;
    };
    AddLikePostCommentCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["commentId"] = this.commentId;
        return data;
    };
    return AddLikePostCommentCommand;
}());
export { AddLikePostCommentCommand };
var RemoveLikePostCommentCommand = /** @class */ (function () {
    function RemoveLikePostCommentCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RemoveLikePostCommentCommand.prototype.init = function (_data) {
        if (_data) {
            this.commentId = _data["commentId"];
        }
    };
    RemoveLikePostCommentCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RemoveLikePostCommentCommand();
        result.init(data);
        return result;
    };
    RemoveLikePostCommentCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["commentId"] = this.commentId;
        return data;
    };
    return RemoveLikePostCommentCommand;
}());
export { RemoveLikePostCommentCommand };
var PaginatedListOfCommentBriefDto = /** @class */ (function () {
    function PaginatedListOfCommentBriefDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfCommentBriefDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(CommentBriefDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfCommentBriefDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfCommentBriefDto();
        result.init(data);
        return result;
    };
    PaginatedListOfCommentBriefDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfCommentBriefDto;
}());
export { PaginatedListOfCommentBriefDto };
var CommentBriefDto = /** @class */ (function () {
    function CommentBriefDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CommentBriefDto.prototype.init = function (_data) {
        if (_data) {
            this.content = _data["content"];
            this.parentCommentId = _data["parentCommentId"];
            this.groupPostId = _data["groupPostId"];
            this.id = _data["id"];
            this.lastModified = _data["lastModified"] ? dayjs(_data["lastModified"].toString()) : undefined;
            this.repliesCount = _data["repliesCount"];
            this.likesCount = _data["likesCount"];
            this.likedByMe = _data["likedByMe"];
            if (Array.isArray(_data["likes"])) {
                this.likes = [];
                for (var _i = 0, _a = _data["likes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.likes.push(LikeUserInfoDto.fromJS(item));
                }
            }
        }
    };
    CommentBriefDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CommentBriefDto();
        result.init(data);
        return result;
    };
    CommentBriefDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["parentCommentId"] = this.parentCommentId;
        data["groupPostId"] = this.groupPostId;
        data["id"] = this.id;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined;
        data["repliesCount"] = this.repliesCount;
        data["likesCount"] = this.likesCount;
        data["likedByMe"] = this.likedByMe;
        if (Array.isArray(this.likes)) {
            data["likes"] = [];
            for (var _i = 0, _a = this.likes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["likes"].push(item.toJSON());
            }
        }
        return data;
    };
    return CommentBriefDto;
}());
export { CommentBriefDto };
var LikeUserInfoDto = /** @class */ (function () {
    function LikeUserInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LikeUserInfoDto.prototype.init = function (_data) {
        if (_data) {
            this.createdBy = _data["createdBy"];
        }
    };
    LikeUserInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LikeUserInfoDto();
        result.init(data);
        return result;
    };
    LikeUserInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["createdBy"] = this.createdBy;
        return data;
    };
    return LikeUserInfoDto;
}());
export { LikeUserInfoDto };
var CursorPaginatedListOfGroupPostCommentDto = /** @class */ (function () {
    function CursorPaginatedListOfGroupPostCommentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CursorPaginatedListOfGroupPostCommentDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GroupPostCommentDto.fromJS(item));
                }
            }
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.nextCursor = _data["nextCursor"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    CursorPaginatedListOfGroupPostCommentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CursorPaginatedListOfGroupPostCommentDto();
        result.init(data);
        return result;
    };
    CursorPaginatedListOfGroupPostCommentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["nextCursor"] = this.nextCursor;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return CursorPaginatedListOfGroupPostCommentDto;
}());
export { CursorPaginatedListOfGroupPostCommentDto };
var GroupPostCommentDto = /** @class */ (function (_super) {
    __extends(GroupPostCommentDto, _super);
    function GroupPostCommentDto(data) {
        return _super.call(this, data) || this;
    }
    GroupPostCommentDto.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            if (Array.isArray(_data["likes"])) {
                this.likes = [];
                for (var _i = 0, _a = _data["likes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.likes.push(LikeDto.fromJS(item));
                }
            }
            this.totalLikes = _data["totalLikes"];
            if (Array.isArray(_data["replies"])) {
                this.replies = [];
                for (var _b = 0, _c = _data["replies"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.replies.push(GroupPostCommentReplyDto.fromJS(item));
                }
            }
            this.notification = _data["notification"] ? NotificationDto.fromJS(_data["notification"]) : undefined;
            this.likedByMe = _data["likedByMe"];
            this.content = _data["content"];
            this.formattedDate = _data["formattedDate"];
            this.created = _data["created"] ? dayjs(_data["created"].toString()) : undefined;
            this.author = _data["author"] ? UserBriefInfoDto.fromJS(_data["author"]) : undefined;
            this.parentCommentId = _data["parentCommentId"];
        }
    };
    GroupPostCommentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GroupPostCommentDto();
        result.init(data);
        return result;
    };
    GroupPostCommentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.likes)) {
            data["likes"] = [];
            for (var _i = 0, _a = this.likes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["likes"].push(item.toJSON());
            }
        }
        data["totalLikes"] = this.totalLikes;
        if (Array.isArray(this.replies)) {
            data["replies"] = [];
            for (var _b = 0, _c = this.replies; _b < _c.length; _b++) {
                var item = _c[_b];
                data["replies"].push(item.toJSON());
            }
        }
        data["notification"] = this.notification ? this.notification.toJSON() : undefined;
        data["likedByMe"] = this.likedByMe;
        data["content"] = this.content;
        data["formattedDate"] = this.formattedDate;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["author"] = this.author ? this.author.toJSON() : undefined;
        data["parentCommentId"] = this.parentCommentId;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return GroupPostCommentDto;
}(HasId));
export { GroupPostCommentDto };
var LikeDto = /** @class */ (function () {
    function LikeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LikeDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.author = _data["author"] ? UserBriefInfoDto.fromJS(_data["author"]) : undefined;
        }
    };
    LikeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LikeDto();
        result.init(data);
        return result;
    };
    LikeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["author"] = this.author ? this.author.toJSON() : undefined;
        return data;
    };
    return LikeDto;
}());
export { LikeDto };
var GroupPostCommentReplyDto = /** @class */ (function () {
    function GroupPostCommentReplyDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GroupPostCommentReplyDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["likes"])) {
                this.likes = [];
                for (var _i = 0, _a = _data["likes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.likes.push(LikeDto.fromJS(item));
                }
            }
            this.totalLikes = _data["totalLikes"];
            this.notification = _data["notification"] ? NotificationDto.fromJS(_data["notification"]) : undefined;
            this.likedByMe = _data["likedByMe"];
            this.parentCommentId = _data["parentCommentId"];
            this.content = _data["content"];
            this.createdAt = _data["createdAt"];
            this.created = _data["created"] ? dayjs(_data["created"].toString()) : undefined;
            this.author = _data["author"] ? UserBriefInfoDto.fromJS(_data["author"]) : undefined;
        }
    };
    GroupPostCommentReplyDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GroupPostCommentReplyDto();
        result.init(data);
        return result;
    };
    GroupPostCommentReplyDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.likes)) {
            data["likes"] = [];
            for (var _i = 0, _a = this.likes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["likes"].push(item.toJSON());
            }
        }
        data["totalLikes"] = this.totalLikes;
        data["notification"] = this.notification ? this.notification.toJSON() : undefined;
        data["likedByMe"] = this.likedByMe;
        data["parentCommentId"] = this.parentCommentId;
        data["content"] = this.content;
        data["createdAt"] = this.createdAt;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["author"] = this.author ? this.author.toJSON() : undefined;
        return data;
    };
    return GroupPostCommentReplyDto;
}());
export { GroupPostCommentReplyDto };
var NotificationDto = /** @class */ (function () {
    function NotificationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NotificationDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.read = _data["read"];
            this.userId = _data["userId"];
        }
    };
    NotificationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NotificationDto();
        result.init(data);
        return result;
    };
    NotificationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["read"] = this.read;
        data["userId"] = this.userId;
        return data;
    };
    return NotificationDto;
}());
export { NotificationDto };
var CursorPaginatedListOfGroupPostDto = /** @class */ (function () {
    function CursorPaginatedListOfGroupPostDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CursorPaginatedListOfGroupPostDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GroupPostDto.fromJS(item));
                }
            }
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.nextCursor = _data["nextCursor"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    CursorPaginatedListOfGroupPostDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CursorPaginatedListOfGroupPostDto();
        result.init(data);
        return result;
    };
    CursorPaginatedListOfGroupPostDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["nextCursor"] = this.nextCursor;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return CursorPaginatedListOfGroupPostDto;
}());
export { CursorPaginatedListOfGroupPostDto };
var GroupPostDto = /** @class */ (function (_super) {
    __extends(GroupPostDto, _super);
    function GroupPostDto(data) {
        return _super.call(this, data) || this;
    }
    GroupPostDto.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            if (Array.isArray(_data["likes"])) {
                this.likes = [];
                for (var _i = 0, _a = _data["likes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.likes.push(LikeDto.fromJS(item));
                }
            }
            this.totalLikes = _data["totalLikes"];
            this.totalComments = _data["totalComments"];
            this.likedByMe = _data["likedByMe"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.groupId = _data["groupId"];
            this.formattedDate = _data["formattedDate"];
            this.created = _data["created"] ? dayjs(_data["created"].toString()) : undefined;
            this.notification = _data["notification"] ? NotificationDto.fromJS(_data["notification"]) : undefined;
            this.author = _data["author"] ? UserBriefInfoDto.fromJS(_data["author"]) : undefined;
        }
    };
    GroupPostDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GroupPostDto();
        result.init(data);
        return result;
    };
    GroupPostDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.likes)) {
            data["likes"] = [];
            for (var _i = 0, _a = this.likes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["likes"].push(item.toJSON());
            }
        }
        data["totalLikes"] = this.totalLikes;
        data["totalComments"] = this.totalComments;
        data["likedByMe"] = this.likedByMe;
        data["title"] = this.title;
        data["content"] = this.content;
        data["groupId"] = this.groupId;
        data["formattedDate"] = this.formattedDate;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["notification"] = this.notification ? this.notification.toJSON() : undefined;
        data["author"] = this.author ? this.author.toJSON() : undefined;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return GroupPostDto;
}(HasId));
export { GroupPostDto };
var GroupPostDataChangesCommandOfGroupPostDto = /** @class */ (function () {
    function GroupPostDataChangesCommandOfGroupPostDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GroupPostDataChangesCommandOfGroupPostDto.prototype.init = function (_data) {
        if (_data) {
            this.title = _data["title"];
            this.content = _data["content"];
        }
    };
    GroupPostDataChangesCommandOfGroupPostDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GroupPostDataChangesCommandOfGroupPostDto();
        result.init(data);
        return result;
    };
    GroupPostDataChangesCommandOfGroupPostDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["content"] = this.content;
        return data;
    };
    return GroupPostDataChangesCommandOfGroupPostDto;
}());
export { GroupPostDataChangesCommandOfGroupPostDto };
var CreateGroupPostCommand = /** @class */ (function (_super) {
    __extends(CreateGroupPostCommand, _super);
    function CreateGroupPostCommand(data) {
        return _super.call(this, data) || this;
    }
    CreateGroupPostCommand.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.groupId = _data["groupId"];
        }
    };
    CreateGroupPostCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateGroupPostCommand();
        result.init(data);
        return result;
    };
    CreateGroupPostCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return CreateGroupPostCommand;
}(GroupPostDataChangesCommandOfGroupPostDto));
export { CreateGroupPostCommand };
var AddLikePostCommand = /** @class */ (function () {
    function AddLikePostCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddLikePostCommand.prototype.init = function (_data) {
        if (_data) {
            this.groupPostId = _data["groupPostId"];
        }
    };
    AddLikePostCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddLikePostCommand();
        result.init(data);
        return result;
    };
    AddLikePostCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["groupPostId"] = this.groupPostId;
        return data;
    };
    return AddLikePostCommand;
}());
export { AddLikePostCommand };
var RemoveLikePostCommand = /** @class */ (function () {
    function RemoveLikePostCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RemoveLikePostCommand.prototype.init = function (_data) {
        if (_data) {
            this.groupPostId = _data["groupPostId"];
        }
    };
    RemoveLikePostCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RemoveLikePostCommand();
        result.init(data);
        return result;
    };
    RemoveLikePostCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["groupPostId"] = this.groupPostId;
        return data;
    };
    return RemoveLikePostCommand;
}());
export { RemoveLikePostCommand };
var GroupPostDataChangesCommandOfLong = /** @class */ (function () {
    function GroupPostDataChangesCommandOfLong(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GroupPostDataChangesCommandOfLong.prototype.init = function (_data) {
        if (_data) {
            this.title = _data["title"];
            this.content = _data["content"];
        }
    };
    GroupPostDataChangesCommandOfLong.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GroupPostDataChangesCommandOfLong();
        result.init(data);
        return result;
    };
    GroupPostDataChangesCommandOfLong.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["content"] = this.content;
        return data;
    };
    return GroupPostDataChangesCommandOfLong;
}());
export { GroupPostDataChangesCommandOfLong };
var UpdateGroupPostCommand = /** @class */ (function (_super) {
    __extends(UpdateGroupPostCommand, _super);
    function UpdateGroupPostCommand(data) {
        return _super.call(this, data) || this;
    }
    UpdateGroupPostCommand.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.id = _data["id"];
        }
    };
    UpdateGroupPostCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateGroupPostCommand();
        result.init(data);
        return result;
    };
    UpdateGroupPostCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return UpdateGroupPostCommand;
}(GroupPostDataChangesCommandOfLong));
export { UpdateGroupPostCommand };
var PaginatedListOfGroupDto = /** @class */ (function () {
    function PaginatedListOfGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfGroupDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GroupDto2.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfGroupDto();
        result.init(data);
        return result;
    };
    PaginatedListOfGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfGroupDto;
}());
export { PaginatedListOfGroupDto };
var BaseGroupDto = /** @class */ (function () {
    function BaseGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BaseGroupDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.coachId = _data["coachId"];
            this.name = _data["name"];
            this.archived = _data["archived"];
            this.slugId = _data["slugId"];
            this.slug = _data["slug"];
            this.membersCanNotPost = _data["membersCanNotPost"];
            this.membersCanNotDiscover = _data["membersCanNotDiscover"];
            this.membersCanNotSeeSidebar = _data["membersCanNotSeeSidebar"];
            this.description = _data["description"];
            this.image = _data["image"];
            this.membersCanMessage = _data["membersCanMessage"];
        }
    };
    BaseGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseGroupDto' cannot be instantiated.");
    };
    BaseGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["coachId"] = this.coachId;
        data["name"] = this.name;
        data["archived"] = this.archived;
        data["slugId"] = this.slugId;
        data["slug"] = this.slug;
        data["membersCanNotPost"] = this.membersCanNotPost;
        data["membersCanNotDiscover"] = this.membersCanNotDiscover;
        data["membersCanNotSeeSidebar"] = this.membersCanNotSeeSidebar;
        data["description"] = this.description;
        data["image"] = this.image;
        data["membersCanMessage"] = this.membersCanMessage;
        return data;
    };
    return BaseGroupDto;
}());
export { BaseGroupDto };
var GroupDto2 = /** @class */ (function (_super) {
    __extends(GroupDto2, _super);
    function GroupDto2(data) {
        return _super.call(this, data) || this;
    }
    GroupDto2.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            if (Array.isArray(_data["members"])) {
                this.members = [];
                for (var _i = 0, _a = _data["members"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.members.push(UserBriefInfoDto.fromJS(item));
                }
            }
            this.totalMembersCount = _data["totalMembersCount"];
        }
    };
    GroupDto2.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GroupDto2();
        result.init(data);
        return result;
    };
    GroupDto2.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (var _i = 0, _a = this.members; _i < _a.length; _i++) {
                var item = _a[_i];
                data["members"].push(item.toJSON());
            }
        }
        data["totalMembersCount"] = this.totalMembersCount;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return GroupDto2;
}(BaseGroupDto));
export { GroupDto2 };
export var GroupStatus;
(function (GroupStatus) {
    GroupStatus["ACTIVE"] = "ACTIVE";
    GroupStatus["ARCHIVED"] = "ARCHIVED";
})(GroupStatus || (GroupStatus = {}));
export var GroupOrderBy;
(function (GroupOrderBy) {
    GroupOrderBy["NAME_ASC"] = "NAME_ASC";
    GroupOrderBy["RECENTLY_ACTIVE"] = "RECENTLY_ACTIVE";
})(GroupOrderBy || (GroupOrderBy = {}));
var GroupsCountDto = /** @class */ (function () {
    function GroupsCountDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GroupsCountDto.prototype.init = function (_data) {
        if (_data) {
            this.active = _data["active"];
            this.archived = _data["archived"];
        }
    };
    GroupsCountDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GroupsCountDto();
        result.init(data);
        return result;
    };
    GroupsCountDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["archived"] = this.archived;
        return data;
    };
    return GroupsCountDto;
}());
export { GroupsCountDto };
var GroupSettingsDto = /** @class */ (function () {
    function GroupSettingsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GroupSettingsDto.prototype.init = function (_data) {
        if (_data) {
            this.inviteCode = _data["inviteCode"] ? InviteCodeDto.fromJS(_data["inviteCode"]) : undefined;
        }
    };
    GroupSettingsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GroupSettingsDto();
        result.init(data);
        return result;
    };
    GroupSettingsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["inviteCode"] = this.inviteCode ? this.inviteCode.toJSON() : undefined;
        return data;
    };
    return GroupSettingsDto;
}());
export { GroupSettingsDto };
var InviteCodeDto = /** @class */ (function () {
    function InviteCodeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InviteCodeDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
        }
    };
    InviteCodeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InviteCodeDto();
        result.init(data);
        return result;
    };
    InviteCodeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        return data;
    };
    return InviteCodeDto;
}());
export { InviteCodeDto };
var PaginatedListOfGroupMemberDto = /** @class */ (function () {
    function PaginatedListOfGroupMemberDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfGroupMemberDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GroupMemberDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfGroupMemberDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfGroupMemberDto();
        result.init(data);
        return result;
    };
    PaginatedListOfGroupMemberDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfGroupMemberDto;
}());
export { PaginatedListOfGroupMemberDto };
var GroupMemberDto = /** @class */ (function () {
    function GroupMemberDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GroupMemberDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.username = _data["username"];
            this.displayName = _data["displayName"];
            this.photoUrl = _data["photoUrl"];
        }
    };
    GroupMemberDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GroupMemberDto();
        result.init(data);
        return result;
    };
    GroupMemberDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["username"] = this.username;
        data["displayName"] = this.displayName;
        data["photoUrl"] = this.photoUrl;
        return data;
    };
    return GroupMemberDto;
}());
export { GroupMemberDto };
var ArchiveGroupCommand = /** @class */ (function () {
    function ArchiveGroupCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ArchiveGroupCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.archived = _data["archived"];
        }
    };
    ArchiveGroupCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ArchiveGroupCommand();
        result.init(data);
        return result;
    };
    ArchiveGroupCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["archived"] = this.archived;
        return data;
    };
    return ArchiveGroupCommand;
}());
export { ArchiveGroupCommand };
var GroupCreatedInfoDto = /** @class */ (function () {
    function GroupCreatedInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GroupCreatedInfoDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.slug = _data["slug"];
            this.slugId = _data["slugId"];
        }
    };
    GroupCreatedInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GroupCreatedInfoDto();
        result.init(data);
        return result;
    };
    GroupCreatedInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slug"] = this.slug;
        data["slugId"] = this.slugId;
        return data;
    };
    return GroupCreatedInfoDto;
}());
export { GroupCreatedInfoDto };
var CreateGroupCommand = /** @class */ (function () {
    function CreateGroupCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateGroupCommand.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
        }
    };
    CreateGroupCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateGroupCommand();
        result.init(data);
        return result;
    };
    CreateGroupCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    };
    return CreateGroupCommand;
}());
export { CreateGroupCommand };
var UpdateGroupCommand = /** @class */ (function () {
    function UpdateGroupCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateGroupCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.membersCanNotPost = _data["membersCanNotPost"];
            this.membersCanNotDiscover = _data["membersCanNotDiscover"];
            this.membersCanNotSeeSidebar = _data["membersCanNotSeeSidebar"];
            this.image = _data["image"];
            this.membersCanMessage = _data["membersCanMessage"];
        }
    };
    UpdateGroupCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateGroupCommand();
        result.init(data);
        return result;
    };
    UpdateGroupCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["membersCanNotPost"] = this.membersCanNotPost;
        data["membersCanNotDiscover"] = this.membersCanNotDiscover;
        data["membersCanNotSeeSidebar"] = this.membersCanNotSeeSidebar;
        data["image"] = this.image;
        data["membersCanMessage"] = this.membersCanMessage;
        return data;
    };
    return UpdateGroupCommand;
}());
export { UpdateGroupCommand };
var BaseInviteCode = /** @class */ (function () {
    function BaseInviteCode(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BaseInviteCode.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.link = _data["link"];
        }
    };
    BaseInviteCode.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BaseInviteCode();
        result.init(data);
        return result;
    };
    BaseInviteCode.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["link"] = this.link;
        return data;
    };
    return BaseInviteCode;
}());
export { BaseInviteCode };
var CreateInviteCodeCommand = /** @class */ (function () {
    function CreateInviteCodeCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateInviteCodeCommand.prototype.init = function (_data) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.programId = _data["programId"];
            this.startDate = _data["startDate"] ? dayjs(_data["startDate"].toString()) : undefined;
        }
    };
    CreateInviteCodeCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateInviteCodeCommand();
        result.init(data);
        return result;
    };
    CreateInviteCodeCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["programId"] = this.programId;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : undefined;
        return data;
    };
    return CreateInviteCodeCommand;
}());
export { CreateInviteCodeCommand };
var UpdateInviteCodeStartDateCommand = /** @class */ (function () {
    function UpdateInviteCodeStartDateCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateInviteCodeStartDateCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? dayjs(_data["startDate"].toString()) : undefined;
        }
    };
    UpdateInviteCodeStartDateCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateInviteCodeStartDateCommand();
        result.init(data);
        return result;
    };
    UpdateInviteCodeStartDateCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : undefined;
        return data;
    };
    return UpdateInviteCodeStartDateCommand;
}());
export { UpdateInviteCodeStartDateCommand };
var InviteInfoDto = /** @class */ (function () {
    function InviteInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InviteInfoDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.accepted = _data["accepted"];
            this.workspaceInfo = _data["workspaceInfo"] ? WorkspaceInfoDto.fromJS(_data["workspaceInfo"]) : undefined;
            this.coachInfo = _data["coachInfo"] ? CoachInfoDto.fromJS(_data["coachInfo"]) : undefined;
        }
    };
    InviteInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InviteInfoDto();
        result.init(data);
        return result;
    };
    InviteInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["accepted"] = this.accepted;
        data["workspaceInfo"] = this.workspaceInfo ? this.workspaceInfo.toJSON() : undefined;
        data["coachInfo"] = this.coachInfo ? this.coachInfo.toJSON() : undefined;
        return data;
    };
    return InviteInfoDto;
}());
export { InviteInfoDto };
var WorkspaceInfoDto = /** @class */ (function () {
    function WorkspaceInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WorkspaceInfoDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.slug = _data["slug"];
            this.message = _data["message"];
            this.logoUrl = _data["logoUrl"];
            this.primaryColor = _data["primaryColor"];
            this.mealLogging = _data["mealLogging"];
            this.brandedApp = _data["brandedApp"] ? BrandedAppDto.fromJS(_data["brandedApp"]) : undefined;
        }
    };
    WorkspaceInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WorkspaceInfoDto();
        result.init(data);
        return result;
    };
    WorkspaceInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["slug"] = this.slug;
        data["message"] = this.message;
        data["logoUrl"] = this.logoUrl;
        data["primaryColor"] = this.primaryColor;
        data["mealLogging"] = this.mealLogging;
        data["brandedApp"] = this.brandedApp ? this.brandedApp.toJSON() : undefined;
        return data;
    };
    return WorkspaceInfoDto;
}());
export { WorkspaceInfoDto };
var BrandedAppDto = /** @class */ (function () {
    function BrandedAppDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BrandedAppDto.prototype.init = function (_data) {
        if (_data) {
            this.status = _data["status"];
            this.name = _data["name"];
            this.logoUrl = _data["logoUrl"];
            this.appleStoreUrl = _data["appleStoreUrl"];
            this.googlePlayUrl = _data["googlePlayUrl"];
        }
    };
    BrandedAppDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BrandedAppDto();
        result.init(data);
        return result;
    };
    BrandedAppDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["name"] = this.name;
        data["logoUrl"] = this.logoUrl;
        data["appleStoreUrl"] = this.appleStoreUrl;
        data["googlePlayUrl"] = this.googlePlayUrl;
        return data;
    };
    return BrandedAppDto;
}());
export { BrandedAppDto };
export var BrandedAppStatus;
(function (BrandedAppStatus) {
    BrandedAppStatus[BrandedAppStatus["NONE"] = 0] = "NONE";
    BrandedAppStatus[BrandedAppStatus["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    BrandedAppStatus[BrandedAppStatus["PUBLISHED"] = 2] = "PUBLISHED";
})(BrandedAppStatus || (BrandedAppStatus = {}));
var CoachInfoDto = /** @class */ (function () {
    function CoachInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CoachInfoDto.prototype.init = function (_data) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.id = _data["id"];
        }
    };
    CoachInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CoachInfoDto();
        result.init(data);
        return result;
    };
    CoachInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["id"] = this.id;
        return data;
    };
    return CoachInfoDto;
}());
export { CoachInfoDto };
var ValidatedInviteCodeDto = /** @class */ (function () {
    function ValidatedInviteCodeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ValidatedInviteCodeDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.coachInfo = _data["coachInfo"] ? CoachInviteInfoDto.fromJS(_data["coachInfo"]) : undefined;
            this.groupInfo = _data["groupInfo"] ? GroupInviteInfoDto.fromJS(_data["groupInfo"]) : undefined;
            this.programInfo = _data["programInfo"] ? InviteToProgramDto.fromJS(_data["programInfo"]) : undefined;
            this.workspaceInfo = _data["workspaceInfo"] ? WorkspaceInfoDto.fromJS(_data["workspaceInfo"]) : undefined;
        }
    };
    ValidatedInviteCodeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ValidatedInviteCodeDto();
        result.init(data);
        return result;
    };
    ValidatedInviteCodeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["coachInfo"] = this.coachInfo ? this.coachInfo.toJSON() : undefined;
        data["groupInfo"] = this.groupInfo ? this.groupInfo.toJSON() : undefined;
        data["programInfo"] = this.programInfo ? this.programInfo.toJSON() : undefined;
        data["workspaceInfo"] = this.workspaceInfo ? this.workspaceInfo.toJSON() : undefined;
        return data;
    };
    return ValidatedInviteCodeDto;
}());
export { ValidatedInviteCodeDto };
var CoachInviteInfoDto = /** @class */ (function () {
    function CoachInviteInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CoachInviteInfoDto.prototype.init = function (_data) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.photoURL = _data["photoURL"];
            this.id = _data["id"];
            this.clientsCountNoSample = _data["clientsCountNoSample"];
            this.plan = _data["plan"];
        }
    };
    CoachInviteInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CoachInviteInfoDto();
        result.init(data);
        return result;
    };
    CoachInviteInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["photoURL"] = this.photoURL;
        data["id"] = this.id;
        data["clientsCountNoSample"] = this.clientsCountNoSample;
        data["plan"] = this.plan;
        return data;
    };
    return CoachInviteInfoDto;
}());
export { CoachInviteInfoDto };
var GroupInviteInfoDto = /** @class */ (function () {
    function GroupInviteInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GroupInviteInfoDto.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.image = _data["image"];
            this.id = _data["id"];
        }
    };
    GroupInviteInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GroupInviteInfoDto();
        result.init(data);
        return result;
    };
    GroupInviteInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["image"] = this.image;
        data["id"] = this.id;
        return data;
    };
    return GroupInviteInfoDto;
}());
export { GroupInviteInfoDto };
var InviteToProgramDto = /** @class */ (function () {
    function InviteToProgramDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InviteToProgramDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.slug = _data["slug"];
            this.image = _data["image"];
            this.description = _data["description"];
            this.length = _data["length"];
        }
    };
    InviteToProgramDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InviteToProgramDto();
        result.init(data);
        return result;
    };
    InviteToProgramDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["slug"] = this.slug;
        data["image"] = this.image;
        data["description"] = this.description;
        data["length"] = this.length;
        return data;
    };
    return InviteToProgramDto;
}());
export { InviteToProgramDto };
var ValidateInviteCodeCommand = /** @class */ (function () {
    function ValidateInviteCodeCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ValidateInviteCodeCommand.prototype.init = function (_data) {
        if (_data) {
            this.code = _data["code"];
        }
    };
    ValidateInviteCodeCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ValidateInviteCodeCommand();
        result.init(data);
        return result;
    };
    ValidateInviteCodeCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    };
    return ValidateInviteCodeCommand;
}());
export { ValidateInviteCodeCommand };
var EmailLinkResult = /** @class */ (function () {
    function EmailLinkResult(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EmailLinkResult.prototype.init = function (_data) {
        if (_data) {
            this.sent = _data["sent"];
            this.nextAttemptIn = _data["nextAttemptIn"];
        }
    };
    EmailLinkResult.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EmailLinkResult();
        result.init(data);
        return result;
    };
    EmailLinkResult.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sent"] = this.sent;
        data["nextAttemptIn"] = this.nextAttemptIn;
        return data;
    };
    return EmailLinkResult;
}());
export { EmailLinkResult };
var ClientLinkInviteCommand = /** @class */ (function () {
    function ClientLinkInviteCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientLinkInviteCommand.prototype.init = function (_data) {
        if (_data) {
            this.email = _data["email"];
            this.code = _data["code"];
        }
    };
    ClientLinkInviteCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientLinkInviteCommand();
        result.init(data);
        return result;
    };
    ClientLinkInviteCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["code"] = this.code;
        return data;
    };
    return ClientLinkInviteCommand;
}());
export { ClientLinkInviteCommand };
var BatchInviteClientsCommand = /** @class */ (function () {
    function BatchInviteClientsCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchInviteClientsCommand.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["emails"])) {
                this.emails = [];
                for (var _i = 0, _a = _data["emails"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.emails.push(item);
                }
            }
            this.message = _data["message"];
        }
    };
    BatchInviteClientsCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchInviteClientsCommand();
        result.init(data);
        return result;
    };
    BatchInviteClientsCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (var _i = 0, _a = this.emails; _i < _a.length; _i++) {
                var item = _a[_i];
                data["emails"].push(item);
            }
        }
        data["message"] = this.message;
        return data;
    };
    return BatchInviteClientsCommand;
}());
export { BatchInviteClientsCommand };
var InviteAddedClientDto = /** @class */ (function () {
    function InviteAddedClientDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InviteAddedClientDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.invitedAt = _data["invitedAt"] ? dayjs(_data["invitedAt"].toString()) : undefined;
            this.client = _data["client"] ? ClientInfoDto2.fromJS(_data["client"]) : undefined;
        }
    };
    InviteAddedClientDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InviteAddedClientDto();
        result.init(data);
        return result;
    };
    InviteAddedClientDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["invitedAt"] = this.invitedAt ? this.invitedAt.toISOString() : undefined;
        data["client"] = this.client ? this.client.toJSON() : undefined;
        return data;
    };
    return InviteAddedClientDto;
}());
export { InviteAddedClientDto };
var InviteAddedClientsCommand = /** @class */ (function () {
    function InviteAddedClientsCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InviteAddedClientsCommand.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [];
                for (var _i = 0, _a = _data["ids"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.ids.push(item);
                }
            }
            this.message = _data["message"];
        }
    };
    InviteAddedClientsCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InviteAddedClientsCommand();
        result.init(data);
        return result;
    };
    InviteAddedClientsCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (var _i = 0, _a = this.ids; _i < _a.length; _i++) {
                var item = _a[_i];
                data["ids"].push(item);
            }
        }
        data["message"] = this.message;
        return data;
    };
    return InviteAddedClientsCommand;
}());
export { InviteAddedClientsCommand };
var ResendInviteCommand = /** @class */ (function () {
    function ResendInviteCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResendInviteCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
        }
    };
    ResendInviteCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResendInviteCommand();
        result.init(data);
        return result;
    };
    ResendInviteCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return ResendInviteCommand;
}());
export { ResendInviteCommand };
var ResendClientVerificationLinkCommand = /** @class */ (function () {
    function ResendClientVerificationLinkCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResendClientVerificationLinkCommand.prototype.init = function (_data) {
        if (_data) {
            this.email = _data["email"];
        }
    };
    ResendClientVerificationLinkCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResendClientVerificationLinkCommand();
        result.init(data);
        return result;
    };
    ResendClientVerificationLinkCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    };
    return ResendClientVerificationLinkCommand;
}());
export { ResendClientVerificationLinkCommand };
var PaginatedListOfMealLoggingDto = /** @class */ (function () {
    function PaginatedListOfMealLoggingDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfMealLoggingDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(MealLoggingDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfMealLoggingDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfMealLoggingDto();
        result.init(data);
        return result;
    };
    PaginatedListOfMealLoggingDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfMealLoggingDto;
}());
export { PaginatedListOfMealLoggingDto };
var MealLoggingDto = /** @class */ (function () {
    function MealLoggingDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MealLoggingDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? dayjs(_data["date"].toString()) : undefined;
            this.description = _data["description"];
            this.photoUrl = _data["photoUrl"];
            this.answers = _data["answers"];
            this.time = _data["time"];
        }
    };
    MealLoggingDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MealLoggingDto();
        result.init(data);
        return result;
    };
    MealLoggingDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined;
        data["description"] = this.description;
        data["photoUrl"] = this.photoUrl;
        data["answers"] = this.answers;
        data["time"] = this.time;
        return data;
    };
    return MealLoggingDto;
}());
export { MealLoggingDto };
var CreateMealLoggingCommand = /** @class */ (function () {
    function CreateMealLoggingCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateMealLoggingCommand.prototype.init = function (_data) {
        if (_data) {
            this.photoUrl = _data["photoUrl"];
            this.description = _data["description"];
            this.answers = _data["answers"];
            this.date = _data["date"];
            this.time = _data["time"];
        }
    };
    CreateMealLoggingCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateMealLoggingCommand();
        result.init(data);
        return result;
    };
    CreateMealLoggingCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["photoUrl"] = this.photoUrl;
        data["description"] = this.description;
        data["answers"] = this.answers;
        data["date"] = this.date;
        data["time"] = this.time;
        return data;
    };
    return CreateMealLoggingCommand;
}());
export { CreateMealLoggingCommand };
var UpdateMealLoggingCommand = /** @class */ (function () {
    function UpdateMealLoggingCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateMealLoggingCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.photoUrl = _data["photoUrl"];
            this.date = _data["date"];
            this.time = _data["time"];
            this.description = _data["description"];
            this.answers = _data["answers"];
        }
    };
    UpdateMealLoggingCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateMealLoggingCommand();
        result.init(data);
        return result;
    };
    UpdateMealLoggingCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["photoUrl"] = this.photoUrl;
        data["date"] = this.date;
        data["time"] = this.time;
        data["description"] = this.description;
        data["answers"] = this.answers;
        return data;
    };
    return UpdateMealLoggingCommand;
}());
export { UpdateMealLoggingCommand };
var PaginatedListOfRecipientsDto = /** @class */ (function () {
    function PaginatedListOfRecipientsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfRecipientsDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(RecipientsDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfRecipientsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfRecipientsDto();
        result.init(data);
        return result;
    };
    PaginatedListOfRecipientsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfRecipientsDto;
}());
export { PaginatedListOfRecipientsDto };
var RecipientsDto = /** @class */ (function () {
    function RecipientsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RecipientsDto.prototype.init = function (_data) {
        if (_data) {
            this.user = _data["user"] ? MessageUserDto.fromJS(_data["user"]) : undefined;
            this.group = _data["group"] ? MessageGroupDto.fromJS(_data["group"]) : undefined;
        }
    };
    RecipientsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RecipientsDto();
        result.init(data);
        return result;
    };
    RecipientsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined;
        data["group"] = this.group ? this.group.toJSON() : undefined;
        return data;
    };
    return RecipientsDto;
}());
export { RecipientsDto };
var MessageUserDto = /** @class */ (function (_super) {
    __extends(MessageUserDto, _super);
    function MessageUserDto(data) {
        return _super.call(this, data) || this;
    }
    MessageUserDto.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
    };
    MessageUserDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MessageUserDto();
        result.init(data);
        return result;
    };
    MessageUserDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return MessageUserDto;
}(BaseUserDto));
export { MessageUserDto };
var MessageGroupDto = /** @class */ (function () {
    function MessageGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MessageGroupDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.slug = _data["slug"];
            this.memberCount = _data["memberCount"];
        }
    };
    MessageGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MessageGroupDto();
        result.init(data);
        return result;
    };
    MessageGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["slug"] = this.slug;
        data["memberCount"] = this.memberCount;
        return data;
    };
    return MessageGroupDto;
}());
export { MessageGroupDto };
var MessageDto = /** @class */ (function () {
    function MessageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MessageDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.formattedDate = _data["formattedDate"];
            this.content = _data["content"];
            this.direction = _data["direction"];
            this.messageAuthor = _data["messageAuthor"] ? MessageAuthorDto.fromJS(_data["messageAuthor"]) : undefined;
        }
    };
    MessageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MessageDto();
        result.init(data);
        return result;
    };
    MessageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formattedDate"] = this.formattedDate;
        data["content"] = this.content;
        data["direction"] = this.direction;
        data["messageAuthor"] = this.messageAuthor ? this.messageAuthor.toJSON() : undefined;
        return data;
    };
    return MessageDto;
}());
export { MessageDto };
export var MessageDirection;
(function (MessageDirection) {
    MessageDirection["OUTGOING"] = "OUTGOING";
    MessageDirection["INCOMING"] = "INCOMING";
})(MessageDirection || (MessageDirection = {}));
var MessageAuthorDto = /** @class */ (function (_super) {
    __extends(MessageAuthorDto, _super);
    function MessageAuthorDto(data) {
        return _super.call(this, data) || this;
    }
    MessageAuthorDto.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
    };
    MessageAuthorDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MessageAuthorDto();
        result.init(data);
        return result;
    };
    MessageAuthorDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return MessageAuthorDto;
}(BaseUserDto));
export { MessageAuthorDto };
var CreateMessageCommand = /** @class */ (function () {
    function CreateMessageCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateMessageCommand.prototype.init = function (_data) {
        if (_data) {
            this.recipient = _data["recipient"];
            this.content = _data["content"];
        }
    };
    CreateMessageCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateMessageCommand();
        result.init(data);
        return result;
    };
    CreateMessageCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["recipient"] = this.recipient;
        data["content"] = this.content;
        return data;
    };
    return CreateMessageCommand;
}());
export { CreateMessageCommand };
var CreateManyMessagesCommand = /** @class */ (function () {
    function CreateManyMessagesCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateManyMessagesCommand.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [];
                for (var _i = 0, _a = _data["recipients"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.recipients.push(item);
                }
            }
            this.content = _data["content"];
        }
    };
    CreateManyMessagesCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateManyMessagesCommand();
        result.init(data);
        return result;
    };
    CreateManyMessagesCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (var _i = 0, _a = this.recipients; _i < _a.length; _i++) {
                var item = _a[_i];
                data["recipients"].push(item);
            }
        }
        data["content"] = this.content;
        return data;
    };
    return CreateManyMessagesCommand;
}());
export { CreateManyMessagesCommand };
var CursorPaginatedListOfNotificationBriefDto = /** @class */ (function () {
    function CursorPaginatedListOfNotificationBriefDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CursorPaginatedListOfNotificationBriefDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(NotificationBriefDto.fromJS(item));
                }
            }
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.nextCursor = _data["nextCursor"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    CursorPaginatedListOfNotificationBriefDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CursorPaginatedListOfNotificationBriefDto();
        result.init(data);
        return result;
    };
    CursorPaginatedListOfNotificationBriefDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["nextCursor"] = this.nextCursor;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return CursorPaginatedListOfNotificationBriefDto;
}());
export { CursorPaginatedListOfNotificationBriefDto };
var NotificationBriefDto = /** @class */ (function (_super) {
    __extends(NotificationBriefDto, _super);
    function NotificationBriefDto(data) {
        return _super.call(this, data) || this;
    }
    NotificationBriefDto.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.deleted = _data["deleted"];
            this.read = _data["read"];
            this.created = _data["created"] ? dayjs(_data["created"].toString()) : undefined;
            this.activityFeedback = _data["activityFeedback"] ? NotificationActivityFeedbackDto.fromJS(_data["activityFeedback"]) : undefined;
            this.clientForm = _data["clientForm"] ? NotificationClientFormDto.fromJS(_data["clientForm"]) : undefined;
            this.groupComment = _data["groupComment"] ? NotificationGroupCommentDto.fromJS(_data["groupComment"]) : undefined;
            this.groupPost = _data["groupPost"] ? NotificationGroupPostDto.fromJS(_data["groupPost"]) : undefined;
            this.message = _data["message"] ? NotificationMessageDto.fromJS(_data["message"]) : undefined;
            this.author = _data["author"] ? AuthorDto.fromJS(_data["author"]) : undefined;
        }
    };
    NotificationBriefDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NotificationBriefDto();
        result.init(data);
        return result;
    };
    NotificationBriefDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deleted"] = this.deleted;
        data["read"] = this.read;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["activityFeedback"] = this.activityFeedback ? this.activityFeedback.toJSON() : undefined;
        data["clientForm"] = this.clientForm ? this.clientForm.toJSON() : undefined;
        data["groupComment"] = this.groupComment ? this.groupComment.toJSON() : undefined;
        data["groupPost"] = this.groupPost ? this.groupPost.toJSON() : undefined;
        data["message"] = this.message ? this.message.toJSON() : undefined;
        data["author"] = this.author ? this.author.toJSON() : undefined;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return NotificationBriefDto;
}(HasId));
export { NotificationBriefDto };
var NotificationActivityFeedbackDto = /** @class */ (function () {
    function NotificationActivityFeedbackDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NotificationActivityFeedbackDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
            this.formattedDate = _data["formattedDate"];
            this.activity = _data["activity"] ? NotificationActivityDto.fromJS(_data["activity"]) : undefined;
        }
    };
    NotificationActivityFeedbackDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NotificationActivityFeedbackDto();
        result.init(data);
        return result;
    };
    NotificationActivityFeedbackDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        data["formattedDate"] = this.formattedDate;
        data["activity"] = this.activity ? this.activity.toJSON() : undefined;
        return data;
    };
    return NotificationActivityFeedbackDto;
}());
export { NotificationActivityFeedbackDto };
var NotificationActivityDto = /** @class */ (function () {
    function NotificationActivityDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NotificationActivityDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? dayjs(_data["date"].toString()) : undefined;
            this.type = _data["type"];
            this.component = _data["component"] ? NotificationComponentDto.fromJS(_data["component"]) : undefined;
            this.clientForm = _data["clientForm"] ? NotificationClientFormDto.fromJS(_data["clientForm"]) : undefined;
        }
    };
    NotificationActivityDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NotificationActivityDto();
        result.init(data);
        return result;
    };
    NotificationActivityDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined;
        data["type"] = this.type;
        data["component"] = this.component ? this.component.toJSON() : undefined;
        data["clientForm"] = this.clientForm ? this.clientForm.toJSON() : undefined;
        return data;
    };
    return NotificationActivityDto;
}());
export { NotificationActivityDto };
var NotificationComponentDto = /** @class */ (function () {
    function NotificationComponentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NotificationComponentDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.slug = _data["slug"];
            this.program = _data["program"] ? NotificationProgramDto.fromJS(_data["program"]) : undefined;
        }
    };
    NotificationComponentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NotificationComponentDto();
        result.init(data);
        return result;
    };
    NotificationComponentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["slug"] = this.slug;
        data["program"] = this.program ? this.program.toJSON() : undefined;
        return data;
    };
    return NotificationComponentDto;
}());
export { NotificationComponentDto };
var NotificationProgramDto = /** @class */ (function () {
    function NotificationProgramDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NotificationProgramDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.slug = _data["slug"];
        }
    };
    NotificationProgramDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NotificationProgramDto();
        result.init(data);
        return result;
    };
    NotificationProgramDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["slug"] = this.slug;
        return data;
    };
    return NotificationProgramDto;
}());
export { NotificationProgramDto };
var NotificationClientFormDto = /** @class */ (function () {
    function NotificationClientFormDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NotificationClientFormDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.slug = _data["slug"];
            this.formattedDate = _data["formattedDate"];
        }
    };
    NotificationClientFormDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NotificationClientFormDto();
        result.init(data);
        return result;
    };
    NotificationClientFormDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["slug"] = this.slug;
        data["formattedDate"] = this.formattedDate;
        return data;
    };
    return NotificationClientFormDto;
}());
export { NotificationClientFormDto };
var NotificationGroupCommentDto = /** @class */ (function () {
    function NotificationGroupCommentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NotificationGroupCommentDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
            this.formattedDate = _data["formattedDate"];
            this.groupPost = _data["groupPost"] ? NotificationGroupPostDto.fromJS(_data["groupPost"]) : undefined;
            this.parentCommentId = _data["parentCommentId"];
        }
    };
    NotificationGroupCommentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NotificationGroupCommentDto();
        result.init(data);
        return result;
    };
    NotificationGroupCommentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        data["formattedDate"] = this.formattedDate;
        data["groupPost"] = this.groupPost ? this.groupPost.toJSON() : undefined;
        data["parentCommentId"] = this.parentCommentId;
        return data;
    };
    return NotificationGroupCommentDto;
}());
export { NotificationGroupCommentDto };
var NotificationGroupPostDto = /** @class */ (function () {
    function NotificationGroupPostDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NotificationGroupPostDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.formattedDate = _data["formattedDate"];
            this.group = _data["group"] ? NotificationGroupDto.fromJS(_data["group"]) : undefined;
        }
    };
    NotificationGroupPostDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NotificationGroupPostDto();
        result.init(data);
        return result;
    };
    NotificationGroupPostDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["content"] = this.content;
        data["formattedDate"] = this.formattedDate;
        data["group"] = this.group ? this.group.toJSON() : undefined;
        return data;
    };
    return NotificationGroupPostDto;
}());
export { NotificationGroupPostDto };
var NotificationGroupDto = /** @class */ (function () {
    function NotificationGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NotificationGroupDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.slug = _data["slug"];
            this.name = _data["name"];
        }
    };
    NotificationGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NotificationGroupDto();
        result.init(data);
        return result;
    };
    NotificationGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slug"] = this.slug;
        data["name"] = this.name;
        return data;
    };
    return NotificationGroupDto;
}());
export { NotificationGroupDto };
var NotificationMessageDto = /** @class */ (function () {
    function NotificationMessageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NotificationMessageDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
            this.formattedDate = _data["formattedDate"];
            this.notified = _data["notified"];
        }
    };
    NotificationMessageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NotificationMessageDto();
        result.init(data);
        return result;
    };
    NotificationMessageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        data["formattedDate"] = this.formattedDate;
        data["notified"] = this.notified;
        return data;
    };
    return NotificationMessageDto;
}());
export { NotificationMessageDto };
var AuthorDto = /** @class */ (function () {
    function AuthorDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AuthorDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.displayName = _data["displayName"];
            this.photoUrl = _data["photoUrl"];
        }
    };
    AuthorDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AuthorDto();
        result.init(data);
        return result;
    };
    AuthorDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["displayName"] = this.displayName;
        data["photoUrl"] = this.photoUrl;
        return data;
    };
    return AuthorDto;
}());
export { AuthorDto };
var NotificationDto2 = /** @class */ (function (_super) {
    __extends(NotificationDto2, _super);
    function NotificationDto2(data) {
        return _super.call(this, data) || this;
    }
    NotificationDto2.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.activityFeedbackDto = _data["activityFeedbackDto"] ? ActivityFeedbackDto.fromJS(_data["activityFeedbackDto"]) : undefined;
            this.groupPostCommentDto = _data["groupPostCommentDto"] ? GroupPostCommentDto.fromJS(_data["groupPostCommentDto"]) : undefined;
            this.groupPostDto = _data["groupPostDto"] ? GroupPostDto.fromJS(_data["groupPostDto"]) : undefined;
            this.messageDto = _data["messageDto"] ? MessageDto.fromJS(_data["messageDto"]) : undefined;
        }
    };
    NotificationDto2.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NotificationDto2();
        result.init(data);
        return result;
    };
    NotificationDto2.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["activityFeedbackDto"] = this.activityFeedbackDto ? this.activityFeedbackDto.toJSON() : undefined;
        data["groupPostCommentDto"] = this.groupPostCommentDto ? this.groupPostCommentDto.toJSON() : undefined;
        data["groupPostDto"] = this.groupPostDto ? this.groupPostDto.toJSON() : undefined;
        data["messageDto"] = this.messageDto ? this.messageDto.toJSON() : undefined;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return NotificationDto2;
}(NotificationBriefDto));
export { NotificationDto2 };
var ClickNotificationCommand = /** @class */ (function () {
    function ClickNotificationCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClickNotificationCommand.prototype.init = function (_data) {
    };
    ClickNotificationCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClickNotificationCommand();
        result.init(data);
        return result;
    };
    ClickNotificationCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        return data;
    };
    return ClickNotificationCommand;
}());
export { ClickNotificationCommand };
var SetDeleteNotificationCommand = /** @class */ (function () {
    function SetDeleteNotificationCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SetDeleteNotificationCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.activityFeedbackId = _data["activityFeedbackId"];
            this.groupPostId = _data["groupPostId"];
            this.groupPostCommentId = _data["groupPostCommentId"];
        }
    };
    SetDeleteNotificationCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SetDeleteNotificationCommand();
        result.init(data);
        return result;
    };
    SetDeleteNotificationCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityFeedbackId"] = this.activityFeedbackId;
        data["groupPostId"] = this.groupPostId;
        data["groupPostCommentId"] = this.groupPostCommentId;
        return data;
    };
    return SetDeleteNotificationCommand;
}());
export { SetDeleteNotificationCommand };
var ReadNotificationCommand = /** @class */ (function () {
    function ReadNotificationCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReadNotificationCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.activityFeedbackId = _data["activityFeedbackId"];
            this.groupPostId = _data["groupPostId"];
            this.groupPostCommentId = _data["groupPostCommentId"];
            this.clientFormId = _data["clientFormId"];
            this.messageId = _data["messageId"];
        }
    };
    ReadNotificationCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReadNotificationCommand();
        result.init(data);
        return result;
    };
    ReadNotificationCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityFeedbackId"] = this.activityFeedbackId;
        data["groupPostId"] = this.groupPostId;
        data["groupPostCommentId"] = this.groupPostCommentId;
        data["clientFormId"] = this.clientFormId;
        data["messageId"] = this.messageId;
        return data;
    };
    return ReadNotificationCommand;
}());
export { ReadNotificationCommand };
var ReadAllNotificationsCommand = /** @class */ (function () {
    function ReadAllNotificationsCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReadAllNotificationsCommand.prototype.init = function (_data) {
    };
    ReadAllNotificationsCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReadAllNotificationsCommand();
        result.init(data);
        return result;
    };
    ReadAllNotificationsCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        return data;
    };
    return ReadAllNotificationsCommand;
}());
export { ReadAllNotificationsCommand };
var UpdateNotificationsSettingsCommand = /** @class */ (function () {
    function UpdateNotificationsSettingsCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateNotificationsSettingsCommand.prototype.init = function (_data) {
        if (_data) {
            this.weeklyUpdate = _data["weeklyUpdate"];
            this.dailyUpdate = _data["dailyUpdate"];
            this.newMessageEmail = _data["newMessageEmail"];
            this.newResponseEmail = _data["newResponseEmail"];
            this.activityCompletion = _data["activityCompletion"];
            this.remindersEmail = _data["remindersEmail"];
            this.remindersSms = _data["remindersSms"];
            this.remindersPush = _data["remindersPush"];
            this.newMessagePush = _data["newMessagePush"];
            this.newResponsePush = _data["newResponsePush"];
            this.newGroupPostEmail = _data["newGroupPostEmail"];
            this.newGroupPostPush = _data["newGroupPostPush"];
            this.groupReplyEmail = _data["groupReplyEmail"];
            this.groupReplyPush = _data["groupReplyPush"];
        }
    };
    UpdateNotificationsSettingsCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateNotificationsSettingsCommand();
        result.init(data);
        return result;
    };
    UpdateNotificationsSettingsCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["weeklyUpdate"] = this.weeklyUpdate;
        data["dailyUpdate"] = this.dailyUpdate;
        data["newMessageEmail"] = this.newMessageEmail;
        data["newResponseEmail"] = this.newResponseEmail;
        data["activityCompletion"] = this.activityCompletion;
        data["remindersEmail"] = this.remindersEmail;
        data["remindersSms"] = this.remindersSms;
        data["remindersPush"] = this.remindersPush;
        data["newMessagePush"] = this.newMessagePush;
        data["newResponsePush"] = this.newResponsePush;
        data["newGroupPostEmail"] = this.newGroupPostEmail;
        data["newGroupPostPush"] = this.newGroupPostPush;
        data["groupReplyEmail"] = this.groupReplyEmail;
        data["groupReplyPush"] = this.groupReplyPush;
        return data;
    };
    return UpdateNotificationsSettingsCommand;
}());
export { UpdateNotificationsSettingsCommand };
var NotificationsSettingDto = /** @class */ (function () {
    function NotificationsSettingDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NotificationsSettingDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.weeklyUpdate = _data["weeklyUpdate"];
            this.dailyUpdate = _data["dailyUpdate"];
            this.newMessageEmail = _data["newMessageEmail"];
            this.newResponseEmail = _data["newResponseEmail"];
            this.activityCompletion = _data["activityCompletion"];
            this.remindersEmail = _data["remindersEmail"];
            this.remindersSms = _data["remindersSms"];
            this.remindersPush = _data["remindersPush"];
            this.newMessagePush = _data["newMessagePush"];
            this.newResponsePush = _data["newResponsePush"];
            this.newGroupPostEmail = _data["newGroupPostEmail"];
            this.newGroupPostPush = _data["newGroupPostPush"];
            this.groupReplyEmail = _data["groupReplyEmail"];
            this.groupReplyPush = _data["groupReplyPush"];
        }
    };
    NotificationsSettingDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NotificationsSettingDto();
        result.init(data);
        return result;
    };
    NotificationsSettingDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["weeklyUpdate"] = this.weeklyUpdate;
        data["dailyUpdate"] = this.dailyUpdate;
        data["newMessageEmail"] = this.newMessageEmail;
        data["newResponseEmail"] = this.newResponseEmail;
        data["activityCompletion"] = this.activityCompletion;
        data["remindersEmail"] = this.remindersEmail;
        data["remindersSms"] = this.remindersSms;
        data["remindersPush"] = this.remindersPush;
        data["newMessagePush"] = this.newMessagePush;
        data["newResponsePush"] = this.newResponsePush;
        data["newGroupPostEmail"] = this.newGroupPostEmail;
        data["newGroupPostPush"] = this.newGroupPostPush;
        data["groupReplyEmail"] = this.groupReplyEmail;
        data["groupReplyPush"] = this.groupReplyPush;
        return data;
    };
    return NotificationsSettingDto;
}());
export { NotificationsSettingDto };
var NutritionEntryDto = /** @class */ (function () {
    function NutritionEntryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NutritionEntryDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.date = _data["date"] ? dayjs(_data["date"].toString()) : undefined;
            this.calories = _data["calories"];
            this.carbs = _data["carbs"];
            this.fat = _data["fat"];
            this.protein = _data["protein"];
            this.cholesterol = _data["cholesterol"];
            this.fiber = _data["fiber"];
            this.sugar = _data["sugar"];
            this.sodium = _data["sodium"];
            this.transFat = _data["transFat"];
            this.alcohol = _data["alcohol"];
            this.lastModified = _data["lastModified"] ? dayjs(_data["lastModified"].toString()) : undefined;
        }
    };
    NutritionEntryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NutritionEntryDto();
        result.init(data);
        return result;
    };
    NutritionEntryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined;
        data["calories"] = this.calories;
        data["carbs"] = this.carbs;
        data["fat"] = this.fat;
        data["protein"] = this.protein;
        data["cholesterol"] = this.cholesterol;
        data["fiber"] = this.fiber;
        data["sugar"] = this.sugar;
        data["sodium"] = this.sodium;
        data["transFat"] = this.transFat;
        data["alcohol"] = this.alcohol;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined;
        return data;
    };
    return NutritionEntryDto;
}());
export { NutritionEntryDto };
var CreateNutritionEntryCommand = /** @class */ (function () {
    function CreateNutritionEntryCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateNutritionEntryCommand.prototype.init = function (_data) {
        if (_data) {
            this.date = _data["date"] ? dayjs(_data["date"].toString()) : undefined;
            this.protein = _data["protein"];
            this.carbs = _data["carbs"];
            this.fat = _data["fat"];
            this.calories = _data["calories"];
        }
    };
    CreateNutritionEntryCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateNutritionEntryCommand();
        result.init(data);
        return result;
    };
    CreateNutritionEntryCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined;
        data["protein"] = this.protein;
        data["carbs"] = this.carbs;
        data["fat"] = this.fat;
        data["calories"] = this.calories;
        return data;
    };
    return CreateNutritionEntryCommand;
}());
export { CreateNutritionEntryCommand };
var UpdateNutritionEntryCommand = /** @class */ (function () {
    function UpdateNutritionEntryCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateNutritionEntryCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? dayjs(_data["date"].toString()) : undefined;
            this.protein = _data["protein"];
            this.carbs = _data["carbs"];
            this.fat = _data["fat"];
            this.calories = _data["calories"];
            this.cholesterol = _data["cholesterol"];
            this.fiber = _data["fiber"];
            this.sugar = _data["sugar"];
            this.sodium = _data["sodium"];
            this.transFat = _data["transFat"];
            this.alcohol = _data["alcohol"];
        }
    };
    UpdateNutritionEntryCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateNutritionEntryCommand();
        result.init(data);
        return result;
    };
    UpdateNutritionEntryCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined;
        data["protein"] = this.protein;
        data["carbs"] = this.carbs;
        data["fat"] = this.fat;
        data["calories"] = this.calories;
        data["cholesterol"] = this.cholesterol;
        data["fiber"] = this.fiber;
        data["sugar"] = this.sugar;
        data["sodium"] = this.sodium;
        data["transFat"] = this.transFat;
        data["alcohol"] = this.alcohol;
        return data;
    };
    return UpdateNutritionEntryCommand;
}());
export { UpdateNutritionEntryCommand };
var NutritionTargetDto = /** @class */ (function () {
    function NutritionTargetDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NutritionTargetDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.trackingType = _data["trackingType"];
            this.carbs = _data["carbs"];
            this.protein = _data["protein"];
            this.fat = _data["fat"];
            this.targetType = _data["targetType"];
            this.commentType = _data["commentType"];
            this.calories = _data["calories"];
            this.date = _data["date"] ? dayjs(_data["date"].toString()) : undefined;
            this.ordinal = _data["ordinal"];
            this.lastModified = _data["lastModified"] ? dayjs(_data["lastModified"].toString()) : undefined;
        }
    };
    NutritionTargetDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NutritionTargetDto();
        result.init(data);
        return result;
    };
    NutritionTargetDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["trackingType"] = this.trackingType;
        data["carbs"] = this.carbs;
        data["protein"] = this.protein;
        data["fat"] = this.fat;
        data["targetType"] = this.targetType;
        data["commentType"] = this.commentType;
        data["calories"] = this.calories;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined;
        data["ordinal"] = this.ordinal;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined;
        return data;
    };
    return NutritionTargetDto;
}());
export { NutritionTargetDto };
export var NutritionTrackingType;
(function (NutritionTrackingType) {
    NutritionTrackingType["MACROS"] = "MACROS";
    NutritionTrackingType["PORTIONS"] = "PORTIONS";
})(NutritionTrackingType || (NutritionTrackingType = {}));
export var NutritionTargetType;
(function (NutritionTargetType) {
    NutritionTargetType["TRAINING_DAYS"] = "TRAINING_DAYS";
    NutritionTargetType["OFF_DAYS"] = "OFF_DAYS";
    NutritionTargetType["REFEED_DAYS"] = "REFEED_DAYS";
    NutritionTargetType["WEEKDAYS"] = "WEEKDAYS";
    NutritionTargetType["WEEKENDS"] = "WEEKENDS";
    NutritionTargetType["ALL_DAYS"] = "ALL_DAYS";
})(NutritionTargetType || (NutritionTargetType = {}));
export var NutritionCommentType;
(function (NutritionCommentType) {
    NutritionCommentType["FULL_MACROS"] = "FULL_MACROS";
    NutritionCommentType["PROTEIN_CALORIES"] = "PROTEIN_CALORIES";
    NutritionCommentType["CALORIES_ONLY"] = "CALORIES_ONLY";
    NutritionCommentType["PROTEIN_ONLY"] = "PROTEIN_ONLY";
    NutritionCommentType["TRACKING_ONLY"] = "TRACKING_ONLY";
})(NutritionCommentType || (NutritionCommentType = {}));
var NutritionTargetCommand = /** @class */ (function () {
    function NutritionTargetCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NutritionTargetCommand.prototype.init = function (_data) {
        if (_data) {
            this.trackingType = _data["trackingType"];
            this.carbs = _data["carbs"];
            this.protein = _data["protein"];
            this.fat = _data["fat"];
            this.targetType = _data["targetType"];
            this.commentType = _data["commentType"];
            this.calories = _data["calories"];
            this.date = _data["date"] ? dayjs(_data["date"].toString()) : undefined;
        }
    };
    NutritionTargetCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'NutritionTargetCommand' cannot be instantiated.");
    };
    NutritionTargetCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["trackingType"] = this.trackingType;
        data["carbs"] = this.carbs;
        data["protein"] = this.protein;
        data["fat"] = this.fat;
        data["targetType"] = this.targetType;
        data["commentType"] = this.commentType;
        data["calories"] = this.calories;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined;
        return data;
    };
    return NutritionTargetCommand;
}());
export { NutritionTargetCommand };
var CreateNutritionTargetCommand = /** @class */ (function (_super) {
    __extends(CreateNutritionTargetCommand, _super);
    function CreateNutritionTargetCommand(data) {
        return _super.call(this, data) || this;
    }
    CreateNutritionTargetCommand.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.clientId = _data["clientId"];
        }
    };
    CreateNutritionTargetCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateNutritionTargetCommand();
        result.init(data);
        return result;
    };
    CreateNutritionTargetCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return CreateNutritionTargetCommand;
}(NutritionTargetCommand));
export { CreateNutritionTargetCommand };
var UpdateNutritionTargetCommand = /** @class */ (function (_super) {
    __extends(UpdateNutritionTargetCommand, _super);
    function UpdateNutritionTargetCommand(data) {
        return _super.call(this, data) || this;
    }
    UpdateNutritionTargetCommand.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.id = _data["id"];
        }
    };
    UpdateNutritionTargetCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateNutritionTargetCommand();
        result.init(data);
        return result;
    };
    UpdateNutritionTargetCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return UpdateNutritionTargetCommand;
}(NutritionTargetCommand));
export { UpdateNutritionTargetCommand };
var ReorderNutritionTargetCommand = /** @class */ (function () {
    function ReorderNutritionTargetCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReorderNutritionTargetCommand.prototype.init = function (_data) {
        if (_data) {
            this.clientId = _data["clientId"];
            if (_data["idsToOrdinals"]) {
                this.idsToOrdinals = {};
                for (var key in _data["idsToOrdinals"]) {
                    if (_data["idsToOrdinals"].hasOwnProperty(key))
                        this.idsToOrdinals[key] = _data["idsToOrdinals"][key];
                }
            }
        }
    };
    ReorderNutritionTargetCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReorderNutritionTargetCommand();
        result.init(data);
        return result;
    };
    ReorderNutritionTargetCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        if (this.idsToOrdinals) {
            data["idsToOrdinals"] = {};
            for (var key in this.idsToOrdinals) {
                if (this.idsToOrdinals.hasOwnProperty(key))
                    data["idsToOrdinals"][key] = this.idsToOrdinals[key];
            }
        }
        return data;
    };
    return ReorderNutritionTargetCommand;
}());
export { ReorderNutritionTargetCommand };
var ApplySingleOrdinalNutritionTargetsCommand = /** @class */ (function () {
    function ApplySingleOrdinalNutritionTargetsCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApplySingleOrdinalNutritionTargetsCommand.prototype.init = function (_data) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.id = _data["id"];
            this.ordinal = _data["ordinal"];
        }
    };
    ApplySingleOrdinalNutritionTargetsCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApplySingleOrdinalNutritionTargetsCommand();
        result.init(data);
        return result;
    };
    ApplySingleOrdinalNutritionTargetsCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["id"] = this.id;
        data["ordinal"] = this.ordinal;
        return data;
    };
    return ApplySingleOrdinalNutritionTargetsCommand;
}());
export { ApplySingleOrdinalNutritionTargetsCommand };
var ProgramFolderDto = /** @class */ (function () {
    function ProgramFolderDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProgramFolderDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    ProgramFolderDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProgramFolderDto();
        result.init(data);
        return result;
    };
    ProgramFolderDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    return ProgramFolderDto;
}());
export { ProgramFolderDto };
var CreateProgramFolderCommand = /** @class */ (function () {
    function CreateProgramFolderCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateProgramFolderCommand.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
        }
    };
    CreateProgramFolderCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateProgramFolderCommand();
        result.init(data);
        return result;
    };
    CreateProgramFolderCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    };
    return CreateProgramFolderCommand;
}());
export { CreateProgramFolderCommand };
var UpdateProgramFolderCommand = /** @class */ (function () {
    function UpdateProgramFolderCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateProgramFolderCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    UpdateProgramFolderCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateProgramFolderCommand();
        result.init(data);
        return result;
    };
    UpdateProgramFolderCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    return UpdateProgramFolderCommand;
}());
export { UpdateProgramFolderCommand };
var PaginatedListOfProgramDto = /** @class */ (function () {
    function PaginatedListOfProgramDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfProgramDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ProgramDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfProgramDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfProgramDto();
        result.init(data);
        return result;
    };
    PaginatedListOfProgramDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfProgramDto;
}());
export { PaginatedListOfProgramDto };
var ProgramDto = /** @class */ (function (_super) {
    __extends(ProgramDto, _super);
    function ProgramDto(data) {
        return _super.call(this, data) || this;
    }
    ProgramDto.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.folderId = _data["folderId"];
            this.createdFromNow = _data["createdFromNow"];
            this.enrolledTotal = _data["enrolledTotal"];
            if (Array.isArray(_data["clients"])) {
                this.clients = [];
                for (var _i = 0, _a = _data["clients"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.clients.push(UserBriefInfoDto.fromJS(item));
                }
            }
        }
    };
    ProgramDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProgramDto();
        result.init(data);
        return result;
    };
    ProgramDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["folderId"] = this.folderId;
        data["createdFromNow"] = this.createdFromNow;
        data["enrolledTotal"] = this.enrolledTotal;
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (var _i = 0, _a = this.clients; _i < _a.length; _i++) {
                var item = _a[_i];
                data["clients"].push(item.toJSON());
            }
        }
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return ProgramDto;
}(BaseProgramDto));
export { ProgramDto };
export var ProgramOrderBy;
(function (ProgramOrderBy) {
    ProgramOrderBy["NAME_DESC"] = "NAME_DESC";
    ProgramOrderBy["NAME_ASC"] = "NAME_ASC";
    ProgramOrderBy["DATE_ADDED_ASC"] = "DATE_ADDED_ASC";
    ProgramOrderBy["DATE_ADDED_DESC"] = "DATE_ADDED_DESC";
})(ProgramOrderBy || (ProgramOrderBy = {}));
var ProgramWeeksInfoDto = /** @class */ (function () {
    function ProgramWeeksInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProgramWeeksInfoDto.prototype.init = function (_data) {
        if (_data) {
            this.programSlug = _data["programSlug"];
            if (Array.isArray(_data["weeks"])) {
                this.weeks = [];
                for (var _i = 0, _a = _data["weeks"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.weeks.push(WeeksInfoDto.fromJS(item));
                }
            }
        }
    };
    ProgramWeeksInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProgramWeeksInfoDto();
        result.init(data);
        return result;
    };
    ProgramWeeksInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["programSlug"] = this.programSlug;
        if (Array.isArray(this.weeks)) {
            data["weeks"] = [];
            for (var _i = 0, _a = this.weeks; _i < _a.length; _i++) {
                var item = _a[_i];
                data["weeks"].push(item.toJSON());
            }
        }
        return data;
    };
    return ProgramWeeksInfoDto;
}());
export { ProgramWeeksInfoDto };
var WeeksInfoDto = /** @class */ (function () {
    function WeeksInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WeeksInfoDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.weekNumber = _data["weekNumber"];
        }
    };
    WeeksInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WeeksInfoDto();
        result.init(data);
        return result;
    };
    WeeksInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["weekNumber"] = this.weekNumber;
        return data;
    };
    return WeeksInfoDto;
}());
export { WeeksInfoDto };
var ProgramsCountDto = /** @class */ (function () {
    function ProgramsCountDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProgramsCountDto.prototype.init = function (_data) {
        if (_data) {
            this.draft = _data["draft"];
        }
    };
    ProgramsCountDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProgramsCountDto();
        result.init(data);
        return result;
    };
    ProgramsCountDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["draft"] = this.draft;
        return data;
    };
    return ProgramsCountDto;
}());
export { ProgramsCountDto };
var CurriculumVm = /** @class */ (function () {
    function CurriculumVm(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CurriculumVm.prototype.init = function (_data) {
        if (_data) {
            this.curriculum = _data["curriculum"] ? CurriculumDto.fromJS(_data["curriculum"]) : undefined;
        }
    };
    CurriculumVm.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CurriculumVm();
        result.init(data);
        return result;
    };
    CurriculumVm.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["curriculum"] = this.curriculum ? this.curriculum.toJSON() : undefined;
        return data;
    };
    return CurriculumVm;
}());
export { CurriculumVm };
var CurriculumDto = /** @class */ (function (_super) {
    __extends(CurriculumDto, _super);
    function CurriculumDto(data) {
        return _super.call(this, data) || this;
    }
    CurriculumDto.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.defaultView = _data["defaultView"];
            if (Array.isArray(_data["weeks"])) {
                this.weeks = [];
                for (var _i = 0, _a = _data["weeks"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.weeks.push(WeekDto.fromJS(item));
                }
            }
        }
    };
    CurriculumDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CurriculumDto();
        result.init(data);
        return result;
    };
    CurriculumDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["defaultView"] = this.defaultView;
        if (Array.isArray(this.weeks)) {
            data["weeks"] = [];
            for (var _i = 0, _a = this.weeks; _i < _a.length; _i++) {
                var item = _a[_i];
                data["weeks"].push(item.toJSON());
            }
        }
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return CurriculumDto;
}(BaseProgramDto));
export { CurriculumDto };
var WeekDto = /** @class */ (function (_super) {
    __extends(WeekDto, _super);
    function WeekDto(data) {
        return _super.call(this, data) || this;
    }
    WeekDto.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            if (Array.isArray(_data["components"])) {
                this.components = [];
                for (var _i = 0, _a = _data["components"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.components.push(ComponentDto2.fromJS(item));
                }
            }
        }
    };
    WeekDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WeekDto();
        result.init(data);
        return result;
    };
    WeekDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (var _i = 0, _a = this.components; _i < _a.length; _i++) {
                var item = _a[_i];
                data["components"].push(item.toJSON());
            }
        }
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return WeekDto;
}(BaseWeekDto));
export { WeekDto };
var ProgramSettingsDto = /** @class */ (function () {
    function ProgramSettingsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProgramSettingsDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.slug = _data["slug"];
            this.slugId = _data["slugId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.length = _data["length"];
            this.defaultView = _data["defaultView"];
            this.image = _data["image"];
            this.inviteCode = _data["inviteCode"] ? ProgramInviteCodeDto.fromJS(_data["inviteCode"]) : undefined;
        }
    };
    ProgramSettingsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProgramSettingsDto();
        result.init(data);
        return result;
    };
    ProgramSettingsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["slug"] = this.slug;
        data["slugId"] = this.slugId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["length"] = this.length;
        data["defaultView"] = this.defaultView;
        data["image"] = this.image;
        data["inviteCode"] = this.inviteCode ? this.inviteCode.toJSON() : undefined;
        return data;
    };
    return ProgramSettingsDto;
}());
export { ProgramSettingsDto };
var ProgramInviteCodeDto = /** @class */ (function () {
    function ProgramInviteCodeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProgramInviteCodeDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.startDate = _data["startDate"] ? dayjs(_data["startDate"].toString()) : undefined;
        }
    };
    ProgramInviteCodeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProgramInviteCodeDto();
        result.init(data);
        return result;
    };
    ProgramInviteCodeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : undefined;
        return data;
    };
    return ProgramInviteCodeDto;
}());
export { ProgramInviteCodeDto };
var PaginatedListOfProgramEnrollDto = /** @class */ (function () {
    function PaginatedListOfProgramEnrollDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfProgramEnrollDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ProgramEnrollDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfProgramEnrollDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfProgramEnrollDto();
        result.init(data);
        return result;
    };
    PaginatedListOfProgramEnrollDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfProgramEnrollDto;
}());
export { PaginatedListOfProgramEnrollDto };
var ProgramEnrollDto = /** @class */ (function () {
    function ProgramEnrollDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProgramEnrollDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.length = _data["length"];
            this.image = _data["image"];
        }
    };
    ProgramEnrollDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProgramEnrollDto();
        result.init(data);
        return result;
    };
    ProgramEnrollDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["length"] = this.length;
        data["image"] = this.image;
        return data;
    };
    return ProgramEnrollDto;
}());
export { ProgramEnrollDto };
var ProgramDataCommand = /** @class */ (function () {
    function ProgramDataCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProgramDataCommand.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.length = _data["length"];
            this.image = _data["image"];
            this.defaultView = _data["defaultView"];
        }
    };
    ProgramDataCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProgramDataCommand();
        result.init(data);
        return result;
    };
    ProgramDataCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["length"] = this.length;
        data["image"] = this.image;
        data["defaultView"] = this.defaultView;
        return data;
    };
    return ProgramDataCommand;
}());
export { ProgramDataCommand };
var CreateProgramCommand = /** @class */ (function (_super) {
    __extends(CreateProgramCommand, _super);
    function CreateProgramCommand(data) {
        return _super.call(this, data) || this;
    }
    CreateProgramCommand.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
    };
    CreateProgramCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateProgramCommand();
        result.init(data);
        return result;
    };
    CreateProgramCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return CreateProgramCommand;
}(ProgramDataCommand));
export { CreateProgramCommand };
var DuplicateProgramResponse = /** @class */ (function () {
    function DuplicateProgramResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DuplicateProgramResponse.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.slug = _data["slug"];
        }
    };
    DuplicateProgramResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DuplicateProgramResponse();
        result.init(data);
        return result;
    };
    DuplicateProgramResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slug"] = this.slug;
        return data;
    };
    return DuplicateProgramResponse;
}());
export { DuplicateProgramResponse };
var DuplicateProgramCommand = /** @class */ (function () {
    function DuplicateProgramCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DuplicateProgramCommand.prototype.init = function (_data) {
        if (_data) {
            this.programId = _data["programId"];
        }
    };
    DuplicateProgramCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DuplicateProgramCommand();
        result.init(data);
        return result;
    };
    DuplicateProgramCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        return data;
    };
    return DuplicateProgramCommand;
}());
export { DuplicateProgramCommand };
var ArchiveProgramCommand = /** @class */ (function () {
    function ArchiveProgramCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ArchiveProgramCommand.prototype.init = function (_data) {
        if (_data) {
            this.programId = _data["programId"];
        }
    };
    ArchiveProgramCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ArchiveProgramCommand();
        result.init(data);
        return result;
    };
    ArchiveProgramCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        return data;
    };
    return ArchiveProgramCommand;
}());
export { ArchiveProgramCommand };
var RestoreProgramCommand = /** @class */ (function () {
    function RestoreProgramCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RestoreProgramCommand.prototype.init = function (_data) {
        if (_data) {
            this.programId = _data["programId"];
        }
    };
    RestoreProgramCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RestoreProgramCommand();
        result.init(data);
        return result;
    };
    RestoreProgramCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        return data;
    };
    return RestoreProgramCommand;
}());
export { RestoreProgramCommand };
var HandleProgramFolderCommand = /** @class */ (function () {
    function HandleProgramFolderCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HandleProgramFolderCommand.prototype.init = function (_data) {
        if (_data) {
            this.programId = _data["programId"];
            this.folderId = _data["folderId"];
        }
    };
    HandleProgramFolderCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HandleProgramFolderCommand();
        result.init(data);
        return result;
    };
    HandleProgramFolderCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        data["folderId"] = this.folderId;
        return data;
    };
    return HandleProgramFolderCommand;
}());
export { HandleProgramFolderCommand };
var UpdateProgramCommand = /** @class */ (function (_super) {
    __extends(UpdateProgramCommand, _super);
    function UpdateProgramCommand(data) {
        return _super.call(this, data) || this;
    }
    UpdateProgramCommand.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    };
    UpdateProgramCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateProgramCommand();
        result.init(data);
        return result;
    };
    UpdateProgramCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return UpdateProgramCommand;
}(ProgramDataCommand));
export { UpdateProgramCommand };
var LockProgramCommand = /** @class */ (function () {
    function LockProgramCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LockProgramCommand.prototype.init = function (_data) {
        if (_data) {
            this.programId = _data["programId"];
        }
    };
    LockProgramCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LockProgramCommand();
        result.init(data);
        return result;
    };
    LockProgramCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        return data;
    };
    return LockProgramCommand;
}());
export { LockProgramCommand };
var UnlockProgramCommand = /** @class */ (function () {
    function UnlockProgramCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UnlockProgramCommand.prototype.init = function (_data) {
        if (_data) {
            this.programId = _data["programId"];
        }
    };
    UnlockProgramCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UnlockProgramCommand();
        result.init(data);
        return result;
    };
    UnlockProgramCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        return data;
    };
    return UnlockProgramCommand;
}());
export { UnlockProgramCommand };
var ProgramTemplatesVm = /** @class */ (function () {
    function ProgramTemplatesVm(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProgramTemplatesVm.prototype.init = function (_data) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["programTemplates"])) {
                this.programTemplates = [];
                for (var _i = 0, _a = _data["programTemplates"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.programTemplates.push(ProgramTemplateDto.fromJS(item));
                }
            }
        }
    };
    ProgramTemplatesVm.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProgramTemplatesVm();
        result.init(data);
        return result;
    };
    ProgramTemplatesVm.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.programTemplates)) {
            data["programTemplates"] = [];
            for (var _i = 0, _a = this.programTemplates; _i < _a.length; _i++) {
                var item = _a[_i];
                data["programTemplates"].push(item.toJSON());
            }
        }
        return data;
    };
    return ProgramTemplatesVm;
}());
export { ProgramTemplatesVm };
var ProgramTemplateDto = /** @class */ (function () {
    function ProgramTemplateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProgramTemplateDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.image = _data["image"];
            this.description = _data["description"];
            this.length = _data["length"];
            this.used = _data["used"];
            this.category = _data["category"];
        }
    };
    ProgramTemplateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProgramTemplateDto();
        result.init(data);
        return result;
    };
    ProgramTemplateDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["image"] = this.image;
        data["description"] = this.description;
        data["length"] = this.length;
        data["used"] = this.used;
        data["category"] = this.category;
        return data;
    };
    return ProgramTemplateDto;
}());
export { ProgramTemplateDto };
var UseProgramTemplateCommand = /** @class */ (function () {
    function UseProgramTemplateCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UseProgramTemplateCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
        }
    };
    UseProgramTemplateCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UseProgramTemplateCommand();
        result.init(data);
        return result;
    };
    UseProgramTemplateCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return UseProgramTemplateCommand;
}());
export { UseProgramTemplateCommand };
var CreatedSetIds = /** @class */ (function () {
    function CreatedSetIds(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreatedSetIds.prototype.init = function (_data) {
        if (_data) {
            this.setId = _data["setId"];
            if (_data["photoIds"]) {
                this.photoIds = {};
                for (var key in _data["photoIds"]) {
                    if (_data["photoIds"].hasOwnProperty(key))
                        this.photoIds[key] = _data["photoIds"][key];
                }
            }
        }
    };
    CreatedSetIds.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreatedSetIds();
        result.init(data);
        return result;
    };
    CreatedSetIds.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["setId"] = this.setId;
        if (this.photoIds) {
            data["photoIds"] = {};
            for (var key in this.photoIds) {
                if (this.photoIds.hasOwnProperty(key))
                    data["photoIds"][key] = this.photoIds[key];
            }
        }
        return data;
    };
    return CreatedSetIds;
}());
export { CreatedSetIds };
var CreateProgressPhotoSetCommand = /** @class */ (function () {
    function CreateProgressPhotoSetCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateProgressPhotoSetCommand.prototype.init = function (_data) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.takenOn = _data["takenOn"];
            this.name = _data["name"];
            if (Array.isArray(_data["photos"])) {
                this.photos = [];
                for (var _i = 0, _a = _data["photos"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.photos.push(ProgressPhotoDto.fromJS(item));
                }
            }
        }
    };
    CreateProgressPhotoSetCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateProgressPhotoSetCommand();
        result.init(data);
        return result;
    };
    CreateProgressPhotoSetCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["takenOn"] = this.takenOn;
        data["name"] = this.name;
        if (Array.isArray(this.photos)) {
            data["photos"] = [];
            for (var _i = 0, _a = this.photos; _i < _a.length; _i++) {
                var item = _a[_i];
                data["photos"].push(item.toJSON());
            }
        }
        return data;
    };
    return CreateProgressPhotoSetCommand;
}());
export { CreateProgressPhotoSetCommand };
var ProgressPhotoDto = /** @class */ (function () {
    function ProgressPhotoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProgressPhotoDto.prototype.init = function (_data) {
        if (_data) {
            this.title = _data["title"];
            this.url = _data["url"];
            this.fileName = _data["fileName"];
            this.size = _data["size"];
        }
    };
    ProgressPhotoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProgressPhotoDto();
        result.init(data);
        return result;
    };
    ProgressPhotoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["url"] = this.url;
        data["fileName"] = this.fileName;
        data["size"] = this.size;
        return data;
    };
    return ProgressPhotoDto;
}());
export { ProgressPhotoDto };
var UpdateProgressPhotoSetCommand = /** @class */ (function () {
    function UpdateProgressPhotoSetCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateProgressPhotoSetCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.takenOn = _data["takenOn"];
            this.name = _data["name"];
            if (Array.isArray(_data["photos"])) {
                this.photos = [];
                for (var _i = 0, _a = _data["photos"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.photos.push(ProgressPhotoDto.fromJS(item));
                }
            }
        }
    };
    UpdateProgressPhotoSetCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateProgressPhotoSetCommand();
        result.init(data);
        return result;
    };
    UpdateProgressPhotoSetCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["takenOn"] = this.takenOn;
        data["name"] = this.name;
        if (Array.isArray(this.photos)) {
            data["photos"] = [];
            for (var _i = 0, _a = this.photos; _i < _a.length; _i++) {
                var item = _a[_i];
                data["photos"].push(item.toJSON());
            }
        }
        return data;
    };
    return UpdateProgressPhotoSetCommand;
}());
export { UpdateProgressPhotoSetCommand };
var PaginatedListOfProgressPhotoSetDto = /** @class */ (function () {
    function PaginatedListOfProgressPhotoSetDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfProgressPhotoSetDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ProgressPhotoSetDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfProgressPhotoSetDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfProgressPhotoSetDto();
        result.init(data);
        return result;
    };
    PaginatedListOfProgressPhotoSetDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfProgressPhotoSetDto;
}());
export { PaginatedListOfProgressPhotoSetDto };
var ProgressPhotoSetDto = /** @class */ (function () {
    function ProgressPhotoSetDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProgressPhotoSetDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.takenOn = _data["takenOn"] ? dayjs(_data["takenOn"].toString()) : undefined;
            this.name = _data["name"];
            if (Array.isArray(_data["photos"])) {
                this.photos = [];
                for (var _i = 0, _a = _data["photos"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.photos.push(ProgressPhotoDto.fromJS(item));
                }
            }
            this.activityId = _data["activityId"];
        }
    };
    ProgressPhotoSetDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProgressPhotoSetDto();
        result.init(data);
        return result;
    };
    ProgressPhotoSetDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["takenOn"] = this.takenOn ? this.takenOn.format('YYYY-MM-DD') : undefined;
        data["name"] = this.name;
        if (Array.isArray(this.photos)) {
            data["photos"] = [];
            for (var _i = 0, _a = this.photos; _i < _a.length; _i++) {
                var item = _a[_i];
                data["photos"].push(item.toJSON());
            }
        }
        data["activityId"] = this.activityId;
        return data;
    };
    return ProgressPhotoSetDto;
}());
export { ProgressPhotoSetDto };
var PaginatedListOfPaginatedProgressPhotoDto = /** @class */ (function () {
    function PaginatedListOfPaginatedProgressPhotoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfPaginatedProgressPhotoDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(PaginatedProgressPhotoDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfPaginatedProgressPhotoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfPaginatedProgressPhotoDto();
        result.init(data);
        return result;
    };
    PaginatedListOfPaginatedProgressPhotoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfPaginatedProgressPhotoDto;
}());
export { PaginatedListOfPaginatedProgressPhotoDto };
var PaginatedProgressPhotoDto = /** @class */ (function () {
    function PaginatedProgressPhotoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedProgressPhotoDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.url = _data["url"];
            this.fileName = _data["fileName"];
            this.size = _data["size"];
            this.weight = _data["weight"];
            this.weightUnit = _data["weightUnit"];
            this.progressPhotoSetId = _data["progressPhotoSetId"];
            this.takenOn = _data["takenOn"];
        }
    };
    PaginatedProgressPhotoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedProgressPhotoDto();
        result.init(data);
        return result;
    };
    PaginatedProgressPhotoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["url"] = this.url;
        data["fileName"] = this.fileName;
        data["size"] = this.size;
        data["weight"] = this.weight;
        data["weightUnit"] = this.weightUnit;
        data["progressPhotoSetId"] = this.progressPhotoSetId;
        data["takenOn"] = this.takenOn;
        return data;
    };
    return PaginatedProgressPhotoDto;
}());
export { PaginatedProgressPhotoDto };
var CreateStepCountCommand = /** @class */ (function () {
    function CreateStepCountCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateStepCountCommand.prototype.init = function (_data) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.targetDate = _data["targetDate"];
            this.steps = _data["steps"];
        }
    };
    CreateStepCountCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateStepCountCommand();
        result.init(data);
        return result;
    };
    CreateStepCountCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["targetDate"] = this.targetDate;
        data["steps"] = this.steps;
        return data;
    };
    return CreateStepCountCommand;
}());
export { CreateStepCountCommand };
var UpdateStepCountCommand = /** @class */ (function () {
    function UpdateStepCountCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateStepCountCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.targetDate = _data["targetDate"];
            this.steps = _data["steps"];
        }
    };
    UpdateStepCountCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateStepCountCommand();
        result.init(data);
        return result;
    };
    UpdateStepCountCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["targetDate"] = this.targetDate;
        data["steps"] = this.steps;
        return data;
    };
    return UpdateStepCountCommand;
}());
export { UpdateStepCountCommand };
var StepsCountDto = /** @class */ (function () {
    function StepsCountDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StepsCountDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.targetDate = _data["targetDate"];
            this.count = _data["count"];
            this.manual = _data["manual"];
        }
    };
    StepsCountDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StepsCountDto();
        result.init(data);
        return result;
    };
    StepsCountDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["targetDate"] = this.targetDate;
        data["count"] = this.count;
        data["manual"] = this.manual;
        return data;
    };
    return StepsCountDto;
}());
export { StepsCountDto };
var SignedUrlVm = /** @class */ (function () {
    function SignedUrlVm(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SignedUrlVm.prototype.init = function (_data) {
        if (_data) {
            this.url = _data["url"];
            this.objectUri = _data["objectUri"];
        }
    };
    SignedUrlVm.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SignedUrlVm();
        result.init(data);
        return result;
    };
    SignedUrlVm.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["objectUri"] = this.objectUri;
        return data;
    };
    return SignedUrlVm;
}());
export { SignedUrlVm };
var CreateSignedUrlCommand = /** @class */ (function () {
    function CreateSignedUrlCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateSignedUrlCommand.prototype.init = function (_data) {
        if (_data) {
            this.refId = _data["refId"];
            this.refType = _data["refType"];
            this.assetType = _data["assetType"];
            this.file = _data["file"];
        }
    };
    CreateSignedUrlCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateSignedUrlCommand();
        result.init(data);
        return result;
    };
    CreateSignedUrlCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["refId"] = this.refId;
        data["refType"] = this.refType;
        data["assetType"] = this.assetType;
        data["file"] = this.file;
        return data;
    };
    return CreateSignedUrlCommand;
}());
export { CreateSignedUrlCommand };
export var AssetType;
(function (AssetType) {
    AssetType["USER_PHOTO"] = "USER_PHOTO";
    AssetType["PROGRAM_IMAGE"] = "PROGRAM_IMAGE";
    AssetType["PROGRAM_AUDIO"] = "PROGRAM_AUDIO";
    AssetType["PROGRAM_VIDEO"] = "PROGRAM_VIDEO";
    AssetType["PROGRAM_FILE"] = "PROGRAM_FILE";
    AssetType["PROGRAM_CHECKIN_PHOTO"] = "PROGRAM_CHECKIN_PHOTO";
    AssetType["PROGRAM_CHECKIN_FILE"] = "PROGRAM_CHECKIN_FILE";
    AssetType["PROGRAM_COVER"] = "PROGRAM_COVER";
    AssetType["MESSAGE_IMAGE"] = "MESSAGE_IMAGE";
    AssetType["MESSAGE_FILE"] = "MESSAGE_FILE";
    AssetType["LIBRARY_FILE"] = "LIBRARY_FILE";
    AssetType["LIBRARY_IMAGE"] = "LIBRARY_IMAGE";
    AssetType["LIBRARY_AUDIO"] = "LIBRARY_AUDIO";
    AssetType["LIBRARY_VIDEO"] = "LIBRARY_VIDEO";
    AssetType["COMPONENT_TEMPLATE"] = "COMPONENT_TEMPLATE";
    AssetType["WORKOUT_MEDIA"] = "WORKOUT_MEDIA";
    AssetType["FEEDBACK_IMAGE"] = "FEEDBACK_IMAGE";
    AssetType["FEEDBACK_FILE"] = "FEEDBACK_FILE";
    AssetType["PORTAL_LOGO"] = "PORTAL_LOGO";
    AssetType["MEAL_PHOTO"] = "MEAL_PHOTO";
    AssetType["CLIENT_FORM_IMAGE"] = "CLIENT_FORM_IMAGE";
    AssetType["GROUP_IMAGE"] = "GROUP_IMAGE";
})(AssetType || (AssetType = {}));
var TranscodedVideoVm = /** @class */ (function () {
    function TranscodedVideoVm(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TranscodedVideoVm.prototype.init = function (_data) {
        if (_data) {
            this.url = _data["url"];
        }
    };
    TranscodedVideoVm.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TranscodedVideoVm();
        result.init(data);
        return result;
    };
    TranscodedVideoVm.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    };
    return TranscodedVideoVm;
}());
export { TranscodedVideoVm };
var TranscodeVideoCommand = /** @class */ (function () {
    function TranscodeVideoCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TranscodeVideoCommand.prototype.init = function (_data) {
        if (_data) {
            this.url = _data["url"];
        }
    };
    TranscodeVideoCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TranscodeVideoCommand();
        result.init(data);
        return result;
    };
    TranscodeVideoCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    };
    return TranscodeVideoCommand;
}());
export { TranscodeVideoCommand };
var PaginatedListOfTagDto = /** @class */ (function () {
    function PaginatedListOfTagDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfTagDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(TagDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfTagDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfTagDto();
        result.init(data);
        return result;
    };
    PaginatedListOfTagDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfTagDto;
}());
export { PaginatedListOfTagDto };
var CreateTagCommand = /** @class */ (function () {
    function CreateTagCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateTagCommand.prototype.init = function (_data) {
        if (_data) {
            this.title = _data["title"];
        }
    };
    CreateTagCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateTagCommand();
        result.init(data);
        return result;
    };
    CreateTagCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        return data;
    };
    return CreateTagCommand;
}());
export { CreateTagCommand };
var UpdateTagCommand = /** @class */ (function () {
    function UpdateTagCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateTagCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    };
    UpdateTagCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateTagCommand();
        result.init(data);
        return result;
    };
    UpdateTagCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    };
    return UpdateTagCommand;
}());
export { UpdateTagCommand };
var TerraSdkOptionsDto = /** @class */ (function () {
    function TerraSdkOptionsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TerraSdkOptionsDto.prototype.init = function (_data) {
        if (_data) {
            this.devId = _data["devId"];
            this.referenceId = _data["referenceId"];
            this.token = _data["token"];
        }
    };
    TerraSdkOptionsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TerraSdkOptionsDto();
        result.init(data);
        return result;
    };
    TerraSdkOptionsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["devId"] = this.devId;
        data["referenceId"] = this.referenceId;
        data["token"] = this.token;
        return data;
    };
    return TerraSdkOptionsDto;
}());
export { TerraSdkOptionsDto };
var TerraWidgetSessionDto = /** @class */ (function () {
    function TerraWidgetSessionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TerraWidgetSessionDto.prototype.init = function (_data) {
        if (_data) {
            this.sessionUrl = _data["sessionUrl"];
        }
    };
    TerraWidgetSessionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TerraWidgetSessionDto();
        result.init(data);
        return result;
    };
    TerraWidgetSessionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sessionUrl"] = this.sessionUrl;
        return data;
    };
    return TerraWidgetSessionDto;
}());
export { TerraWidgetSessionDto };
var ThreadDto = /** @class */ (function () {
    function ThreadDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ThreadDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.slug = _data["slug"];
            this.read = _data["read"];
            this.lastMessage = _data["lastMessage"] ? LastMessageDto.fromJS(_data["lastMessage"]) : undefined;
            this.threadAuthor = _data["threadAuthor"] ? ThreadAuthorDto.fromJS(_data["threadAuthor"]) : undefined;
            this.group = _data["group"] ? GroupDto3.fromJS(_data["group"]) : undefined;
            if (Array.isArray(_data["messages"])) {
                this.messages = [];
                for (var _i = 0, _a = _data["messages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.messages.push(MessageDto.fromJS(item));
                }
            }
        }
    };
    ThreadDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ThreadDto();
        result.init(data);
        return result;
    };
    ThreadDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slug"] = this.slug;
        data["read"] = this.read;
        data["lastMessage"] = this.lastMessage ? this.lastMessage.toJSON() : undefined;
        data["threadAuthor"] = this.threadAuthor ? this.threadAuthor.toJSON() : undefined;
        data["group"] = this.group ? this.group.toJSON() : undefined;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (var _i = 0, _a = this.messages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["messages"].push(item.toJSON());
            }
        }
        return data;
    };
    return ThreadDto;
}());
export { ThreadDto };
var LastMessageDto = /** @class */ (function () {
    function LastMessageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LastMessageDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"];
        }
    };
    LastMessageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LastMessageDto();
        result.init(data);
        return result;
    };
    LastMessageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt;
        return data;
    };
    return LastMessageDto;
}());
export { LastMessageDto };
var ThreadAuthorDto = /** @class */ (function (_super) {
    __extends(ThreadAuthorDto, _super);
    function ThreadAuthorDto(data) {
        return _super.call(this, data) || this;
    }
    ThreadAuthorDto.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
    };
    ThreadAuthorDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ThreadAuthorDto();
        result.init(data);
        return result;
    };
    ThreadAuthorDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return ThreadAuthorDto;
}(BaseUserDto));
export { ThreadAuthorDto };
var GroupDto3 = /** @class */ (function () {
    function GroupDto3(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GroupDto3.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.memberCount = _data["memberCount"];
        }
    };
    GroupDto3.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GroupDto3();
        result.init(data);
        return result;
    };
    GroupDto3.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["memberCount"] = this.memberCount;
        return data;
    };
    return GroupDto3;
}());
export { GroupDto3 };
var PaginatedListOfThreadsDto = /** @class */ (function () {
    function PaginatedListOfThreadsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfThreadsDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ThreadsDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfThreadsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfThreadsDto();
        result.init(data);
        return result;
    };
    PaginatedListOfThreadsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfThreadsDto;
}());
export { PaginatedListOfThreadsDto };
var ThreadsDto = /** @class */ (function () {
    function ThreadsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ThreadsDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.slug = _data["slug"];
            this.read = _data["read"];
            this.threadAuthor = _data["threadAuthor"] ? ThreadAuthorDto.fromJS(_data["threadAuthor"]) : undefined;
            this.group = _data["group"] ? GroupDto3.fromJS(_data["group"]) : undefined;
            this.content = _data["content"];
            this.formattedDate = _data["formattedDate"];
        }
    };
    ThreadsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ThreadsDto();
        result.init(data);
        return result;
    };
    ThreadsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slug"] = this.slug;
        data["read"] = this.read;
        data["threadAuthor"] = this.threadAuthor ? this.threadAuthor.toJSON() : undefined;
        data["group"] = this.group ? this.group.toJSON() : undefined;
        data["content"] = this.content;
        data["formattedDate"] = this.formattedDate;
        return data;
    };
    return ThreadsDto;
}());
export { ThreadsDto };
var MessagesCountDto = /** @class */ (function () {
    function MessagesCountDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MessagesCountDto.prototype.init = function (_data) {
        if (_data) {
            this.messagesCount = _data["messagesCount"];
        }
    };
    MessagesCountDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MessagesCountDto();
        result.init(data);
        return result;
    };
    MessagesCountDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["messagesCount"] = this.messagesCount;
        return data;
    };
    return MessagesCountDto;
}());
export { MessagesCountDto };
var UpdateThreadCommand = /** @class */ (function () {
    function UpdateThreadCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateThreadCommand.prototype.init = function (_data) {
        if (_data) {
            this.threadId = _data["threadId"];
            this.read = _data["read"];
            this.archived = _data["archived"];
        }
    };
    UpdateThreadCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateThreadCommand();
        result.init(data);
        return result;
    };
    UpdateThreadCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["threadId"] = this.threadId;
        data["read"] = this.read;
        data["archived"] = this.archived;
        return data;
    };
    return UpdateThreadCommand;
}());
export { UpdateThreadCommand };
var PaginatedListOfUnsplashImageRecord = /** @class */ (function () {
    function PaginatedListOfUnsplashImageRecord(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfUnsplashImageRecord.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(UnsplashImageRecord.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfUnsplashImageRecord.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfUnsplashImageRecord();
        result.init(data);
        return result;
    };
    PaginatedListOfUnsplashImageRecord.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfUnsplashImageRecord;
}());
export { PaginatedListOfUnsplashImageRecord };
var UnsplashImageRecord = /** @class */ (function () {
    function UnsplashImageRecord(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UnsplashImageRecord.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.color = _data["color"];
            this.description = _data["description"];
            this.urls = _data["urls"] ? UnsplashImageUrlsRecord.fromJS(_data["urls"]) : undefined;
            this.author_name = _data["author_name"];
            this.author_url = _data["author_url"];
        }
    };
    UnsplashImageRecord.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UnsplashImageRecord();
        result.init(data);
        return result;
    };
    UnsplashImageRecord.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["width"] = this.width;
        data["height"] = this.height;
        data["color"] = this.color;
        data["description"] = this.description;
        data["urls"] = this.urls ? this.urls.toJSON() : undefined;
        data["author_name"] = this.author_name;
        data["author_url"] = this.author_url;
        return data;
    };
    return UnsplashImageRecord;
}());
export { UnsplashImageRecord };
var UnsplashImageUrlsRecord = /** @class */ (function () {
    function UnsplashImageUrlsRecord(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UnsplashImageUrlsRecord.prototype.init = function (_data) {
        if (_data) {
            this.raw = _data["raw"];
            this.full = _data["full"];
            this.regular = _data["regular"];
            this.small = _data["small"];
            this.thumb = _data["thumb"];
        }
    };
    UnsplashImageUrlsRecord.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UnsplashImageUrlsRecord();
        result.init(data);
        return result;
    };
    UnsplashImageUrlsRecord.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["raw"] = this.raw;
        data["full"] = this.full;
        data["regular"] = this.regular;
        data["small"] = this.small;
        data["thumb"] = this.thumb;
        return data;
    };
    return UnsplashImageUrlsRecord;
}());
export { UnsplashImageUrlsRecord };
var UrlMetadata = /** @class */ (function () {
    function UrlMetadata(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UrlMetadata.prototype.init = function (_data) {
        if (_data) {
            this.url = _data["url"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.image = _data["image"];
        }
    };
    UrlMetadata.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UrlMetadata();
        result.init(data);
        return result;
    };
    UrlMetadata.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["title"] = this.title;
        data["description"] = this.description;
        data["image"] = this.image;
        return data;
    };
    return UrlMetadata;
}());
export { UrlMetadata };
var SendEmailVerificationCodeCommand = /** @class */ (function () {
    function SendEmailVerificationCodeCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SendEmailVerificationCodeCommand.prototype.init = function (_data) {
        if (_data) {
            this.email = _data["email"];
        }
    };
    SendEmailVerificationCodeCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SendEmailVerificationCodeCommand();
        result.init(data);
        return result;
    };
    SendEmailVerificationCodeCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    };
    return SendEmailVerificationCodeCommand;
}());
export { SendEmailVerificationCodeCommand };
var PaginatedListOfUserNoteContentDto = /** @class */ (function () {
    function PaginatedListOfUserNoteContentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfUserNoteContentDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(UserNoteContentDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfUserNoteContentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfUserNoteContentDto();
        result.init(data);
        return result;
    };
    PaginatedListOfUserNoteContentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfUserNoteContentDto;
}());
export { PaginatedListOfUserNoteContentDto };
var UserNoteContentDto = /** @class */ (function () {
    function UserNoteContentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserNoteContentDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.content = _data["content"];
            this.created = _data["created"] ? dayjs(_data["created"].toString()) : undefined;
            this.lastModified = _data["lastModified"] ? dayjs(_data["lastModified"].toString()) : undefined;
        }
    };
    UserNoteContentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserNoteContentDto();
        result.init(data);
        return result;
    };
    UserNoteContentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["content"] = this.content;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined;
        return data;
    };
    return UserNoteContentDto;
}());
export { UserNoteContentDto };
var CreateUserNoteCommand = /** @class */ (function () {
    function CreateUserNoteCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateUserNoteCommand.prototype.init = function (_data) {
        if (_data) {
            this.userId = _data["userId"];
            this.content = _data["content"];
        }
    };
    CreateUserNoteCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateUserNoteCommand();
        result.init(data);
        return result;
    };
    CreateUserNoteCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["content"] = this.content;
        return data;
    };
    return CreateUserNoteCommand;
}());
export { CreateUserNoteCommand };
var UpdateUserNoteCommand = /** @class */ (function () {
    function UpdateUserNoteCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateUserNoteCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
        }
    };
    UpdateUserNoteCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateUserNoteCommand();
        result.init(data);
        return result;
    };
    UpdateUserNoteCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        return data;
    };
    return UpdateUserNoteCommand;
}());
export { UpdateUserNoteCommand };
var AuthBaseDto = /** @class */ (function () {
    function AuthBaseDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AuthBaseDto.prototype.init = function (_data) {
        if (_data) {
            this.accessToken = _data["accessToken"];
        }
    };
    AuthBaseDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AuthBaseDto();
        result.init(data);
        return result;
    };
    AuthBaseDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        return data;
    };
    return AuthBaseDto;
}());
export { AuthBaseDto };
var ClientSignUpCommand = /** @class */ (function () {
    function ClientSignUpCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientSignUpCommand.prototype.init = function (_data) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.timezone = _data["timezone"];
        }
    };
    ClientSignUpCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientSignUpCommand();
        result.init(data);
        return result;
    };
    ClientSignUpCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["password"] = this.password;
        data["timezone"] = this.timezone;
        return data;
    };
    return ClientSignUpCommand;
}());
export { ClientSignUpCommand };
var SendEmailVerificationResponse = /** @class */ (function () {
    function SendEmailVerificationResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SendEmailVerificationResponse.prototype.init = function (_data) {
        if (_data) {
            this.sent = _data["sent"];
            this.nextAttemptInSeconds = _data["nextAttemptInSeconds"];
        }
    };
    SendEmailVerificationResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SendEmailVerificationResponse();
        result.init(data);
        return result;
    };
    SendEmailVerificationResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sent"] = this.sent;
        data["nextAttemptInSeconds"] = this.nextAttemptInSeconds;
        return data;
    };
    return SendEmailVerificationResponse;
}());
export { SendEmailVerificationResponse };
var PreCoachSignUpCommand = /** @class */ (function () {
    function PreCoachSignUpCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PreCoachSignUpCommand.prototype.init = function (_data) {
        if (_data) {
            this.email = _data["email"];
        }
    };
    PreCoachSignUpCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PreCoachSignUpCommand();
        result.init(data);
        return result;
    };
    PreCoachSignUpCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    };
    return PreCoachSignUpCommand;
}());
export { PreCoachSignUpCommand };
var CompleteCoachSignUpCommand = /** @class */ (function () {
    function CompleteCoachSignUpCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompleteCoachSignUpCommand.prototype.init = function (_data) {
        if (_data) {
            this.email = _data["email"];
            this.sessionToken = _data["sessionToken"];
            this.password = _data["password"];
            this.displayName = _data["displayName"];
            this.timezone = _data["timezone"];
            this.referral = _data["referral"];
        }
    };
    CompleteCoachSignUpCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CompleteCoachSignUpCommand();
        result.init(data);
        return result;
    };
    CompleteCoachSignUpCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["sessionToken"] = this.sessionToken;
        data["password"] = this.password;
        data["displayName"] = this.displayName;
        data["timezone"] = this.timezone;
        data["referral"] = this.referral;
        return data;
    };
    return CompleteCoachSignUpCommand;
}());
export { CompleteCoachSignUpCommand };
var SignUpClientCompleteCommand = /** @class */ (function () {
    function SignUpClientCompleteCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SignUpClientCompleteCommand.prototype.init = function (_data) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.height = _data["height"];
            this.weight = _data["weight"];
            this.gender = _data["gender"];
            this.units = _data["units"];
            this.location = _data["location"];
            this.birthday = _data["birthday"];
        }
    };
    SignUpClientCompleteCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SignUpClientCompleteCommand();
        result.init(data);
        return result;
    };
    SignUpClientCompleteCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["height"] = this.height;
        data["weight"] = this.weight;
        data["gender"] = this.gender;
        data["units"] = this.units;
        data["location"] = this.location;
        data["birthday"] = this.birthday;
        return data;
    };
    return SignUpClientCompleteCommand;
}());
export { SignUpClientCompleteCommand };
export var Gender;
(function (Gender) {
    Gender["MALE"] = "MALE";
    Gender["FEMALE"] = "FEMALE";
    Gender["PRIVATE"] = "PRIVATE";
})(Gender || (Gender = {}));
export var UnitSystem;
(function (UnitSystem) {
    UnitSystem["US"] = "US";
    UnitSystem["METRIC"] = "METRIC";
})(UnitSystem || (UnitSystem = {}));
var SignUpClientCompletePhotoCommand = /** @class */ (function () {
    function SignUpClientCompletePhotoCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SignUpClientCompletePhotoCommand.prototype.init = function (_data) {
        if (_data) {
            this.photoUrl = _data["photoUrl"];
        }
    };
    SignUpClientCompletePhotoCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SignUpClientCompletePhotoCommand();
        result.init(data);
        return result;
    };
    SignUpClientCompletePhotoCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["photoUrl"] = this.photoUrl;
        return data;
    };
    return SignUpClientCompletePhotoCommand;
}());
export { SignUpClientCompletePhotoCommand };
var SignInCommand = /** @class */ (function () {
    function SignInCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SignInCommand.prototype.init = function (_data) {
        if (_data) {
            this.idToken = _data["idToken"];
        }
    };
    SignInCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SignInCommand();
        result.init(data);
        return result;
    };
    SignInCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["idToken"] = this.idToken;
        return data;
    };
    return SignInCommand;
}());
export { SignInCommand };
var CustomTokenDto = /** @class */ (function () {
    function CustomTokenDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CustomTokenDto.prototype.init = function (_data) {
        if (_data) {
            this.customToken = _data["customToken"];
        }
    };
    CustomTokenDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CustomTokenDto();
        result.init(data);
        return result;
    };
    CustomTokenDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["customToken"] = this.customToken;
        return data;
    };
    return CustomTokenDto;
}());
export { CustomTokenDto };
var SignInWithAuthTokenCommand = /** @class */ (function () {
    function SignInWithAuthTokenCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SignInWithAuthTokenCommand.prototype.init = function (_data) {
        if (_data) {
            this.token = _data["token"];
            this.timezone = _data["timezone"];
        }
    };
    SignInWithAuthTokenCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SignInWithAuthTokenCommand();
        result.init(data);
        return result;
    };
    SignInWithAuthTokenCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["timezone"] = this.timezone;
        return data;
    };
    return SignInWithAuthTokenCommand;
}());
export { SignInWithAuthTokenCommand };
var ClientSignUpWithAuthTokenCommand = /** @class */ (function () {
    function ClientSignUpWithAuthTokenCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientSignUpWithAuthTokenCommand.prototype.init = function (_data) {
        if (_data) {
            this.code = _data["code"];
            this.token = _data["token"];
            this.timezone = _data["timezone"];
        }
    };
    ClientSignUpWithAuthTokenCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientSignUpWithAuthTokenCommand();
        result.init(data);
        return result;
    };
    ClientSignUpWithAuthTokenCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["token"] = this.token;
        data["timezone"] = this.timezone;
        return data;
    };
    return ClientSignUpWithAuthTokenCommand;
}());
export { ClientSignUpWithAuthTokenCommand };
var ExchangeRefreshCommand = /** @class */ (function () {
    function ExchangeRefreshCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExchangeRefreshCommand.prototype.init = function (_data) {
        if (_data) {
            this.expiredToken = _data["expiredToken"];
        }
    };
    ExchangeRefreshCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExchangeRefreshCommand();
        result.init(data);
        return result;
    };
    ExchangeRefreshCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["expiredToken"] = this.expiredToken;
        return data;
    };
    return ExchangeRefreshCommand;
}());
export { ExchangeRefreshCommand };
var ResetPasswordCommand = /** @class */ (function () {
    function ResetPasswordCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResetPasswordCommand.prototype.init = function (_data) {
        if (_data) {
            this.email = _data["email"];
            this.workspaceSlug = _data["workspaceSlug"];
        }
    };
    ResetPasswordCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResetPasswordCommand();
        result.init(data);
        return result;
    };
    ResetPasswordCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["workspaceSlug"] = this.workspaceSlug;
        return data;
    };
    return ResetPasswordCommand;
}());
export { ResetPasswordCommand };
var VerifyEmailCommand = /** @class */ (function () {
    function VerifyEmailCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VerifyEmailCommand.prototype.init = function (_data) {
        if (_data) {
            this.oobCode = _data["oobCode"];
            this.email = _data["email"];
        }
    };
    VerifyEmailCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VerifyEmailCommand();
        result.init(data);
        return result;
    };
    VerifyEmailCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["oobCode"] = this.oobCode;
        data["email"] = this.email;
        return data;
    };
    return VerifyEmailCommand;
}());
export { VerifyEmailCommand };
var VerifySignUpEmailResponse = /** @class */ (function () {
    function VerifySignUpEmailResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VerifySignUpEmailResponse.prototype.init = function (_data) {
        if (_data) {
            this.sessionToken = _data["sessionToken"];
        }
    };
    VerifySignUpEmailResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VerifySignUpEmailResponse();
        result.init(data);
        return result;
    };
    VerifySignUpEmailResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sessionToken"] = this.sessionToken;
        return data;
    };
    return VerifySignUpEmailResponse;
}());
export { VerifySignUpEmailResponse };
var VerifySignUpEmailCommand = /** @class */ (function () {
    function VerifySignUpEmailCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VerifySignUpEmailCommand.prototype.init = function (_data) {
        if (_data) {
            this.code = _data["code"];
            this.email = _data["email"];
        }
    };
    VerifySignUpEmailCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VerifySignUpEmailCommand();
        result.init(data);
        return result;
    };
    VerifySignUpEmailCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["email"] = this.email;
        return data;
    };
    return VerifySignUpEmailCommand;
}());
export { VerifySignUpEmailCommand };
var UpdateUserProfileCommand = /** @class */ (function () {
    function UpdateUserProfileCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateUserProfileCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.displayName = _data["displayName"];
            this.photoUrl = _data["photoUrl"];
            this.timezone = _data["timezone"];
            this.height = _data["height"];
            this.weight = _data["weight"];
            this.gender = _data["gender"];
            this.units = _data["units"];
            this.birthday = _data["birthday"];
            this.location = _data["location"];
            this.admin = _data["admin"];
            this.topToolBar = _data["topToolBar"];
            this.trialExpiryDate = _data["trialExpiryDate"] ? dayjs(_data["trialExpiryDate"].toString()) : undefined;
            this.phone = _data["phone"];
            this.phoneCode = _data["phoneCode"];
        }
    };
    UpdateUserProfileCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateUserProfileCommand();
        result.init(data);
        return result;
    };
    UpdateUserProfileCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["displayName"] = this.displayName;
        data["photoUrl"] = this.photoUrl;
        data["timezone"] = this.timezone;
        data["height"] = this.height;
        data["weight"] = this.weight;
        data["gender"] = this.gender;
        data["units"] = this.units;
        data["birthday"] = this.birthday;
        data["location"] = this.location;
        data["admin"] = this.admin;
        data["topToolBar"] = this.topToolBar;
        data["trialExpiryDate"] = this.trialExpiryDate ? this.trialExpiryDate.toISOString() : undefined;
        data["phone"] = this.phone;
        data["phoneCode"] = this.phoneCode;
        return data;
    };
    return UpdateUserProfileCommand;
}());
export { UpdateUserProfileCommand };
var UpdateEmailCommand = /** @class */ (function () {
    function UpdateEmailCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateEmailCommand.prototype.init = function (_data) {
        if (_data) {
            this.email = _data["email"];
            this.code = _data["code"];
        }
    };
    UpdateEmailCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateEmailCommand();
        result.init(data);
        return result;
    };
    UpdateEmailCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["code"] = this.code;
        return data;
    };
    return UpdateEmailCommand;
}());
export { UpdateEmailCommand };
var SignInAsCommand = /** @class */ (function () {
    function SignInAsCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SignInAsCommand.prototype.init = function (_data) {
        if (_data) {
            this.desiredUserId = _data["desiredUserId"];
        }
    };
    SignInAsCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SignInAsCommand();
        result.init(data);
        return result;
    };
    SignInAsCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["desiredUserId"] = this.desiredUserId;
        return data;
    };
    return SignInAsCommand;
}());
export { SignInAsCommand };
var UserInfoDto = /** @class */ (function () {
    function UserInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserInfoDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.email = _data["email"];
            this.rawEmail = _data["rawEmail"];
            this.externalReferenceId = _data["externalReferenceId"];
            this.displayName = _data["displayName"];
            this.photoUrl = _data["photoUrl"];
            this.archived = _data["archived"];
            this.phone = _data["phone"];
            this.phoneCode = _data["phoneCode"];
            this.phoneVerified = _data["phoneVerified"];
            this.timeZone = _data["timeZone"];
            this.role = _data["role"];
            this.location = _data["location"];
            this.birthday = _data["birthday"];
            this.age = _data["age"];
            this.gender = _data["gender"];
            this.units = _data["units"];
            this.height = _data["height"];
            this.weight = _data["weight"];
            this.created = _data["created"] ? dayjs(_data["created"].toString()) : undefined;
            this.passwordUpdatedAt = _data["passwordUpdatedAt"] ? dayjs(_data["passwordUpdatedAt"].toString()) : undefined;
            this.passwordSet = _data["passwordSet"];
            this.isSample = _data["isSample"];
            this.isImpersonating = _data["isImpersonating"];
            this.admin = _data["admin"];
            this.topToolbar = _data["topToolbar"];
            this.trialExpiryDate = _data["trialExpiryDate"] ? dayjs(_data["trialExpiryDate"].toString()) : undefined;
            this.trialExpired = _data["trialExpired"];
            this.plan = _data["plan"];
            this.planTier = _data["planTier"];
            this.clientsCount = _data["clientsCount"];
            this.clientsCountNoSample = _data["clientsCountNoSample"];
            this.notificationUnreadCount = _data["notificationUnreadCount"];
            this.notificationsActive = _data["notificationsActive"];
            this.unreadActivitiesCount = _data["unreadActivitiesCount"];
            this.unreadMessagesCount = _data["unreadMessagesCount"];
            this.groupsCount = _data["groupsCount"];
            this.programsCount = _data["programsCount"];
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [];
                for (var _i = 0, _a = _data["accounts"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.accounts.push(UserAccountInfoDto.fromJS(item));
                }
            }
            this.workspace = _data["workspace"] ? WorkspaceInfoDto.fromJS(_data["workspace"]) : undefined;
            this.subscription = _data["subscription"] ? SubscriptionBriefDto.fromJS(_data["subscription"]) : undefined;
            this.coach = _data["coach"] ? CoachInfoDto2.fromJS(_data["coach"]) : undefined;
            this.terraConnected = _data["terraConnected"];
            if (Array.isArray(_data["terraProviders"])) {
                this.terraProviders = [];
                for (var _b = 0, _c = _data["terraProviders"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.terraProviders.push(TerraProviderDto.fromJS(item));
                }
            }
            this.lastLoginAt = _data["lastLoginAt"] ? dayjs(_data["lastLoginAt"].toString()) : undefined;
            this.lastLoginAtRelative = _data["lastLoginAtRelative"];
        }
    };
    UserInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserInfoDto();
        result.init(data);
        return result;
    };
    UserInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["email"] = this.email;
        data["rawEmail"] = this.rawEmail;
        data["externalReferenceId"] = this.externalReferenceId;
        data["displayName"] = this.displayName;
        data["photoUrl"] = this.photoUrl;
        data["archived"] = this.archived;
        data["phone"] = this.phone;
        data["phoneCode"] = this.phoneCode;
        data["phoneVerified"] = this.phoneVerified;
        data["timeZone"] = this.timeZone;
        data["role"] = this.role;
        data["location"] = this.location;
        data["birthday"] = this.birthday;
        data["age"] = this.age;
        data["gender"] = this.gender;
        data["units"] = this.units;
        data["height"] = this.height;
        data["weight"] = this.weight;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["passwordUpdatedAt"] = this.passwordUpdatedAt ? this.passwordUpdatedAt.toISOString() : undefined;
        data["passwordSet"] = this.passwordSet;
        data["isSample"] = this.isSample;
        data["isImpersonating"] = this.isImpersonating;
        data["admin"] = this.admin;
        data["topToolbar"] = this.topToolbar;
        data["trialExpiryDate"] = this.trialExpiryDate ? this.trialExpiryDate.toISOString() : undefined;
        data["trialExpired"] = this.trialExpired;
        data["plan"] = this.plan;
        data["planTier"] = this.planTier;
        data["clientsCount"] = this.clientsCount;
        data["clientsCountNoSample"] = this.clientsCountNoSample;
        data["notificationUnreadCount"] = this.notificationUnreadCount;
        data["notificationsActive"] = this.notificationsActive;
        data["unreadActivitiesCount"] = this.unreadActivitiesCount;
        data["unreadMessagesCount"] = this.unreadMessagesCount;
        data["groupsCount"] = this.groupsCount;
        data["programsCount"] = this.programsCount;
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (var _i = 0, _a = this.accounts; _i < _a.length; _i++) {
                var item = _a[_i];
                data["accounts"].push(item.toJSON());
            }
        }
        data["workspace"] = this.workspace ? this.workspace.toJSON() : undefined;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : undefined;
        data["coach"] = this.coach ? this.coach.toJSON() : undefined;
        data["terraConnected"] = this.terraConnected;
        if (Array.isArray(this.terraProviders)) {
            data["terraProviders"] = [];
            for (var _b = 0, _c = this.terraProviders; _b < _c.length; _b++) {
                var item = _c[_b];
                data["terraProviders"].push(item.toJSON());
            }
        }
        data["lastLoginAt"] = this.lastLoginAt ? this.lastLoginAt.toISOString() : undefined;
        data["lastLoginAtRelative"] = this.lastLoginAtRelative;
        return data;
    };
    return UserInfoDto;
}());
export { UserInfoDto };
var UserAccountInfoDto = /** @class */ (function () {
    function UserAccountInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserAccountInfoDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.role = _data["role"];
            this.isSample = _data["isSample"];
            this.username = _data["username"];
            this.email = _data["email"];
            this.displayName = _data["displayName"];
            this.photoUrl = _data["photoUrl"];
            this.phone = _data["phone"];
            this.timeZone = _data["timeZone"];
            this.created = _data["created"] ? dayjs(_data["created"].toString()) : undefined;
        }
    };
    UserAccountInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserAccountInfoDto();
        result.init(data);
        return result;
    };
    UserAccountInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["role"] = this.role;
        data["isSample"] = this.isSample;
        data["username"] = this.username;
        data["email"] = this.email;
        data["displayName"] = this.displayName;
        data["photoUrl"] = this.photoUrl;
        data["phone"] = this.phone;
        data["timeZone"] = this.timeZone;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        return data;
    };
    return UserAccountInfoDto;
}());
export { UserAccountInfoDto };
var SubscriptionBriefDto = /** @class */ (function () {
    function SubscriptionBriefDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SubscriptionBriefDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.periodEndDate = _data["PeriodEndDate"];
            this.canceledDate = _data["CanceledDate"];
            this.cancelAtPeriodEnd = _data["cancelAtPeriodEnd"];
            this.expired = _data["expired"];
            this.expiresAt = _data["expiresAt"] ? dayjs(_data["expiresAt"].toString()) : undefined;
        }
    };
    SubscriptionBriefDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SubscriptionBriefDto();
        result.init(data);
        return result;
    };
    SubscriptionBriefDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["PeriodEndDate"] = this.periodEndDate;
        data["CanceledDate"] = this.canceledDate;
        data["cancelAtPeriodEnd"] = this.cancelAtPeriodEnd;
        data["expired"] = this.expired;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.format('YYYY-MM-DD') : undefined;
        return data;
    };
    return SubscriptionBriefDto;
}());
export { SubscriptionBriefDto };
var CoachInfoDto2 = /** @class */ (function () {
    function CoachInfoDto2(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CoachInfoDto2.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.username = _data["username"];
            this.displayName = _data["displayName"];
            this.photoUrl = _data["photoUrl"];
        }
    };
    CoachInfoDto2.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CoachInfoDto2();
        result.init(data);
        return result;
    };
    CoachInfoDto2.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["username"] = this.username;
        data["displayName"] = this.displayName;
        data["photoUrl"] = this.photoUrl;
        return data;
    };
    return CoachInfoDto2;
}());
export { CoachInfoDto2 };
var TerraProviderDto = /** @class */ (function () {
    function TerraProviderDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TerraProviderDto.prototype.init = function (_data) {
        if (_data) {
            this.provider = _data["provider"];
        }
    };
    TerraProviderDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TerraProviderDto();
        result.init(data);
        return result;
    };
    TerraProviderDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider;
        return data;
    };
    return TerraProviderDto;
}());
export { TerraProviderDto };
var PaginatedListOfAdminUserInfoDto = /** @class */ (function () {
    function PaginatedListOfAdminUserInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfAdminUserInfoDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(AdminUserInfoDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfAdminUserInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfAdminUserInfoDto();
        result.init(data);
        return result;
    };
    PaginatedListOfAdminUserInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfAdminUserInfoDto;
}());
export { PaginatedListOfAdminUserInfoDto };
var AdminUserInfoDto = /** @class */ (function () {
    function AdminUserInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AdminUserInfoDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.role = _data["role"];
            this.clientsCount = _data["clientsCount"];
            this.username = _data["username"];
            this.admin = _data["admin"];
            this.email = _data["email"];
            this.displayName = _data["displayName"];
            this.photoUrl = _data["photoUrl"];
            this.programsCount = _data["programsCount"];
            this.lastLoginAt = _data["lastLoginAt"] ? dayjs(_data["lastLoginAt"].toString()) : undefined;
        }
    };
    AdminUserInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdminUserInfoDto();
        result.init(data);
        return result;
    };
    AdminUserInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["role"] = this.role;
        data["clientsCount"] = this.clientsCount;
        data["username"] = this.username;
        data["admin"] = this.admin;
        data["email"] = this.email;
        data["displayName"] = this.displayName;
        data["photoUrl"] = this.photoUrl;
        data["programsCount"] = this.programsCount;
        data["lastLoginAt"] = this.lastLoginAt ? this.lastLoginAt.toISOString() : undefined;
        return data;
    };
    return AdminUserInfoDto;
}());
export { AdminUserInfoDto };
export var UserRole;
(function (UserRole) {
    UserRole[UserRole["CLIENT"] = 0] = "CLIENT";
    UserRole[UserRole["COACH"] = 1] = "COACH";
    UserRole[UserRole["ADMIN"] = 2] = "ADMIN";
})(UserRole || (UserRole = {}));
var UserInfoDto2 = /** @class */ (function () {
    function UserInfoDto2(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserInfoDto2.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.displayName = _data["displayName"];
            this.role = _data["role"];
            this.admin = _data["admin"];
            this.trialExpiryDate = _data["trialExpiryDate"] ? dayjs(_data["trialExpiryDate"].toString()) : undefined;
            this.goHighLevelAccountState = _data["goHighLevelAccountState"];
            if (Array.isArray(_data["goHighLevelAccountLink"])) {
                this.goHighLevelAccountLink = [];
                for (var _i = 0, _a = _data["goHighLevelAccountLink"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.goHighLevelAccountLink.push(item);
                }
            }
            this.isUserExistsInGHL = _data["isUserExistsInGHL"];
            this.stripeCustomerLink = _data["stripeCustomerLink"];
            this.subscriptionPeriodEnd = _data["subscriptionPeriodEnd"];
            this.subscriptionStatus = _data["subscriptionStatus"];
        }
    };
    UserInfoDto2.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserInfoDto2();
        result.init(data);
        return result;
    };
    UserInfoDto2.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["displayName"] = this.displayName;
        data["role"] = this.role;
        data["admin"] = this.admin;
        data["trialExpiryDate"] = this.trialExpiryDate ? this.trialExpiryDate.toISOString() : undefined;
        data["goHighLevelAccountState"] = this.goHighLevelAccountState;
        if (Array.isArray(this.goHighLevelAccountLink)) {
            data["goHighLevelAccountLink"] = [];
            for (var _i = 0, _a = this.goHighLevelAccountLink; _i < _a.length; _i++) {
                var item = _a[_i];
                data["goHighLevelAccountLink"].push(item);
            }
        }
        data["isUserExistsInGHL"] = this.isUserExistsInGHL;
        data["stripeCustomerLink"] = this.stripeCustomerLink;
        data["subscriptionPeriodEnd"] = this.subscriptionPeriodEnd;
        data["subscriptionStatus"] = this.subscriptionStatus;
        return data;
    };
    return UserInfoDto2;
}());
export { UserInfoDto2 };
var AddWeekCommand = /** @class */ (function () {
    function AddWeekCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddWeekCommand.prototype.init = function (_data) {
        if (_data) {
            this.programId = _data["programId"];
        }
    };
    AddWeekCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddWeekCommand();
        result.init(data);
        return result;
    };
    AddWeekCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        return data;
    };
    return AddWeekCommand;
}());
export { AddWeekCommand };
var MoveWeekCommand = /** @class */ (function () {
    function MoveWeekCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MoveWeekCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.direction = _data["direction"];
        }
    };
    MoveWeekCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MoveWeekCommand();
        result.init(data);
        return result;
    };
    MoveWeekCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["direction"] = this.direction;
        return data;
    };
    return MoveWeekCommand;
}());
export { MoveWeekCommand };
export var WeekMoveDirection;
(function (WeekMoveDirection) {
    WeekMoveDirection["UP"] = "UP";
    WeekMoveDirection["DOWN"] = "DOWN";
})(WeekMoveDirection || (WeekMoveDirection = {}));
var DuplicateWeekResult = /** @class */ (function () {
    function DuplicateWeekResult(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DuplicateWeekResult.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.week = _data["week"] ? WeekDto.fromJS(_data["week"]) : undefined;
            if (Array.isArray(_data["createdComponents"])) {
                this.createdComponents = [];
                for (var _i = 0, _a = _data["createdComponents"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.createdComponents.push(CreatedComponentResult.fromJS(item));
                }
            }
            if (Array.isArray(_data["positions"])) {
                this.positions = [];
                for (var _b = 0, _c = _data["positions"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.positions.push(item);
                }
            }
        }
    };
    DuplicateWeekResult.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DuplicateWeekResult();
        result.init(data);
        return result;
    };
    DuplicateWeekResult.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["week"] = this.week ? this.week.toJSON() : undefined;
        if (Array.isArray(this.createdComponents)) {
            data["createdComponents"] = [];
            for (var _i = 0, _a = this.createdComponents; _i < _a.length; _i++) {
                var item = _a[_i];
                data["createdComponents"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (var _b = 0, _c = this.positions; _b < _c.length; _b++) {
                var item = _c[_b];
                data["positions"].push(item);
            }
        }
        return data;
    };
    return DuplicateWeekResult;
}());
export { DuplicateWeekResult };
var DuplicateWeekCommand = /** @class */ (function () {
    function DuplicateWeekCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DuplicateWeekCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.programId = _data["programId"];
        }
    };
    DuplicateWeekCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DuplicateWeekCommand();
        result.init(data);
        return result;
    };
    DuplicateWeekCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["programId"] = this.programId;
        return data;
    };
    return DuplicateWeekCommand;
}());
export { DuplicateWeekCommand };
var UpdateWeekComponentsOrderCommand = /** @class */ (function () {
    function UpdateWeekComponentsOrderCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateWeekComponentsOrderCommand.prototype.init = function (_data) {
        if (_data) {
            this.weekId = _data["weekId"];
            if (Array.isArray(_data["positions"])) {
                this.positions = [];
                for (var _i = 0, _a = _data["positions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.positions.push(item);
                }
            }
        }
    };
    UpdateWeekComponentsOrderCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateWeekComponentsOrderCommand();
        result.init(data);
        return result;
    };
    UpdateWeekComponentsOrderCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["weekId"] = this.weekId;
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (var _i = 0, _a = this.positions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["positions"].push(item);
            }
        }
        return data;
    };
    return UpdateWeekComponentsOrderCommand;
}());
export { UpdateWeekComponentsOrderCommand };
var UpdateWeekDescriptionCommand = /** @class */ (function () {
    function UpdateWeekDescriptionCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateWeekDescriptionCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    };
    UpdateWeekDescriptionCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateWeekDescriptionCommand();
        result.init(data);
        return result;
    };
    UpdateWeekDescriptionCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    };
    return UpdateWeekDescriptionCommand;
}());
export { UpdateWeekDescriptionCommand };
var PaginatedListOfUserExerciseDto = /** @class */ (function () {
    function PaginatedListOfUserExerciseDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfUserExerciseDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(UserExerciseDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfUserExerciseDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfUserExerciseDto();
        result.init(data);
        return result;
    };
    PaginatedListOfUserExerciseDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfUserExerciseDto;
}());
export { PaginatedListOfUserExerciseDto };
var UserExerciseDto = /** @class */ (function () {
    function UserExerciseDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserExerciseDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.exerciseId = _data["exerciseId"];
            this.exercise = _data["exercise"] ? UserExerciseAssetDto.fromJS(_data["exercise"]) : undefined;
            this.title = _data["title"];
            this.completedAt = _data["completedAt"] ? dayjs(_data["completedAt"].toString()) : undefined;
        }
    };
    UserExerciseDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserExerciseDto();
        result.init(data);
        return result;
    };
    UserExerciseDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["exerciseId"] = this.exerciseId;
        data["exercise"] = this.exercise ? this.exercise.toJSON() : undefined;
        data["title"] = this.title;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined;
        return data;
    };
    return UserExerciseDto;
}());
export { UserExerciseDto };
var UserExerciseAssetDto = /** @class */ (function () {
    function UserExerciseAssetDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserExerciseAssetDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    UserExerciseAssetDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserExerciseAssetDto();
        result.init(data);
        return result;
    };
    UserExerciseAssetDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    return UserExerciseAssetDto;
}());
export { UserExerciseAssetDto };
var PaginatedListOfExerciseResultsDto = /** @class */ (function () {
    function PaginatedListOfExerciseResultsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaginatedListOfExerciseResultsDto.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ExerciseResultsDto.fromJS(item));
                }
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PaginatedListOfExerciseResultsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaginatedListOfExerciseResultsDto();
        result.init(data);
        return result;
    };
    PaginatedListOfExerciseResultsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PaginatedListOfExerciseResultsDto;
}());
export { PaginatedListOfExerciseResultsDto };
var ExerciseResultsDto = /** @class */ (function () {
    function ExerciseResultsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExerciseResultsDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.activity = _data["activity"] ? WorkoutActivityDto.fromJS(_data["activity"]) : undefined;
        }
    };
    ExerciseResultsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExerciseResultsDto();
        result.init(data);
        return result;
    };
    ExerciseResultsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["activity"] = this.activity ? this.activity.toJSON() : undefined;
        return data;
    };
    return ExerciseResultsDto;
}());
export { ExerciseResultsDto };
var WorkoutActivityDto = /** @class */ (function () {
    function WorkoutActivityDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WorkoutActivityDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.completedAt = _data["completedAt"] ? dayjs(_data["completedAt"].toString()) : undefined;
            this.endWorkout = _data["endWorkout"];
            this.component = _data["component"] ? ComponentInfoDto2.fromJS(_data["component"]) : undefined;
        }
    };
    WorkoutActivityDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WorkoutActivityDto();
        result.init(data);
        return result;
    };
    WorkoutActivityDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined;
        data["endWorkout"] = this.endWorkout;
        data["component"] = this.component ? this.component.toJSON() : undefined;
        return data;
    };
    return WorkoutActivityDto;
}());
export { WorkoutActivityDto };
var ComponentInfoDto2 = /** @class */ (function () {
    function ComponentInfoDto2(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ComponentInfoDto2.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
            this.title = _data["title"];
        }
    };
    ComponentInfoDto2.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ComponentInfoDto2();
        result.init(data);
        return result;
    };
    ComponentInfoDto2.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        data["title"] = this.title;
        return data;
    };
    return ComponentInfoDto2;
}());
export { ComponentInfoDto2 };
var GetWorkspaceClientPortalDto = /** @class */ (function () {
    function GetWorkspaceClientPortalDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetWorkspaceClientPortalDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.slug = _data["slug"];
            this.message = _data["message"];
            this.logoUrl = _data["logoUrl"];
            this.mealLogging = _data["mealLogging"];
            this.mealLoggingQuestions = _data["mealLoggingQuestions"];
            this.mealLoggingQuestionsTotal = _data["mealLoggingQuestionsTotal"];
        }
    };
    GetWorkspaceClientPortalDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetWorkspaceClientPortalDto();
        result.init(data);
        return result;
    };
    GetWorkspaceClientPortalDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["slug"] = this.slug;
        data["message"] = this.message;
        data["logoUrl"] = this.logoUrl;
        data["mealLogging"] = this.mealLogging;
        data["mealLoggingQuestions"] = this.mealLoggingQuestions;
        data["mealLoggingQuestionsTotal"] = this.mealLoggingQuestionsTotal;
        return data;
    };
    return GetWorkspaceClientPortalDto;
}());
export { GetWorkspaceClientPortalDto };
var GetCoachWorkspaceThemeDto = /** @class */ (function () {
    function GetCoachWorkspaceThemeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetCoachWorkspaceThemeDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.primaryColor = _data["primaryColor"];
        }
    };
    GetCoachWorkspaceThemeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetCoachWorkspaceThemeDto();
        result.init(data);
        return result;
    };
    GetCoachWorkspaceThemeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["primaryColor"] = this.primaryColor;
        return data;
    };
    return GetCoachWorkspaceThemeDto;
}());
export { GetCoachWorkspaceThemeDto };
var UpdateWorkspaceCommand = /** @class */ (function () {
    function UpdateWorkspaceCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateWorkspaceCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.slug = _data["slug"];
            this.message = _data["message"];
            this.logoUrl = _data["logoUrl"];
            this.mealLogging = _data["mealLogging"];
        }
    };
    UpdateWorkspaceCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateWorkspaceCommand();
        result.init(data);
        return result;
    };
    UpdateWorkspaceCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["slug"] = this.slug;
        data["message"] = this.message;
        data["logoUrl"] = this.logoUrl;
        data["mealLogging"] = this.mealLogging;
        return data;
    };
    return UpdateWorkspaceCommand;
}());
export { UpdateWorkspaceCommand };
var SetWorkspaceColorCommand = /** @class */ (function () {
    function SetWorkspaceColorCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SetWorkspaceColorCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.primaryColor = _data["primaryColor"];
        }
    };
    SetWorkspaceColorCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SetWorkspaceColorCommand();
        result.init(data);
        return result;
    };
    SetWorkspaceColorCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["primaryColor"] = this.primaryColor;
        return data;
    };
    return SetWorkspaceColorCommand;
}());
export { SetWorkspaceColorCommand };
var UpdateMealLoggingPromptsCommand = /** @class */ (function () {
    function UpdateMealLoggingPromptsCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateMealLoggingPromptsCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.mealLoggingQuestions = _data["mealLoggingQuestions"];
        }
    };
    UpdateMealLoggingPromptsCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateMealLoggingPromptsCommand();
        result.init(data);
        return result;
    };
    UpdateMealLoggingPromptsCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mealLoggingQuestions"] = this.mealLoggingQuestions;
        return data;
    };
    return UpdateMealLoggingPromptsCommand;
}());
export { UpdateMealLoggingPromptsCommand };
var GetWorkspaceDto = /** @class */ (function () {
    function GetWorkspaceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetWorkspaceDto.prototype.init = function (_data) {
        if (_data) {
            this.workspace = _data["workspace"] ? WorkspaceDto.fromJS(_data["workspace"]) : undefined;
        }
    };
    GetWorkspaceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetWorkspaceDto();
        result.init(data);
        return result;
    };
    GetWorkspaceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["workspace"] = this.workspace ? this.workspace.toJSON() : undefined;
        return data;
    };
    return GetWorkspaceDto;
}());
export { GetWorkspaceDto };
var WorkspaceDto = /** @class */ (function () {
    function WorkspaceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WorkspaceDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.primaryColor = _data["primaryColor"];
            this.slug = _data["slug"];
            this.name = _data["name"];
            this.logoUrl = _data["logoUrl"];
            this.brandedApp = _data["brandedApp"] ? BrandedAppDto.fromJS(_data["brandedApp"]) : undefined;
        }
    };
    WorkspaceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WorkspaceDto();
        result.init(data);
        return result;
    };
    WorkspaceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["primaryColor"] = this.primaryColor;
        data["slug"] = this.slug;
        data["name"] = this.name;
        data["logoUrl"] = this.logoUrl;
        data["brandedApp"] = this.brandedApp ? this.brandedApp.toJSON() : undefined;
        return data;
    };
    return WorkspaceDto;
}());
export { WorkspaceDto };
var ApiException = /** @class */ (function (_super) {
    __extends(ApiException, _super);
    function ApiException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isApiException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    ApiException.isApiException = function (obj) {
        return obj.isApiException === true;
    };
    return ApiException;
}(Error));
export { ApiException };
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
function isAxiosError(obj) {
    return obj && obj.isAxiosError === true;
}
